//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param email (optional) 
     * @param userId (optional) 
     * @return Success
     */
    userNameOrEmailExist(email: string | undefined, userId: number | undefined): Observable<CheckResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Account/UserNameOrEmailExist?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserNameOrEmailExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserNameOrEmailExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckResultDto>;
        }));
    }

    protected processUserNameOrEmailExist(response: HttpResponseBase): Observable<CheckResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CheckResultDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    sendConfirmationEmail(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendConfirmationEmail?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendConfirmationEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param token (optional) 
     * @return Success
     */
    confirmEmail(userId: number | undefined, token: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ConfirmEmail?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: ForgotPasswordDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Account/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param token (optional) 
     * @return Success
     */
    sendNewPasswordAfterReset(userId: number | undefined, token: string | undefined): Observable<ResetPasswordResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendNewPasswordAfterReset?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNewPasswordAfterReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNewPasswordAfterReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordResultDto>;
        }));
    }

    protected processSendNewPasswordAfterReset(response: HttpResponseBase): Observable<ResetPasswordResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ResetPasswordResultDto>(null as any);
    }
}

@Injectable()
export class ActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateActivityDto | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateActivityDto | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto>(null as any);
    }

    /**
     * @param title (optional) 
     * @param id (optional) 
     * @return Success
     */
    delete(title: string | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Delete?";
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param activityOutputId (optional) 
     * @return Success
     */
    getMaximumOutputQuantity(activityOutputId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetMaximumOutputQuantity?";
        if (activityOutputId === null)
            throw new Error("The parameter 'activityOutputId' cannot be null.");
        else if (activityOutputId !== undefined)
            url_ += "activityOutputId=" + encodeURIComponent("" + activityOutputId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaximumOutputQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaximumOutputQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMaximumOutputQuantity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param activityOutputId (optional) 
     * @param commitmentOutputId (optional) 
     * @return Success
     */
    getUpdateMaximumOutputQuantity(activityOutputId: number | undefined, commitmentOutputId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetUpdateMaximumOutputQuantity?";
        if (activityOutputId === null)
            throw new Error("The parameter 'activityOutputId' cannot be null.");
        else if (activityOutputId !== undefined)
            url_ += "activityOutputId=" + encodeURIComponent("" + activityOutputId) + "&";
        if (commitmentOutputId === null)
            throw new Error("The parameter 'commitmentOutputId' cannot be null.");
        else if (commitmentOutputId !== undefined)
            url_ += "commitmentOutputId=" + encodeURIComponent("" + commitmentOutputId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpdateMaximumOutputQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpdateMaximumOutputQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUpdateMaximumOutputQuantity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param contractId (optional) 
     * @param customerIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, contractId: number | undefined, customerIds: number[] | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ActivityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "ContractId=" + encodeURIComponent("" + contractId) + "&";
        if (customerIds === null)
            throw new Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "CustomerIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ActivityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ActivityCategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateActivityCategoryDto | undefined): Observable<ActivityCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCategory/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityCategoryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ActivityCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityCategoryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateActivityCategoryDto | undefined): Observable<ActivityCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCategory/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityCategoryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ActivityCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityCategoryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ActivityCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCategory/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityCategoryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ActivityCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityCategoryDto>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ActivityCategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCategory/GetAll?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityCategoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityCategoryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ActivityCategoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityCategoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityCategoryDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityCategory/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ActivityMacroCategoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ActivityMacroCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityMacroCategory/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityMacroCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityMacroCategoryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ActivityMacroCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityMacroCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityMacroCategoryDto>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ActivityMacroCategoryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityMacroCategory/GetAll?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityMacroCategoryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityMacroCategoryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ActivityMacroCategoryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityMacroCategoryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityMacroCategoryDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateActivityMacroCategoryDto | undefined): Observable<ActivityMacroCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityMacroCategory/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityMacroCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityMacroCategoryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ActivityMacroCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityMacroCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityMacroCategoryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateActivityMacroCategoryDto | undefined): Observable<ActivityMacroCategoryDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityMacroCategory/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityMacroCategoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityMacroCategoryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ActivityMacroCategoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityMacroCategoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityMacroCategoryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityMacroCategory/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ActivityOutputServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param activity_Id (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(activity_Id: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ActivityOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityOutput/GetAll?";
        if (activity_Id === null)
            throw new Error("The parameter 'activity_Id' cannot be null.");
        else if (activity_Id !== undefined)
            url_ += "Activity.Id=" + encodeURIComponent("" + activity_Id) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityOutputDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityOutputDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ActivityOutputDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityOutputDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActivityOutputDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ApprovalLevelCarbonCopyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ApprovalLevelCarbonCopyDto | undefined): Observable<ApprovalLevelCarbonCopyDto> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalLevelCarbonCopy/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovalLevelCarbonCopyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovalLevelCarbonCopyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApprovalLevelCarbonCopyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApprovalLevelCarbonCopyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApprovalLevelCarbonCopyDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalLevelCarbonCopy/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param hrRequestOrganizationUnitsApproverId (optional) 
     * @return Success
     */
    getAll(hrRequestOrganizationUnitsApproverId: number | undefined): Observable<ApprovalLevelCarbonCopyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalLevelCarbonCopy/GetAll?";
        if (hrRequestOrganizationUnitsApproverId === null)
            throw new Error("The parameter 'hrRequestOrganizationUnitsApproverId' cannot be null.");
        else if (hrRequestOrganizationUnitsApproverId !== undefined)
            url_ += "hrRequestOrganizationUnitsApproverId=" + encodeURIComponent("" + hrRequestOrganizationUnitsApproverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApprovalLevelCarbonCopyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApprovalLevelCarbonCopyDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApprovalLevelCarbonCopyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApprovalLevelCarbonCopyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApprovalLevelCarbonCopyDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param hrRequestOrganizationUnitsApproverId (optional) 
     * @return Success
     */
    getUsersAssignableAsCarbonCopyByKeyword(keyword: string | undefined, hrRequestOrganizationUnitsApproverId: number | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ApprovalLevelCarbonCopy/GetUsersAssignableAsCarbonCopyByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (hrRequestOrganizationUnitsApproverId === null)
            throw new Error("The parameter 'hrRequestOrganizationUnitsApproverId' cannot be null.");
        else if (hrRequestOrganizationUnitsApproverId !== undefined)
            url_ += "hrRequestOrganizationUnitsApproverId=" + encodeURIComponent("" + hrRequestOrganizationUnitsApproverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersAssignableAsCarbonCopyByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersAssignableAsCarbonCopyByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetUsersAssignableAsCarbonCopyByKeyword(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }
}

@Injectable()
export class AreaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getAreasByKeyword(keyword: string | undefined): Observable<AreaDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetAreasByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAreasByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAreasByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaDto[]>;
        }));
    }

    protected processGetAreasByKeyword(response: HttpResponseBase): Observable<AreaDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AreaDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AreaDto> {
        let url_ = this.baseUrl + "/api/services/app/Area/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AreaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AreaDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param contractName (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, contractName: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AreaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Area/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (contractName === null)
            throw new Error("The parameter 'contractName' cannot be null.");
        else if (contractName !== undefined)
            url_ += "ContractName=" + encodeURIComponent("" + contractName) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AreaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AreaDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: AreaDto | undefined): Observable<AreaDto> {
        let url_ = this.baseUrl + "/api/services/app/Area/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AreaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AreaDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: AreaDto | undefined): Observable<AreaDto> {
        let url_ = this.baseUrl + "/api/services/app/Area/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AreaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AreaDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Area/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AttendanceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAttendanceDto | undefined): Observable<AttendanceDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendance/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAttendanceDto | undefined): Observable<AttendanceDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendance/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceDto>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadExcel(groupId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendance/DownloadExcel?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AttendanceDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendance/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AttendanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceDto>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(groupId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AttendanceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Attendance/GetAll?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AttendanceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AttendanceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AttendanceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AttendanceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AttendanceDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Attendance/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CategoryDictionaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CategoryDictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryDictionary/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDictionaryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CategoryDictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDictionaryDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<CategoryDictionaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryDictionary/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDictionaryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDictionaryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CategoryDictionaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDictionaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDictionaryDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CategoryDictionaryDto | undefined): Observable<CategoryDictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryDictionary/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDictionaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CategoryDictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDictionaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CategoryDictionaryDto | undefined): Observable<CategoryDictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryDictionary/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryDictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryDictionaryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CategoryDictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryDictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CategoryDictionaryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategoryDictionary/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CertificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param id (optional) 
     * @return Success
     */
    getAvailableByKeyword(keyword: string | undefined, id: number | undefined): Observable<CertificationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Certification/GetAvailableByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificationDto[]>;
        }));
    }

    protected processGetAvailableByKeyword(response: HttpResponseBase): Observable<CertificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CertificationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificationDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/Certification/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CertificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificationDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CertificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Certification/GetAll?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CertificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificationDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CertificationDto | undefined): Observable<CertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/Certification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CertificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CertificationDto | undefined): Observable<CertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/Certification/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CertificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CertificationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CertificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CertificationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Certification/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ClockingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkIfRelatedPlanningExist(body: CreateClockingDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Clocking/CheckIfRelatedPlanningExist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfRelatedPlanningExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfRelatedPlanningExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfRelatedPlanningExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateClockingDto | undefined): Observable<ClockingDto> {
        let url_ = this.baseUrl + "/api/services/app/Clocking/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClockingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClockingDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ClockingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClockingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClockingDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateClockingDto | undefined): Observable<ClockingDto> {
        let url_ = this.baseUrl + "/api/services/app/Clocking/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClockingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClockingDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ClockingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClockingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClockingDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Clocking/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param service_Id (optional) 
     * @param group_Id (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadExcel(service_Id: number | undefined, group_Id: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/Clocking/DownloadExcel?";
        if (service_Id === null)
            throw new Error("The parameter 'service_Id' cannot be null.");
        else if (service_Id !== undefined)
            url_ += "Service.Id=" + encodeURIComponent("" + service_Id) + "&";
        if (group_Id === null)
            throw new Error("The parameter 'group_Id' cannot be null.");
        else if (group_Id !== undefined)
            url_ += "Group.Id=" + encodeURIComponent("" + group_Id) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ClockingDto> {
        let url_ = this.baseUrl + "/api/services/app/Clocking/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClockingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClockingDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClockingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClockingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClockingDto>(null as any);
    }

    /**
     * @param service_Id (optional) 
     * @param group_Id (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(service_Id: number | undefined, group_Id: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ClockingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Clocking/GetAll?";
        if (service_Id === null)
            throw new Error("The parameter 'service_Id' cannot be null.");
        else if (service_Id !== undefined)
            url_ += "Service.Id=" + encodeURIComponent("" + service_Id) + "&";
        if (group_Id === null)
            throw new Error("The parameter 'group_Id' cannot be null.");
        else if (group_Id !== undefined)
            url_ += "Group.Id=" + encodeURIComponent("" + group_Id) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClockingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClockingDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ClockingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClockingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ClockingDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class CommitmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CommitmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Commitment/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommitmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommitmentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CommitmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommitmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommitmentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCommitmentDto | undefined): Observable<CommitmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Commitment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommitmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommitmentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CommitmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommitmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommitmentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCommitmentDto | undefined): Observable<CommitmentDto> {
        let url_ = this.baseUrl + "/api/services/app/Commitment/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommitmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommitmentDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CommitmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommitmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommitmentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRemainingAmount(body: RemainingAmountInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Commitment/GetRemainingAmount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRemainingAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRemainingAmount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetRemainingAmount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(costItem: string, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Commitment/Delete?";
        if (costItem === undefined || costItem === null)
            throw new Error("The parameter 'costItem' must be defined and cannot be null.");
        else
            url_ += "CostItem=" + encodeURIComponent("" + costItem) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param commitmentOutputId (optional) 
     * @return Success
     */
    getMaximumOutputQuantity(commitmentOutputId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Commitment/GetMaximumOutputQuantity?";
        if (commitmentOutputId === null)
            throw new Error("The parameter 'commitmentOutputId' cannot be null.");
        else if (commitmentOutputId !== undefined)
            url_ += "commitmentOutputId=" + encodeURIComponent("" + commitmentOutputId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaximumOutputQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaximumOutputQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMaximumOutputQuantity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param commitmentOutputId (optional) 
     * @param receiptOutputId (optional) 
     * @return Success
     */
    getUpdateMaximumOutputQuantity(commitmentOutputId: number | undefined, receiptOutputId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Commitment/GetUpdateMaximumOutputQuantity?";
        if (commitmentOutputId === null)
            throw new Error("The parameter 'commitmentOutputId' cannot be null.");
        else if (commitmentOutputId !== undefined)
            url_ += "commitmentOutputId=" + encodeURIComponent("" + commitmentOutputId) + "&";
        if (receiptOutputId === null)
            throw new Error("The parameter 'receiptOutputId' cannot be null.");
        else if (receiptOutputId !== undefined)
            url_ += "receiptOutputId=" + encodeURIComponent("" + receiptOutputId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpdateMaximumOutputQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpdateMaximumOutputQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUpdateMaximumOutputQuantity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param contractId (optional) 
     * @param activityId (optional) 
     * @param identificationCode (optional) 
     * @param subjectIds (optional) 
     * @param keyword (optional) 
     * @param categoryId (optional) 
     * @param costFrom (optional) 
     * @param costTo (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(contractId: number | undefined, activityId: number | undefined, identificationCode: string | undefined, subjectIds: number[] | undefined, keyword: string | undefined, categoryId: number | undefined, costFrom: number | undefined, costTo: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CommitmentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Commitment/GetAll?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "ContractId=" + encodeURIComponent("" + contractId) + "&";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "ActivityId=" + encodeURIComponent("" + activityId) + "&";
        if (identificationCode === null)
            throw new Error("The parameter 'identificationCode' cannot be null.");
        else if (identificationCode !== undefined)
            url_ += "IdentificationCode=" + encodeURIComponent("" + identificationCode) + "&";
        if (subjectIds === null)
            throw new Error("The parameter 'subjectIds' cannot be null.");
        else if (subjectIds !== undefined)
            subjectIds && subjectIds.forEach(item => { url_ += "SubjectIds=" + encodeURIComponent("" + item) + "&"; });
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "CategoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (costFrom === null)
            throw new Error("The parameter 'costFrom' cannot be null.");
        else if (costFrom !== undefined)
            url_ += "CostFrom=" + encodeURIComponent("" + costFrom) + "&";
        if (costTo === null)
            throw new Error("The parameter 'costTo' cannot be null.");
        else if (costTo !== undefined)
            url_ += "CostTo=" + encodeURIComponent("" + costTo) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommitmentDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommitmentDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CommitmentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommitmentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommitmentDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class CommitmentOutputServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param commitment_Id (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(commitment_Id: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CommitmentOutputDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CommitmentOutput/GetAll?";
        if (commitment_Id === null)
            throw new Error("The parameter 'commitment_Id' cannot be null.");
        else if (commitment_Id !== undefined)
            url_ += "Commitment.Id=" + encodeURIComponent("" + commitment_Id) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommitmentOutputDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommitmentOutputDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CommitmentOutputDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommitmentOutputDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CommitmentOutputDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ContactReportPartialUDSServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateContactReportPartialUDSDto | undefined): Observable<ContactReportPartialUDSDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactReportPartialUDS/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactReportPartialUDSDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactReportPartialUDSDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ContactReportPartialUDSDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactReportPartialUDSDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactReportPartialUDSDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ContactReportPartialUDSDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactReportPartialUDS/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactReportPartialUDSDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactReportPartialUDSDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ContactReportPartialUDSDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactReportPartialUDSDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactReportPartialUDSDto>(null as any);
    }

    /**
     * @param serviceReportId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceReportId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ContactReportPartialUDSDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactReportPartialUDS/GetAll?";
        if (serviceReportId === null)
            throw new Error("The parameter 'serviceReportId' cannot be null.");
        else if (serviceReportId !== undefined)
            url_ += "ServiceReportId=" + encodeURIComponent("" + serviceReportId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactReportPartialUDSDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactReportPartialUDSDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ContactReportPartialUDSDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactReportPartialUDSDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactReportPartialUDSDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ContactReportPartialUDSDto | undefined): Observable<ContactReportPartialUDSDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactReportPartialUDS/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactReportPartialUDSDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactReportPartialUDSDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ContactReportPartialUDSDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactReportPartialUDSDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactReportPartialUDSDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ContactReportPartialUDS/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ContactReportPartialWithClassesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateContactReportPartialWithClassesDto | undefined): Observable<ContactReportPartialWithClassesDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactReportPartialWithClasses/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactReportPartialWithClassesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactReportPartialWithClassesDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ContactReportPartialWithClassesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactReportPartialWithClassesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactReportPartialWithClassesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ContactReportPartialWithClassesDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactReportPartialWithClasses/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactReportPartialWithClassesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactReportPartialWithClassesDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ContactReportPartialWithClassesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactReportPartialWithClassesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactReportPartialWithClassesDto>(null as any);
    }

    /**
     * @param serviceReportId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceReportId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ContactReportPartialWithClassesDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactReportPartialWithClasses/GetAll?";
        if (serviceReportId === null)
            throw new Error("The parameter 'serviceReportId' cannot be null.");
        else if (serviceReportId !== undefined)
            url_ += "ServiceReportId=" + encodeURIComponent("" + serviceReportId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactReportPartialWithClassesDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactReportPartialWithClassesDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ContactReportPartialWithClassesDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactReportPartialWithClassesDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactReportPartialWithClassesDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ContactReportPartialWithClassesDto | undefined): Observable<ContactReportPartialWithClassesDto> {
        let url_ = this.baseUrl + "/api/services/app/ContactReportPartialWithClasses/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContactReportPartialWithClassesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContactReportPartialWithClassesDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ContactReportPartialWithClassesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactReportPartialWithClassesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContactReportPartialWithClassesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ContactReportPartialWithClasses/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ContractServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ContractDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateContractDto | undefined): Observable<ContractDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ContractDto | undefined): Observable<ContractDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractDto>(null as any);
    }

    /**
     * @param title (optional) 
     * @param id (optional) 
     * @return Success
     */
    delete(title: string | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Contract/Delete?";
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getAllByKeyword(keyword: string | undefined): Observable<ContractDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetAllByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDto[]>;
        }));
    }

    protected processGetAllByKeyword(response: HttpResponseBase): Observable<ContractDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContractDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getMinimumAmount(id: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetMinimumAmount?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMinimumAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMinimumAmount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetMinimumAmount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActivitiesAmountSum(id: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetActivitiesAmountSum?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivitiesAmountSum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivitiesAmountSum(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetActivitiesAmountSum(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param id (optional) 
     * @param activityId (optional) 
     * @return Success
     */
    getUpdateActivitiesAmountSum(id: number | undefined, activityId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetUpdateActivitiesAmountSum?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (activityId === null)
            throw new Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUpdateActivitiesAmountSum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpdateActivitiesAmountSum(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUpdateActivitiesAmountSum(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param customerLeader (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, customerLeader: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ContractDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Contract/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (customerLeader === null)
            throw new Error("The parameter 'customerLeader' cannot be null.");
        else if (customerLeader !== undefined)
            url_ += "CustomerLeader=" + encodeURIComponent("" + customerLeader) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ContractDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ContractFileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ContractFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ContractPartnerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param contractId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(contractId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ContractPartnerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ContractPartner/GetAll?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "ContractId=" + encodeURIComponent("" + contractId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractPartnerDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractPartnerDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ContractPartnerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractPartnerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractPartnerDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ContractTypeDictionaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ContractTypeDictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ContractTypeDictionary/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractTypeDictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractTypeDictionaryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ContractTypeDictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractTypeDictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractTypeDictionaryDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ContractTypeDictionaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ContractTypeDictionary/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractTypeDictionaryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractTypeDictionaryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ContractTypeDictionaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractTypeDictionaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractTypeDictionaryDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ContractTypeDictionaryDto | undefined): Observable<ContractTypeDictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ContractTypeDictionary/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractTypeDictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractTypeDictionaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ContractTypeDictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractTypeDictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractTypeDictionaryDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ContractTypeDictionaryDto | undefined): Observable<ContractTypeDictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ContractTypeDictionary/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractTypeDictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractTypeDictionaryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ContractTypeDictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractTypeDictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ContractTypeDictionaryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ContractTypeDictionary/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCustomerDto | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CustomerDto | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getAllNotPaginated(keyword: string | undefined): Observable<CustomerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetAllNotPaginated?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNotPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNotPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto[]>;
        }));
    }

    protected processGetAllNotPaginated(response: HttpResponseBase): Observable<CustomerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CustomerDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param fiscalCode (optional) 
     * @param vATCode (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, fiscalCode: string | undefined, vATCode: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Customer/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (fiscalCode === null)
            throw new Error("The parameter 'fiscalCode' cannot be null.");
        else if (fiscalCode !== undefined)
            url_ += "FiscalCode=" + encodeURIComponent("" + fiscalCode) + "&";
        if (vATCode === null)
            throw new Error("The parameter 'vATCode' cannot be null.");
        else if (vATCode !== undefined)
            url_ += "VATCode=" + encodeURIComponent("" + vATCode) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CustomerDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class DuePaycheckServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DuePaycheckDto> {
        let url_ = this.baseUrl + "/api/services/app/DuePaycheck/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DuePaycheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DuePaycheckDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DuePaycheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DuePaycheckDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DuePaycheckDto>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    import(file: FileParameter | undefined): Observable<FailedRowImportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DuePaycheck/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FailedRowImportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FailedRowImportDto[]>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<FailedRowImportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FailedRowImportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FailedRowImportDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDuePaycheckDto | undefined): Observable<DuePaycheckDto> {
        let url_ = this.baseUrl + "/api/services/app/DuePaycheck/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DuePaycheckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DuePaycheckDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DuePaycheckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DuePaycheckDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DuePaycheckDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param name (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaid (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, name: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, isPaid: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DuePaycheckDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DuePaycheck/GetAll?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (isPaid === null)
            throw new Error("The parameter 'isPaid' cannot be null.");
        else if (isPaid !== undefined)
            url_ += "IsPaid=" + encodeURIComponent("" + isPaid) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DuePaycheckDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DuePaycheckDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DuePaycheckDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DuePaycheckDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DuePaycheckDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class DuePaycheckFileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param fiscalCode (optional) 
     * @param name (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param duePaycheckId (optional) 
     * @param isRead (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(fiscalCode: string | undefined, name: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, duePaycheckId: number | undefined, isRead: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DuePaycheckFileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DuePaycheckFile/GetAll?";
        if (fiscalCode === null)
            throw new Error("The parameter 'fiscalCode' cannot be null.");
        else if (fiscalCode !== undefined)
            url_ += "FiscalCode=" + encodeURIComponent("" + fiscalCode) + "&";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (duePaycheckId === null)
            throw new Error("The parameter 'duePaycheckId' cannot be null.");
        else if (duePaycheckId !== undefined)
            url_ += "DuePaycheckId=" + encodeURIComponent("" + duePaycheckId) + "&";
        if (isRead === null)
            throw new Error("The parameter 'isRead' cannot be null.");
        else if (isRead !== undefined)
            url_ += "IsRead=" + encodeURIComponent("" + isRead) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DuePaycheckFileDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DuePaycheckFileDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DuePaycheckFileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DuePaycheckFileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DuePaycheckFileDtoPagedResultDto>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    uploadPaycheckFile(file: FileParameter | undefined): Observable<FailedRowImportDto> {
        let url_ = this.baseUrl + "/api/services/app/DuePaycheckFile/UploadPaycheckFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadPaycheckFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadPaycheckFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FailedRowImportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FailedRowImportDto>;
        }));
    }

    protected processUploadPaycheckFile(response: HttpResponseBase): Observable<FailedRowImportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FailedRowImportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FailedRowImportDto>(null as any);
    }
}

@Injectable()
export class EducationalDegreeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param id (optional) 
     * @return Success
     */
    getAvailableByKeyword(keyword: string | undefined, id: number | undefined): Observable<EducationalDegreeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EducationalDegree/GetAvailableByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationalDegreeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationalDegreeDto[]>;
        }));
    }

    protected processGetAvailableByKeyword(response: HttpResponseBase): Observable<EducationalDegreeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EducationalDegreeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EducationalDegreeDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<EducationalDegreeDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationalDegree/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationalDegreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationalDegreeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EducationalDegreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalDegreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EducationalDegreeDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EducationalDegreeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationalDegree/GetAll?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationalDegreeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationalDegreeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EducationalDegreeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalDegreeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EducationalDegreeDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: EducationalDegreeDto | undefined): Observable<EducationalDegreeDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationalDegree/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationalDegreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationalDegreeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EducationalDegreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalDegreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EducationalDegreeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: EducationalDegreeDto | undefined): Observable<EducationalDegreeDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationalDegree/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationalDegreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationalDegreeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EducationalDegreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalDegreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EducationalDegreeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EducationalDegree/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class EducationalDegreeLevelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAll(): Observable<EducationalDegreeLevelDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EducationalDegreeLevel/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationalDegreeLevelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationalDegreeLevelDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EducationalDegreeLevelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EducationalDegreeLevelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EducationalDegreeLevelDto[]>(null as any);
    }
}

@Injectable()
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(body: PagedAndSortedFileResultRequestDto | undefined): Observable<FileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDtoPagedResultDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    getAssociatedEntities(fileId: number | undefined): Observable<FileAssociatedEntitiesDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetAssociatedEntities?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssociatedEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssociatedEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileAssociatedEntitiesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileAssociatedEntitiesDto>;
        }));
    }

    protected processGetAssociatedEntities(response: HttpResponseBase): Observable<FileAssociatedEntitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileAssociatedEntitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileAssociatedEntitiesDto>(null as any);
    }

    /**
     * @return Success
     */
    getUploadFileRequest(): Observable<UploadFileRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetUploadFileRequest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUploadFileRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUploadFileRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadFileRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadFileRequestDto>;
        }));
    }

    protected processGetUploadFileRequest(response: HttpResponseBase): Observable<UploadFileRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadFileRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadFileRequestDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateFileDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param file (optional) 
     * @param fileTypeId (optional) 
     * @param expirationDate (optional) 
     * @param associatedFileEntitiesIds_ServiceIdDVR (optional) 
     * @param associatedFileEntitiesIds_ServicesId (optional) 
     * @param associatedFileEntitiesIds_UserIds (optional) 
     * @param associatedFileEntitiesIds_ContractIds (optional) 
     * @param associatedFileEntitiesIds_HRRequestIds (optional) 
     * @param associatedFileEntitiesIds_ActivityIds (optional) 
     * @param associatedFileEntitiesIds_CommitmentIds (optional) 
     * @param associatedFileEntitiesIds_UserParentId (optional) 
     * @return Success
     */
    uploadFile(file: FileParameter | undefined, fileTypeId: number | undefined, expirationDate: string | undefined, associatedFileEntitiesIds_ServiceIdDVR: number | undefined, associatedFileEntitiesIds_ServicesId: number[] | undefined, associatedFileEntitiesIds_UserIds: number[] | undefined, associatedFileEntitiesIds_ContractIds: number[] | undefined, associatedFileEntitiesIds_HRRequestIds: number[] | undefined, associatedFileEntitiesIds_ActivityIds: number[] | undefined, associatedFileEntitiesIds_CommitmentIds: number[] | undefined, associatedFileEntitiesIds_UserParentId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/UploadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (fileTypeId === null || fileTypeId === undefined)
            throw new Error("The parameter 'fileTypeId' cannot be null.");
        else
            content_.append("FileTypeId", fileTypeId.toString());
        if (expirationDate === null || expirationDate === undefined)
            throw new Error("The parameter 'expirationDate' cannot be null.");
        else
            content_.append("ExpirationDate", expirationDate.toString());
        if (associatedFileEntitiesIds_ServiceIdDVR === null || associatedFileEntitiesIds_ServiceIdDVR === undefined)
            throw new Error("The parameter 'associatedFileEntitiesIds_ServiceIdDVR' cannot be null.");
        else
            content_.append("AssociatedFileEntitiesIds.ServiceIdDVR", associatedFileEntitiesIds_ServiceIdDVR.toString());
        if (associatedFileEntitiesIds_ServicesId === null || associatedFileEntitiesIds_ServicesId === undefined)
            throw new Error("The parameter 'associatedFileEntitiesIds_ServicesId' cannot be null.");
        else
            associatedFileEntitiesIds_ServicesId.forEach(item_ => content_.append("AssociatedFileEntitiesIds.ServicesId", item_.toString()));
        if (associatedFileEntitiesIds_UserIds === null || associatedFileEntitiesIds_UserIds === undefined)
            throw new Error("The parameter 'associatedFileEntitiesIds_UserIds' cannot be null.");
        else
            associatedFileEntitiesIds_UserIds.forEach(item_ => content_.append("AssociatedFileEntitiesIds.UserIds", item_.toString()));
        if (associatedFileEntitiesIds_ContractIds === null || associatedFileEntitiesIds_ContractIds === undefined)
            throw new Error("The parameter 'associatedFileEntitiesIds_ContractIds' cannot be null.");
        else
            associatedFileEntitiesIds_ContractIds.forEach(item_ => content_.append("AssociatedFileEntitiesIds.ContractIds", item_.toString()));
        if (associatedFileEntitiesIds_HRRequestIds === null || associatedFileEntitiesIds_HRRequestIds === undefined)
            throw new Error("The parameter 'associatedFileEntitiesIds_HRRequestIds' cannot be null.");
        else
            associatedFileEntitiesIds_HRRequestIds.forEach(item_ => content_.append("AssociatedFileEntitiesIds.HRRequestIds", item_.toString()));
        if (associatedFileEntitiesIds_ActivityIds === null || associatedFileEntitiesIds_ActivityIds === undefined)
            throw new Error("The parameter 'associatedFileEntitiesIds_ActivityIds' cannot be null.");
        else
            associatedFileEntitiesIds_ActivityIds.forEach(item_ => content_.append("AssociatedFileEntitiesIds.ActivityIds", item_.toString()));
        if (associatedFileEntitiesIds_CommitmentIds === null || associatedFileEntitiesIds_CommitmentIds === undefined)
            throw new Error("The parameter 'associatedFileEntitiesIds_CommitmentIds' cannot be null.");
        else
            associatedFileEntitiesIds_CommitmentIds.forEach(item_ => content_.append("AssociatedFileEntitiesIds.CommitmentIds", item_.toString()));
        if (associatedFileEntitiesIds_UserParentId === null || associatedFileEntitiesIds_UserParentId === undefined)
            throw new Error("The parameter 'associatedFileEntitiesIds_UserParentId' cannot be null.");
        else
            content_.append("AssociatedFileEntitiesIds.UserParentId", associatedFileEntitiesIds_UserParentId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processUploadFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    downloadFile(fileId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/File/DownloadFile?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDownloadDto>(null as any);
    }

    /**
     * @param fileId (optional) 
     * @param body (optional) 
     * @return Success
     */
    createFileAssociations(fileId: number | undefined, body: AssociatedFileEntitiesIdsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/File/CreateFileAssociations?";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFileAssociations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFileAssociations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateFileAssociations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getFiltersFileAssociation(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/File/GetFiltersFileAssociation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiltersFileAssociation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiltersFileAssociation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetFiltersFileAssociation(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }

    /**
     * @param filters (optional) 
     * @param keyword (optional) 
     * @param maxElementsSuggestion (optional) 
     * @param maxElementsSearch (optional) 
     * @param fileId (optional) 
     * @return Success
     */
    getSuggestionEntities(filters: string[] | undefined, keyword: string | undefined, maxElementsSuggestion: number | undefined, maxElementsSearch: number | undefined, fileId: number | undefined): Observable<SuggestionEntitiesDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetSuggestionEntities?";
        if (filters === null)
            throw new Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            filters && filters.forEach(item => { url_ += "filters=" + encodeURIComponent("" + item) + "&"; });
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (maxElementsSuggestion === null)
            throw new Error("The parameter 'maxElementsSuggestion' cannot be null.");
        else if (maxElementsSuggestion !== undefined)
            url_ += "maxElementsSuggestion=" + encodeURIComponent("" + maxElementsSuggestion) + "&";
        if (maxElementsSearch === null)
            throw new Error("The parameter 'maxElementsSearch' cannot be null.");
        else if (maxElementsSearch !== undefined)
            url_ += "maxElementsSearch=" + encodeURIComponent("" + maxElementsSearch) + "&";
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSuggestionEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSuggestionEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SuggestionEntitiesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SuggestionEntitiesDto>;
        }));
    }

    protected processGetSuggestionEntities(response: HttpResponseBase): Observable<SuggestionEntitiesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SuggestionEntitiesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SuggestionEntitiesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/File/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateFileDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }
}

@Injectable()
export class FileTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getByKeyword(keyword: string | undefined): Observable<FileTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FileType/GetByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileTypeDto[]>;
        }));
    }

    protected processGetByKeyword(response: HttpResponseBase): Observable<FileTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileTypeDto[]>(null as any);
    }
}

@Injectable()
export class GroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param groupId (optional) 
     * @return Success
     */
    getWithUserList(groupId: number | undefined): Observable<GroupUsersDto> {
        let url_ = this.baseUrl + "/api/services/app/Group/GetWithUserList?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWithUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWithUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupUsersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupUsersDto>;
        }));
    }

    protected processGetWithUserList(response: HttpResponseBase): Observable<GroupUsersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupUsersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupUsersDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateGroupDto | undefined): Observable<GroupDto> {
        let url_ = this.baseUrl + "/api/services/app/Group/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<GroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Group/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CreateGroupDto | undefined): Observable<GroupDto> {
        let url_ = this.baseUrl + "/api/services/app/Group/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<GroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GroupDto> {
        let url_ = this.baseUrl + "/api/services/app/Group/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<GroupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Group/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GroupDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GroupDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<GroupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GroupDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class HRRequestServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHRRequestDto | undefined): Observable<HRRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HRRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHRRequestDto | undefined): Observable<HRRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HRRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveReject(body: CreateHRRequestApprovalFlowDto | undefined): Observable<HRRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/ApproveReject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApproveReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApproveReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestDto>;
        }));
    }

    protected processApproveReject(response: HttpResponseBase): Observable<HRRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestDto>(null as any);
    }

    /**
     * @param hrRequestId (optional) 
     * @return Success
     */
    checkIfHRRequestHaveSomeApprover(hrRequestId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/CheckIfHRRequestHaveSomeApprover?";
        if (hrRequestId === null)
            throw new Error("The parameter 'hrRequestId' cannot be null.");
        else if (hrRequestId !== undefined)
            url_ += "hrRequestId=" + encodeURIComponent("" + hrRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfHRRequestHaveSomeApprover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfHRRequestHaveSomeApprover(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfHRRequestHaveSomeApprover(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param hrRequestId (optional) 
     * @param hrRequestOrganizationUnitsApproverId (optional) 
     * @return Success
     */
    getIfApproverIsEnabledForApproveRejectApprovationHRRequest(hrRequestId: number | undefined, hrRequestOrganizationUnitsApproverId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetIfApproverIsEnabledForApproveRejectApprovationHRRequest?";
        if (hrRequestId === null)
            throw new Error("The parameter 'hrRequestId' cannot be null.");
        else if (hrRequestId !== undefined)
            url_ += "hrRequestId=" + encodeURIComponent("" + hrRequestId) + "&";
        if (hrRequestOrganizationUnitsApproverId === null)
            throw new Error("The parameter 'hrRequestOrganizationUnitsApproverId' cannot be null.");
        else if (hrRequestOrganizationUnitsApproverId !== undefined)
            url_ += "hrRequestOrganizationUnitsApproverId=" + encodeURIComponent("" + hrRequestOrganizationUnitsApproverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIfApproverIsEnabledForApproveRejectApprovationHRRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIfApproverIsEnabledForApproveRejectApprovationHRRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetIfApproverIsEnabledForApproveRejectApprovationHRRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param hrRequestId (optional) 
     * @param hrRequestOrganizationUnitsApproverId (optional) 
     * @return Success
     */
    getIfApproverIsEnabledForApproveRejectCancellationHRRequest(hrRequestId: number | undefined, hrRequestOrganizationUnitsApproverId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetIfApproverIsEnabledForApproveRejectCancellationHRRequest?";
        if (hrRequestId === null)
            throw new Error("The parameter 'hrRequestId' cannot be null.");
        else if (hrRequestId !== undefined)
            url_ += "hrRequestId=" + encodeURIComponent("" + hrRequestId) + "&";
        if (hrRequestOrganizationUnitsApproverId === null)
            throw new Error("The parameter 'hrRequestOrganizationUnitsApproverId' cannot be null.");
        else if (hrRequestOrganizationUnitsApproverId !== undefined)
            url_ += "hrRequestOrganizationUnitsApproverId=" + encodeURIComponent("" + hrRequestOrganizationUnitsApproverId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIfApproverIsEnabledForApproveRejectCancellationHRRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIfApproverIsEnabledForApproveRejectCancellationHRRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetIfApproverIsEnabledForApproveRejectCancellationHRRequest(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param hrRequestId (optional) 
     * @return Success
     */
    getApprovedHRRequest(hrRequestId: number | undefined): Observable<HRRequestApproverDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetApprovedHRRequest?";
        if (hrRequestId === null)
            throw new Error("The parameter 'hrRequestId' cannot be null.");
        else if (hrRequestId !== undefined)
            url_ += "hrRequestId=" + encodeURIComponent("" + hrRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApprovedHRRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApprovedHRRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestApproverDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestApproverDto[]>;
        }));
    }

    protected processGetApprovedHRRequest(response: HttpResponseBase): Observable<HRRequestApproverDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HRRequestApproverDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestApproverDto[]>(null as any);
    }

    /**
     * @param hrRequestId (optional) 
     * @return Success
     */
    getHRRequestApprovalFlow(hrRequestId: number | undefined): Observable<HRRequestApproverDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetHRRequestApprovalFlow?";
        if (hrRequestId === null)
            throw new Error("The parameter 'hrRequestId' cannot be null.");
        else if (hrRequestId !== undefined)
            url_ += "hrRequestId=" + encodeURIComponent("" + hrRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHRRequestApprovalFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHRRequestApprovalFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestApproverDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestApproverDto[]>;
        }));
    }

    protected processGetHRRequestApprovalFlow(response: HttpResponseBase): Observable<HRRequestApproverDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HRRequestApproverDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestApproverDto[]>(null as any);
    }

    /**
     * @param hrRequestId (optional) 
     * @return Success
     */
    getHRRequestCancellationFlow(hrRequestId: number | undefined): Observable<HRRequestApproverDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetHRRequestCancellationFlow?";
        if (hrRequestId === null)
            throw new Error("The parameter 'hrRequestId' cannot be null.");
        else if (hrRequestId !== undefined)
            url_ += "hrRequestId=" + encodeURIComponent("" + hrRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHRRequestCancellationFlow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHRRequestCancellationFlow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestApproverDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestApproverDto[]>;
        }));
    }

    protected processGetHRRequestCancellationFlow(response: HttpResponseBase): Observable<HRRequestApproverDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HRRequestApproverDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestApproverDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getHRRequestTypes(): Observable<HRRequestTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetHRRequestTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHRRequestTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHRRequestTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestTypeDto[]>;
        }));
    }

    protected processGetHRRequestTypes(response: HttpResponseBase): Observable<HRRequestTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HRRequestTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestTypeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getHRRequestStates(): Observable<HRRequestStateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetHRRequestStates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHRRequestStates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHRRequestStates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestStateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestStateDto[]>;
        }));
    }

    protected processGetHRRequestStates(response: HttpResponseBase): Observable<HRRequestStateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HRRequestStateDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestStateDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getCurrencyTypes(): Observable<CurrencyTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetCurrencyTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrencyTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrencyTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrencyTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrencyTypeDto[]>;
        }));
    }

    protected processGetCurrencyTypes(response: HttpResponseBase): Observable<CurrencyTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CurrencyTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CurrencyTypeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPurchaseTypes(): Observable<PurchaseTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetPurchaseTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchaseTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseTypeDto[]>;
        }));
    }

    protected processGetPurchaseTypes(response: HttpResponseBase): Observable<PurchaseTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PurchaseTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseTypeDto[]>(null as any);
    }

    /**
     * @return Success
     */
    getPaymentTypes(): Observable<PaymentTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetPaymentTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentTypeDto[]>;
        }));
    }

    protected processGetPaymentTypes(response: HttpResponseBase): Observable<PaymentTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentTypeDto[]>(null as any);
    }

    /**
     * @param purchase (optional) 
     * @return Success
     */
    getPurchaseType(purchase: number | undefined): Observable<PurchaseTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetPurchaseType?";
        if (purchase === null)
            throw new Error("The parameter 'purchase' cannot be null.");
        else if (purchase !== undefined)
            url_ += "purchase=" + encodeURIComponent("" + purchase) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPurchaseType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPurchaseType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PurchaseTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PurchaseTypeDto>;
        }));
    }

    protected processGetPurchaseType(response: HttpResponseBase): Observable<PurchaseTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PurchaseTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PurchaseTypeDto>(null as any);
    }

    /**
     * @param payment (optional) 
     * @return Success
     */
    getPaymentType(payment: number | undefined): Observable<PaymentTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetPaymentType?";
        if (payment === null)
            throw new Error("The parameter 'payment' cannot be null.");
        else if (payment !== undefined)
            url_ += "payment=" + encodeURIComponent("" + payment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentTypeDto>;
        }));
    }

    protected processGetPaymentType(response: HttpResponseBase): Observable<PaymentTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PaymentTypeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createSupplyingObject(body: CreatedHRRequestAndSupplyingObjectDto | undefined): Observable<HRRequestSupplyingObject> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/CreateSupplyingObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSupplyingObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSupplyingObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestSupplyingObject>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestSupplyingObject>;
        }));
    }

    protected processCreateSupplyingObject(response: HttpResponseBase): Observable<HRRequestSupplyingObject> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestSupplyingObject.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestSupplyingObject>(null as any);
    }

    /**
     * @param hrRequestId (optional) 
     * @param hrRequestSupplyingObjectId (optional) 
     * @return Success
     */
    deleteSupplyingObject(hrRequestId: number | undefined, hrRequestSupplyingObjectId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/DeleteSupplyingObject?";
        if (hrRequestId === null)
            throw new Error("The parameter 'hrRequestId' cannot be null.");
        else if (hrRequestId !== undefined)
            url_ += "hrRequestId=" + encodeURIComponent("" + hrRequestId) + "&";
        if (hrRequestSupplyingObjectId === null)
            throw new Error("The parameter 'hrRequestSupplyingObjectId' cannot be null.");
        else if (hrRequestSupplyingObjectId !== undefined)
            url_ += "hrRequestSupplyingObjectId=" + encodeURIComponent("" + hrRequestSupplyingObjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSupplyingObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSupplyingObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSupplyingObject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param hrRequestId (optional) 
     * @return Success
     */
    saveSupplyingRequest(hrRequestId: number | undefined): Observable<HRRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/SaveSupplyingRequest?";
        if (hrRequestId === null)
            throw new Error("The parameter 'hrRequestId' cannot be null.");
        else if (hrRequestId !== undefined)
            url_ += "hrRequestId=" + encodeURIComponent("" + hrRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSupplyingRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSupplyingRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestDto>;
        }));
    }

    protected processSaveSupplyingRequest(response: HttpResponseBase): Observable<HRRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    startProcessCancellationRequest(id: number | undefined): Observable<HRRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/StartProcessCancellationRequest?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartProcessCancellationRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartProcessCancellationRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestDto>;
        }));
    }

    protected processStartProcessCancellationRequest(response: HttpResponseBase): Observable<HRRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateSupplyingObject(body: HRRequestSupplyingObjectDto | undefined): Observable<HRRequestSupplyingObject> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/UpdateSupplyingObject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSupplyingObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSupplyingObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestSupplyingObject>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestSupplyingObject>;
        }));
    }

    protected processUpdateSupplyingObject(response: HttpResponseBase): Observable<HRRequestSupplyingObject> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestSupplyingObject.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestSupplyingObject>(null as any);
    }

    /**
     * @param hrRequestId (optional) 
     * @return Success
     */
    getHRRequestSupplyingObject(hrRequestId: number | undefined): Observable<HRRequestSupplyingObjectDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetHRRequestSupplyingObject?";
        if (hrRequestId === null)
            throw new Error("The parameter 'hrRequestId' cannot be null.");
        else if (hrRequestId !== undefined)
            url_ += "hrRequestId=" + encodeURIComponent("" + hrRequestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHRRequestSupplyingObject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHRRequestSupplyingObject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestSupplyingObjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestSupplyingObjectDto[]>;
        }));
    }

    protected processGetHRRequestSupplyingObject(response: HttpResponseBase): Observable<HRRequestSupplyingObjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HRRequestSupplyingObjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestSupplyingObjectDto[]>(null as any);
    }

    /**
     * @param hrRequestId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getSupplyingObjectsByHrRequestId(hrRequestId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HRRequestSupplyingObjectDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetSupplyingObjectsByHrRequestId?";
        if (hrRequestId === null)
            throw new Error("The parameter 'hrRequestId' cannot be null.");
        else if (hrRequestId !== undefined)
            url_ += "HrRequestId=" + encodeURIComponent("" + hrRequestId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplyingObjectsByHrRequestId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplyingObjectsByHrRequestId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestSupplyingObjectDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestSupplyingObjectDtoPagedResultDto>;
        }));
    }

    protected processGetSupplyingObjectsByHrRequestId(response: HttpResponseBase): Observable<HRRequestSupplyingObjectDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestSupplyingObjectDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestSupplyingObjectDtoPagedResultDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param hRRequestTypeId (optional) 
     * @param hRRequestStateId (optional) 
     * @param approverId (optional) 
     * @param organizationUnitId (optional) 
     * @param startDateIntervalStart (optional) 
     * @param startDateIntervalEnd (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadExcel(keyword: string | undefined, hRRequestTypeId: number | undefined, hRRequestStateId: number | undefined, approverId: number | undefined, organizationUnitId: number | undefined, startDateIntervalStart: moment.Moment | undefined, startDateIntervalEnd: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/DownloadExcel?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (hRRequestTypeId === null)
            throw new Error("The parameter 'hRRequestTypeId' cannot be null.");
        else if (hRRequestTypeId !== undefined)
            url_ += "HRRequestTypeId=" + encodeURIComponent("" + hRRequestTypeId) + "&";
        if (hRRequestStateId === null)
            throw new Error("The parameter 'hRRequestStateId' cannot be null.");
        else if (hRRequestStateId !== undefined)
            url_ += "HRRequestStateId=" + encodeURIComponent("" + hRRequestStateId) + "&";
        if (approverId === null)
            throw new Error("The parameter 'approverId' cannot be null.");
        else if (approverId !== undefined)
            url_ += "ApproverId=" + encodeURIComponent("" + approverId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        if (startDateIntervalStart === null)
            throw new Error("The parameter 'startDateIntervalStart' cannot be null.");
        else if (startDateIntervalStart !== undefined)
            url_ += "StartDateIntervalStart=" + encodeURIComponent(startDateIntervalStart ? "" + startDateIntervalStart.toISOString() : "") + "&";
        if (startDateIntervalEnd === null)
            throw new Error("The parameter 'startDateIntervalEnd' cannot be null.");
        else if (startDateIntervalEnd !== undefined)
            url_ += "StartDateIntervalEnd=" + encodeURIComponent(startDateIntervalEnd ? "" + startDateIntervalEnd.toISOString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HRRequestDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HRRequestDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param hRRequestTypeId (optional) 
     * @param hRRequestStateId (optional) 
     * @param approverId (optional) 
     * @param organizationUnitId (optional) 
     * @param startDateIntervalStart (optional) 
     * @param startDateIntervalEnd (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, hRRequestTypeId: number | undefined, hRRequestStateId: number | undefined, approverId: number | undefined, organizationUnitId: number | undefined, startDateIntervalStart: moment.Moment | undefined, startDateIntervalEnd: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HRRequestDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequest/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (hRRequestTypeId === null)
            throw new Error("The parameter 'hRRequestTypeId' cannot be null.");
        else if (hRRequestTypeId !== undefined)
            url_ += "HRRequestTypeId=" + encodeURIComponent("" + hRRequestTypeId) + "&";
        if (hRRequestStateId === null)
            throw new Error("The parameter 'hRRequestStateId' cannot be null.");
        else if (hRRequestStateId !== undefined)
            url_ += "HRRequestStateId=" + encodeURIComponent("" + hRRequestStateId) + "&";
        if (approverId === null)
            throw new Error("The parameter 'approverId' cannot be null.");
        else if (approverId !== undefined)
            url_ += "ApproverId=" + encodeURIComponent("" + approverId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        if (startDateIntervalStart === null)
            throw new Error("The parameter 'startDateIntervalStart' cannot be null.");
        else if (startDateIntervalStart !== undefined)
            url_ += "StartDateIntervalStart=" + encodeURIComponent(startDateIntervalStart ? "" + startDateIntervalStart.toISOString() : "") + "&";
        if (startDateIntervalEnd === null)
            throw new Error("The parameter 'startDateIntervalEnd' cannot be null.");
        else if (startDateIntervalEnd !== undefined)
            url_ += "StartDateIntervalEnd=" + encodeURIComponent(startDateIntervalEnd ? "" + startDateIntervalEnd.toISOString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HRRequestDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class HRRequestOrganizationUnitsApproverServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHRRequestOrganizationUnitsApproverDto | undefined): Observable<HRRequestOrganizationUnitsApproverDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestOrganizationUnitsApprover/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestOrganizationUnitsApproverDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestOrganizationUnitsApproverDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HRRequestOrganizationUnitsApproverDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestOrganizationUnitsApproverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestOrganizationUnitsApproverDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: HRRequestOrganizationUnitsApproverDto | undefined): Observable<HRRequestOrganizationUnitsApproverDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestOrganizationUnitsApprover/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestOrganizationUnitsApproverDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestOrganizationUnitsApproverDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HRRequestOrganizationUnitsApproverDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestOrganizationUnitsApproverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestOrganizationUnitsApproverDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestOrganizationUnitsApprover/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param hrRequestTypeOrganizationUnitId (optional) 
     * @return Success
     */
    getAllByHRRequestTypeOrganizationUnitId(hrRequestTypeOrganizationUnitId: number | undefined): Observable<HRRequestOrganizationUnitsApproverDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestOrganizationUnitsApprover/GetAllByHRRequestTypeOrganizationUnitId?";
        if (hrRequestTypeOrganizationUnitId === null)
            throw new Error("The parameter 'hrRequestTypeOrganizationUnitId' cannot be null.");
        else if (hrRequestTypeOrganizationUnitId !== undefined)
            url_ += "hrRequestTypeOrganizationUnitId=" + encodeURIComponent("" + hrRequestTypeOrganizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByHRRequestTypeOrganizationUnitId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByHRRequestTypeOrganizationUnitId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestOrganizationUnitsApproverDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestOrganizationUnitsApproverDto[]>;
        }));
    }

    protected processGetAllByHRRequestTypeOrganizationUnitId(response: HttpResponseBase): Observable<HRRequestOrganizationUnitsApproverDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HRRequestOrganizationUnitsApproverDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestOrganizationUnitsApproverDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param hrRequestTypeOrganizationUnitId (optional) 
     * @return Success
     */
    getUsersAssignableAsApproverByKeyword(keyword: string | undefined, hrRequestTypeOrganizationUnitId: number | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestOrganizationUnitsApprover/GetUsersAssignableAsApproverByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (hrRequestTypeOrganizationUnitId === null)
            throw new Error("The parameter 'hrRequestTypeOrganizationUnitId' cannot be null.");
        else if (hrRequestTypeOrganizationUnitId !== undefined)
            url_ += "hrRequestTypeOrganizationUnitId=" + encodeURIComponent("" + hrRequestTypeOrganizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersAssignableAsApproverByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersAssignableAsApproverByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetUsersAssignableAsApproverByKeyword(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HRRequestOrganizationUnitsApproverDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestOrganizationUnitsApprover/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestOrganizationUnitsApproverDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestOrganizationUnitsApproverDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HRRequestOrganizationUnitsApproverDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestOrganizationUnitsApproverDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestOrganizationUnitsApproverDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<HRRequestOrganizationUnitsApproverDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestOrganizationUnitsApprover/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestOrganizationUnitsApproverDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestOrganizationUnitsApproverDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HRRequestOrganizationUnitsApproverDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestOrganizationUnitsApproverDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestOrganizationUnitsApproverDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class HRRequestTypeOrganizationUnitsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: HRRequestTypeOrganizationUnitsDto | undefined): Observable<HRRequestTypeOrganizationUnitsDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestTypeOrganizationUnits/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestTypeOrganizationUnitsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestTypeOrganizationUnitsDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HRRequestTypeOrganizationUnitsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestTypeOrganizationUnitsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestTypeOrganizationUnitsDto>(null as any);
    }

    /**
     * @param hrRequestTypeId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    checkIfHRRequestTypeOrganizationUnitExist(hrRequestTypeId: number | undefined, organizationUnitId: number | undefined): Observable<HRRequestTypeOrganizationUnitsDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestTypeOrganizationUnits/CheckIfHRRequestTypeOrganizationUnitExist?";
        if (hrRequestTypeId === null)
            throw new Error("The parameter 'hrRequestTypeId' cannot be null.");
        else if (hrRequestTypeId !== undefined)
            url_ += "hrRequestTypeId=" + encodeURIComponent("" + hrRequestTypeId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfHRRequestTypeOrganizationUnitExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfHRRequestTypeOrganizationUnitExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestTypeOrganizationUnitsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestTypeOrganizationUnitsDto>;
        }));
    }

    protected processCheckIfHRRequestTypeOrganizationUnitExist(response: HttpResponseBase): Observable<HRRequestTypeOrganizationUnitsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestTypeOrganizationUnitsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestTypeOrganizationUnitsDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestTypeOrganizationUnits/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HRRequestTypeOrganizationUnitsDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestTypeOrganizationUnits/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestTypeOrganizationUnitsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestTypeOrganizationUnitsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HRRequestTypeOrganizationUnitsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestTypeOrganizationUnitsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestTypeOrganizationUnitsDto>(null as any);
    }

    /**
     * @param hRRequestTypeId (optional) 
     * @param organizationUnitId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(hRRequestTypeId: number | undefined, organizationUnitId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HRRequestTypeOrganizationUnitsDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestTypeOrganizationUnits/GetAll?";
        if (hRRequestTypeId === null)
            throw new Error("The parameter 'hRRequestTypeId' cannot be null.");
        else if (hRRequestTypeId !== undefined)
            url_ += "HRRequestTypeId=" + encodeURIComponent("" + hRRequestTypeId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestTypeOrganizationUnitsDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestTypeOrganizationUnitsDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HRRequestTypeOrganizationUnitsDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestTypeOrganizationUnitsDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestTypeOrganizationUnitsDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: HRRequestTypeOrganizationUnitsDto | undefined): Observable<HRRequestTypeOrganizationUnitsDto> {
        let url_ = this.baseUrl + "/api/services/app/HRRequestTypeOrganizationUnits/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HRRequestTypeOrganizationUnitsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HRRequestTypeOrganizationUnitsDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HRRequestTypeOrganizationUnitsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HRRequestTypeOrganizationUnitsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<HRRequestTypeOrganizationUnitsDto>(null as any);
    }
}

@Injectable()
export class MediaEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMediaEventDto | undefined): Observable<MediaEventDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaEvent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaEventDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MediaEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MediaEventDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMediaEventDto | undefined): Observable<MediaEventDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaEvent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaEventDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MediaEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MediaEventDto>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    uploadMediaEventFile(file: FileParameter | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaEvent/UploadMediaEventFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadMediaEventFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadMediaEventFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processUploadMediaEventFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MediaEventDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaEvent/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaEventDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MediaEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MediaEventDto>(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param service_Id (optional) 
     * @param group_Id (optional) 
     * @param beneficiary_Id (optional) 
     * @param activity_Id (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, service_Id: number | undefined, group_Id: number | undefined, beneficiary_Id: number | undefined, activity_Id: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MediaEventDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaEvent/GetAll?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (service_Id === null)
            throw new Error("The parameter 'service_Id' cannot be null.");
        else if (service_Id !== undefined)
            url_ += "Service.Id=" + encodeURIComponent("" + service_Id) + "&";
        if (group_Id === null)
            throw new Error("The parameter 'group_Id' cannot be null.");
        else if (group_Id !== undefined)
            url_ += "Group.Id=" + encodeURIComponent("" + group_Id) + "&";
        if (beneficiary_Id === null)
            throw new Error("The parameter 'beneficiary_Id' cannot be null.");
        else if (beneficiary_Id !== undefined)
            url_ += "Beneficiary.Id=" + encodeURIComponent("" + beneficiary_Id) + "&";
        if (activity_Id === null)
            throw new Error("The parameter 'activity_Id' cannot be null.");
        else if (activity_Id !== undefined)
            url_ += "Activity.Id=" + encodeURIComponent("" + activity_Id) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaEventDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaEventDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MediaEventDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaEventDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MediaEventDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MediaEvent/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class MediaEventFileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MediaEventFileDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaEventFile/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaEventFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaEventFileDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MediaEventFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaEventFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MediaEventFileDto>(null as any);
    }

    /**
     * @param mediaEventId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(mediaEventId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MediaEventFileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaEventFile/GetAll?";
        if (mediaEventId === null)
            throw new Error("The parameter 'mediaEventId' cannot be null.");
        else if (mediaEventId !== undefined)
            url_ += "MediaEventId=" + encodeURIComponent("" + mediaEventId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaEventFileDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaEventFileDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MediaEventFileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaEventFileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MediaEventFileDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: MediaEventFileDto | undefined): Observable<MediaEventFileDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaEventFile/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaEventFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaEventFileDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MediaEventFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaEventFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MediaEventFileDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: MediaEventFileDto | undefined): Observable<MediaEventFileDto> {
        let url_ = this.baseUrl + "/api/services/app/MediaEventFile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MediaEventFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MediaEventFileDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MediaEventFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MediaEventFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MediaEventFileDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MediaEventFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class MessageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMessageDto | undefined): Observable<MessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Message/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageDto>(null as any);
    }

    /**
     * @param topicId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(topicId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MessageDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Message/GetAll?";
        if (topicId === null)
            throw new Error("The parameter 'topicId' cannot be null.");
        else if (topicId !== undefined)
            url_ += "TopicId=" + encodeURIComponent("" + topicId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MessageDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MessageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MessageDto[]>(null as any);
    }
}

@Injectable()
export class MunicipalityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param id (optional) 
     * @return Success
     */
    getAllByKeyword(keyword: string | undefined, id: number | undefined): Observable<MunicipalityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Municipality/GetAllByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MunicipalityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MunicipalityDto[]>;
        }));
    }

    protected processGetAllByKeyword(response: HttpResponseBase): Observable<MunicipalityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MunicipalityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MunicipalityDto[]>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllNoAutocomplete(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MunicipalityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Municipality/GetAllNoAutocomplete?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllNoAutocomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllNoAutocomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MunicipalityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MunicipalityDto[]>;
        }));
    }

    protected processGetAllNoAutocomplete(response: HttpResponseBase): Observable<MunicipalityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MunicipalityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MunicipalityDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MunicipalityBaseDto> {
        let url_ = this.baseUrl + "/api/services/app/Municipality/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MunicipalityBaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MunicipalityBaseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MunicipalityBaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MunicipalityBaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MunicipalityBaseDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param id (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, id: number | undefined): Observable<MunicipalityBaseDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Municipality/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MunicipalityBaseDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MunicipalityBaseDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MunicipalityBaseDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MunicipalityBaseDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MunicipalityBaseDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: MunicipalityBaseDto | undefined): Observable<MunicipalityBaseDto> {
        let url_ = this.baseUrl + "/api/services/app/Municipality/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MunicipalityBaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MunicipalityBaseDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MunicipalityBaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MunicipalityBaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MunicipalityBaseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: MunicipalityBaseDto | undefined): Observable<MunicipalityBaseDto> {
        let url_ = this.baseUrl + "/api/services/app/Municipality/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MunicipalityBaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MunicipalityBaseDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MunicipalityBaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MunicipalityBaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MunicipalityBaseDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Municipality/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class NonAttendanceMotivationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<NonAttendanceMotivationDto> {
        let url_ = this.baseUrl + "/api/services/app/NonAttendanceMotivation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonAttendanceMotivationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonAttendanceMotivationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<NonAttendanceMotivationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NonAttendanceMotivationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonAttendanceMotivationDto>(null as any);
    }

    /**
     * @param keywork (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keywork: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<NonAttendanceMotivationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/NonAttendanceMotivation/GetAll?";
        if (keywork === null)
            throw new Error("The parameter 'keywork' cannot be null.");
        else if (keywork !== undefined)
            url_ += "Keywork=" + encodeURIComponent("" + keywork) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonAttendanceMotivationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonAttendanceMotivationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NonAttendanceMotivationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NonAttendanceMotivationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonAttendanceMotivationDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: NonAttendanceMotivationDto | undefined): Observable<NonAttendanceMotivationDto> {
        let url_ = this.baseUrl + "/api/services/app/NonAttendanceMotivation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonAttendanceMotivationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonAttendanceMotivationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<NonAttendanceMotivationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NonAttendanceMotivationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonAttendanceMotivationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: NonAttendanceMotivationDto | undefined): Observable<NonAttendanceMotivationDto> {
        let url_ = this.baseUrl + "/api/services/app/NonAttendanceMotivation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NonAttendanceMotivationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NonAttendanceMotivationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<NonAttendanceMotivationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NonAttendanceMotivationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NonAttendanceMotivationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/NonAttendanceMotivation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAll(body: PagedNotificationResultRequestDto | undefined): Observable<NotificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotificationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotificationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<NotificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<NotificationDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getUnreadNotificationsCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUnreadNotificationsCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnreadNotificationsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadNotificationsCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUnreadNotificationsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(null as any);
    }

    /**
     * @param userNotificationId (optional) 
     * @return Success
     */
    setRead(userNotificationId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetRead?";
        if (userNotificationId === null)
            throw new Error("The parameter 'userNotificationId' cannot be null.");
        else if (userNotificationId !== undefined)
            url_ += "userNotificationId=" + encodeURIComponent("" + userNotificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getNotificationEntityTypes(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationEntityTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationEntityTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationEntityTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetNotificationEntityTypes(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>(null as any);
    }
}

@Injectable()
export class OperatorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getOperatorsByBeneficiary(beneficiaryId: number, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceOperatorDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Operator/GetOperatorsByBeneficiary?";
        if (beneficiaryId === undefined || beneficiaryId === null)
            throw new Error("The parameter 'beneficiaryId' must be defined and cannot be null.");
        else
            url_ += "BeneficiaryId=" + encodeURIComponent("" + beneficiaryId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOperatorsByBeneficiary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOperatorsByBeneficiary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorDto[]>;
        }));
    }

    protected processGetOperatorsByBeneficiary(response: HttpResponseBase): Observable<ServiceOperatorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceOperatorDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorDto[]>(null as any);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param organizationUnitId (optional) 
     * @return Success
     */
    getWithUserList(organizationUnitId: number | undefined): Observable<OrganizationUnitUsersDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetWithUserList?";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWithUserList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWithUserList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitUsersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitUsersDto>;
        }));
    }

    protected processGetWithUserList(response: HttpResponseBase): Observable<OrganizationUnitUsersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitUsersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitUsersDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: OrganizationUnitDto | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: OrganizationUnitDto | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getOrganizationUnitsByKeyword(keyword: string | undefined): Observable<OrganizationUnitDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitsByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitsByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitsByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto[]>;
        }));
    }

    protected processGetOrganizationUnitsByKeyword(response: HttpResponseBase): Observable<OrganizationUnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationUnitDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrganizationUnitDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrganizationUnitDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrganizationUnitDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ParentalDegreeDictionaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param isVisibleToDescendant (optional) 
     * @return Success
     */
    getAll(isVisibleToDescendant: boolean | undefined): Observable<ParentalDegreeDictionaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ParentalDegreeDictionary/GetAll?";
        if (isVisibleToDescendant === null)
            throw new Error("The parameter 'isVisibleToDescendant' cannot be null.");
        else if (isVisibleToDescendant !== undefined)
            url_ += "IsVisibleToDescendant=" + encodeURIComponent("" + isVisibleToDescendant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParentalDegreeDictionaryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParentalDegreeDictionaryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ParentalDegreeDictionaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParentalDegreeDictionaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ParentalDegreeDictionaryDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class PlanningServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePlanningDto | undefined): Observable<PlanningDto> {
        let url_ = this.baseUrl + "/api/services/app/Planning/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanningDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanningDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PlanningDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanningDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanningDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePlanningDto | undefined): Observable<PlanningDto> {
        let url_ = this.baseUrl + "/api/services/app/Planning/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanningDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanningDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PlanningDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanningDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanningDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Planning/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param serviceIds (optional) 
     * @param group_Id (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadExcel(serviceIds: number[] | undefined, group_Id: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/Planning/DownloadExcel?";
        if (serviceIds === null)
            throw new Error("The parameter 'serviceIds' cannot be null.");
        else if (serviceIds !== undefined)
            serviceIds && serviceIds.forEach(item => { url_ += "ServiceIds=" + encodeURIComponent("" + item) + "&"; });
        if (group_Id === null)
            throw new Error("The parameter 'group_Id' cannot be null.");
        else if (group_Id !== undefined)
            url_ += "Group.Id=" + encodeURIComponent("" + group_Id) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PlanningDto> {
        let url_ = this.baseUrl + "/api/services/app/Planning/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanningDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanningDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PlanningDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanningDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanningDto>(null as any);
    }

    /**
     * @param serviceIds (optional) 
     * @param group_Id (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceIds: number[] | undefined, group_Id: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PlanningDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Planning/GetAll?";
        if (serviceIds === null)
            throw new Error("The parameter 'serviceIds' cannot be null.");
        else if (serviceIds !== undefined)
            serviceIds && serviceIds.forEach(item => { url_ += "ServiceIds=" + encodeURIComponent("" + item) + "&"; });
        if (group_Id === null)
            throw new Error("The parameter 'group_Id' cannot be null.");
        else if (group_Id !== undefined)
            url_ += "Group.Id=" + encodeURIComponent("" + group_Id) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlanningDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlanningDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PlanningDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlanningDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PlanningDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ProfessionalRegisterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param id (optional) 
     * @return Success
     */
    getAvailableByKeyword(keyword: string | undefined, id: number | undefined): Observable<ProfessionalRegisterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionalRegister/GetAvailableByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalRegisterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalRegisterDto[]>;
        }));
    }

    protected processGetAvailableByKeyword(response: HttpResponseBase): Observable<ProfessionalRegisterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProfessionalRegisterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfessionalRegisterDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProfessionalRegisterDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionalRegister/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalRegisterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalRegisterDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProfessionalRegisterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalRegisterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfessionalRegisterDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProfessionalRegisterDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionalRegister/GetAll?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalRegisterDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalRegisterDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProfessionalRegisterDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalRegisterDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfessionalRegisterDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ProfessionalRegisterDto | undefined): Observable<ProfessionalRegisterDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionalRegister/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalRegisterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalRegisterDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProfessionalRegisterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalRegisterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfessionalRegisterDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ProfessionalRegisterDto | undefined): Observable<ProfessionalRegisterDto> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionalRegister/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfessionalRegisterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfessionalRegisterDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProfessionalRegisterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfessionalRegisterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ProfessionalRegisterDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProfessionalRegister/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class QualificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param id (optional) 
     * @return Success
     */
    getAvailableByKeyword(keyword: string | undefined, id: number | undefined): Observable<QualificationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Qualification/GetAvailableByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationDto[]>;
        }));
    }

    protected processGetAvailableByKeyword(response: HttpResponseBase): Observable<QualificationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualificationDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<QualificationDto> {
        let url_ = this.baseUrl + "/api/services/app/Qualification/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<QualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualificationDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<QualificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Qualification/GetAll?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<QualificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualificationDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: QualificationDto | undefined): Observable<QualificationDto> {
        let url_ = this.baseUrl + "/api/services/app/Qualification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<QualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualificationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: QualificationDto | undefined): Observable<QualificationDto> {
        let url_ = this.baseUrl + "/api/services/app/Qualification/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<QualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<QualificationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<QualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<QualificationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Qualification/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReceiptServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateReceiptDto | undefined): Observable<ReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateReceiptDto | undefined): Observable<ReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptDto>(null as any);
    }

    /**
     * @param title (optional) 
     * @param id (optional) 
     * @return Success
     */
    delete(title: string | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/Delete?";
        if (title === null)
            throw new Error("The parameter 'title' cannot be null.");
        else if (title !== undefined)
            url_ += "Title=" + encodeURIComponent("" + title) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    uploadReceiptFile(file: FileParameter | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/UploadReceiptFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadReceiptFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadReceiptFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processUploadReceiptFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllUsersWithFeePerHour(): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/GetAllUsersWithFeePerHour";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsersWithFeePerHour(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsersWithFeePerHour(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetAllUsersWithFeePerHour(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param activity_Id (optional) 
     * @param contract_Id (optional) 
     * @param commitment_Id (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, activity_Id: number | undefined, contract_Id: number | undefined, commitment_Id: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReceiptDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Receipt/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (activity_Id === null)
            throw new Error("The parameter 'activity_Id' cannot be null.");
        else if (activity_Id !== undefined)
            url_ += "Activity.Id=" + encodeURIComponent("" + activity_Id) + "&";
        if (contract_Id === null)
            throw new Error("The parameter 'contract_Id' cannot be null.");
        else if (contract_Id !== undefined)
            url_ += "Contract.Id=" + encodeURIComponent("" + contract_Id) + "&";
        if (commitment_Id === null)
            throw new Error("The parameter 'commitment_Id' cannot be null.");
        else if (commitment_Id !== undefined)
            url_ += "Commitment.Id=" + encodeURIComponent("" + commitment_Id) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReceiptDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ReceiptFilesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ReceiptFilesDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptFiles/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptFilesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptFilesDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReceiptFilesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptFilesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptFilesDto>(null as any);
    }

    /**
     * @param receipId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(receipId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReceiptFilesDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptFiles/GetAll?";
        if (receipId === null)
            throw new Error("The parameter 'receipId' cannot be null.");
        else if (receipId !== undefined)
            url_ += "ReceipId=" + encodeURIComponent("" + receipId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptFilesDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptFilesDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReceiptFilesDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptFilesDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptFilesDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ReceiptFilesDto | undefined): Observable<ReceiptFilesDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptFiles/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptFilesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptFilesDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReceiptFilesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptFilesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptFilesDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ReceiptFilesDto | undefined): Observable<ReceiptFilesDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptFiles/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptFilesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptFilesDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReceiptFilesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptFilesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReceiptFilesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptFiles/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RegistrationParametersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getByUser(id: number | undefined): Observable<RegistrationParametersDto> {
        let url_ = this.baseUrl + "/api/services/app/RegistrationParameters/GetByUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistrationParametersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistrationParametersDto>;
        }));
    }

    protected processGetByUser(response: HttpResponseBase): Observable<RegistrationParametersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationParametersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegistrationParametersDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateRegistrationParametersDto | undefined): Observable<RegistrationParametersDto> {
        let url_ = this.baseUrl + "/api/services/app/RegistrationParameters/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegistrationParametersDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegistrationParametersDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RegistrationParametersDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegistrationParametersDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RegistrationParametersDto>(null as any);
    }
}

@Injectable()
export class ReminderDictionaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined, sorting: string | undefined): Observable<ReminderDictionaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReminderDictionary/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReminderDictionaryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReminderDictionaryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReminderDictionaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReminderDictionaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReminderDictionaryDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermissionDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ScheduledEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateScheduledEventDto | undefined): Observable<ScheduledEventDo> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledEvent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledEventDo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledEventDo>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ScheduledEventDo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledEventDo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduledEventDo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateScheduledEventDto | undefined): Observable<ScheduledEventDo> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledEvent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledEventDo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledEventDo>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ScheduledEventDo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledEventDo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduledEventDo>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledEvent/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<ScheduledEventDo> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledEvent/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledEventDo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledEventDo>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ScheduledEventDo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledEventDo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduledEventDo>(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param entityType (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(entityId: number | undefined, entityType: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ScheduledEventDoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledEvent/GetAll?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledEventDoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledEventDoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ScheduledEventDoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledEventDoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduledEventDoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ScheduledNotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateScheduledNotificationDto | undefined): Observable<ScheduledNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledNotification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledNotificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledNotificationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ScheduledNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledNotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduledNotificationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledNotification/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateScheduledNotificationDto | undefined): Observable<ScheduledNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledNotification/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledNotificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledNotificationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ScheduledNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledNotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduledNotificationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: string | undefined): Observable<ScheduledNotificationDto> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledNotification/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledNotificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledNotificationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ScheduledNotificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledNotificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduledNotificationDto>(null as any);
    }

    /**
     * @param entityId (optional) 
     * @param entityType (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(entityId: number | undefined, entityType: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ScheduledNotificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledNotification/GetAll?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (entityType === null)
            throw new Error("The parameter 'entityType' cannot be null.");
        else if (entityType !== undefined)
            url_ += "EntityType=" + encodeURIComponent("" + entityType) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledNotificationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledNotificationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ScheduledNotificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduledNotificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduledNotificationDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ScheduledNotificationUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateScheduledNotificationUserDto | undefined): Observable<ScheduledNotificationUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledNotificationUser/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScheduledNotificationUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScheduledNotificationUserDto[]>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ScheduledNotificationUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScheduledNotificationUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ScheduledNotificationUserDto[]>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledNotificationUser/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SchoolYearServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SchoolYearDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SchoolYear/GetAll?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchoolYearDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchoolYearDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SchoolYearDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchoolYearDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SchoolYearDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceDto | undefined): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceDto | undefined): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Service/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getServiceByKeyword(keyword: string | undefined): Observable<ServiceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Service/GetServiceByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto[]>;
        }));
    }

    protected processGetServiceByKeyword(response: HttpResponseBase): Observable<ServiceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDto[]>(null as any);
    }

    /**
     * @param contractId (optional) 
     * @param customerId (optional) 
     * @param keyword (optional) 
     * @param endDateMin (optional) 
     * @param endDateMax (optional) 
     * @param schoolYearId (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param includeOperator (optional) 
     * @return Success
     */
    downloadExcel(contractId: number | undefined, customerId: number | undefined, keyword: string | undefined, endDateMin: moment.Moment | undefined, endDateMax: moment.Moment | undefined, schoolYearId: number | undefined, userId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined, includeOperator: boolean | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/DownloadExcel?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "ContractId=" + encodeURIComponent("" + contractId) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (endDateMin === null)
            throw new Error("The parameter 'endDateMin' cannot be null.");
        else if (endDateMin !== undefined)
            url_ += "EndDateMin=" + encodeURIComponent(endDateMin ? "" + endDateMin.toISOString() : "") + "&";
        if (endDateMax === null)
            throw new Error("The parameter 'endDateMax' cannot be null.");
        else if (endDateMax !== undefined)
            url_ += "EndDateMax=" + encodeURIComponent(endDateMax ? "" + endDateMax.toISOString() : "") + "&";
        if (schoolYearId === null)
            throw new Error("The parameter 'schoolYearId' cannot be null.");
        else if (schoolYearId !== undefined)
            url_ += "SchoolYearId=" + encodeURIComponent("" + schoolYearId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (includeOperator === null)
            throw new Error("The parameter 'includeOperator' cannot be null.");
        else if (includeOperator !== undefined)
            url_ += "includeOperator=" + encodeURIComponent("" + includeOperator) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDto>(null as any);
    }

    /**
     * @param contractId (optional) 
     * @param customerId (optional) 
     * @param keyword (optional) 
     * @param endDateMin (optional) 
     * @param endDateMax (optional) 
     * @param schoolYearId (optional) 
     * @param userId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(contractId: number | undefined, customerId: number | undefined, keyword: string | undefined, endDateMin: moment.Moment | undefined, endDateMax: moment.Moment | undefined, schoolYearId: number | undefined, userId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/GetAll?";
        if (contractId === null)
            throw new Error("The parameter 'contractId' cannot be null.");
        else if (contractId !== undefined)
            url_ += "ContractId=" + encodeURIComponent("" + contractId) + "&";
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            url_ += "CustomerId=" + encodeURIComponent("" + customerId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (endDateMin === null)
            throw new Error("The parameter 'endDateMin' cannot be null.");
        else if (endDateMin !== undefined)
            url_ += "EndDateMin=" + encodeURIComponent(endDateMin ? "" + endDateMin.toISOString() : "") + "&";
        if (endDateMax === null)
            throw new Error("The parameter 'endDateMax' cannot be null.");
        else if (endDateMax !== undefined)
            url_ += "EndDateMax=" + encodeURIComponent(endDateMax ? "" + endDateMax.toISOString() : "") + "&";
        if (schoolYearId === null)
            throw new Error("The parameter 'schoolYearId' cannot be null.");
        else if (schoolYearId !== undefined)
            url_ += "SchoolYearId=" + encodeURIComponent("" + schoolYearId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ServiceAreaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param serviceId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceAreaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceArea/GetAll?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceAreaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceAreaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceAreaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceAreaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceAreaDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ServiceBeneficiaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceBeneficiaryDto | undefined): Observable<ServiceBeneficiaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceBeneficiary/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceBeneficiaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceBeneficiaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceBeneficiaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceBeneficiaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceBeneficiaryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceBeneficiary/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceBeneficiaryDto | undefined): Observable<ServiceBeneficiaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceBeneficiary/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceBeneficiaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceBeneficiaryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceBeneficiaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceBeneficiaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceBeneficiaryDto>(null as any);
    }

    /**
     * @param beneficiaryId (optional) 
     * @param serviceId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getBeneficiariesByServiceId(beneficiaryId: number | undefined, serviceId: number | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceBeneficiaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceBeneficiary/GetBeneficiariesByServiceId?";
        if (beneficiaryId === null)
            throw new Error("The parameter 'beneficiaryId' cannot be null.");
        else if (beneficiaryId !== undefined)
            url_ += "BeneficiaryId=" + encodeURIComponent("" + beneficiaryId) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBeneficiariesByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeneficiariesByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceBeneficiaryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceBeneficiaryDtoPagedResultDto>;
        }));
    }

    protected processGetBeneficiariesByServiceId(response: HttpResponseBase): Observable<ServiceBeneficiaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceBeneficiaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceBeneficiaryDtoPagedResultDto>(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param keyword (optional) 
     * @return Success
     */
    getBeneficiariesByServiceIdNotPaginated(serviceId: number | undefined, keyword: string | undefined): Observable<ServiceBeneficiaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceBeneficiary/GetBeneficiariesByServiceIdNotPaginated?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBeneficiariesByServiceIdNotPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeneficiariesByServiceIdNotPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceBeneficiaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceBeneficiaryDto[]>;
        }));
    }

    protected processGetBeneficiariesByServiceIdNotPaginated(response: HttpResponseBase): Observable<ServiceBeneficiaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceBeneficiaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceBeneficiaryDto[]>(null as any);
    }

    /**
     * @param beneficiaryId (optional) 
     * @param serviceId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getServicesByBeneficiaryId(beneficiaryId: number | undefined, serviceId: number | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceBeneficiaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceBeneficiary/GetServicesByBeneficiaryId?";
        if (beneficiaryId === null)
            throw new Error("The parameter 'beneficiaryId' cannot be null.");
        else if (beneficiaryId !== undefined)
            url_ += "BeneficiaryId=" + encodeURIComponent("" + beneficiaryId) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServicesByBeneficiaryId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServicesByBeneficiaryId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceBeneficiaryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceBeneficiaryDtoPagedResultDto>;
        }));
    }

    protected processGetServicesByBeneficiaryId(response: HttpResponseBase): Observable<ServiceBeneficiaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceBeneficiaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceBeneficiaryDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceBeneficiaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceBeneficiary/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceBeneficiaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceBeneficiaryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceBeneficiaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceBeneficiaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceBeneficiaryDto>(null as any);
    }

    /**
     * @param beneficiaryId (optional) 
     * @param serviceId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(beneficiaryId: number | undefined, serviceId: number | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceBeneficiaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceBeneficiary/GetAll?";
        if (beneficiaryId === null)
            throw new Error("The parameter 'beneficiaryId' cannot be null.");
        else if (beneficiaryId !== undefined)
            url_ += "BeneficiaryId=" + encodeURIComponent("" + beneficiaryId) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceBeneficiaryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceBeneficiaryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceBeneficiaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceBeneficiaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceBeneficiaryDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ServiceCustomerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param serviceId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceCustomerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCustomer/GetAll?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCustomerDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCustomerDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceCustomerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCustomerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceCustomerDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ServiceFileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ServiceGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceGroupDto | undefined): Observable<ServiceGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceGroup/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceGroupDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceGroupDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getGroupByServiceId(groupId: number | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceGroupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceGroup/GetGroupByServiceId?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceGroupDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceGroupDtoPagedResultDto>;
        }));
    }

    protected processGetGroupByServiceId(response: HttpResponseBase): Observable<ServiceGroupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceGroupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceGroupDtoPagedResultDto>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getServiceByGroupId(groupId: number | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceGroupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceGroup/GetServiceByGroupId?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceByGroupId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceByGroupId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceGroupDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceGroupDtoPagedResultDto>;
        }));
    }

    protected processGetServiceByGroupId(response: HttpResponseBase): Observable<ServiceGroupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceGroupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceGroupDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceGroup/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceGroupDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceGroupDto>(null as any);
    }

    /**
     * @param groupId (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(groupId: number | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceGroupDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceGroup/GetAll?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "GroupId=" + encodeURIComponent("" + groupId) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceGroupDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceGroupDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceGroupDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceGroupDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceGroupDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CreateServiceGroupDto | undefined): Observable<ServiceGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceGroup/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceGroupDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceGroupDto>(null as any);
    }
}

@Injectable()
export class ServiceOperatorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceOperatorDto | undefined): Observable<ServiceOperatorDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperator/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceOperatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceOperatorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceOperatorDto | undefined): Observable<ServiceOperatorDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperator/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceOperatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceOperatorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperator/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getWorkShiftFrequencyDictionary(): Observable<WorkShiftFrequencyTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperator/GetWorkShiftFrequencyDictionary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkShiftFrequencyDictionary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkShiftFrequencyDictionary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkShiftFrequencyTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkShiftFrequencyTypeDto[]>;
        }));
    }

    protected processGetWorkShiftFrequencyDictionary(response: HttpResponseBase): Observable<WorkShiftFrequencyTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkShiftFrequencyTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkShiftFrequencyTypeDto[]>(null as any);
    }

    /**
     * @param serviceOperatorId (optional) 
     * @param startInterval (optional) 
     * @param endInterval (optional) 
     * @return Success
     */
    getWorkedMinutesByInterval(serviceOperatorId: number | undefined, startInterval: moment.Moment | undefined, endInterval: moment.Moment | undefined): Observable<ServiceOperatorWorkedMinutesDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperator/GetWorkedMinutesByInterval?";
        if (serviceOperatorId === null)
            throw new Error("The parameter 'serviceOperatorId' cannot be null.");
        else if (serviceOperatorId !== undefined)
            url_ += "serviceOperatorId=" + encodeURIComponent("" + serviceOperatorId) + "&";
        if (startInterval === null)
            throw new Error("The parameter 'startInterval' cannot be null.");
        else if (startInterval !== undefined)
            url_ += "startInterval=" + encodeURIComponent(startInterval ? "" + startInterval.toISOString() : "") + "&";
        if (endInterval === null)
            throw new Error("The parameter 'endInterval' cannot be null.");
        else if (endInterval !== undefined)
            url_ += "endInterval=" + encodeURIComponent(endInterval ? "" + endInterval.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkedMinutesByInterval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkedMinutesByInterval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorWorkedMinutesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorWorkedMinutesDto>;
        }));
    }

    protected processGetWorkedMinutesByInterval(response: HttpResponseBase): Observable<ServiceOperatorWorkedMinutesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceOperatorWorkedMinutesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorWorkedMinutesDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceOperatorDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperator/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceOperatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceOperatorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorDto>(null as any);
    }

    /**
     * @param operatorId (optional) 
     * @param serviceId (optional) 
     * @param keyword (optional) 
     * @param isCoordinator (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(operatorId: number | undefined, serviceId: number | undefined, keyword: string | undefined, isCoordinator: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceOperatorDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperator/GetAll?";
        if (operatorId === null)
            throw new Error("The parameter 'operatorId' cannot be null.");
        else if (operatorId !== undefined)
            url_ += "OperatorId=" + encodeURIComponent("" + operatorId) + "&";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isCoordinator === null)
            throw new Error("The parameter 'isCoordinator' cannot be null.");
        else if (isCoordinator !== undefined)
            url_ += "IsCoordinator=" + encodeURIComponent("" + isCoordinator) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceOperatorDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceOperatorDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class ServiceOperatorBeneficiaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceOperatorBeneficiaryDto | undefined): Observable<ServiceOperatorBeneficiaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorBeneficiary/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorBeneficiaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorBeneficiaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceOperatorBeneficiaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceOperatorBeneficiaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorBeneficiaryDto>(null as any);
    }

    /**
     * @param serviceOperatorBeneficiaryId (optional) 
     * @return Success
     */
    delete(serviceOperatorBeneficiaryId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorBeneficiary/Delete?";
        if (serviceOperatorBeneficiaryId === null)
            throw new Error("The parameter 'serviceOperatorBeneficiaryId' cannot be null.");
        else if (serviceOperatorBeneficiaryId !== undefined)
            url_ += "serviceOperatorBeneficiaryId=" + encodeURIComponent("" + serviceOperatorBeneficiaryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param serviceOperatorScheduledId (optional) 
     * @return Success
     */
    getBeneficiariesByServiceOperatorIdNotPaginated(serviceOperatorScheduledId: number | undefined): Observable<ServiceOperatorScheduledBeneficiaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorBeneficiary/GetBeneficiariesByServiceOperatorIdNotPaginated?";
        if (serviceOperatorScheduledId === null)
            throw new Error("The parameter 'serviceOperatorScheduledId' cannot be null.");
        else if (serviceOperatorScheduledId !== undefined)
            url_ += "serviceOperatorScheduledId=" + encodeURIComponent("" + serviceOperatorScheduledId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBeneficiariesByServiceOperatorIdNotPaginated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBeneficiariesByServiceOperatorIdNotPaginated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorScheduledBeneficiaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorScheduledBeneficiaryDto[]>;
        }));
    }

    protected processGetBeneficiariesByServiceOperatorIdNotPaginated(response: HttpResponseBase): Observable<ServiceOperatorScheduledBeneficiaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceOperatorScheduledBeneficiaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorScheduledBeneficiaryDto[]>(null as any);
    }

    /**
     * @param serviceIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getServiceOperatorBeneficiaries(serviceIds: number[] | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<ServiceOperatorScheduledBeneficiaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorBeneficiary/GetServiceOperatorBeneficiaries?";
        if (serviceIds === null)
            throw new Error("The parameter 'serviceIds' cannot be null.");
        else if (serviceIds !== undefined)
            serviceIds && serviceIds.forEach(item => { url_ += "ServiceIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceOperatorBeneficiaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceOperatorBeneficiaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorScheduledBeneficiaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorScheduledBeneficiaryDto[]>;
        }));
    }

    protected processGetServiceOperatorBeneficiaries(response: HttpResponseBase): Observable<ServiceOperatorScheduledBeneficiaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceOperatorScheduledBeneficiaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorScheduledBeneficiaryDto[]>(null as any);
    }
}

@Injectable()
export class ServiceOperatorScheduledServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceOperatorScheduledDto | undefined): Observable<ServiceOperatorScheduledDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorScheduled/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorScheduledDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorScheduledDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceOperatorScheduledDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceOperatorScheduledDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorScheduledDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkMultipleInterval(body: CreateMultipleServiceOperatorScheduledDto | undefined): Observable<ServiceOperatorScheduledIntervalResultDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorScheduled/CheckMultipleInterval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckMultipleInterval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckMultipleInterval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorScheduledIntervalResultDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorScheduledIntervalResultDto[]>;
        }));
    }

    protected processCheckMultipleInterval(response: HttpResponseBase): Observable<ServiceOperatorScheduledIntervalResultDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceOperatorScheduledIntervalResultDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorScheduledIntervalResultDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMultiple(body: CreateMultipleServiceOperatorScheduledDto | undefined): Observable<ServiceOperatorScheduledDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorScheduled/CreateMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMultiple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMultiple(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorScheduledDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorScheduledDto[]>;
        }));
    }

    protected processCreateMultiple(response: HttpResponseBase): Observable<ServiceOperatorScheduledDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceOperatorScheduledDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorScheduledDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceOperatorScheduledDto | undefined): Observable<ServiceOperatorScheduledDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorScheduled/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorScheduledDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorScheduledDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceOperatorScheduledDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceOperatorScheduledDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorScheduledDto>(null as any);
    }

    /**
     * @param serviceOperatorId (optional) 
     * @return Success
     */
    simpleBadgePunchIn(serviceOperatorId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorScheduled/SimpleBadgePunchIn?";
        if (serviceOperatorId === null)
            throw new Error("The parameter 'serviceOperatorId' cannot be null.");
        else if (serviceOperatorId !== undefined)
            url_ += "ServiceOperatorId=" + encodeURIComponent("" + serviceOperatorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSimpleBadgePunchIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSimpleBadgePunchIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSimpleBadgePunchIn(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param serviceOperatorScheduledId (optional) 
     * @return Success
     */
    advancedBadgePunchIn(serviceOperatorScheduledId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorScheduled/AdvancedBadgePunchIn?";
        if (serviceOperatorScheduledId === null)
            throw new Error("The parameter 'serviceOperatorScheduledId' cannot be null.");
        else if (serviceOperatorScheduledId !== undefined)
            url_ += "serviceOperatorScheduledId=" + encodeURIComponent("" + serviceOperatorScheduledId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdvancedBadgePunchIn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdvancedBadgePunchIn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAdvancedBadgePunchIn(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param serviceIds (optional) 
     * @param operatorIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param inProgress (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadExcel(serviceIds: number[] | undefined, operatorIds: number[] | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, inProgress: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorScheduled/DownloadExcel?";
        if (serviceIds === null)
            throw new Error("The parameter 'serviceIds' cannot be null.");
        else if (serviceIds !== undefined)
            serviceIds && serviceIds.forEach(item => { url_ += "ServiceIds=" + encodeURIComponent("" + item) + "&"; });
        if (operatorIds === null)
            throw new Error("The parameter 'operatorIds' cannot be null.");
        else if (operatorIds !== undefined)
            operatorIds && operatorIds.forEach(item => { url_ += "OperatorIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (inProgress === null)
            throw new Error("The parameter 'inProgress' cannot be null.");
        else if (inProgress !== undefined)
            url_ += "InProgress=" + encodeURIComponent("" + inProgress) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceOperatorScheduledDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorScheduled/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorScheduledDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorScheduledDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceOperatorScheduledDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceOperatorScheduledDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorScheduledDto>(null as any);
    }

    /**
     * @param serviceIds (optional) 
     * @param operatorIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param inProgress (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceIds: number[] | undefined, operatorIds: number[] | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, inProgress: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceOperatorScheduledDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorScheduled/GetAll?";
        if (serviceIds === null)
            throw new Error("The parameter 'serviceIds' cannot be null.");
        else if (serviceIds !== undefined)
            serviceIds && serviceIds.forEach(item => { url_ += "ServiceIds=" + encodeURIComponent("" + item) + "&"; });
        if (operatorIds === null)
            throw new Error("The parameter 'operatorIds' cannot be null.");
        else if (operatorIds !== undefined)
            operatorIds && operatorIds.forEach(item => { url_ += "OperatorIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (inProgress === null)
            throw new Error("The parameter 'inProgress' cannot be null.");
        else if (inProgress !== undefined)
            url_ += "InProgress=" + encodeURIComponent("" + inProgress) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceOperatorScheduledDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceOperatorScheduledDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceOperatorScheduledDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceOperatorScheduledDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceOperatorScheduledDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceOperatorScheduled/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ServiceReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceReportDto | undefined): Observable<ServiceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceReportDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceReportDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceReportDto | undefined): Observable<ServiceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceReportDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceReportDto>(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param year (optional) 
     * @param quarter (optional) 
     * @return Success
     */
    checkIfServiceReportExist(serviceId: number | undefined, year: number | undefined, quarter: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/CheckIfServiceReportExist?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (quarter === null)
            throw new Error("The parameter 'quarter' cannot be null.");
        else if (quarter !== undefined)
            url_ += "quarter=" + encodeURIComponent("" + quarter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfServiceReportExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfServiceReportExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfServiceReportExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadExcel(serviceId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/DownloadExcel?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceReportDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceReportDto>(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/GetAll?";
        if (serviceId === null)
            throw new Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceReportDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceReportDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ServiceReportDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCurrentLoginInformationsOutput>(null as any);
    }
}

@Injectable()
export class SummaryTrackingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getContractSummary(id: number | undefined): Observable<SummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/SummaryTracking/GetContractSummary?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContractSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContractSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SummaryDto>;
        }));
    }

    protected processGetContractSummary(response: HttpResponseBase): Observable<SummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SummaryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getActivitySummary(id: number | undefined): Observable<SummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/SummaryTracking/GetActivitySummary?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivitySummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivitySummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SummaryDto>;
        }));
    }

    protected processGetActivitySummary(response: HttpResponseBase): Observable<SummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SummaryDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getCommitmentSummary(id: number | undefined): Observable<SummaryDto> {
        let url_ = this.baseUrl + "/api/services/app/SummaryTracking/GetCommitmentSummary?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCommitmentSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCommitmentSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SummaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SummaryDto>;
        }));
    }

    protected processGetCommitmentSummary(response: HttpResponseBase): Observable<SummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SummaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SummaryDto>(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param licenseKey (optional) 
     * @return Success
     */
    getByLicenseKey(licenseKey: string | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetByLicenseKey?";
        if (licenseKey === null)
            throw new Error("The parameter 'licenseKey' cannot be null.");
        else if (licenseKey !== undefined)
            url_ += "licenseKey=" + encodeURIComponent("" + licenseKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByLicenseKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByLicenseKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGetByLicenseKey(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TenantDto>(null as any);
    }
}

@Injectable()
export class TimeIntervalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TimeIntervalDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeInterval/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeIntervalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeIntervalDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TimeIntervalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeIntervalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TimeIntervalDto>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TimeIntervalDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeInterval/GetAll?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeIntervalDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeIntervalDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TimeIntervalDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeIntervalDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TimeIntervalDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTimeIntervalDto | undefined): Observable<TimeIntervalDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeInterval/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeIntervalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeIntervalDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TimeIntervalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeIntervalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TimeIntervalDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTimeIntervalDto | undefined): Observable<TimeIntervalDto> {
        let url_ = this.baseUrl + "/api/services/app/TimeInterval/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TimeIntervalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TimeIntervalDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TimeIntervalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TimeIntervalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TimeIntervalDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TimeInterval/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExternalAuthenticateResultModel>(null as any);
    }
}

@Injectable()
export class TopicServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TopicDto> {
        let url_ = this.baseUrl + "/api/services/app/Topic/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopicDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopicDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TopicDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopicDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopicDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTopicDto | undefined): Observable<TopicDto> {
        let url_ = this.baseUrl + "/api/services/app/Topic/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopicDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopicDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TopicDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopicDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopicDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTopicDto | undefined): Observable<TopicDto> {
        let url_ = this.baseUrl + "/api/services/app/Topic/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopicDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopicDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TopicDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopicDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopicDto>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TopicDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Topic/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopicDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopicDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TopicDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopicDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TopicDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Topic/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @return Success
     */
    getMyProfile(): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetMyProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetMyProfile(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    restore(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Restore?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRestore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRestore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRestore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    activate(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Activate?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    deactivate(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Deactivate?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    unlockLogin(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockLogin?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return Success
     */
    getRoles(): Observable<RoleDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RoleDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forceResetPassword(body: ForceResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ForceResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processForceResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getUsersAssignableInServiceOperatorByKeyword(keyword: string | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersAssignableInServiceOperatorByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersAssignableInServiceOperatorByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersAssignableInServiceOperatorByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetUsersAssignableInServiceOperatorByKeyword(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getUsersAssignableInServiceBeneficiaryByKeyword(keyword: string | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersAssignableInServiceBeneficiaryByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersAssignableInServiceBeneficiaryByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersAssignableInServiceBeneficiaryByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetUsersAssignableInServiceBeneficiaryByKeyword(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @return Success
     */
    getUsersByKeyword(keyword: string | undefined): Observable<BaseUserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BaseUserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BaseUserDto[]>;
        }));
    }

    protected processGetUsersByKeyword(response: HttpResponseBase): Observable<BaseUserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BaseUserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BaseUserDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param roleId (optional) 
     * @param roleName (optional) 
     * @param qualificationIds (optional) 
     * @param educationalDegreeIds (optional) 
     * @param professionalRegisterIds (optional) 
     * @param certificationIds (optional) 
     * @param contractTypeIds (optional) 
     * @param groupIds (optional) 
     * @param genderIds (optional) 
     * @param email (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    downloadExcel(keyword: string | undefined, isActive: boolean | undefined, roleId: number | undefined, roleName: string | undefined, qualificationIds: number[] | undefined, educationalDegreeIds: number[] | undefined, professionalRegisterIds: number[] | undefined, certificationIds: number[] | undefined, contractTypeIds: number[] | undefined, groupIds: number[] | undefined, genderIds: number[] | undefined, email: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileExcelDto> {
        let url_ = this.baseUrl + "/api/services/app/User/DownloadExcel?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (roleName === null)
            throw new Error("The parameter 'roleName' cannot be null.");
        else if (roleName !== undefined)
            url_ += "RoleName=" + encodeURIComponent("" + roleName) + "&";
        if (qualificationIds === null)
            throw new Error("The parameter 'qualificationIds' cannot be null.");
        else if (qualificationIds !== undefined)
            qualificationIds && qualificationIds.forEach(item => { url_ += "QualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (educationalDegreeIds === null)
            throw new Error("The parameter 'educationalDegreeIds' cannot be null.");
        else if (educationalDegreeIds !== undefined)
            educationalDegreeIds && educationalDegreeIds.forEach(item => { url_ += "EducationalDegreeIds=" + encodeURIComponent("" + item) + "&"; });
        if (professionalRegisterIds === null)
            throw new Error("The parameter 'professionalRegisterIds' cannot be null.");
        else if (professionalRegisterIds !== undefined)
            professionalRegisterIds && professionalRegisterIds.forEach(item => { url_ += "ProfessionalRegisterIds=" + encodeURIComponent("" + item) + "&"; });
        if (certificationIds === null)
            throw new Error("The parameter 'certificationIds' cannot be null.");
        else if (certificationIds !== undefined)
            certificationIds && certificationIds.forEach(item => { url_ += "CertificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (contractTypeIds === null)
            throw new Error("The parameter 'contractTypeIds' cannot be null.");
        else if (contractTypeIds !== undefined)
            contractTypeIds && contractTypeIds.forEach(item => { url_ += "ContractTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (groupIds === null)
            throw new Error("The parameter 'groupIds' cannot be null.");
        else if (groupIds !== undefined)
            groupIds && groupIds.forEach(item => { url_ += "GroupIds=" + encodeURIComponent("" + item) + "&"; });
        if (genderIds === null)
            throw new Error("The parameter 'genderIds' cannot be null.");
        else if (genderIds !== undefined)
            genderIds && genderIds.forEach(item => { url_ += "GenderIds=" + encodeURIComponent("" + item) + "&"; });
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExcelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExcelDto>;
        }));
    }

    protected processDownloadExcel(response: HttpResponseBase): Observable<FileExcelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExcelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileExcelDto>(null as any);
    }

    /**
     * @return Success
     */
    getAllGenders(): Observable<GenderDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAllGenders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllGenders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllGenders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenderDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenderDto[]>;
        }));
    }

    protected processGetAllGenders(response: HttpResponseBase): Observable<GenderDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GenderDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenderDto[]>(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    importBeneficiaries(file: FileParameter | undefined): Observable<FailedRowImportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/User/ImportBeneficiaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportBeneficiaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportBeneficiaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FailedRowImportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FailedRowImportDto[]>;
        }));
    }

    protected processImportBeneficiaries(response: HttpResponseBase): Observable<FailedRowImportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FailedRowImportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FailedRowImportDto[]>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param roleId (optional) 
     * @param roleName (optional) 
     * @param qualificationIds (optional) 
     * @param educationalDegreeIds (optional) 
     * @param professionalRegisterIds (optional) 
     * @param certificationIds (optional) 
     * @param contractTypeIds (optional) 
     * @param groupIds (optional) 
     * @param genderIds (optional) 
     * @param email (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, roleId: number | undefined, roleName: string | undefined, qualificationIds: number[] | undefined, educationalDegreeIds: number[] | undefined, professionalRegisterIds: number[] | undefined, certificationIds: number[] | undefined, contractTypeIds: number[] | undefined, groupIds: number[] | undefined, genderIds: number[] | undefined, email: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (roleName === null)
            throw new Error("The parameter 'roleName' cannot be null.");
        else if (roleName !== undefined)
            url_ += "RoleName=" + encodeURIComponent("" + roleName) + "&";
        if (qualificationIds === null)
            throw new Error("The parameter 'qualificationIds' cannot be null.");
        else if (qualificationIds !== undefined)
            qualificationIds && qualificationIds.forEach(item => { url_ += "QualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (educationalDegreeIds === null)
            throw new Error("The parameter 'educationalDegreeIds' cannot be null.");
        else if (educationalDegreeIds !== undefined)
            educationalDegreeIds && educationalDegreeIds.forEach(item => { url_ += "EducationalDegreeIds=" + encodeURIComponent("" + item) + "&"; });
        if (professionalRegisterIds === null)
            throw new Error("The parameter 'professionalRegisterIds' cannot be null.");
        else if (professionalRegisterIds !== undefined)
            professionalRegisterIds && professionalRegisterIds.forEach(item => { url_ += "ProfessionalRegisterIds=" + encodeURIComponent("" + item) + "&"; });
        if (certificationIds === null)
            throw new Error("The parameter 'certificationIds' cannot be null.");
        else if (certificationIds !== undefined)
            certificationIds && certificationIds.forEach(item => { url_ += "CertificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (contractTypeIds === null)
            throw new Error("The parameter 'contractTypeIds' cannot be null.");
        else if (contractTypeIds !== undefined)
            contractTypeIds && contractTypeIds.forEach(item => { url_ += "ContractTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (groupIds === null)
            throw new Error("The parameter 'groupIds' cannot be null.");
        else if (groupIds !== undefined)
            groupIds && groupIds.forEach(item => { url_ += "GroupIds=" + encodeURIComponent("" + item) + "&"; });
        if (genderIds === null)
            throw new Error("The parameter 'genderIds' cannot be null.");
        else if (genderIds !== undefined)
            genderIds && genderIds.forEach(item => { url_ += "GenderIds=" + encodeURIComponent("" + item) + "&"; });
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class UserCertificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: UserCertificationDto | undefined): Observable<UserCertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCertification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCertificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCertificationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserCertificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCertificationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserCertificationDto | undefined): Observable<UserCertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCertification/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCertificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCertificationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserCertificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCertificationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserCertificationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCertification/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCertificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCertificationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserCertificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCertificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCertificationDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserCertificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserCertification/GetAll?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserCertificationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserCertificationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserCertificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserCertificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserCertificationDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserCertification/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserEducationalDegreeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: UserEducationalDegreeDto | undefined): Observable<UserEducationalDegreeDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEducationalDegree/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEducationalDegreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEducationalDegreeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserEducationalDegreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEducationalDegreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserEducationalDegreeDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserEducationalDegreeDto | undefined): Observable<UserEducationalDegreeDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEducationalDegree/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEducationalDegreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEducationalDegreeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserEducationalDegreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEducationalDegreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserEducationalDegreeDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserEducationalDegreeDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEducationalDegree/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEducationalDegreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEducationalDegreeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserEducationalDegreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEducationalDegreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserEducationalDegreeDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserEducationalDegreeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserEducationalDegree/GetAll?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserEducationalDegreeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserEducationalDegreeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserEducationalDegreeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEducationalDegreeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserEducationalDegreeDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserEducationalDegree/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserFileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserMediaEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserMediaEventDto | undefined): Observable<UserMediaEventDto> {
        let url_ = this.baseUrl + "/api/services/app/UserMediaEvent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMediaEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMediaEventDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserMediaEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserMediaEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserMediaEventDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserMediaEventDto | undefined): Observable<UserMediaEventDto> {
        let url_ = this.baseUrl + "/api/services/app/UserMediaEvent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMediaEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMediaEventDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserMediaEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserMediaEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserMediaEventDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserMediaEventDto> {
        let url_ = this.baseUrl + "/api/services/app/UserMediaEvent/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMediaEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMediaEventDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserMediaEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserMediaEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserMediaEventDto>(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserMediaEventDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserMediaEvent/GetAll?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserMediaEventDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserMediaEventDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserMediaEventDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserMediaEventDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserMediaEventDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserMediaEvent/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserOrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUpdateUserOrganizationUnitDto | undefined): Observable<UserOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/UserOrganizationUnit/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOrganizationUnitDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserOrganizationUnitDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserOrganizationUnit/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param organizationUnitId (optional) 
     * @param roleId (optional) 
     * @param id (optional) 
     * @return Success
     */
    get(organizationUnitId: number | undefined, roleId: number | undefined, id: number | undefined): Observable<UserOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/UserOrganizationUnit/Get?";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOrganizationUnitDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserOrganizationUnitDto>(null as any);
    }

    /**
     * @param organizationUnitId (optional) 
     * @param roleIds (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(organizationUnitId: number | undefined, roleIds: number[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserOrganizationUnitDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserOrganizationUnit/GetAll?";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        if (roleIds === null)
            throw new Error("The parameter 'roleIds' cannot be null.");
        else if (roleIds !== undefined)
            roleIds && roleIds.forEach(item => { url_ += "RoleIds=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOrganizationUnitDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOrganizationUnitDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserOrganizationUnitDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserOrganizationUnitDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserOrganizationUnitDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CreateUpdateUserOrganizationUnitDto | undefined): Observable<UserOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/UserOrganizationUnit/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserOrganizationUnitDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserOrganizationUnitDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    checkIfUserIsInOrganizationUnit(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UserOrganizationUnit/CheckIfUserIsInOrganizationUnit?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfUserIsInOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfUserIsInOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfUserIsInOrganizationUnit(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    getAvailableUserForGroupByKeyword(keyword: string | undefined, organizationUnitId: number | undefined): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserOrganizationUnit/GetAvailableUserForGroupByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "keyword=" + encodeURIComponent("" + keyword) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "organizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableUserForGroupByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableUserForGroupByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetAvailableUserForGroupByKeyword(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserDto[]>(null as any);
    }
}

@Injectable()
export class UserParentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserParentDto | undefined): Observable<UserParentDto> {
        let url_ = this.baseUrl + "/api/services/app/UserParent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserParentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserParentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserParentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserParentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserParentDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserParentDto | undefined): Observable<UserParentDto> {
        let url_ = this.baseUrl + "/api/services/app/UserParent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserParentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserParentDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserParentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserParentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserParentDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    checkInvoicingExists(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/UserParent/CheckInvoicingExists?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckInvoicingExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckInvoicingExists(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckInvoicingExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserParentDto> {
        let url_ = this.baseUrl + "/api/services/app/UserParent/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserParentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserParentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserParentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserParentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserParentDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserParentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserParent/GetAll?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserParentDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserParentDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserParentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserParentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserParentDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserParent/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserParentFileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserParentFileDto | undefined): Observable<UserParentFileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserParentFile/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserParentFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserParentFileDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserParentFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserParentFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserParentFileDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserParentFileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserParentFile/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserParentFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserParentFileDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserParentFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserParentFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserParentFileDto>(null as any);
    }

    /**
     * @param userParentId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userParentId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserParentFileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserParentFile/GetAll?";
        if (userParentId === null)
            throw new Error("The parameter 'userParentId' cannot be null.");
        else if (userParentId !== undefined)
            url_ += "UserParentId=" + encodeURIComponent("" + userParentId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserParentFileDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserParentFileDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserParentFileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserParentFileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserParentFileDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: CreateUserParentFileDto | undefined): Observable<UserParentFileDto> {
        let url_ = this.baseUrl + "/api/services/app/UserParentFile/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserParentFileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserParentFileDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserParentFileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserParentFileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserParentFileDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserParentFile/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserProfessionalRegisterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: UserProfessionalRegisterDto | undefined): Observable<UserProfessionalRegisterDto> {
        let url_ = this.baseUrl + "/api/services/app/UserProfessionalRegister/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfessionalRegisterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfessionalRegisterDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserProfessionalRegisterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfessionalRegisterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProfessionalRegisterDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserProfessionalRegisterDto | undefined): Observable<UserProfessionalRegisterDto> {
        let url_ = this.baseUrl + "/api/services/app/UserProfessionalRegister/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfessionalRegisterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfessionalRegisterDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserProfessionalRegisterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfessionalRegisterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProfessionalRegisterDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserProfessionalRegisterDto> {
        let url_ = this.baseUrl + "/api/services/app/UserProfessionalRegister/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfessionalRegisterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfessionalRegisterDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserProfessionalRegisterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfessionalRegisterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProfessionalRegisterDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserProfessionalRegisterDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserProfessionalRegister/GetAll?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserProfessionalRegisterDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserProfessionalRegisterDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserProfessionalRegisterDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserProfessionalRegisterDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserProfessionalRegisterDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserProfessionalRegister/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserQualificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: UserQualificationDto | undefined): Observable<UserQualificationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserQualification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserQualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserQualificationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserQualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserQualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserQualificationDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserQualificationDto | undefined): Observable<UserQualificationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserQualification/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserQualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserQualificationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserQualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserQualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserQualificationDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserQualificationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserQualification/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserQualificationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserQualificationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserQualificationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserQualificationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserQualificationDto>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param keyword (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, keyword: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserQualificationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserQualification/GetAll?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserQualificationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserQualificationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserQualificationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserQualificationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserQualificationDtoPagedResultDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserQualification/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class UserReportPartialServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserReportPartialDto | undefined): Observable<UserReportPartialDto> {
        let url_ = this.baseUrl + "/api/services/app/UserReportPartial/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReportPartialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReportPartialDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserReportPartialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportPartialDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserReportPartialDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserReportPartialDto> {
        let url_ = this.baseUrl + "/api/services/app/UserReportPartial/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReportPartialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReportPartialDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserReportPartialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportPartialDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserReportPartialDto>(null as any);
    }

    /**
     * @param serviceReportId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceReportId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserReportPartialDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UserReportPartial/GetAll?";
        if (serviceReportId === null)
            throw new Error("The parameter 'serviceReportId' cannot be null.");
        else if (serviceReportId !== undefined)
            url_ += "ServiceReportId=" + encodeURIComponent("" + serviceReportId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReportPartialDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReportPartialDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserReportPartialDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportPartialDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserReportPartialDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UserReportPartialDto | undefined): Observable<UserReportPartialDto> {
        let url_ = this.baseUrl + "/api/services/app/UserReportPartial/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserReportPartialDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserReportPartialDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserReportPartialDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserReportPartialDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserReportPartialDto>(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserReportPartial/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WorkContractServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param keyword (optional) 
     * @param id (optional) 
     * @return Success
     */
    getAllByKeyword(keyword: string | undefined, id: number | undefined): Observable<WorkContractTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WorkContract/GetAllByKeyword?";
        if (keyword === null)
            throw new Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByKeyword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByKeyword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkContractTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkContractTypeDto[]>;
        }));
    }

    protected processGetAllByKeyword(response: HttpResponseBase): Observable<WorkContractTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkContractTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkContractTypeDto[]>(null as any);
    }
}

@Injectable()
export class WorkContractLevelDictionaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<WorkContractLevelDictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkContractLevelDictionary/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkContractLevelDictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkContractLevelDictionaryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WorkContractLevelDictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkContractLevelDictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkContractLevelDictionaryDto>(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<WorkContractLevelDictionaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WorkContractLevelDictionary/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkContractLevelDictionaryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkContractLevelDictionaryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WorkContractLevelDictionaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkContractLevelDictionaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<WorkContractLevelDictionaryDtoPagedResultDto>(null as any);
    }
}

export class ActivityCategoryDto implements IActivityCategoryDto {
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    color!: string | undefined;
    activityMacroCategory!: ActivityMacroCategoryDto;

    constructor(data?: IActivityCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.activityMacroCategory = _data["activityMacroCategory"] ? ActivityMacroCategoryDto.fromJS(_data["activityMacroCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["color"] = this.color;
        data["activityMacroCategory"] = this.activityMacroCategory ? this.activityMacroCategory.toJSON() : <any>undefined;
        return data;
    }

    clone(): ActivityCategoryDto {
        const json = this.toJSON();
        let result = new ActivityCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IActivityCategoryDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    color: string | undefined;
    activityMacroCategory: ActivityMacroCategoryDto;
}

export class ActivityCategoryDtoPagedResultDto implements IActivityCategoryDtoPagedResultDto {
    items!: ActivityCategoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IActivityCategoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActivityCategoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ActivityCategoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityCategoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ActivityCategoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ActivityCategoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IActivityCategoryDtoPagedResultDto {
    items: ActivityCategoryDto[] | undefined;
    totalCount: number;
}

export class ActivityCustomerDto implements IActivityCustomerDto {
    id!: number;
    customer!: CustomerDto;
    importPercentage!: number;
    partialCoFinancingPercentage!: number;
    reclaimedImport!: number;

    constructor(data?: IActivityCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.importPercentage = _data["importPercentage"];
            this.partialCoFinancingPercentage = _data["partialCoFinancingPercentage"];
            this.reclaimedImport = _data["reclaimedImport"];
        }
    }

    static fromJS(data: any): ActivityCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["importPercentage"] = this.importPercentage;
        data["partialCoFinancingPercentage"] = this.partialCoFinancingPercentage;
        data["reclaimedImport"] = this.reclaimedImport;
        return data;
    }

    clone(): ActivityCustomerDto {
        const json = this.toJSON();
        let result = new ActivityCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IActivityCustomerDto {
    id: number;
    customer: CustomerDto;
    importPercentage: number;
    partialCoFinancingPercentage: number;
    reclaimedImport: number;
}

export class ActivityDto implements IActivityDto {
    id!: number;
    contract!: ContractDto;
    title!: string | undefined;
    description!: string | undefined;
    totalCost!: number;
    totalCostWithIndirectPercentage!: number;
    headquarter!: string | undefined;
    localizations!: string | undefined;
    partners!: ActivityCustomerDto[] | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    outputs!: ActivityOutputDto[] | undefined;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            this.title = _data["title"];
            this.description = _data["description"];
            this.totalCost = _data["totalCost"];
            this.totalCostWithIndirectPercentage = _data["totalCostWithIndirectPercentage"];
            this.headquarter = _data["headquarter"];
            this.localizations = _data["localizations"];
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(ActivityCustomerDto.fromJS(item));
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["outputs"])) {
                this.outputs = [] as any;
                for (let item of _data["outputs"])
                    this.outputs!.push(ActivityOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["totalCost"] = this.totalCost;
        data["totalCostWithIndirectPercentage"] = this.totalCostWithIndirectPercentage;
        data["headquarter"] = this.headquarter;
        data["localizations"] = this.localizations;
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.outputs)) {
            data["outputs"] = [];
            for (let item of this.outputs)
                data["outputs"].push(item.toJSON());
        }
        return data;
    }

    clone(): ActivityDto {
        const json = this.toJSON();
        let result = new ActivityDto();
        result.init(json);
        return result;
    }
}

export interface IActivityDto {
    id: number;
    contract: ContractDto;
    title: string | undefined;
    description: string | undefined;
    totalCost: number;
    totalCostWithIndirectPercentage: number;
    headquarter: string | undefined;
    localizations: string | undefined;
    partners: ActivityCustomerDto[] | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    outputs: ActivityOutputDto[] | undefined;
}

export class ActivityDtoPagedResultDto implements IActivityDtoPagedResultDto {
    items!: ActivityDto[] | undefined;
    totalCount!: number;

    constructor(data?: IActivityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActivityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ActivityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ActivityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ActivityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IActivityDtoPagedResultDto {
    items: ActivityDto[] | undefined;
    totalCount: number;
}

export class ActivityMacroCategoryDto implements IActivityMacroCategoryDto {
    id!: number;
    title!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: IActivityMacroCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): ActivityMacroCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityMacroCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): ActivityMacroCategoryDto {
        const json = this.toJSON();
        let result = new ActivityMacroCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IActivityMacroCategoryDto {
    id: number;
    title: string | undefined;
    staticCode: string | undefined;
}

export class ActivityMacroCategoryDtoPagedResultDto implements IActivityMacroCategoryDtoPagedResultDto {
    items!: ActivityMacroCategoryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IActivityMacroCategoryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActivityMacroCategoryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ActivityMacroCategoryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityMacroCategoryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ActivityMacroCategoryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ActivityMacroCategoryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IActivityMacroCategoryDtoPagedResultDto {
    items: ActivityMacroCategoryDto[] | undefined;
    totalCount: number;
}

export class ActivityOutputDto implements IActivityOutputDto {
    id!: number;
    description!: string | undefined;
    amount!: number;
    canBeRemoved!: boolean;

    constructor(data?: IActivityOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.canBeRemoved = _data["canBeRemoved"];
        }
    }

    static fromJS(data: any): ActivityOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["canBeRemoved"] = this.canBeRemoved;
        return data;
    }

    clone(): ActivityOutputDto {
        const json = this.toJSON();
        let result = new ActivityOutputDto();
        result.init(json);
        return result;
    }
}

export interface IActivityOutputDto {
    id: number;
    description: string | undefined;
    amount: number;
    canBeRemoved: boolean;
}

export class ActivityOutputDtoPagedResultDto implements IActivityOutputDtoPagedResultDto {
    items!: ActivityOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: IActivityOutputDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActivityOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ActivityOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ActivityOutputDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ActivityOutputDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IActivityOutputDtoPagedResultDto {
    items: ActivityOutputDto[] | undefined;
    totalCount: number;
}

export class AddressCreateDto implements IAddressCreateDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    postalCode!: string | undefined;
    municipality!: MunicipalityDto;

    constructor(data?: IAddressCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.postalCode = _data["postalCode"];
            this.municipality = _data["municipality"] ? MunicipalityDto.fromJS(_data["municipality"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddressCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["postalCode"] = this.postalCode;
        data["municipality"] = this.municipality ? this.municipality.toJSON() : <any>undefined;
        return data;
    }

    clone(): AddressCreateDto {
        const json = this.toJSON();
        let result = new AddressCreateDto();
        result.init(json);
        return result;
    }
}

export interface IAddressCreateDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    postalCode: string | undefined;
    municipality: MunicipalityDto;
}

export class AddressDto implements IAddressDto {
    id!: number;
    name!: string | undefined;
    postalCode!: string | undefined;
    description!: string | undefined;
    isMain!: boolean;
    municipality!: MunicipalityDto;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.postalCode = _data["postalCode"];
            this.description = _data["description"];
            this.isMain = _data["isMain"];
            this.municipality = _data["municipality"] ? MunicipalityDto.fromJS(_data["municipality"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["postalCode"] = this.postalCode;
        data["description"] = this.description;
        data["isMain"] = this.isMain;
        data["municipality"] = this.municipality ? this.municipality.toJSON() : <any>undefined;
        return data;
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    id: number;
    name: string | undefined;
    postalCode: string | undefined;
    description: string | undefined;
    isMain: boolean;
    municipality: MunicipalityDto;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: moment.Moment;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : <any>undefined;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class ApprovalLevelCarbonCopyDto implements IApprovalLevelCarbonCopyDto {
    id!: number;
    user!: BaseUserDto;
    hrRequestOrganizationUnitsApproverId!: number;

    constructor(data?: IApprovalLevelCarbonCopyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? BaseUserDto.fromJS(_data["user"]) : <any>undefined;
            this.hrRequestOrganizationUnitsApproverId = _data["hrRequestOrganizationUnitsApproverId"];
        }
    }

    static fromJS(data: any): ApprovalLevelCarbonCopyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalLevelCarbonCopyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["hrRequestOrganizationUnitsApproverId"] = this.hrRequestOrganizationUnitsApproverId;
        return data;
    }

    clone(): ApprovalLevelCarbonCopyDto {
        const json = this.toJSON();
        let result = new ApprovalLevelCarbonCopyDto();
        result.init(json);
        return result;
    }
}

export interface IApprovalLevelCarbonCopyDto {
    id: number;
    user: BaseUserDto;
    hrRequestOrganizationUnitsApproverId: number;
}

export class AreaDto implements IAreaDto {
    id!: number;
    name!: string | undefined;
    tenantId!: number;

    constructor(data?: IAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): AreaDto {
        const json = this.toJSON();
        let result = new AreaDto();
        result.init(json);
        return result;
    }
}

export interface IAreaDto {
    id: number;
    name: string | undefined;
    tenantId: number;
}

export class AreaDtoPagedResultDto implements IAreaDtoPagedResultDto {
    items!: AreaDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAreaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AreaDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AreaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AreaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AreaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAreaDtoPagedResultDto {
    items: AreaDto[] | undefined;
    totalCount: number;
}

export class AssociatedFileEntitiesIdsDto implements IAssociatedFileEntitiesIdsDto {
    serviceIdDVR!: number | undefined;
    servicesId!: number[] | undefined;
    userIds!: number[] | undefined;
    contractIds!: number[] | undefined;
    hrRequestIds!: number[] | undefined;
    activityIds!: number[] | undefined;
    commitmentIds!: number[] | undefined;
    userParentId!: number | undefined;

    constructor(data?: IAssociatedFileEntitiesIdsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceIdDVR = _data["serviceIdDVR"];
            if (Array.isArray(_data["servicesId"])) {
                this.servicesId = [] as any;
                for (let item of _data["servicesId"])
                    this.servicesId!.push(item);
            }
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["contractIds"])) {
                this.contractIds = [] as any;
                for (let item of _data["contractIds"])
                    this.contractIds!.push(item);
            }
            if (Array.isArray(_data["hrRequestIds"])) {
                this.hrRequestIds = [] as any;
                for (let item of _data["hrRequestIds"])
                    this.hrRequestIds!.push(item);
            }
            if (Array.isArray(_data["activityIds"])) {
                this.activityIds = [] as any;
                for (let item of _data["activityIds"])
                    this.activityIds!.push(item);
            }
            if (Array.isArray(_data["commitmentIds"])) {
                this.commitmentIds = [] as any;
                for (let item of _data["commitmentIds"])
                    this.commitmentIds!.push(item);
            }
            this.userParentId = _data["userParentId"];
        }
    }

    static fromJS(data: any): AssociatedFileEntitiesIdsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssociatedFileEntitiesIdsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceIdDVR"] = this.serviceIdDVR;
        if (Array.isArray(this.servicesId)) {
            data["servicesId"] = [];
            for (let item of this.servicesId)
                data["servicesId"].push(item);
        }
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.contractIds)) {
            data["contractIds"] = [];
            for (let item of this.contractIds)
                data["contractIds"].push(item);
        }
        if (Array.isArray(this.hrRequestIds)) {
            data["hrRequestIds"] = [];
            for (let item of this.hrRequestIds)
                data["hrRequestIds"].push(item);
        }
        if (Array.isArray(this.activityIds)) {
            data["activityIds"] = [];
            for (let item of this.activityIds)
                data["activityIds"].push(item);
        }
        if (Array.isArray(this.commitmentIds)) {
            data["commitmentIds"] = [];
            for (let item of this.commitmentIds)
                data["commitmentIds"].push(item);
        }
        data["userParentId"] = this.userParentId;
        return data;
    }

    clone(): AssociatedFileEntitiesIdsDto {
        const json = this.toJSON();
        let result = new AssociatedFileEntitiesIdsDto();
        result.init(json);
        return result;
    }
}

export interface IAssociatedFileEntitiesIdsDto {
    serviceIdDVR: number | undefined;
    servicesId: number[] | undefined;
    userIds: number[] | undefined;
    contractIds: number[] | undefined;
    hrRequestIds: number[] | undefined;
    activityIds: number[] | undefined;
    commitmentIds: number[] | undefined;
    userParentId: number | undefined;
}

export class AttendanceDto implements IAttendanceDto {
    id!: number;
    group!: OrganizationUnitDto;
    beneficiary!: UserDto;
    date!: moment.Moment;
    entryDate!: moment.Moment;
    exitDate!: moment.Moment | undefined;
    isMissing!: boolean;
    isJustified!: boolean;
    nonAttendanceMotivation!: NonAttendanceMotivationDto;

    constructor(data?: IAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.group = _data["group"] ? OrganizationUnitDto.fromJS(_data["group"]) : <any>undefined;
            this.beneficiary = _data["beneficiary"] ? UserDto.fromJS(_data["beneficiary"]) : <any>undefined;
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.entryDate = _data["entryDate"] ? moment(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? moment(_data["exitDate"].toString()) : <any>undefined;
            this.isMissing = _data["isMissing"];
            this.isJustified = _data["isJustified"];
            this.nonAttendanceMotivation = _data["nonAttendanceMotivation"] ? NonAttendanceMotivationDto.fromJS(_data["nonAttendanceMotivation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["beneficiary"] = this.beneficiary ? this.beneficiary.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toISOString() : <any>undefined;
        data["isMissing"] = this.isMissing;
        data["isJustified"] = this.isJustified;
        data["nonAttendanceMotivation"] = this.nonAttendanceMotivation ? this.nonAttendanceMotivation.toJSON() : <any>undefined;
        return data;
    }

    clone(): AttendanceDto {
        const json = this.toJSON();
        let result = new AttendanceDto();
        result.init(json);
        return result;
    }
}

export interface IAttendanceDto {
    id: number;
    group: OrganizationUnitDto;
    beneficiary: UserDto;
    date: moment.Moment;
    entryDate: moment.Moment;
    exitDate: moment.Moment | undefined;
    isMissing: boolean;
    isJustified: boolean;
    nonAttendanceMotivation: NonAttendanceMotivationDto;
}

export class AttendanceDtoPagedResultDto implements IAttendanceDtoPagedResultDto {
    items!: AttendanceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAttendanceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AttendanceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AttendanceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AttendanceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AttendanceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AttendanceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAttendanceDtoPagedResultDto {
    items: AttendanceDto[] | undefined;
    totalCount: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    rememberClient!: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    userId!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class BaseUserDto implements IBaseUserDto {
    id!: number;
    readonly entityType!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    fullName!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    color!: string | undefined;

    constructor(data?: IBaseUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).entityType = _data["entityType"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): BaseUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["color"] = this.color;
        return data;
    }

    clone(): BaseUserDto {
        const json = this.toJSON();
        let result = new BaseUserDto();
        result.init(json);
        return result;
    }
}

export interface IBaseUserDto {
    id: number;
    entityType: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    color: string | undefined;
}

export class CategoryDictionaryDto implements ICategoryDictionaryDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: ICategoryDictionaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CategoryDictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): CategoryDictionaryDto {
        const json = this.toJSON();
        let result = new CategoryDictionaryDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryDictionaryDto {
    id: number;
    description: string | undefined;
}

export class CategoryDictionaryDtoPagedResultDto implements ICategoryDictionaryDtoPagedResultDto {
    items!: CategoryDictionaryDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICategoryDictionaryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CategoryDictionaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CategoryDictionaryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryDictionaryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CategoryDictionaryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CategoryDictionaryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryDictionaryDtoPagedResultDto {
    items: CategoryDictionaryDto[] | undefined;
    totalCount: number;
}

export class CertificationDto implements ICertificationDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: ICertificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CertificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): CertificationDto {
        const json = this.toJSON();
        let result = new CertificationDto();
        result.init(json);
        return result;
    }
}

export interface ICertificationDto {
    id: number;
    description: string | undefined;
}

export class CertificationDtoPagedResultDto implements ICertificationDtoPagedResultDto {
    items!: CertificationDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICertificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CertificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CertificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CertificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CertificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CertificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICertificationDtoPagedResultDto {
    items: CertificationDto[] | undefined;
    totalCount: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme!: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CheckResultDto implements ICheckResultDto {
    result!: boolean;
    message!: string | undefined;

    constructor(data?: ICheckResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CheckResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["message"] = this.message;
        return data;
    }

    clone(): CheckResultDto {
        const json = this.toJSON();
        let result = new CheckResultDto();
        result.init(json);
        return result;
    }
}

export interface ICheckResultDto {
    result: boolean;
    message: string | undefined;
}

export class ClockingDto implements IClockingDto {
    id!: number;
    service!: ServiceDto;
    group!: GroupDto;
    educator!: UserDto;
    date!: moment.Moment;
    timeIntervals!: TimeIntervalDto[] | undefined;

    constructor(data?: IClockingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
            this.group = _data["group"] ? GroupDto.fromJS(_data["group"]) : <any>undefined;
            this.educator = _data["educator"] ? UserDto.fromJS(_data["educator"]) : <any>undefined;
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["timeIntervals"])) {
                this.timeIntervals = [] as any;
                for (let item of _data["timeIntervals"])
                    this.timeIntervals!.push(TimeIntervalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ClockingDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClockingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["educator"] = this.educator ? this.educator.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.timeIntervals)) {
            data["timeIntervals"] = [];
            for (let item of this.timeIntervals)
                data["timeIntervals"].push(item.toJSON());
        }
        return data;
    }

    clone(): ClockingDto {
        const json = this.toJSON();
        let result = new ClockingDto();
        result.init(json);
        return result;
    }
}

export interface IClockingDto {
    id: number;
    service: ServiceDto;
    group: GroupDto;
    educator: UserDto;
    date: moment.Moment;
    timeIntervals: TimeIntervalDto[] | undefined;
}

export class ClockingDtoPagedResultDto implements IClockingDtoPagedResultDto {
    items!: ClockingDto[] | undefined;
    totalCount!: number;

    constructor(data?: IClockingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ClockingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ClockingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClockingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ClockingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ClockingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IClockingDtoPagedResultDto {
    items: ClockingDto[] | undefined;
    totalCount: number;
}

export class CommitmentDto implements ICommitmentDto {
    id!: number;
    subject!: CustomerDto;
    category!: CategoryDictionaryDto;
    costItem!: string | undefined;
    description!: string | undefined;
    menHours!: number | undefined;
    unitNumber!: number;
    unitCost!: number;
    totalCost!: number;
    totalCostWithIndirectPercentage!: number;
    coFinancingPercentage!: number;
    coFinancing!: number;
    grossCoFinancingWithIndirectPercentage!: number;
    unitOfMeasure!: string | undefined;
    requiredAmount!: number;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    outputs!: CommitmentOutputDto[] | undefined;
    activity!: ActivityDto;
    remainingCost!: number;
    staff!: UserDto;
    monthHours!: number;
    idCode!: string | undefined;
    registerType!: string | undefined;

    constructor(data?: ICommitmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"] ? CustomerDto.fromJS(_data["subject"]) : <any>undefined;
            this.category = _data["category"] ? CategoryDictionaryDto.fromJS(_data["category"]) : <any>undefined;
            this.costItem = _data["costItem"];
            this.description = _data["description"];
            this.menHours = _data["menHours"];
            this.unitNumber = _data["unitNumber"];
            this.unitCost = _data["unitCost"];
            this.totalCost = _data["totalCost"];
            this.totalCostWithIndirectPercentage = _data["totalCostWithIndirectPercentage"];
            this.coFinancingPercentage = _data["coFinancingPercentage"];
            this.coFinancing = _data["coFinancing"];
            this.grossCoFinancingWithIndirectPercentage = _data["grossCoFinancingWithIndirectPercentage"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.requiredAmount = _data["requiredAmount"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["outputs"])) {
                this.outputs = [] as any;
                for (let item of _data["outputs"])
                    this.outputs!.push(CommitmentOutputDto.fromJS(item));
            }
            this.activity = _data["activity"] ? ActivityDto.fromJS(_data["activity"]) : <any>undefined;
            this.remainingCost = _data["remainingCost"];
            this.staff = _data["staff"] ? UserDto.fromJS(_data["staff"]) : <any>undefined;
            this.monthHours = _data["monthHours"];
            this.idCode = _data["idCode"];
            this.registerType = _data["registerType"];
        }
    }

    static fromJS(data: any): CommitmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommitmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["costItem"] = this.costItem;
        data["description"] = this.description;
        data["menHours"] = this.menHours;
        data["unitNumber"] = this.unitNumber;
        data["unitCost"] = this.unitCost;
        data["totalCost"] = this.totalCost;
        data["totalCostWithIndirectPercentage"] = this.totalCostWithIndirectPercentage;
        data["coFinancingPercentage"] = this.coFinancingPercentage;
        data["coFinancing"] = this.coFinancing;
        data["grossCoFinancingWithIndirectPercentage"] = this.grossCoFinancingWithIndirectPercentage;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["requiredAmount"] = this.requiredAmount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.outputs)) {
            data["outputs"] = [];
            for (let item of this.outputs)
                data["outputs"].push(item.toJSON());
        }
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["remainingCost"] = this.remainingCost;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        data["monthHours"] = this.monthHours;
        data["idCode"] = this.idCode;
        data["registerType"] = this.registerType;
        return data;
    }

    clone(): CommitmentDto {
        const json = this.toJSON();
        let result = new CommitmentDto();
        result.init(json);
        return result;
    }
}

export interface ICommitmentDto {
    id: number;
    subject: CustomerDto;
    category: CategoryDictionaryDto;
    costItem: string | undefined;
    description: string | undefined;
    menHours: number | undefined;
    unitNumber: number;
    unitCost: number;
    totalCost: number;
    totalCostWithIndirectPercentage: number;
    coFinancingPercentage: number;
    coFinancing: number;
    grossCoFinancingWithIndirectPercentage: number;
    unitOfMeasure: string | undefined;
    requiredAmount: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    outputs: CommitmentOutputDto[] | undefined;
    activity: ActivityDto;
    remainingCost: number;
    staff: UserDto;
    monthHours: number;
    idCode: string | undefined;
    registerType: string | undefined;
}

export class CommitmentDtoPagedResultDto implements ICommitmentDtoPagedResultDto {
    items!: CommitmentDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICommitmentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CommitmentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CommitmentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommitmentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CommitmentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CommitmentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICommitmentDtoPagedResultDto {
    items: CommitmentDto[] | undefined;
    totalCount: number;
}

export class CommitmentOutputDto implements ICommitmentOutputDto {
    id!: number;
    amount!: number;
    activityOutputId!: number;
    outputDescription!: string | undefined;

    constructor(data?: ICommitmentOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.activityOutputId = _data["activityOutputId"];
            this.outputDescription = _data["outputDescription"];
        }
    }

    static fromJS(data: any): CommitmentOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommitmentOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["activityOutputId"] = this.activityOutputId;
        data["outputDescription"] = this.outputDescription;
        return data;
    }

    clone(): CommitmentOutputDto {
        const json = this.toJSON();
        let result = new CommitmentOutputDto();
        result.init(json);
        return result;
    }
}

export interface ICommitmentOutputDto {
    id: number;
    amount: number;
    activityOutputId: number;
    outputDescription: string | undefined;
}

export class CommitmentOutputDtoPagedResultDto implements ICommitmentOutputDtoPagedResultDto {
    items!: CommitmentOutputDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICommitmentOutputDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CommitmentOutputDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CommitmentOutputDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommitmentOutputDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CommitmentOutputDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CommitmentOutputDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICommitmentOutputDtoPagedResultDto {
    items: CommitmentOutputDto[] | undefined;
    totalCount: number;
}

export class ConferenceDto implements IConferenceDto {
    id!: number;
    title!: string | undefined;
    number!: number;

    constructor(data?: IConferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): ConferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["number"] = this.number;
        return data;
    }

    clone(): ConferenceDto {
        const json = this.toJSON();
        let result = new ConferenceDto();
        result.init(json);
        return result;
    }
}

export interface IConferenceDto {
    id: number;
    title: string | undefined;
    number: number;
}

export class ContactReportPartialUDSDto implements IContactReportPartialUDSDto {
    id!: number;
    creationTime!: moment.Moment;
    maleContacts!: number | undefined;
    femaleContacts!: number | undefined;
    nonBinaryContacts!: number | undefined;
    contactsUnder14!: number | undefined;
    contacts1418!: number | undefined;
    contacts1925!: number | undefined;
    contacts2640!: number | undefined;
    contacts4150!: number | undefined;
    contacts5165!: number | undefined;
    contactsOver65!: number | undefined;
    infoPoints!: InfoPointDto[] | undefined;
    territorialAnimationEvents!: TerritorialAnimationEventDto[] | undefined;

    constructor(data?: IContactReportPartialUDSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.maleContacts = _data["maleContacts"];
            this.femaleContacts = _data["femaleContacts"];
            this.nonBinaryContacts = _data["nonBinaryContacts"];
            this.contactsUnder14 = _data["contactsUnder14"];
            this.contacts1418 = _data["contacts1418"];
            this.contacts1925 = _data["contacts1925"];
            this.contacts2640 = _data["contacts2640"];
            this.contacts4150 = _data["contacts4150"];
            this.contacts5165 = _data["contacts5165"];
            this.contactsOver65 = _data["contactsOver65"];
            if (Array.isArray(_data["infoPoints"])) {
                this.infoPoints = [] as any;
                for (let item of _data["infoPoints"])
                    this.infoPoints!.push(InfoPointDto.fromJS(item));
            }
            if (Array.isArray(_data["territorialAnimationEvents"])) {
                this.territorialAnimationEvents = [] as any;
                for (let item of _data["territorialAnimationEvents"])
                    this.territorialAnimationEvents!.push(TerritorialAnimationEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContactReportPartialUDSDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactReportPartialUDSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["maleContacts"] = this.maleContacts;
        data["femaleContacts"] = this.femaleContacts;
        data["nonBinaryContacts"] = this.nonBinaryContacts;
        data["contactsUnder14"] = this.contactsUnder14;
        data["contacts1418"] = this.contacts1418;
        data["contacts1925"] = this.contacts1925;
        data["contacts2640"] = this.contacts2640;
        data["contacts4150"] = this.contacts4150;
        data["contacts5165"] = this.contacts5165;
        data["contactsOver65"] = this.contactsOver65;
        if (Array.isArray(this.infoPoints)) {
            data["infoPoints"] = [];
            for (let item of this.infoPoints)
                data["infoPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.territorialAnimationEvents)) {
            data["territorialAnimationEvents"] = [];
            for (let item of this.territorialAnimationEvents)
                data["territorialAnimationEvents"].push(item.toJSON());
        }
        return data;
    }

    clone(): ContactReportPartialUDSDto {
        const json = this.toJSON();
        let result = new ContactReportPartialUDSDto();
        result.init(json);
        return result;
    }
}

export interface IContactReportPartialUDSDto {
    id: number;
    creationTime: moment.Moment;
    maleContacts: number | undefined;
    femaleContacts: number | undefined;
    nonBinaryContacts: number | undefined;
    contactsUnder14: number | undefined;
    contacts1418: number | undefined;
    contacts1925: number | undefined;
    contacts2640: number | undefined;
    contacts4150: number | undefined;
    contacts5165: number | undefined;
    contactsOver65: number | undefined;
    infoPoints: InfoPointDto[] | undefined;
    territorialAnimationEvents: TerritorialAnimationEventDto[] | undefined;
}

export class ContactReportPartialUDSDtoPagedResultDto implements IContactReportPartialUDSDtoPagedResultDto {
    items!: ContactReportPartialUDSDto[] | undefined;
    totalCount!: number;

    constructor(data?: IContactReportPartialUDSDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContactReportPartialUDSDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ContactReportPartialUDSDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactReportPartialUDSDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ContactReportPartialUDSDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ContactReportPartialUDSDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IContactReportPartialUDSDtoPagedResultDto {
    items: ContactReportPartialUDSDto[] | undefined;
    totalCount: number;
}

export class ContactReportPartialWithClassesDto implements IContactReportPartialWithClassesDto {
    id!: number;
    creationTime!: moment.Moment;
    involvedSchools!: number | undefined;
    schoolNames!: string | undefined;
    involvedClasses!: number | undefined;
    maleStudents!: number | undefined;
    femaleStudents!: number | undefined;

    constructor(data?: IContactReportPartialWithClassesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.involvedSchools = _data["involvedSchools"];
            this.schoolNames = _data["schoolNames"];
            this.involvedClasses = _data["involvedClasses"];
            this.maleStudents = _data["maleStudents"];
            this.femaleStudents = _data["femaleStudents"];
        }
    }

    static fromJS(data: any): ContactReportPartialWithClassesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactReportPartialWithClassesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["involvedSchools"] = this.involvedSchools;
        data["schoolNames"] = this.schoolNames;
        data["involvedClasses"] = this.involvedClasses;
        data["maleStudents"] = this.maleStudents;
        data["femaleStudents"] = this.femaleStudents;
        return data;
    }

    clone(): ContactReportPartialWithClassesDto {
        const json = this.toJSON();
        let result = new ContactReportPartialWithClassesDto();
        result.init(json);
        return result;
    }
}

export interface IContactReportPartialWithClassesDto {
    id: number;
    creationTime: moment.Moment;
    involvedSchools: number | undefined;
    schoolNames: string | undefined;
    involvedClasses: number | undefined;
    maleStudents: number | undefined;
    femaleStudents: number | undefined;
}

export class ContactReportPartialWithClassesDtoPagedResultDto implements IContactReportPartialWithClassesDtoPagedResultDto {
    items!: ContactReportPartialWithClassesDto[] | undefined;
    totalCount!: number;

    constructor(data?: IContactReportPartialWithClassesDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContactReportPartialWithClassesDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ContactReportPartialWithClassesDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactReportPartialWithClassesDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ContactReportPartialWithClassesDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ContactReportPartialWithClassesDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IContactReportPartialWithClassesDtoPagedResultDto {
    items: ContactReportPartialWithClassesDto[] | undefined;
    totalCount: number;
}

export class ContractDto implements IContractDto {
    id!: number;
    title!: string | undefined;
    contractType!: ContractTypeDictionaryDto;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    amount!: number;
    indirectCostsPercentage!: number;
    coFinancingPercentage!: number;
    spendingThresholdsPercentage!: number;
    partners!: ContractPartnerDto[] | undefined;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.contractType = _data["contractType"] ? ContractTypeDictionaryDto.fromJS(_data["contractType"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.indirectCostsPercentage = _data["indirectCostsPercentage"];
            this.coFinancingPercentage = _data["coFinancingPercentage"];
            this.spendingThresholdsPercentage = _data["spendingThresholdsPercentage"];
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(ContractPartnerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["contractType"] = this.contractType ? this.contractType.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["indirectCostsPercentage"] = this.indirectCostsPercentage;
        data["coFinancingPercentage"] = this.coFinancingPercentage;
        data["spendingThresholdsPercentage"] = this.spendingThresholdsPercentage;
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        return data;
    }

    clone(): ContractDto {
        const json = this.toJSON();
        let result = new ContractDto();
        result.init(json);
        return result;
    }
}

export interface IContractDto {
    id: number;
    title: string | undefined;
    contractType: ContractTypeDictionaryDto;
    startDate: moment.Moment;
    endDate: moment.Moment;
    amount: number;
    indirectCostsPercentage: number;
    coFinancingPercentage: number;
    spendingThresholdsPercentage: number;
    partners: ContractPartnerDto[] | undefined;
}

export class ContractDtoPagedResultDto implements IContractDtoPagedResultDto {
    items!: ContractDto[] | undefined;
    totalCount!: number;

    constructor(data?: IContractDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContractDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ContractDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ContractDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ContractDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IContractDtoPagedResultDto {
    items: ContractDto[] | undefined;
    totalCount: number;
}

export class ContractFileDto implements IContractFileDto {
    id!: number;
    contract!: ContractDto;
    creationTime!: moment.Moment;

    constructor(data?: IContractFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContractFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ContractFileDto {
        const json = this.toJSON();
        let result = new ContractFileDto();
        result.init(json);
        return result;
    }
}

export interface IContractFileDto {
    id: number;
    contract: ContractDto;
    creationTime: moment.Moment;
}

export class ContractPartnerDto implements IContractPartnerDto {
    id!: number;
    customer!: CustomerDto;
    importPercentage!: number;
    partialCoFinancingPercentage!: number;
    reclaimedImport!: number;
    isLeader!: boolean;
    canBeRemoved!: boolean;

    constructor(data?: IContractPartnerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
            this.importPercentage = _data["importPercentage"];
            this.partialCoFinancingPercentage = _data["partialCoFinancingPercentage"];
            this.reclaimedImport = _data["reclaimedImport"];
            this.isLeader = _data["isLeader"];
            this.canBeRemoved = _data["canBeRemoved"];
        }
    }

    static fromJS(data: any): ContractPartnerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractPartnerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["importPercentage"] = this.importPercentage;
        data["partialCoFinancingPercentage"] = this.partialCoFinancingPercentage;
        data["reclaimedImport"] = this.reclaimedImport;
        data["isLeader"] = this.isLeader;
        data["canBeRemoved"] = this.canBeRemoved;
        return data;
    }

    clone(): ContractPartnerDto {
        const json = this.toJSON();
        let result = new ContractPartnerDto();
        result.init(json);
        return result;
    }
}

export interface IContractPartnerDto {
    id: number;
    customer: CustomerDto;
    importPercentage: number;
    partialCoFinancingPercentage: number;
    reclaimedImport: number;
    isLeader: boolean;
    canBeRemoved: boolean;
}

export class ContractPartnerDtoPagedResultDto implements IContractPartnerDtoPagedResultDto {
    items!: ContractPartnerDto[] | undefined;
    totalCount!: number;

    constructor(data?: IContractPartnerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContractPartnerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ContractPartnerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractPartnerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ContractPartnerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ContractPartnerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IContractPartnerDtoPagedResultDto {
    items: ContractPartnerDto[] | undefined;
    totalCount: number;
}

export class ContractTypeDictionaryDto implements IContractTypeDictionaryDto {
    id!: number;
    type!: string | undefined;

    constructor(data?: IContractTypeDictionaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ContractTypeDictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTypeDictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }

    clone(): ContractTypeDictionaryDto {
        const json = this.toJSON();
        let result = new ContractTypeDictionaryDto();
        result.init(json);
        return result;
    }
}

export interface IContractTypeDictionaryDto {
    id: number;
    type: string | undefined;
}

export class ContractTypeDictionaryDtoPagedResultDto implements IContractTypeDictionaryDtoPagedResultDto {
    items!: ContractTypeDictionaryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IContractTypeDictionaryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContractTypeDictionaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ContractTypeDictionaryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractTypeDictionaryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ContractTypeDictionaryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ContractTypeDictionaryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IContractTypeDictionaryDtoPagedResultDto {
    items: ContractTypeDictionaryDto[] | undefined;
    totalCount: number;
}

export class CreateActivityCategoryDto implements ICreateActivityCategoryDto {
    title!: string | undefined;
    description!: string | undefined;
    color!: string | undefined;
    activityMacroCategory!: Int64EntityDto;

    constructor(data?: ICreateActivityCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.activityMacroCategory = _data["activityMacroCategory"] ? Int64EntityDto.fromJS(_data["activityMacroCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateActivityCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["description"] = this.description;
        data["color"] = this.color;
        data["activityMacroCategory"] = this.activityMacroCategory ? this.activityMacroCategory.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateActivityCategoryDto {
        const json = this.toJSON();
        let result = new CreateActivityCategoryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateActivityCategoryDto {
    title: string | undefined;
    description: string | undefined;
    color: string | undefined;
    activityMacroCategory: Int64EntityDto;
}

export class CreateActivityDto implements ICreateActivityDto {
    contract!: Int64EntityDto;
    title!: string;
    description!: string | undefined;
    totalCost!: number;
    headquarter!: string | undefined;
    localizations!: string | undefined;
    partners!: ActivityCustomerDto[] | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    outputs!: CreateActivityOutputDto[];

    constructor(data?: ICreateActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contract = new Int64EntityDto();
            this.outputs = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contract = _data["contract"] ? Int64EntityDto.fromJS(_data["contract"]) : new Int64EntityDto();
            this.title = _data["title"];
            this.description = _data["description"];
            this.totalCost = _data["totalCost"];
            this.headquarter = _data["headquarter"];
            this.localizations = _data["localizations"];
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(ActivityCustomerDto.fromJS(item));
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["outputs"])) {
                this.outputs = [] as any;
                for (let item of _data["outputs"])
                    this.outputs!.push(CreateActivityOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["title"] = this.title;
        data["description"] = this.description;
        data["totalCost"] = this.totalCost;
        data["headquarter"] = this.headquarter;
        data["localizations"] = this.localizations;
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.outputs)) {
            data["outputs"] = [];
            for (let item of this.outputs)
                data["outputs"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateActivityDto {
        const json = this.toJSON();
        let result = new CreateActivityDto();
        result.init(json);
        return result;
    }
}

export interface ICreateActivityDto {
    contract: Int64EntityDto;
    title: string;
    description: string | undefined;
    totalCost: number;
    headquarter: string | undefined;
    localizations: string | undefined;
    partners: ActivityCustomerDto[] | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    outputs: CreateActivityOutputDto[];
}

export class CreateActivityMacroCategoryDto implements ICreateActivityMacroCategoryDto {
    title!: string | undefined;

    constructor(data?: ICreateActivityMacroCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): CreateActivityMacroCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityMacroCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        return data;
    }

    clone(): CreateActivityMacroCategoryDto {
        const json = this.toJSON();
        let result = new CreateActivityMacroCategoryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateActivityMacroCategoryDto {
    title: string | undefined;
}

export class CreateActivityOutputDto implements ICreateActivityOutputDto {
    description!: string | undefined;
    amount!: number;

    constructor(data?: ICreateActivityOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): CreateActivityOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["amount"] = this.amount;
        return data;
    }

    clone(): CreateActivityOutputDto {
        const json = this.toJSON();
        let result = new CreateActivityOutputDto();
        result.init(json);
        return result;
    }
}

export interface ICreateActivityOutputDto {
    description: string | undefined;
    amount: number;
}

export class CreateAttendanceDto implements ICreateAttendanceDto {
    group!: Int64EntityDto;
    beneficiary!: Int64EntityDto;
    date!: moment.Moment;
    entryDate!: moment.Moment;
    exitDate!: moment.Moment | undefined;
    isMissing!: boolean;
    isJustified!: boolean;
    motivation!: Int64EntityDto;

    constructor(data?: ICreateAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.group = new Int64EntityDto();
            this.beneficiary = new Int64EntityDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"] ? Int64EntityDto.fromJS(_data["group"]) : new Int64EntityDto();
            this.beneficiary = _data["beneficiary"] ? Int64EntityDto.fromJS(_data["beneficiary"]) : new Int64EntityDto();
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.entryDate = _data["entryDate"] ? moment(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? moment(_data["exitDate"].toString()) : <any>undefined;
            this.isMissing = _data["isMissing"];
            this.isJustified = _data["isJustified"];
            this.motivation = _data["motivation"] ? Int64EntityDto.fromJS(_data["motivation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["beneficiary"] = this.beneficiary ? this.beneficiary.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toISOString() : <any>undefined;
        data["isMissing"] = this.isMissing;
        data["isJustified"] = this.isJustified;
        data["motivation"] = this.motivation ? this.motivation.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateAttendanceDto {
        const json = this.toJSON();
        let result = new CreateAttendanceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAttendanceDto {
    group: Int64EntityDto;
    beneficiary: Int64EntityDto;
    date: moment.Moment;
    entryDate: moment.Moment;
    exitDate: moment.Moment | undefined;
    isMissing: boolean;
    isJustified: boolean;
    motivation: Int64EntityDto;
}

export class CreateClockingDto implements ICreateClockingDto {
    service!: Int64EntityDto;
    educator!: Int64EntityDto;
    group!: Int64EntityDto;
    date!: moment.Moment;
    timeIntervals!: CreateTimeIntervalDto[];

    constructor(data?: ICreateClockingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.service = new Int64EntityDto();
            this.educator = new Int64EntityDto();
            this.group = new Int64EntityDto();
            this.timeIntervals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"] ? Int64EntityDto.fromJS(_data["service"]) : new Int64EntityDto();
            this.educator = _data["educator"] ? Int64EntityDto.fromJS(_data["educator"]) : new Int64EntityDto();
            this.group = _data["group"] ? Int64EntityDto.fromJS(_data["group"]) : new Int64EntityDto();
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["timeIntervals"])) {
                this.timeIntervals = [] as any;
                for (let item of _data["timeIntervals"])
                    this.timeIntervals!.push(CreateTimeIntervalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateClockingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateClockingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["educator"] = this.educator ? this.educator.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.timeIntervals)) {
            data["timeIntervals"] = [];
            for (let item of this.timeIntervals)
                data["timeIntervals"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateClockingDto {
        const json = this.toJSON();
        let result = new CreateClockingDto();
        result.init(json);
        return result;
    }
}

export interface ICreateClockingDto {
    service: Int64EntityDto;
    educator: Int64EntityDto;
    group: Int64EntityDto;
    date: moment.Moment;
    timeIntervals: CreateTimeIntervalDto[];
}

export class CreateCommitmentDto implements ICreateCommitmentDto {
    subject!: Int64EntityDto;
    category!: Int64EntityDto;
    costItem!: string;
    description!: string | undefined;
    menHours!: number | undefined;
    unitNumber!: number;
    unitCost!: number;
    coFinancingPercentage!: number;
    coFinancing!: number;
    grossCoFinancingWithIndirectPercentage!: number;
    unitOfMeasure!: string | undefined;
    requiredAmount!: number;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    outputs!: CreateCommitmentOutputDto[] | undefined;
    activity!: Int64EntityDto;
    staff!: Int64EntityDto;
    idCode!: string | undefined;
    registerType!: string | undefined;

    constructor(data?: ICreateCommitmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subject = new Int64EntityDto();
            this.category = new Int64EntityDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"] ? Int64EntityDto.fromJS(_data["subject"]) : new Int64EntityDto();
            this.category = _data["category"] ? Int64EntityDto.fromJS(_data["category"]) : new Int64EntityDto();
            this.costItem = _data["costItem"];
            this.description = _data["description"];
            this.menHours = _data["menHours"];
            this.unitNumber = _data["unitNumber"];
            this.unitCost = _data["unitCost"];
            this.coFinancingPercentage = _data["coFinancingPercentage"];
            this.coFinancing = _data["coFinancing"];
            this.grossCoFinancingWithIndirectPercentage = _data["grossCoFinancingWithIndirectPercentage"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.requiredAmount = _data["requiredAmount"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["outputs"])) {
                this.outputs = [] as any;
                for (let item of _data["outputs"])
                    this.outputs!.push(CreateCommitmentOutputDto.fromJS(item));
            }
            this.activity = _data["activity"] ? Int64EntityDto.fromJS(_data["activity"]) : <any>undefined;
            this.staff = _data["staff"] ? Int64EntityDto.fromJS(_data["staff"]) : <any>undefined;
            this.idCode = _data["idCode"];
            this.registerType = _data["registerType"];
        }
    }

    static fromJS(data: any): CreateCommitmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommitmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["costItem"] = this.costItem;
        data["description"] = this.description;
        data["menHours"] = this.menHours;
        data["unitNumber"] = this.unitNumber;
        data["unitCost"] = this.unitCost;
        data["coFinancingPercentage"] = this.coFinancingPercentage;
        data["coFinancing"] = this.coFinancing;
        data["grossCoFinancingWithIndirectPercentage"] = this.grossCoFinancingWithIndirectPercentage;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["requiredAmount"] = this.requiredAmount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.outputs)) {
            data["outputs"] = [];
            for (let item of this.outputs)
                data["outputs"].push(item.toJSON());
        }
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        data["idCode"] = this.idCode;
        data["registerType"] = this.registerType;
        return data;
    }

    clone(): CreateCommitmentDto {
        const json = this.toJSON();
        let result = new CreateCommitmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCommitmentDto {
    subject: Int64EntityDto;
    category: Int64EntityDto;
    costItem: string;
    description: string | undefined;
    menHours: number | undefined;
    unitNumber: number;
    unitCost: number;
    coFinancingPercentage: number;
    coFinancing: number;
    grossCoFinancingWithIndirectPercentage: number;
    unitOfMeasure: string | undefined;
    requiredAmount: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    outputs: CreateCommitmentOutputDto[] | undefined;
    activity: Int64EntityDto;
    staff: Int64EntityDto;
    idCode: string | undefined;
    registerType: string | undefined;
}

export class CreateCommitmentOutputDto implements ICreateCommitmentOutputDto {
    amount!: number;
    activityOutputId!: number;

    constructor(data?: ICreateCommitmentOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.activityOutputId = _data["activityOutputId"];
        }
    }

    static fromJS(data: any): CreateCommitmentOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommitmentOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["activityOutputId"] = this.activityOutputId;
        return data;
    }

    clone(): CreateCommitmentOutputDto {
        const json = this.toJSON();
        let result = new CreateCommitmentOutputDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCommitmentOutputDto {
    amount: number;
    activityOutputId: number;
}

export class CreateContactReportPartialUDSDto implements ICreateContactReportPartialUDSDto {
    serviceReportId!: number;
    maleContacts!: number | undefined;
    femaleContacts!: number | undefined;
    nonBinaryContacts!: number | undefined;
    contactsUnder14!: number | undefined;
    contacts1418!: number | undefined;
    contacts1925!: number | undefined;
    contacts2640!: number | undefined;
    contacts4150!: number | undefined;
    contacts5165!: number | undefined;
    contactsOver65!: number | undefined;
    infoPoints!: InfoPointDto[] | undefined;
    territorialAnimationEvents!: TerritorialAnimationEventDto[] | undefined;

    constructor(data?: ICreateContactReportPartialUDSDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceReportId = _data["serviceReportId"];
            this.maleContacts = _data["maleContacts"];
            this.femaleContacts = _data["femaleContacts"];
            this.nonBinaryContacts = _data["nonBinaryContacts"];
            this.contactsUnder14 = _data["contactsUnder14"];
            this.contacts1418 = _data["contacts1418"];
            this.contacts1925 = _data["contacts1925"];
            this.contacts2640 = _data["contacts2640"];
            this.contacts4150 = _data["contacts4150"];
            this.contacts5165 = _data["contacts5165"];
            this.contactsOver65 = _data["contactsOver65"];
            if (Array.isArray(_data["infoPoints"])) {
                this.infoPoints = [] as any;
                for (let item of _data["infoPoints"])
                    this.infoPoints!.push(InfoPointDto.fromJS(item));
            }
            if (Array.isArray(_data["territorialAnimationEvents"])) {
                this.territorialAnimationEvents = [] as any;
                for (let item of _data["territorialAnimationEvents"])
                    this.territorialAnimationEvents!.push(TerritorialAnimationEventDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateContactReportPartialUDSDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactReportPartialUDSDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceReportId"] = this.serviceReportId;
        data["maleContacts"] = this.maleContacts;
        data["femaleContacts"] = this.femaleContacts;
        data["nonBinaryContacts"] = this.nonBinaryContacts;
        data["contactsUnder14"] = this.contactsUnder14;
        data["contacts1418"] = this.contacts1418;
        data["contacts1925"] = this.contacts1925;
        data["contacts2640"] = this.contacts2640;
        data["contacts4150"] = this.contacts4150;
        data["contacts5165"] = this.contacts5165;
        data["contactsOver65"] = this.contactsOver65;
        if (Array.isArray(this.infoPoints)) {
            data["infoPoints"] = [];
            for (let item of this.infoPoints)
                data["infoPoints"].push(item.toJSON());
        }
        if (Array.isArray(this.territorialAnimationEvents)) {
            data["territorialAnimationEvents"] = [];
            for (let item of this.territorialAnimationEvents)
                data["territorialAnimationEvents"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateContactReportPartialUDSDto {
        const json = this.toJSON();
        let result = new CreateContactReportPartialUDSDto();
        result.init(json);
        return result;
    }
}

export interface ICreateContactReportPartialUDSDto {
    serviceReportId: number;
    maleContacts: number | undefined;
    femaleContacts: number | undefined;
    nonBinaryContacts: number | undefined;
    contactsUnder14: number | undefined;
    contacts1418: number | undefined;
    contacts1925: number | undefined;
    contacts2640: number | undefined;
    contacts4150: number | undefined;
    contacts5165: number | undefined;
    contactsOver65: number | undefined;
    infoPoints: InfoPointDto[] | undefined;
    territorialAnimationEvents: TerritorialAnimationEventDto[] | undefined;
}

export class CreateContactReportPartialWithClassesDto implements ICreateContactReportPartialWithClassesDto {
    serviceReportId!: number;
    schoolNames!: string | undefined;
    involvedSchools!: number | undefined;
    involvedClasses!: number | undefined;
    maleStudents!: number | undefined;
    femaleStudents!: number | undefined;

    constructor(data?: ICreateContactReportPartialWithClassesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceReportId = _data["serviceReportId"];
            this.schoolNames = _data["schoolNames"];
            this.involvedSchools = _data["involvedSchools"];
            this.involvedClasses = _data["involvedClasses"];
            this.maleStudents = _data["maleStudents"];
            this.femaleStudents = _data["femaleStudents"];
        }
    }

    static fromJS(data: any): CreateContactReportPartialWithClassesDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContactReportPartialWithClassesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceReportId"] = this.serviceReportId;
        data["schoolNames"] = this.schoolNames;
        data["involvedSchools"] = this.involvedSchools;
        data["involvedClasses"] = this.involvedClasses;
        data["maleStudents"] = this.maleStudents;
        data["femaleStudents"] = this.femaleStudents;
        return data;
    }

    clone(): CreateContactReportPartialWithClassesDto {
        const json = this.toJSON();
        let result = new CreateContactReportPartialWithClassesDto();
        result.init(json);
        return result;
    }
}

export interface ICreateContactReportPartialWithClassesDto {
    serviceReportId: number;
    schoolNames: string | undefined;
    involvedSchools: number | undefined;
    involvedClasses: number | undefined;
    maleStudents: number | undefined;
    femaleStudents: number | undefined;
}

export class CreateContractDto implements ICreateContractDto {
    title!: string;
    contractType!: ContractTypeDictionaryDto;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    amount!: number;
    indirectCostsPercentage!: number;
    coFinancingPercentage!: number;
    partners!: ContractPartnerDto[] | undefined;
    spendingThresholdsPercentage!: number;

    constructor(data?: ICreateContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.contractType = _data["contractType"] ? ContractTypeDictionaryDto.fromJS(_data["contractType"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.amount = _data["amount"];
            this.indirectCostsPercentage = _data["indirectCostsPercentage"];
            this.coFinancingPercentage = _data["coFinancingPercentage"];
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(ContractPartnerDto.fromJS(item));
            }
            this.spendingThresholdsPercentage = _data["spendingThresholdsPercentage"];
        }
    }

    static fromJS(data: any): CreateContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["contractType"] = this.contractType ? this.contractType.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["amount"] = this.amount;
        data["indirectCostsPercentage"] = this.indirectCostsPercentage;
        data["coFinancingPercentage"] = this.coFinancingPercentage;
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        data["spendingThresholdsPercentage"] = this.spendingThresholdsPercentage;
        return data;
    }

    clone(): CreateContractDto {
        const json = this.toJSON();
        let result = new CreateContractDto();
        result.init(json);
        return result;
    }
}

export interface ICreateContractDto {
    title: string;
    contractType: ContractTypeDictionaryDto;
    startDate: moment.Moment;
    endDate: moment.Moment;
    amount: number;
    indirectCostsPercentage: number;
    coFinancingPercentage: number;
    partners: ContractPartnerDto[] | undefined;
    spendingThresholdsPercentage: number;
}

export class CreateCustomerDto implements ICreateCustomerDto {
    id!: number;
    businessName!: string | undefined;
    fiscalCode!: string | undefined;
    vatCode!: string | undefined;
    address!: AddressCreateDto;
    referent!: string | undefined;

    constructor(data?: ICreateCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.businessName = _data["businessName"];
            this.fiscalCode = _data["fiscalCode"];
            this.vatCode = _data["vatCode"];
            this.address = _data["address"] ? AddressCreateDto.fromJS(_data["address"]) : <any>undefined;
            this.referent = _data["referent"];
        }
    }

    static fromJS(data: any): CreateCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["businessName"] = this.businessName;
        data["fiscalCode"] = this.fiscalCode;
        data["vatCode"] = this.vatCode;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["referent"] = this.referent;
        return data;
    }

    clone(): CreateCustomerDto {
        const json = this.toJSON();
        let result = new CreateCustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomerDto {
    id: number;
    businessName: string | undefined;
    fiscalCode: string | undefined;
    vatCode: string | undefined;
    address: AddressCreateDto;
    referent: string | undefined;
}

export class CreatedHRRequestAndSupplyingObjectDto implements ICreatedHRRequestAndSupplyingObjectDto {
    hrRequestId!: number | undefined;
    hrRequestSupplyingObjectId!: number | undefined;
    name!: string | undefined;
    quantity!: number;
    unitPrice!: number;

    constructor(data?: ICreatedHRRequestAndSupplyingObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hrRequestId = _data["hrRequestId"];
            this.hrRequestSupplyingObjectId = _data["hrRequestSupplyingObjectId"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
        }
    }

    static fromJS(data: any): CreatedHRRequestAndSupplyingObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatedHRRequestAndSupplyingObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hrRequestId"] = this.hrRequestId;
        data["hrRequestSupplyingObjectId"] = this.hrRequestSupplyingObjectId;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        return data;
    }

    clone(): CreatedHRRequestAndSupplyingObjectDto {
        const json = this.toJSON();
        let result = new CreatedHRRequestAndSupplyingObjectDto();
        result.init(json);
        return result;
    }
}

export interface ICreatedHRRequestAndSupplyingObjectDto {
    hrRequestId: number | undefined;
    hrRequestSupplyingObjectId: number | undefined;
    name: string | undefined;
    quantity: number;
    unitPrice: number;
}

export class CreateFileDto implements ICreateFileDto {
    mask!: string | undefined;
    fileName!: string | undefined;
    fileContentType!: string | undefined;
    fileLength!: number;
    fileTypeId!: number;
    expirationDate!: string | undefined;
    associatedFileEntitiesIds!: AssociatedFileEntitiesIdsDto;

    constructor(data?: ICreateFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mask = _data["mask"];
            this.fileName = _data["fileName"];
            this.fileContentType = _data["fileContentType"];
            this.fileLength = _data["fileLength"];
            this.fileTypeId = _data["fileTypeId"];
            this.expirationDate = _data["expirationDate"];
            this.associatedFileEntitiesIds = _data["associatedFileEntitiesIds"] ? AssociatedFileEntitiesIdsDto.fromJS(_data["associatedFileEntitiesIds"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mask"] = this.mask;
        data["fileName"] = this.fileName;
        data["fileContentType"] = this.fileContentType;
        data["fileLength"] = this.fileLength;
        data["fileTypeId"] = this.fileTypeId;
        data["expirationDate"] = this.expirationDate;
        data["associatedFileEntitiesIds"] = this.associatedFileEntitiesIds ? this.associatedFileEntitiesIds.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateFileDto {
        const json = this.toJSON();
        let result = new CreateFileDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFileDto {
    mask: string | undefined;
    fileName: string | undefined;
    fileContentType: string | undefined;
    fileLength: number;
    fileTypeId: number;
    expirationDate: string | undefined;
    associatedFileEntitiesIds: AssociatedFileEntitiesIdsDto;
}

export class CreateGroupDto implements ICreateGroupDto {
    id!: number;
    displayName!: string | undefined;
    schoolYear!: Int64EntityDto;
    description!: string | undefined;

    constructor(data?: ICreateGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.schoolYear = _data["schoolYear"] ? Int64EntityDto.fromJS(_data["schoolYear"]) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["schoolYear"] = this.schoolYear ? this.schoolYear.toJSON() : <any>undefined;
        data["description"] = this.description;
        return data;
    }

    clone(): CreateGroupDto {
        const json = this.toJSON();
        let result = new CreateGroupDto();
        result.init(json);
        return result;
    }
}

export interface ICreateGroupDto {
    id: number;
    displayName: string | undefined;
    schoolYear: Int64EntityDto;
    description: string | undefined;
}

export class CreateHRRequestApprovalFlowDto implements ICreateHRRequestApprovalFlowDto {
    hrRequestId!: number;
    hrRequestOrganizationUnitsApproverId!: number;
    annotation!: string | undefined;
    isApproved!: boolean;
    isCancellationOperation!: boolean;

    constructor(data?: ICreateHRRequestApprovalFlowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hrRequestId = _data["hrRequestId"];
            this.hrRequestOrganizationUnitsApproverId = _data["hrRequestOrganizationUnitsApproverId"];
            this.annotation = _data["annotation"];
            this.isApproved = _data["isApproved"];
            this.isCancellationOperation = _data["isCancellationOperation"];
        }
    }

    static fromJS(data: any): CreateHRRequestApprovalFlowDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHRRequestApprovalFlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hrRequestId"] = this.hrRequestId;
        data["hrRequestOrganizationUnitsApproverId"] = this.hrRequestOrganizationUnitsApproverId;
        data["annotation"] = this.annotation;
        data["isApproved"] = this.isApproved;
        data["isCancellationOperation"] = this.isCancellationOperation;
        return data;
    }

    clone(): CreateHRRequestApprovalFlowDto {
        const json = this.toJSON();
        let result = new CreateHRRequestApprovalFlowDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHRRequestApprovalFlowDto {
    hrRequestId: number;
    hrRequestOrganizationUnitsApproverId: number;
    annotation: string | undefined;
    isApproved: boolean;
    isCancellationOperation: boolean;
}

export class CreateHRRequestDto implements ICreateHRRequestDto {
    user!: Int64EntityDto;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    totalDays!: number | undefined;
    totalHours!: number | undefined;
    hrRequestTypeId!: number;
    illnessCertNumber!: string | undefined;
    userAnnotation!: string | undefined;
    projectReference!: string | undefined;
    place!: string | undefined;
    activity!: string | undefined;
    deliveryPlace!: string | undefined;
    deliveryTime!: string | undefined;
    projectCode!: string | undefined;
    purchaseReason!: string | undefined;
    purchaseTypeId!: number;
    supplier!: string | undefined;
    paymentTypeId!: number;
    currencyTypeId!: number;

    constructor(data?: ICreateHRRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? Int64EntityDto.fromJS(_data["user"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.totalDays = _data["totalDays"];
            this.totalHours = _data["totalHours"];
            this.hrRequestTypeId = _data["hrRequestTypeId"];
            this.illnessCertNumber = _data["illnessCertNumber"];
            this.userAnnotation = _data["userAnnotation"];
            this.projectReference = _data["projectReference"];
            this.place = _data["place"];
            this.activity = _data["activity"];
            this.deliveryPlace = _data["deliveryPlace"];
            this.deliveryTime = _data["deliveryTime"];
            this.projectCode = _data["projectCode"];
            this.purchaseReason = _data["purchaseReason"];
            this.purchaseTypeId = _data["purchaseTypeId"];
            this.supplier = _data["supplier"];
            this.paymentTypeId = _data["paymentTypeId"];
            this.currencyTypeId = _data["currencyTypeId"];
        }
    }

    static fromJS(data: any): CreateHRRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHRRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["hrRequestTypeId"] = this.hrRequestTypeId;
        data["illnessCertNumber"] = this.illnessCertNumber;
        data["userAnnotation"] = this.userAnnotation;
        data["projectReference"] = this.projectReference;
        data["place"] = this.place;
        data["activity"] = this.activity;
        data["deliveryPlace"] = this.deliveryPlace;
        data["deliveryTime"] = this.deliveryTime;
        data["projectCode"] = this.projectCode;
        data["purchaseReason"] = this.purchaseReason;
        data["purchaseTypeId"] = this.purchaseTypeId;
        data["supplier"] = this.supplier;
        data["paymentTypeId"] = this.paymentTypeId;
        data["currencyTypeId"] = this.currencyTypeId;
        return data;
    }

    clone(): CreateHRRequestDto {
        const json = this.toJSON();
        let result = new CreateHRRequestDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHRRequestDto {
    user: Int64EntityDto;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    totalDays: number | undefined;
    totalHours: number | undefined;
    hrRequestTypeId: number;
    illnessCertNumber: string | undefined;
    userAnnotation: string | undefined;
    projectReference: string | undefined;
    place: string | undefined;
    activity: string | undefined;
    deliveryPlace: string | undefined;
    deliveryTime: string | undefined;
    projectCode: string | undefined;
    purchaseReason: string | undefined;
    purchaseTypeId: number;
    supplier: string | undefined;
    paymentTypeId: number;
    currencyTypeId: number;
}

export class CreateHRRequestOrganizationUnitsApproverDto implements ICreateHRRequestOrganizationUnitsApproverDto {
    userId!: number;
    hrRequestTypeOrganizationUnitId!: number;

    constructor(data?: ICreateHRRequestOrganizationUnitsApproverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.hrRequestTypeOrganizationUnitId = _data["hrRequestTypeOrganizationUnitId"];
        }
    }

    static fromJS(data: any): CreateHRRequestOrganizationUnitsApproverDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHRRequestOrganizationUnitsApproverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["hrRequestTypeOrganizationUnitId"] = this.hrRequestTypeOrganizationUnitId;
        return data;
    }

    clone(): CreateHRRequestOrganizationUnitsApproverDto {
        const json = this.toJSON();
        let result = new CreateHRRequestOrganizationUnitsApproverDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHRRequestOrganizationUnitsApproverDto {
    userId: number;
    hrRequestTypeOrganizationUnitId: number;
}

export class CreateMediaEventDto implements ICreateMediaEventDto {
    description!: string | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    service!: Int64EntityDto;
    group!: Int64EntityDto;
    mediaIds!: number[] | undefined;
    activityCategory!: Int64EntityDto;
    userIds!: number[] | undefined;
    usersHours!: string | undefined;

    constructor(data?: ICreateMediaEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.service = new Int64EntityDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.service = _data["service"] ? Int64EntityDto.fromJS(_data["service"]) : new Int64EntityDto();
            this.group = _data["group"] ? Int64EntityDto.fromJS(_data["group"]) : <any>undefined;
            if (Array.isArray(_data["mediaIds"])) {
                this.mediaIds = [] as any;
                for (let item of _data["mediaIds"])
                    this.mediaIds!.push(item);
            }
            this.activityCategory = _data["activityCategory"] ? Int64EntityDto.fromJS(_data["activityCategory"]) : <any>undefined;
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.usersHours = _data["usersHours"];
        }
    }

    static fromJS(data: any): CreateMediaEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMediaEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        if (Array.isArray(this.mediaIds)) {
            data["mediaIds"] = [];
            for (let item of this.mediaIds)
                data["mediaIds"].push(item);
        }
        data["activityCategory"] = this.activityCategory ? this.activityCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["usersHours"] = this.usersHours;
        return data;
    }

    clone(): CreateMediaEventDto {
        const json = this.toJSON();
        let result = new CreateMediaEventDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMediaEventDto {
    description: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    service: Int64EntityDto;
    group: Int64EntityDto;
    mediaIds: number[] | undefined;
    activityCategory: Int64EntityDto;
    userIds: number[] | undefined;
    usersHours: string | undefined;
}

export class CreateMessageDto implements ICreateMessageDto {
    text!: string | undefined;
    topicId!: number;
    fileIds!: number[] | undefined;

    constructor(data?: ICreateMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.topicId = _data["topicId"];
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["topicId"] = this.topicId;
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        return data;
    }

    clone(): CreateMessageDto {
        const json = this.toJSON();
        let result = new CreateMessageDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMessageDto {
    text: string | undefined;
    topicId: number;
    fileIds: number[] | undefined;
}

export class CreateMultipleServiceOperatorScheduledDto implements ICreateMultipleServiceOperatorScheduledDto {
    serviceOperatorId!: number;
    serviceOperatorsScheduled!: MultipleServiceOperatorScheduledDto[] | undefined;

    constructor(data?: ICreateMultipleServiceOperatorScheduledDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceOperatorId = _data["serviceOperatorId"];
            if (Array.isArray(_data["serviceOperatorsScheduled"])) {
                this.serviceOperatorsScheduled = [] as any;
                for (let item of _data["serviceOperatorsScheduled"])
                    this.serviceOperatorsScheduled!.push(MultipleServiceOperatorScheduledDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMultipleServiceOperatorScheduledDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMultipleServiceOperatorScheduledDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceOperatorId"] = this.serviceOperatorId;
        if (Array.isArray(this.serviceOperatorsScheduled)) {
            data["serviceOperatorsScheduled"] = [];
            for (let item of this.serviceOperatorsScheduled)
                data["serviceOperatorsScheduled"].push(item.toJSON());
        }
        return data;
    }

    clone(): CreateMultipleServiceOperatorScheduledDto {
        const json = this.toJSON();
        let result = new CreateMultipleServiceOperatorScheduledDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMultipleServiceOperatorScheduledDto {
    serviceOperatorId: number;
    serviceOperatorsScheduled: MultipleServiceOperatorScheduledDto[] | undefined;
}

export class CreatePlanningDto implements ICreatePlanningDto {
    service!: Int64EntityDto;
    group!: Int64EntityDto;
    educator!: Int64EntityDto;
    timeIntervals!: TimeIntervalDto[];
    date!: moment.Moment;
    annotation!: string | undefined;
    childrenCount!: number;

    constructor(data?: ICreatePlanningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.service = new Int64EntityDto();
            this.group = new Int64EntityDto();
            this.educator = new Int64EntityDto();
            this.timeIntervals = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"] ? Int64EntityDto.fromJS(_data["service"]) : new Int64EntityDto();
            this.group = _data["group"] ? Int64EntityDto.fromJS(_data["group"]) : new Int64EntityDto();
            this.educator = _data["educator"] ? Int64EntityDto.fromJS(_data["educator"]) : new Int64EntityDto();
            if (Array.isArray(_data["timeIntervals"])) {
                this.timeIntervals = [] as any;
                for (let item of _data["timeIntervals"])
                    this.timeIntervals!.push(TimeIntervalDto.fromJS(item));
            }
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.annotation = _data["annotation"];
            this.childrenCount = _data["childrenCount"];
        }
    }

    static fromJS(data: any): CreatePlanningDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlanningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["educator"] = this.educator ? this.educator.toJSON() : <any>undefined;
        if (Array.isArray(this.timeIntervals)) {
            data["timeIntervals"] = [];
            for (let item of this.timeIntervals)
                data["timeIntervals"].push(item.toJSON());
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["annotation"] = this.annotation;
        data["childrenCount"] = this.childrenCount;
        return data;
    }

    clone(): CreatePlanningDto {
        const json = this.toJSON();
        let result = new CreatePlanningDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePlanningDto {
    service: Int64EntityDto;
    group: Int64EntityDto;
    educator: Int64EntityDto;
    timeIntervals: TimeIntervalDto[];
    date: moment.Moment;
    annotation: string | undefined;
    childrenCount: number;
}

export class CreateReceiptDto implements ICreateReceiptDto {
    title!: string | undefined;
    commitment!: Int64EntityDto;
    outputs!: ReceiptOutputDto[] | undefined;
    amount!: number;
    billingDate!: moment.Moment;
    fileIds!: number[] | undefined;
    feePerHour!: number | undefined;
    workedHours!: number | undefined;
    duePaycheck!: Int64EntityDto;

    constructor(data?: ICreateReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"];
            this.commitment = _data["commitment"] ? Int64EntityDto.fromJS(_data["commitment"]) : <any>undefined;
            if (Array.isArray(_data["outputs"])) {
                this.outputs = [] as any;
                for (let item of _data["outputs"])
                    this.outputs!.push(ReceiptOutputDto.fromJS(item));
            }
            this.amount = _data["amount"];
            this.billingDate = _data["billingDate"] ? moment(_data["billingDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
            this.feePerHour = _data["feePerHour"];
            this.workedHours = _data["workedHours"];
            this.duePaycheck = _data["duePaycheck"] ? Int64EntityDto.fromJS(_data["duePaycheck"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["commitment"] = this.commitment ? this.commitment.toJSON() : <any>undefined;
        if (Array.isArray(this.outputs)) {
            data["outputs"] = [];
            for (let item of this.outputs)
                data["outputs"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["billingDate"] = this.billingDate ? this.billingDate.toISOString() : <any>undefined;
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        data["feePerHour"] = this.feePerHour;
        data["workedHours"] = this.workedHours;
        data["duePaycheck"] = this.duePaycheck ? this.duePaycheck.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateReceiptDto {
        const json = this.toJSON();
        let result = new CreateReceiptDto();
        result.init(json);
        return result;
    }
}

export interface ICreateReceiptDto {
    title: string | undefined;
    commitment: Int64EntityDto;
    outputs: ReceiptOutputDto[] | undefined;
    amount: number;
    billingDate: moment.Moment;
    fileIds: number[] | undefined;
    feePerHour: number | undefined;
    workedHours: number | undefined;
    duePaycheck: Int64EntityDto;
}

export class CreateRoleDto implements ICreateRoleDto {
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateScheduledEventDto implements ICreateScheduledEventDto {
    entityId!: number;
    entityType!: string | undefined;
    eventName!: string | undefined;
    description!: string | undefined;
    groupIds!: number[] | undefined;
    roleIds!: number[] | undefined;
    color!: string | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    reminder!: Int64EntityDto;
    service!: Int64EntityDto;

    constructor(data?: ICreateScheduledEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            this.eventName = _data["eventName"];
            this.description = _data["description"];
            if (Array.isArray(_data["groupIds"])) {
                this.groupIds = [] as any;
                for (let item of _data["groupIds"])
                    this.groupIds!.push(item);
            }
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.color = _data["color"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.reminder = _data["reminder"] ? Int64EntityDto.fromJS(_data["reminder"]) : <any>undefined;
            this.service = _data["service"] ? Int64EntityDto.fromJS(_data["service"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateScheduledEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScheduledEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        data["eventName"] = this.eventName;
        data["description"] = this.description;
        if (Array.isArray(this.groupIds)) {
            data["groupIds"] = [];
            for (let item of this.groupIds)
                data["groupIds"].push(item);
        }
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["color"] = this.color;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["reminder"] = this.reminder ? this.reminder.toJSON() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateScheduledEventDto {
        const json = this.toJSON();
        let result = new CreateScheduledEventDto();
        result.init(json);
        return result;
    }
}

export interface ICreateScheduledEventDto {
    entityId: number;
    entityType: string | undefined;
    eventName: string | undefined;
    description: string | undefined;
    groupIds: number[] | undefined;
    roleIds: number[] | undefined;
    color: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    reminder: Int64EntityDto;
    service: Int64EntityDto;
}

export class CreateScheduledNotificationDto implements ICreateScheduledNotificationDto {
    entityId!: number;
    entityType!: string | undefined;
    notificationName!: string | undefined;
    description!: string | undefined;
    userIds!: number[] | undefined;
    dueDate!: moment.Moment;
    reminder!: Int64EntityDto;

    constructor(data?: ICreateScheduledNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            this.notificationName = _data["notificationName"];
            this.description = _data["description"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.reminder = _data["reminder"] ? Int64EntityDto.fromJS(_data["reminder"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateScheduledNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScheduledNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        data["notificationName"] = this.notificationName;
        data["description"] = this.description;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["reminder"] = this.reminder ? this.reminder.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateScheduledNotificationDto {
        const json = this.toJSON();
        let result = new CreateScheduledNotificationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateScheduledNotificationDto {
    entityId: number;
    entityType: string | undefined;
    notificationName: string | undefined;
    description: string | undefined;
    userIds: number[] | undefined;
    dueDate: moment.Moment;
    reminder: Int64EntityDto;
}

export class CreateScheduledNotificationUserDto implements ICreateScheduledNotificationUserDto {
    userId!: number;
    scheduledNotificationId!: string;

    constructor(data?: ICreateScheduledNotificationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.scheduledNotificationId = _data["scheduledNotificationId"];
        }
    }

    static fromJS(data: any): CreateScheduledNotificationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScheduledNotificationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["scheduledNotificationId"] = this.scheduledNotificationId;
        return data;
    }

    clone(): CreateScheduledNotificationUserDto {
        const json = this.toJSON();
        let result = new CreateScheduledNotificationUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateScheduledNotificationUserDto {
    userId: number;
    scheduledNotificationId: string;
}

export class CreateServiceBeneficiaryDto implements ICreateServiceBeneficiaryDto {
    serviceId!: number;
    beneficiaryId!: number;

    constructor(data?: ICreateServiceBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.beneficiaryId = _data["beneficiaryId"];
        }
    }

    static fromJS(data: any): CreateServiceBeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceBeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["beneficiaryId"] = this.beneficiaryId;
        return data;
    }

    clone(): CreateServiceBeneficiaryDto {
        const json = this.toJSON();
        let result = new CreateServiceBeneficiaryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceBeneficiaryDto {
    serviceId: number;
    beneficiaryId: number;
}

export class CreateServiceDto implements ICreateServiceDto {
    id!: number;
    contractId!: number | undefined;
    dvrFileId!: number;
    description!: string;
    userAmount!: number;
    dpi!: string | undefined;
    totalHour!: number | undefined;
    fundAmount!: number | undefined;
    referenceTerritories!: string | undefined;
    areasOfService!: AreaDto[];
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    referenceUser!: string | undefined;
    isClosed!: boolean;
    requiredProfiles!: string | undefined;
    customers!: CustomerDto[] | undefined;
    annotation!: string | undefined;
    schoolYear!: Int64EntityDto;

    constructor(data?: ICreateServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.areasOfService = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractId = _data["contractId"];
            this.dvrFileId = _data["dvrFileId"];
            this.description = _data["description"];
            this.userAmount = _data["userAmount"];
            this.dpi = _data["dpi"];
            this.totalHour = _data["totalHour"];
            this.fundAmount = _data["fundAmount"];
            this.referenceTerritories = _data["referenceTerritories"];
            if (Array.isArray(_data["areasOfService"])) {
                this.areasOfService = [] as any;
                for (let item of _data["areasOfService"])
                    this.areasOfService!.push(AreaDto.fromJS(item));
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.referenceUser = _data["referenceUser"];
            this.isClosed = _data["isClosed"];
            this.requiredProfiles = _data["requiredProfiles"];
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(CustomerDto.fromJS(item));
            }
            this.annotation = _data["annotation"];
            this.schoolYear = _data["schoolYear"] ? Int64EntityDto.fromJS(_data["schoolYear"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractId"] = this.contractId;
        data["dvrFileId"] = this.dvrFileId;
        data["description"] = this.description;
        data["userAmount"] = this.userAmount;
        data["dpi"] = this.dpi;
        data["totalHour"] = this.totalHour;
        data["fundAmount"] = this.fundAmount;
        data["referenceTerritories"] = this.referenceTerritories;
        if (Array.isArray(this.areasOfService)) {
            data["areasOfService"] = [];
            for (let item of this.areasOfService)
                data["areasOfService"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["referenceUser"] = this.referenceUser;
        data["isClosed"] = this.isClosed;
        data["requiredProfiles"] = this.requiredProfiles;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["annotation"] = this.annotation;
        data["schoolYear"] = this.schoolYear ? this.schoolYear.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateServiceDto {
        const json = this.toJSON();
        let result = new CreateServiceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceDto {
    id: number;
    contractId: number | undefined;
    dvrFileId: number;
    description: string;
    userAmount: number;
    dpi: string | undefined;
    totalHour: number | undefined;
    fundAmount: number | undefined;
    referenceTerritories: string | undefined;
    areasOfService: AreaDto[];
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    referenceUser: string | undefined;
    isClosed: boolean;
    requiredProfiles: string | undefined;
    customers: CustomerDto[] | undefined;
    annotation: string | undefined;
    schoolYear: Int64EntityDto;
}

export class CreateServiceGroupDto implements ICreateServiceGroupDto {
    id!: number;
    serviceId!: number;
    groupId!: number;

    constructor(data?: ICreateServiceGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): CreateServiceGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["groupId"] = this.groupId;
        return data;
    }

    clone(): CreateServiceGroupDto {
        const json = this.toJSON();
        let result = new CreateServiceGroupDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceGroupDto {
    id: number;
    serviceId: number;
    groupId: number;
}

export class CreateServiceOperatorBeneficiaryDto implements ICreateServiceOperatorBeneficiaryDto {
    serviceOperatorScheduledId!: number;
    serviceBeneficiaryId!: number;

    constructor(data?: ICreateServiceOperatorBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceOperatorScheduledId = _data["serviceOperatorScheduledId"];
            this.serviceBeneficiaryId = _data["serviceBeneficiaryId"];
        }
    }

    static fromJS(data: any): CreateServiceOperatorBeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceOperatorBeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceOperatorScheduledId"] = this.serviceOperatorScheduledId;
        data["serviceBeneficiaryId"] = this.serviceBeneficiaryId;
        return data;
    }

    clone(): CreateServiceOperatorBeneficiaryDto {
        const json = this.toJSON();
        let result = new CreateServiceOperatorBeneficiaryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceOperatorBeneficiaryDto {
    serviceOperatorScheduledId: number;
    serviceBeneficiaryId: number;
}

export class CreateServiceOperatorDto implements ICreateServiceOperatorDto {
    serviceId!: number;
    operatorId!: number;
    hourPerUserPredicted!: number | undefined;
    hourPerUserAtClosure!: number | undefined;
    workShiftFrequencyType!: WorkShiftFrequencyTypeDto;
    hoursAtPeriod!: number | undefined;
    feePerHour!: number | undefined;
    isCoordinator!: boolean;

    constructor(data?: ICreateServiceOperatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.operatorId = _data["operatorId"];
            this.hourPerUserPredicted = _data["hourPerUserPredicted"];
            this.hourPerUserAtClosure = _data["hourPerUserAtClosure"];
            this.workShiftFrequencyType = _data["workShiftFrequencyType"] ? WorkShiftFrequencyTypeDto.fromJS(_data["workShiftFrequencyType"]) : <any>undefined;
            this.hoursAtPeriod = _data["hoursAtPeriod"];
            this.feePerHour = _data["feePerHour"];
            this.isCoordinator = _data["isCoordinator"];
        }
    }

    static fromJS(data: any): CreateServiceOperatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceOperatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["operatorId"] = this.operatorId;
        data["hourPerUserPredicted"] = this.hourPerUserPredicted;
        data["hourPerUserAtClosure"] = this.hourPerUserAtClosure;
        data["workShiftFrequencyType"] = this.workShiftFrequencyType ? this.workShiftFrequencyType.toJSON() : <any>undefined;
        data["hoursAtPeriod"] = this.hoursAtPeriod;
        data["feePerHour"] = this.feePerHour;
        data["isCoordinator"] = this.isCoordinator;
        return data;
    }

    clone(): CreateServiceOperatorDto {
        const json = this.toJSON();
        let result = new CreateServiceOperatorDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceOperatorDto {
    serviceId: number;
    operatorId: number;
    hourPerUserPredicted: number | undefined;
    hourPerUserAtClosure: number | undefined;
    workShiftFrequencyType: WorkShiftFrequencyTypeDto;
    hoursAtPeriod: number | undefined;
    feePerHour: number | undefined;
    isCoordinator: boolean;
}

export class CreateServiceOperatorScheduledDto implements ICreateServiceOperatorScheduledDto {
    serviceOperator!: ServiceOperatorDto;
    predictedStartDate!: moment.Moment;
    predictedEndDate!: moment.Moment;
    workShiftFrequencyType!: WorkShiftFrequencyTypeDto;
    hoursAtPeriod!: number | undefined;
    workedMinutes!: number;
    predictedMinutes!: number | undefined;
    annotationForOperator!: string | undefined;
    feePerHour!: number | undefined;

    constructor(data?: ICreateServiceOperatorScheduledDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.serviceOperator = new ServiceOperatorDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceOperator = _data["serviceOperator"] ? ServiceOperatorDto.fromJS(_data["serviceOperator"]) : new ServiceOperatorDto();
            this.predictedStartDate = _data["predictedStartDate"] ? moment(_data["predictedStartDate"].toString()) : <any>undefined;
            this.predictedEndDate = _data["predictedEndDate"] ? moment(_data["predictedEndDate"].toString()) : <any>undefined;
            this.workShiftFrequencyType = _data["workShiftFrequencyType"] ? WorkShiftFrequencyTypeDto.fromJS(_data["workShiftFrequencyType"]) : <any>undefined;
            this.hoursAtPeriod = _data["hoursAtPeriod"];
            this.workedMinutes = _data["workedMinutes"];
            this.predictedMinutes = _data["predictedMinutes"];
            this.annotationForOperator = _data["annotationForOperator"];
            this.feePerHour = _data["feePerHour"];
        }
    }

    static fromJS(data: any): CreateServiceOperatorScheduledDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceOperatorScheduledDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceOperator"] = this.serviceOperator ? this.serviceOperator.toJSON() : <any>undefined;
        data["predictedStartDate"] = this.predictedStartDate ? this.predictedStartDate.toISOString() : <any>undefined;
        data["predictedEndDate"] = this.predictedEndDate ? this.predictedEndDate.toISOString() : <any>undefined;
        data["workShiftFrequencyType"] = this.workShiftFrequencyType ? this.workShiftFrequencyType.toJSON() : <any>undefined;
        data["hoursAtPeriod"] = this.hoursAtPeriod;
        data["workedMinutes"] = this.workedMinutes;
        data["predictedMinutes"] = this.predictedMinutes;
        data["annotationForOperator"] = this.annotationForOperator;
        data["feePerHour"] = this.feePerHour;
        return data;
    }

    clone(): CreateServiceOperatorScheduledDto {
        const json = this.toJSON();
        let result = new CreateServiceOperatorScheduledDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceOperatorScheduledDto {
    serviceOperator: ServiceOperatorDto;
    predictedStartDate: moment.Moment;
    predictedEndDate: moment.Moment;
    workShiftFrequencyType: WorkShiftFrequencyTypeDto;
    hoursAtPeriod: number | undefined;
    workedMinutes: number;
    predictedMinutes: number | undefined;
    annotationForOperator: string | undefined;
    feePerHour: number | undefined;
}

export class CreateServiceReportDto implements ICreateServiceReportDto {
    serviceId!: number;
    year!: number;
    quarter!: string;
    equipesAmount!: number | undefined;
    supervisionsAmount!: number | undefined;
    meetingWithInstitutions!: number | undefined;
    formationCourses!: number | undefined;
    prePostDegreeInternships!: number | undefined;
    publications!: PublicationDto[] | undefined;
    conferences!: ConferenceDto[] | undefined;
    foreignNationalities!: string | undefined;
    informativeMaterialsDistribuited!: number | undefined;
    caredUsersInformations!: UserReportPartialDto;
    usersContactsInformationsUDS!: ContactReportPartialUDSDto;
    usersContactsInformationsWithClasses!: ContactReportPartialWithClassesDto;
    informationContact!: number | undefined;
    psychoeducationalCounselingCourses!: number | undefined;
    counselingPreventionRDD!: number | undefined;
    activityOfSocialSecretary!: number | undefined;
    psychotherapyCourses!: number | undefined;
    psychotherapyGroups!: number | undefined;
    psycologicalCounselingSending!: number | undefined;
    medicalAdviceCounseling!: number | undefined;
    medications!: number | undefined;
    legalCounseling!: number | undefined;
    regularizationCourses!: number | undefined;
    regularUsers!: number | undefined;
    italianSchoolPlacemetsForForeigners!: number | undefined;
    schoolPlacementsMiddleSchoolDiploma!: number | undefined;
    usersWithMiddleSchoolDiploma!: number | undefined;
    highSchoolPlacements!: number | undefined;
    usersWithHighSchoolDiploma!: number | undefined;
    professionalTrainingCoursePlacements!: number | undefined;
    usersCourseFinished!: number | undefined;
    studySupportCourses!: number | undefined;
    workOrientationCourses!: number | undefined;
    workInternshipsActivated!: number | undefined;
    workPlacements!: number | undefined;
    housingAutonomyCourses!: number | undefined;
    usersWithHousingAutonomy!: number | undefined;
    internalRapidHIVTestsAmount!: number | undefined;
    internalRapidHCVTestsAmount!: number | undefined;
    psychoeducationalLabs!: PsychoeducationalLabDto[] | undefined;
    informationAwarenessCourses!: InformationAwarenessCourseDto[] | undefined;
    testedSubstancesAmount!: number | undefined;
    psychotherapyCoursesOutService!: number | undefined;
    psychotherapyGroupsSendings!: number | undefined;
    medicalCounselingSendings!: number | undefined;
    legalCounselingSendings!: number | undefined;
    studySuportCoursesSendings!: number | undefined;
    workOrientationCoursesSendings!: number | undefined;
    externalRapidHIVAndHCVTestsAmount!: number | undefined;
    otherSendings!: OtherSendingsDto[] | undefined;
    totalHygienAndSanitaryKits!: number | undefined;
    washingMachinesDone!: number | undefined;
    showersCarried!: number | undefined;
    totalInjectiveKits!: number | undefined;
    totalPulmonaryKits!: number | undefined;
    narcan!: number | undefined;
    condomsDistribuited!: number | undefined;
    informativeMaterial!: number | undefined;
    refreshmentMaterial!: number | undefined;
    meals!: number | undefined;
    gadgets!: GadgetDto[] | undefined;
    socialPosts!: number | undefined;
    socialPostsVisualizations!: number | undefined;
    legalArea!: string | undefined;
    sanitaryArea!: string | undefined;
    welfarePartnerArea!: string | undefined;
    volunteeringParishesArea!: string | undefined;
    publicServices!: string | undefined;
    other!: string | undefined;

    constructor(data?: ICreateServiceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.year = _data["year"];
            this.quarter = _data["quarter"];
            this.equipesAmount = _data["equipesAmount"];
            this.supervisionsAmount = _data["supervisionsAmount"];
            this.meetingWithInstitutions = _data["meetingWithInstitutions"];
            this.formationCourses = _data["formationCourses"];
            this.prePostDegreeInternships = _data["prePostDegreeInternships"];
            if (Array.isArray(_data["publications"])) {
                this.publications = [] as any;
                for (let item of _data["publications"])
                    this.publications!.push(PublicationDto.fromJS(item));
            }
            if (Array.isArray(_data["conferences"])) {
                this.conferences = [] as any;
                for (let item of _data["conferences"])
                    this.conferences!.push(ConferenceDto.fromJS(item));
            }
            this.foreignNationalities = _data["foreignNationalities"];
            this.informativeMaterialsDistribuited = _data["informativeMaterialsDistribuited"];
            this.caredUsersInformations = _data["caredUsersInformations"] ? UserReportPartialDto.fromJS(_data["caredUsersInformations"]) : <any>undefined;
            this.usersContactsInformationsUDS = _data["usersContactsInformationsUDS"] ? ContactReportPartialUDSDto.fromJS(_data["usersContactsInformationsUDS"]) : <any>undefined;
            this.usersContactsInformationsWithClasses = _data["usersContactsInformationsWithClasses"] ? ContactReportPartialWithClassesDto.fromJS(_data["usersContactsInformationsWithClasses"]) : <any>undefined;
            this.informationContact = _data["informationContact"];
            this.psychoeducationalCounselingCourses = _data["psychoeducationalCounselingCourses"];
            this.counselingPreventionRDD = _data["counselingPreventionRDD"];
            this.activityOfSocialSecretary = _data["activityOfSocialSecretary"];
            this.psychotherapyCourses = _data["psychotherapyCourses"];
            this.psychotherapyGroups = _data["psychotherapyGroups"];
            this.psycologicalCounselingSending = _data["psycologicalCounselingSending"];
            this.medicalAdviceCounseling = _data["medicalAdviceCounseling"];
            this.medications = _data["medications"];
            this.legalCounseling = _data["legalCounseling"];
            this.regularizationCourses = _data["regularizationCourses"];
            this.regularUsers = _data["regularUsers"];
            this.italianSchoolPlacemetsForForeigners = _data["italianSchoolPlacemetsForForeigners"];
            this.schoolPlacementsMiddleSchoolDiploma = _data["schoolPlacementsMiddleSchoolDiploma"];
            this.usersWithMiddleSchoolDiploma = _data["usersWithMiddleSchoolDiploma"];
            this.highSchoolPlacements = _data["highSchoolPlacements"];
            this.usersWithHighSchoolDiploma = _data["usersWithHighSchoolDiploma"];
            this.professionalTrainingCoursePlacements = _data["professionalTrainingCoursePlacements"];
            this.usersCourseFinished = _data["usersCourseFinished"];
            this.studySupportCourses = _data["studySupportCourses"];
            this.workOrientationCourses = _data["workOrientationCourses"];
            this.workInternshipsActivated = _data["workInternshipsActivated"];
            this.workPlacements = _data["workPlacements"];
            this.housingAutonomyCourses = _data["housingAutonomyCourses"];
            this.usersWithHousingAutonomy = _data["usersWithHousingAutonomy"];
            this.internalRapidHIVTestsAmount = _data["internalRapidHIVTestsAmount"];
            this.internalRapidHCVTestsAmount = _data["internalRapidHCVTestsAmount"];
            if (Array.isArray(_data["psychoeducationalLabs"])) {
                this.psychoeducationalLabs = [] as any;
                for (let item of _data["psychoeducationalLabs"])
                    this.psychoeducationalLabs!.push(PsychoeducationalLabDto.fromJS(item));
            }
            if (Array.isArray(_data["informationAwarenessCourses"])) {
                this.informationAwarenessCourses = [] as any;
                for (let item of _data["informationAwarenessCourses"])
                    this.informationAwarenessCourses!.push(InformationAwarenessCourseDto.fromJS(item));
            }
            this.testedSubstancesAmount = _data["testedSubstancesAmount"];
            this.psychotherapyCoursesOutService = _data["psychotherapyCoursesOutService"];
            this.psychotherapyGroupsSendings = _data["psychotherapyGroupsSendings"];
            this.medicalCounselingSendings = _data["medicalCounselingSendings"];
            this.legalCounselingSendings = _data["legalCounselingSendings"];
            this.studySuportCoursesSendings = _data["studySuportCoursesSendings"];
            this.workOrientationCoursesSendings = _data["workOrientationCoursesSendings"];
            this.externalRapidHIVAndHCVTestsAmount = _data["externalRapidHIVAndHCVTestsAmount"];
            if (Array.isArray(_data["otherSendings"])) {
                this.otherSendings = [] as any;
                for (let item of _data["otherSendings"])
                    this.otherSendings!.push(OtherSendingsDto.fromJS(item));
            }
            this.totalHygienAndSanitaryKits = _data["totalHygienAndSanitaryKits"];
            this.washingMachinesDone = _data["washingMachinesDone"];
            this.showersCarried = _data["showersCarried"];
            this.totalInjectiveKits = _data["totalInjectiveKits"];
            this.totalPulmonaryKits = _data["totalPulmonaryKits"];
            this.narcan = _data["narcan"];
            this.condomsDistribuited = _data["condomsDistribuited"];
            this.informativeMaterial = _data["informativeMaterial"];
            this.refreshmentMaterial = _data["refreshmentMaterial"];
            this.meals = _data["meals"];
            if (Array.isArray(_data["gadgets"])) {
                this.gadgets = [] as any;
                for (let item of _data["gadgets"])
                    this.gadgets!.push(GadgetDto.fromJS(item));
            }
            this.socialPosts = _data["socialPosts"];
            this.socialPostsVisualizations = _data["socialPostsVisualizations"];
            this.legalArea = _data["legalArea"];
            this.sanitaryArea = _data["sanitaryArea"];
            this.welfarePartnerArea = _data["welfarePartnerArea"];
            this.volunteeringParishesArea = _data["volunteeringParishesArea"];
            this.publicServices = _data["publicServices"];
            this.other = _data["other"];
        }
    }

    static fromJS(data: any): CreateServiceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["year"] = this.year;
        data["quarter"] = this.quarter;
        data["equipesAmount"] = this.equipesAmount;
        data["supervisionsAmount"] = this.supervisionsAmount;
        data["meetingWithInstitutions"] = this.meetingWithInstitutions;
        data["formationCourses"] = this.formationCourses;
        data["prePostDegreeInternships"] = this.prePostDegreeInternships;
        if (Array.isArray(this.publications)) {
            data["publications"] = [];
            for (let item of this.publications)
                data["publications"].push(item.toJSON());
        }
        if (Array.isArray(this.conferences)) {
            data["conferences"] = [];
            for (let item of this.conferences)
                data["conferences"].push(item.toJSON());
        }
        data["foreignNationalities"] = this.foreignNationalities;
        data["informativeMaterialsDistribuited"] = this.informativeMaterialsDistribuited;
        data["caredUsersInformations"] = this.caredUsersInformations ? this.caredUsersInformations.toJSON() : <any>undefined;
        data["usersContactsInformationsUDS"] = this.usersContactsInformationsUDS ? this.usersContactsInformationsUDS.toJSON() : <any>undefined;
        data["usersContactsInformationsWithClasses"] = this.usersContactsInformationsWithClasses ? this.usersContactsInformationsWithClasses.toJSON() : <any>undefined;
        data["informationContact"] = this.informationContact;
        data["psychoeducationalCounselingCourses"] = this.psychoeducationalCounselingCourses;
        data["counselingPreventionRDD"] = this.counselingPreventionRDD;
        data["activityOfSocialSecretary"] = this.activityOfSocialSecretary;
        data["psychotherapyCourses"] = this.psychotherapyCourses;
        data["psychotherapyGroups"] = this.psychotherapyGroups;
        data["psycologicalCounselingSending"] = this.psycologicalCounselingSending;
        data["medicalAdviceCounseling"] = this.medicalAdviceCounseling;
        data["medications"] = this.medications;
        data["legalCounseling"] = this.legalCounseling;
        data["regularizationCourses"] = this.regularizationCourses;
        data["regularUsers"] = this.regularUsers;
        data["italianSchoolPlacemetsForForeigners"] = this.italianSchoolPlacemetsForForeigners;
        data["schoolPlacementsMiddleSchoolDiploma"] = this.schoolPlacementsMiddleSchoolDiploma;
        data["usersWithMiddleSchoolDiploma"] = this.usersWithMiddleSchoolDiploma;
        data["highSchoolPlacements"] = this.highSchoolPlacements;
        data["usersWithHighSchoolDiploma"] = this.usersWithHighSchoolDiploma;
        data["professionalTrainingCoursePlacements"] = this.professionalTrainingCoursePlacements;
        data["usersCourseFinished"] = this.usersCourseFinished;
        data["studySupportCourses"] = this.studySupportCourses;
        data["workOrientationCourses"] = this.workOrientationCourses;
        data["workInternshipsActivated"] = this.workInternshipsActivated;
        data["workPlacements"] = this.workPlacements;
        data["housingAutonomyCourses"] = this.housingAutonomyCourses;
        data["usersWithHousingAutonomy"] = this.usersWithHousingAutonomy;
        data["internalRapidHIVTestsAmount"] = this.internalRapidHIVTestsAmount;
        data["internalRapidHCVTestsAmount"] = this.internalRapidHCVTestsAmount;
        if (Array.isArray(this.psychoeducationalLabs)) {
            data["psychoeducationalLabs"] = [];
            for (let item of this.psychoeducationalLabs)
                data["psychoeducationalLabs"].push(item.toJSON());
        }
        if (Array.isArray(this.informationAwarenessCourses)) {
            data["informationAwarenessCourses"] = [];
            for (let item of this.informationAwarenessCourses)
                data["informationAwarenessCourses"].push(item.toJSON());
        }
        data["testedSubstancesAmount"] = this.testedSubstancesAmount;
        data["psychotherapyCoursesOutService"] = this.psychotherapyCoursesOutService;
        data["psychotherapyGroupsSendings"] = this.psychotherapyGroupsSendings;
        data["medicalCounselingSendings"] = this.medicalCounselingSendings;
        data["legalCounselingSendings"] = this.legalCounselingSendings;
        data["studySuportCoursesSendings"] = this.studySuportCoursesSendings;
        data["workOrientationCoursesSendings"] = this.workOrientationCoursesSendings;
        data["externalRapidHIVAndHCVTestsAmount"] = this.externalRapidHIVAndHCVTestsAmount;
        if (Array.isArray(this.otherSendings)) {
            data["otherSendings"] = [];
            for (let item of this.otherSendings)
                data["otherSendings"].push(item.toJSON());
        }
        data["totalHygienAndSanitaryKits"] = this.totalHygienAndSanitaryKits;
        data["washingMachinesDone"] = this.washingMachinesDone;
        data["showersCarried"] = this.showersCarried;
        data["totalInjectiveKits"] = this.totalInjectiveKits;
        data["totalPulmonaryKits"] = this.totalPulmonaryKits;
        data["narcan"] = this.narcan;
        data["condomsDistribuited"] = this.condomsDistribuited;
        data["informativeMaterial"] = this.informativeMaterial;
        data["refreshmentMaterial"] = this.refreshmentMaterial;
        data["meals"] = this.meals;
        if (Array.isArray(this.gadgets)) {
            data["gadgets"] = [];
            for (let item of this.gadgets)
                data["gadgets"].push(item.toJSON());
        }
        data["socialPosts"] = this.socialPosts;
        data["socialPostsVisualizations"] = this.socialPostsVisualizations;
        data["legalArea"] = this.legalArea;
        data["sanitaryArea"] = this.sanitaryArea;
        data["welfarePartnerArea"] = this.welfarePartnerArea;
        data["volunteeringParishesArea"] = this.volunteeringParishesArea;
        data["publicServices"] = this.publicServices;
        data["other"] = this.other;
        return data;
    }

    clone(): CreateServiceReportDto {
        const json = this.toJSON();
        let result = new CreateServiceReportDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceReportDto {
    serviceId: number;
    year: number;
    quarter: string;
    equipesAmount: number | undefined;
    supervisionsAmount: number | undefined;
    meetingWithInstitutions: number | undefined;
    formationCourses: number | undefined;
    prePostDegreeInternships: number | undefined;
    publications: PublicationDto[] | undefined;
    conferences: ConferenceDto[] | undefined;
    foreignNationalities: string | undefined;
    informativeMaterialsDistribuited: number | undefined;
    caredUsersInformations: UserReportPartialDto;
    usersContactsInformationsUDS: ContactReportPartialUDSDto;
    usersContactsInformationsWithClasses: ContactReportPartialWithClassesDto;
    informationContact: number | undefined;
    psychoeducationalCounselingCourses: number | undefined;
    counselingPreventionRDD: number | undefined;
    activityOfSocialSecretary: number | undefined;
    psychotherapyCourses: number | undefined;
    psychotherapyGroups: number | undefined;
    psycologicalCounselingSending: number | undefined;
    medicalAdviceCounseling: number | undefined;
    medications: number | undefined;
    legalCounseling: number | undefined;
    regularizationCourses: number | undefined;
    regularUsers: number | undefined;
    italianSchoolPlacemetsForForeigners: number | undefined;
    schoolPlacementsMiddleSchoolDiploma: number | undefined;
    usersWithMiddleSchoolDiploma: number | undefined;
    highSchoolPlacements: number | undefined;
    usersWithHighSchoolDiploma: number | undefined;
    professionalTrainingCoursePlacements: number | undefined;
    usersCourseFinished: number | undefined;
    studySupportCourses: number | undefined;
    workOrientationCourses: number | undefined;
    workInternshipsActivated: number | undefined;
    workPlacements: number | undefined;
    housingAutonomyCourses: number | undefined;
    usersWithHousingAutonomy: number | undefined;
    internalRapidHIVTestsAmount: number | undefined;
    internalRapidHCVTestsAmount: number | undefined;
    psychoeducationalLabs: PsychoeducationalLabDto[] | undefined;
    informationAwarenessCourses: InformationAwarenessCourseDto[] | undefined;
    testedSubstancesAmount: number | undefined;
    psychotherapyCoursesOutService: number | undefined;
    psychotherapyGroupsSendings: number | undefined;
    medicalCounselingSendings: number | undefined;
    legalCounselingSendings: number | undefined;
    studySuportCoursesSendings: number | undefined;
    workOrientationCoursesSendings: number | undefined;
    externalRapidHIVAndHCVTestsAmount: number | undefined;
    otherSendings: OtherSendingsDto[] | undefined;
    totalHygienAndSanitaryKits: number | undefined;
    washingMachinesDone: number | undefined;
    showersCarried: number | undefined;
    totalInjectiveKits: number | undefined;
    totalPulmonaryKits: number | undefined;
    narcan: number | undefined;
    condomsDistribuited: number | undefined;
    informativeMaterial: number | undefined;
    refreshmentMaterial: number | undefined;
    meals: number | undefined;
    gadgets: GadgetDto[] | undefined;
    socialPosts: number | undefined;
    socialPostsVisualizations: number | undefined;
    legalArea: string | undefined;
    sanitaryArea: string | undefined;
    welfarePartnerArea: string | undefined;
    volunteeringParishesArea: string | undefined;
    publicServices: string | undefined;
    other: string | undefined;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    connectionString!: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateTimeIntervalDto implements ICreateTimeIntervalDto {
    startDate!: moment.Moment;
    endDate!: moment.Moment | undefined;

    constructor(data?: ICreateTimeIntervalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateTimeIntervalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTimeIntervalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateTimeIntervalDto {
        const json = this.toJSON();
        let result = new CreateTimeIntervalDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTimeIntervalDto {
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
}

export class CreateTopicDto implements ICreateTopicDto {
    subject!: string | undefined;
    messageText!: string | undefined;
    userRecipientIds!: number[] | undefined;

    constructor(data?: ICreateTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subject = _data["subject"];
            this.messageText = _data["messageText"];
            if (Array.isArray(_data["userRecipientIds"])) {
                this.userRecipientIds = [] as any;
                for (let item of _data["userRecipientIds"])
                    this.userRecipientIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subject"] = this.subject;
        data["messageText"] = this.messageText;
        if (Array.isArray(this.userRecipientIds)) {
            data["userRecipientIds"] = [];
            for (let item of this.userRecipientIds)
                data["userRecipientIds"].push(item);
        }
        return data;
    }

    clone(): CreateTopicDto {
        const json = this.toJSON();
        let result = new CreateTopicDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTopicDto {
    subject: string | undefined;
    messageText: string | undefined;
    userRecipientIds: number[] | undefined;
}

export class CreateUpdateReceiptOutputDto implements ICreateUpdateReceiptOutputDto {
    id!: number;
    commitmentOutput!: Int64EntityDto;
    amount!: number;

    constructor(data?: ICreateUpdateReceiptOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commitmentOutput = _data["commitmentOutput"] ? Int64EntityDto.fromJS(_data["commitmentOutput"]) : <any>undefined;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): CreateUpdateReceiptOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateReceiptOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commitmentOutput"] = this.commitmentOutput ? this.commitmentOutput.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }

    clone(): CreateUpdateReceiptOutputDto {
        const json = this.toJSON();
        let result = new CreateUpdateReceiptOutputDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateReceiptOutputDto {
    id: number;
    commitmentOutput: Int64EntityDto;
    amount: number;
}

export class CreateUpdateUserOrganizationUnitDto implements ICreateUpdateUserOrganizationUnitDto {
    id!: number;
    userId!: number;
    organizationUnitId!: number;

    constructor(data?: ICreateUpdateUserOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): CreateUpdateUserOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUpdateUserOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }

    clone(): CreateUpdateUserOrganizationUnitDto {
        const json = this.toJSON();
        let result = new CreateUpdateUserOrganizationUnitDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUpdateUserOrganizationUnitDto {
    id: number;
    userId: number;
    organizationUnitId: number;
}

export class CreateUserDto implements ICreateUserDto {
    name!: string;
    surname!: string | undefined;
    gender!: Int32EntityDto;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    vatCode!: string | undefined;
    fiscalCode!: string | undefined;
    birthDate!: moment.Moment | undefined;
    address!: AddressCreateDto;
    isActive!: boolean;
    roleNames!: string[] | undefined;
    annotation!: string | undefined;
    workerUserAdditional!: CreateWorkerUserAdditionalDto;
    feePerHour!: number | undefined;
    color!: string | undefined;
    municipality!: Int64EntityDto;
    foreignPlaceOfBirth!: string | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.gender = new Int32EntityDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.gender = _data["gender"] ? Int32EntityDto.fromJS(_data["gender"]) : new Int32EntityDto();
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.vatCode = _data["vatCode"];
            this.fiscalCode = _data["fiscalCode"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.address = _data["address"] ? AddressCreateDto.fromJS(_data["address"]) : <any>undefined;
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.annotation = _data["annotation"];
            this.workerUserAdditional = _data["workerUserAdditional"] ? CreateWorkerUserAdditionalDto.fromJS(_data["workerUserAdditional"]) : <any>undefined;
            this.feePerHour = _data["feePerHour"];
            this.color = _data["color"];
            this.municipality = _data["municipality"] ? Int64EntityDto.fromJS(_data["municipality"]) : <any>undefined;
            this.foreignPlaceOfBirth = _data["foreignPlaceOfBirth"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["vatCode"] = this.vatCode;
        data["fiscalCode"] = this.fiscalCode;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["annotation"] = this.annotation;
        data["workerUserAdditional"] = this.workerUserAdditional ? this.workerUserAdditional.toJSON() : <any>undefined;
        data["feePerHour"] = this.feePerHour;
        data["color"] = this.color;
        data["municipality"] = this.municipality ? this.municipality.toJSON() : <any>undefined;
        data["foreignPlaceOfBirth"] = this.foreignPlaceOfBirth;
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    name: string;
    surname: string | undefined;
    gender: Int32EntityDto;
    emailAddress: string;
    phoneNumber: string | undefined;
    vatCode: string | undefined;
    fiscalCode: string | undefined;
    birthDate: moment.Moment | undefined;
    address: AddressCreateDto;
    isActive: boolean;
    roleNames: string[] | undefined;
    annotation: string | undefined;
    workerUserAdditional: CreateWorkerUserAdditionalDto;
    feePerHour: number | undefined;
    color: string | undefined;
    municipality: Int64EntityDto;
    foreignPlaceOfBirth: string | undefined;
}

export class CreateUserMediaEventDto implements ICreateUserMediaEventDto {
    user!: Int64EntityDto;
    entryDate!: moment.Moment;
    exitDate!: moment.Moment;

    constructor(data?: ICreateUserMediaEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new Int64EntityDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? Int64EntityDto.fromJS(_data["user"]) : new Int64EntityDto();
            this.entryDate = _data["entryDate"] ? moment(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? moment(_data["exitDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUserMediaEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserMediaEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): CreateUserMediaEventDto {
        const json = this.toJSON();
        let result = new CreateUserMediaEventDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserMediaEventDto {
    user: Int64EntityDto;
    entryDate: moment.Moment;
    exitDate: moment.Moment;
}

export class CreateUserParentDto implements ICreateUserParentDto {
    name!: string;
    surname!: string;
    birthDate!: moment.Moment;
    emailAddress!: string;
    address!: AddressCreateDto;
    fiscalCode!: string;
    genderId!: number;
    phoneNumber!: string | undefined;
    parentalDegree!: Int64EntityDto;
    user!: Int64EntityDto;
    delegate!: boolean;
    invoicing!: boolean;

    constructor(data?: ICreateUserParentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.parentalDegree = new Int64EntityDto();
            this.user = new Int64EntityDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.address = _data["address"] ? AddressCreateDto.fromJS(_data["address"]) : <any>undefined;
            this.fiscalCode = _data["fiscalCode"];
            this.genderId = _data["genderId"];
            this.phoneNumber = _data["phoneNumber"];
            this.parentalDegree = _data["parentalDegree"] ? Int64EntityDto.fromJS(_data["parentalDegree"]) : new Int64EntityDto();
            this.user = _data["user"] ? Int64EntityDto.fromJS(_data["user"]) : new Int64EntityDto();
            this.delegate = _data["delegate"];
            this.invoicing = _data["invoicing"];
        }
    }

    static fromJS(data: any): CreateUserParentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserParentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["fiscalCode"] = this.fiscalCode;
        data["genderId"] = this.genderId;
        data["phoneNumber"] = this.phoneNumber;
        data["parentalDegree"] = this.parentalDegree ? this.parentalDegree.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["delegate"] = this.delegate;
        data["invoicing"] = this.invoicing;
        return data;
    }

    clone(): CreateUserParentDto {
        const json = this.toJSON();
        let result = new CreateUserParentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserParentDto {
    name: string;
    surname: string;
    birthDate: moment.Moment;
    emailAddress: string;
    address: AddressCreateDto;
    fiscalCode: string;
    genderId: number;
    phoneNumber: string | undefined;
    parentalDegree: Int64EntityDto;
    user: Int64EntityDto;
    delegate: boolean;
    invoicing: boolean;
}

export class CreateUserParentFileDto implements ICreateUserParentFileDto {
    id!: number;
    userParent!: Int64EntityDto;
    file!: CreateFileDto;

    constructor(data?: ICreateUserParentFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userParent = new Int64EntityDto();
            this.file = new CreateFileDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userParent = _data["userParent"] ? Int64EntityDto.fromJS(_data["userParent"]) : new Int64EntityDto();
            this.file = _data["file"] ? CreateFileDto.fromJS(_data["file"]) : new CreateFileDto();
        }
    }

    static fromJS(data: any): CreateUserParentFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserParentFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userParent"] = this.userParent ? this.userParent.toJSON() : <any>undefined;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateUserParentFileDto {
        const json = this.toJSON();
        let result = new CreateUserParentFileDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserParentFileDto {
    id: number;
    userParent: Int64EntityDto;
    file: CreateFileDto;
}

export class CreateUserReportPartialDto implements ICreateUserReportPartialDto {
    serviceReportId!: number;
    caredItalianMaleUsers!: number | undefined;
    caredItalianFemaleUsers!: number | undefined;
    caredItalianNonBinaryUsers!: number | undefined;
    caredForeignMaleUsers!: number | undefined;
    caredForeignFemaleUsers!: number | undefined;
    caredForeignNonBinaryUsers!: number | undefined;
    caredHomelessUsers!: number | undefined;
    caredUsersUnder14!: number | undefined;
    caredUsers1418!: number | undefined;
    caredUsers1925!: number | undefined;
    caredUsers2640!: number | undefined;
    caredUsers4150!: number | undefined;
    caredUsers5165!: number | undefined;
    caredUsersOver65!: number | undefined;

    constructor(data?: ICreateUserReportPartialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceReportId = _data["serviceReportId"];
            this.caredItalianMaleUsers = _data["caredItalianMaleUsers"];
            this.caredItalianFemaleUsers = _data["caredItalianFemaleUsers"];
            this.caredItalianNonBinaryUsers = _data["caredItalianNonBinaryUsers"];
            this.caredForeignMaleUsers = _data["caredForeignMaleUsers"];
            this.caredForeignFemaleUsers = _data["caredForeignFemaleUsers"];
            this.caredForeignNonBinaryUsers = _data["caredForeignNonBinaryUsers"];
            this.caredHomelessUsers = _data["caredHomelessUsers"];
            this.caredUsersUnder14 = _data["caredUsersUnder14"];
            this.caredUsers1418 = _data["caredUsers1418"];
            this.caredUsers1925 = _data["caredUsers1925"];
            this.caredUsers2640 = _data["caredUsers2640"];
            this.caredUsers4150 = _data["caredUsers4150"];
            this.caredUsers5165 = _data["caredUsers5165"];
            this.caredUsersOver65 = _data["caredUsersOver65"];
        }
    }

    static fromJS(data: any): CreateUserReportPartialDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserReportPartialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceReportId"] = this.serviceReportId;
        data["caredItalianMaleUsers"] = this.caredItalianMaleUsers;
        data["caredItalianFemaleUsers"] = this.caredItalianFemaleUsers;
        data["caredItalianNonBinaryUsers"] = this.caredItalianNonBinaryUsers;
        data["caredForeignMaleUsers"] = this.caredForeignMaleUsers;
        data["caredForeignFemaleUsers"] = this.caredForeignFemaleUsers;
        data["caredForeignNonBinaryUsers"] = this.caredForeignNonBinaryUsers;
        data["caredHomelessUsers"] = this.caredHomelessUsers;
        data["caredUsersUnder14"] = this.caredUsersUnder14;
        data["caredUsers1418"] = this.caredUsers1418;
        data["caredUsers1925"] = this.caredUsers1925;
        data["caredUsers2640"] = this.caredUsers2640;
        data["caredUsers4150"] = this.caredUsers4150;
        data["caredUsers5165"] = this.caredUsers5165;
        data["caredUsersOver65"] = this.caredUsersOver65;
        return data;
    }

    clone(): CreateUserReportPartialDto {
        const json = this.toJSON();
        let result = new CreateUserReportPartialDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserReportPartialDto {
    serviceReportId: number;
    caredItalianMaleUsers: number | undefined;
    caredItalianFemaleUsers: number | undefined;
    caredItalianNonBinaryUsers: number | undefined;
    caredForeignMaleUsers: number | undefined;
    caredForeignFemaleUsers: number | undefined;
    caredForeignNonBinaryUsers: number | undefined;
    caredHomelessUsers: number | undefined;
    caredUsersUnder14: number | undefined;
    caredUsers1418: number | undefined;
    caredUsers1925: number | undefined;
    caredUsers2640: number | undefined;
    caredUsers4150: number | undefined;
    caredUsers5165: number | undefined;
    caredUsersOver65: number | undefined;
}

export class CreateWorkerUserAdditionalDto implements ICreateWorkerUserAdditionalDto {
    isAssociate!: boolean | undefined;
    isVoluntaryAssociate!: boolean | undefined;
    isWorker!: boolean | undefined;
    workContractTypeId!: number | undefined;
    workContractLevelId!: number | undefined;
    educationalDegreeLevelId!: number | undefined;

    constructor(data?: ICreateWorkerUserAdditionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAssociate = _data["isAssociate"];
            this.isVoluntaryAssociate = _data["isVoluntaryAssociate"];
            this.isWorker = _data["isWorker"];
            this.workContractTypeId = _data["workContractTypeId"];
            this.workContractLevelId = _data["workContractLevelId"];
            this.educationalDegreeLevelId = _data["educationalDegreeLevelId"];
        }
    }

    static fromJS(data: any): CreateWorkerUserAdditionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWorkerUserAdditionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAssociate"] = this.isAssociate;
        data["isVoluntaryAssociate"] = this.isVoluntaryAssociate;
        data["isWorker"] = this.isWorker;
        data["workContractTypeId"] = this.workContractTypeId;
        data["workContractLevelId"] = this.workContractLevelId;
        data["educationalDegreeLevelId"] = this.educationalDegreeLevelId;
        return data;
    }

    clone(): CreateWorkerUserAdditionalDto {
        const json = this.toJSON();
        let result = new CreateWorkerUserAdditionalDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWorkerUserAdditionalDto {
    isAssociate: boolean | undefined;
    isVoluntaryAssociate: boolean | undefined;
    isWorker: boolean | undefined;
    workContractTypeId: number | undefined;
    workContractLevelId: number | undefined;
    educationalDegreeLevelId: number | undefined;
}

export class CurrencyTypeDto implements ICurrencyTypeDto {
    id!: number;
    description!: string | undefined;
    displayName!: string | undefined;

    constructor(data?: ICurrencyTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CurrencyTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): CurrencyTypeDto {
        const json = this.toJSON();
        let result = new CurrencyTypeDto();
        result.init(json);
        return result;
    }
}

export interface ICurrencyTypeDto {
    id: number;
    description: string | undefined;
    displayName: string | undefined;
}

export class CustomerDto implements ICustomerDto {
    id!: number;
    readonly entityType!: string | undefined;
    businessName!: string | undefined;
    fiscalCode!: string | undefined;
    vatCode!: string | undefined;
    address!: AddressDto;
    referent!: string | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).entityType = _data["entityType"];
            this.businessName = _data["businessName"];
            this.fiscalCode = _data["fiscalCode"];
            this.vatCode = _data["vatCode"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.referent = _data["referent"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["businessName"] = this.businessName;
        data["fiscalCode"] = this.fiscalCode;
        data["vatCode"] = this.vatCode;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["referent"] = this.referent;
        return data;
    }

    clone(): CustomerDto {
        const json = this.toJSON();
        let result = new CustomerDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDto {
    id: number;
    entityType: string | undefined;
    businessName: string | undefined;
    fiscalCode: string | undefined;
    vatCode: string | undefined;
    address: AddressDto;
    referent: string | undefined;
}

export class CustomerDtoPagedResultDto implements ICustomerDtoPagedResultDto {
    items!: CustomerDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CustomerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomerDtoPagedResultDto {
    items: CustomerDto[] | undefined;
    totalCount: number;
}

export enum DiaperOptions {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class DuePaycheckDto implements IDuePaycheckDto {
    id!: number;
    month!: string | undefined;
    year!: number;
    user!: BaseUserDto;
    paymentType!: PaycheckPaymentTypeDto;
    netToPay!: number;
    paidDate!: moment.Moment | undefined;

    constructor(data?: IDuePaycheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.user = _data["user"] ? BaseUserDto.fromJS(_data["user"]) : <any>undefined;
            this.paymentType = _data["paymentType"] ? PaycheckPaymentTypeDto.fromJS(_data["paymentType"]) : <any>undefined;
            this.netToPay = _data["netToPay"];
            this.paidDate = _data["paidDate"] ? moment(_data["paidDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DuePaycheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new DuePaycheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["month"] = this.month;
        data["year"] = this.year;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["paymentType"] = this.paymentType ? this.paymentType.toJSON() : <any>undefined;
        data["netToPay"] = this.netToPay;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): DuePaycheckDto {
        const json = this.toJSON();
        let result = new DuePaycheckDto();
        result.init(json);
        return result;
    }
}

export interface IDuePaycheckDto {
    id: number;
    month: string | undefined;
    year: number;
    user: BaseUserDto;
    paymentType: PaycheckPaymentTypeDto;
    netToPay: number;
    paidDate: moment.Moment | undefined;
}

export class DuePaycheckDtoPagedResultDto implements IDuePaycheckDtoPagedResultDto {
    items!: DuePaycheckDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDuePaycheckDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DuePaycheckDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DuePaycheckDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DuePaycheckDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DuePaycheckDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DuePaycheckDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDuePaycheckDtoPagedResultDto {
    items: DuePaycheckDto[] | undefined;
    totalCount: number;
}

export class DuePaycheckFileDto implements IDuePaycheckFileDto {
    id!: number;
    duePaycheck!: DuePaycheckDto;
    fileId!: number;
    readDateTime!: moment.Moment | undefined;

    constructor(data?: IDuePaycheckFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.duePaycheck = _data["duePaycheck"] ? DuePaycheckDto.fromJS(_data["duePaycheck"]) : <any>undefined;
            this.fileId = _data["fileId"];
            this.readDateTime = _data["readDateTime"] ? moment(_data["readDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DuePaycheckFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new DuePaycheckFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["duePaycheck"] = this.duePaycheck ? this.duePaycheck.toJSON() : <any>undefined;
        data["fileId"] = this.fileId;
        data["readDateTime"] = this.readDateTime ? this.readDateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): DuePaycheckFileDto {
        const json = this.toJSON();
        let result = new DuePaycheckFileDto();
        result.init(json);
        return result;
    }
}

export interface IDuePaycheckFileDto {
    id: number;
    duePaycheck: DuePaycheckDto;
    fileId: number;
    readDateTime: moment.Moment | undefined;
}

export class DuePaycheckFileDtoPagedResultDto implements IDuePaycheckFileDtoPagedResultDto {
    items!: DuePaycheckFileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDuePaycheckFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DuePaycheckFileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DuePaycheckFileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DuePaycheckFileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DuePaycheckFileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DuePaycheckFileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDuePaycheckFileDtoPagedResultDto {
    items: DuePaycheckFileDto[] | undefined;
    totalCount: number;
}

export class EducationalDegreeDto implements IEducationalDegreeDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IEducationalDegreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EducationalDegreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalDegreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): EducationalDegreeDto {
        const json = this.toJSON();
        let result = new EducationalDegreeDto();
        result.init(json);
        return result;
    }
}

export interface IEducationalDegreeDto {
    id: number;
    description: string | undefined;
}

export class EducationalDegreeDtoPagedResultDto implements IEducationalDegreeDtoPagedResultDto {
    items!: EducationalDegreeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IEducationalDegreeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EducationalDegreeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EducationalDegreeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalDegreeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EducationalDegreeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EducationalDegreeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEducationalDegreeDtoPagedResultDto {
    items: EducationalDegreeDto[] | undefined;
    totalCount: number;
}

export class EducationalDegreeLevelDto implements IEducationalDegreeLevelDto {
    id!: number;
    value!: string | undefined;

    constructor(data?: IEducationalDegreeLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): EducationalDegreeLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalDegreeLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }

    clone(): EducationalDegreeLevelDto {
        const json = this.toJSON();
        let result = new EducationalDegreeLevelDto();
        result.init(json);
        return result;
    }
}

export interface IEducationalDegreeLevelDto {
    id: number;
    value: string | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class FailedRowImportDto implements IFailedRowImportDto {
    rowIndex!: string | undefined;
    propertyName!: string | undefined;
    reason!: string | undefined;

    constructor(data?: IFailedRowImportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data["rowIndex"];
            this.propertyName = _data["propertyName"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): FailedRowImportDto {
        data = typeof data === 'object' ? data : {};
        let result = new FailedRowImportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex;
        data["propertyName"] = this.propertyName;
        data["reason"] = this.reason;
        return data;
    }

    clone(): FailedRowImportDto {
        const json = this.toJSON();
        let result = new FailedRowImportDto();
        result.init(json);
        return result;
    }
}

export interface IFailedRowImportDto {
    rowIndex: string | undefined;
    propertyName: string | undefined;
    reason: string | undefined;
}

export class FileAssociatedEntitiesDto implements IFileAssociatedEntitiesDto {
    users!: UserFileDto[] | undefined;
    services!: ServiceFileDto[] | undefined;
    contracts!: ContractFileDto[] | undefined;
    hrRequests!: HRRequestFileDto[] | undefined;

    constructor(data?: IFileAssociatedEntitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserFileDto.fromJS(item));
            }
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceFileDto.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(ContractFileDto.fromJS(item));
            }
            if (Array.isArray(_data["hrRequests"])) {
                this.hrRequests = [] as any;
                for (let item of _data["hrRequests"])
                    this.hrRequests!.push(HRRequestFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileAssociatedEntitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileAssociatedEntitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item.toJSON());
        }
        if (Array.isArray(this.hrRequests)) {
            data["hrRequests"] = [];
            for (let item of this.hrRequests)
                data["hrRequests"].push(item.toJSON());
        }
        return data;
    }

    clone(): FileAssociatedEntitiesDto {
        const json = this.toJSON();
        let result = new FileAssociatedEntitiesDto();
        result.init(json);
        return result;
    }
}

export interface IFileAssociatedEntitiesDto {
    users: UserFileDto[] | undefined;
    services: ServiceFileDto[] | undefined;
    contracts: ContractFileDto[] | undefined;
    hrRequests: HRRequestFileDto[] | undefined;
}

export class FileDownloadDto implements IFileDownloadDto {
    file!: FileDto;
    byteArray!: string | undefined;

    constructor(data?: IFileDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
            this.byteArray = _data["byteArray"];
        }
    }

    static fromJS(data: any): FileDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["byteArray"] = this.byteArray;
        return data;
    }

    clone(): FileDownloadDto {
        const json = this.toJSON();
        let result = new FileDownloadDto();
        result.init(json);
        return result;
    }
}

export interface IFileDownloadDto {
    file: FileDto;
    byteArray: string | undefined;
}

export class FileDto implements IFileDto {
    id!: number;
    readonly entityType!: string | undefined;
    mask!: string | undefined;
    name!: string | undefined;
    extension!: string | undefined;
    mimeType!: string | undefined;
    size!: number;
    expirationDate!: moment.Moment | undefined;
    fileType!: FileTypeDto;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).entityType = _data["entityType"];
            this.mask = _data["mask"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.fileType = _data["fileType"] ? FileTypeDto.fromJS(_data["fileType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["mask"] = this.mask;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["fileType"] = this.fileType ? this.fileType.toJSON() : <any>undefined;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    id: number;
    entityType: string | undefined;
    mask: string | undefined;
    name: string | undefined;
    extension: string | undefined;
    mimeType: string | undefined;
    size: number;
    expirationDate: moment.Moment | undefined;
    fileType: FileTypeDto;
}

export class FileDtoPagedResultDto implements IFileDtoPagedResultDto {
    items!: FileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFileDtoPagedResultDto {
    items: FileDto[] | undefined;
    totalCount: number;
}

export class FileExcelDto implements IFileExcelDto {
    fileName!: string | undefined;
    fileData!: string | undefined;
    mimeType!: string | undefined;

    constructor(data?: IFileExcelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileData = _data["fileData"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileExcelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileExcelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileData"] = this.fileData;
        data["mimeType"] = this.mimeType;
        return data;
    }

    clone(): FileExcelDto {
        const json = this.toJSON();
        let result = new FileExcelDto();
        result.init(json);
        return result;
    }
}

export interface IFileExcelDto {
    fileName: string | undefined;
    fileData: string | undefined;
    mimeType: string | undefined;
}

export class FileTypeDto implements IFileTypeDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IFileTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FileTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): FileTypeDto {
        const json = this.toJSON();
        let result = new FileTypeDto();
        result.init(json);
        return result;
    }
}

export interface IFileTypeDto {
    id: number;
    description: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class ForceResetPasswordDto implements IForceResetPasswordDto {
    adminPassword!: string;
    userId!: number;
    newPassword!: string;

    constructor(data?: IForceResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ForceResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForceResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ForceResetPasswordDto {
        const json = this.toJSON();
        let result = new ForceResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForceResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class ForgotPasswordDto implements IForgotPasswordDto {
    emailAddress!: string;

    constructor(data?: IForgotPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ForgotPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): ForgotPasswordDto {
        const json = this.toJSON();
        let result = new ForgotPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordDto {
    emailAddress: string;
}

export class GadgetDto implements IGadgetDto {
    id!: number;
    title!: string | undefined;
    number!: number;

    constructor(data?: IGadgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): GadgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new GadgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["number"] = this.number;
        return data;
    }

    clone(): GadgetDto {
        const json = this.toJSON();
        let result = new GadgetDto();
        result.init(json);
        return result;
    }
}

export interface IGadgetDto {
    id: number;
    title: string | undefined;
    number: number;
}

export class GenderDto implements IGenderDto {
    id!: number;
    value!: string | undefined;

    constructor(data?: IGenderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GenderDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }

    clone(): GenderDto {
        const json = this.toJSON();
        let result = new GenderDto();
        result.init(json);
        return result;
    }
}

export interface IGenderDto {
    id: number;
    value: string | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application!: ApplicationInfoDto;
    user!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;
    servicesAsCoordinator!: number[] | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            if (Array.isArray(_data["servicesAsCoordinator"])) {
                this.servicesAsCoordinator = [] as any;
                for (let item of _data["servicesAsCoordinator"])
                    this.servicesAsCoordinator!.push(item);
            }
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        if (Array.isArray(this.servicesAsCoordinator)) {
            data["servicesAsCoordinator"] = [];
            for (let item of this.servicesAsCoordinator)
                data["servicesAsCoordinator"].push(item);
        }
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    servicesAsCoordinator: number[] | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GroupDto implements IGroupDto {
    id!: number;
    displayName!: string | undefined;
    schoolYear!: SchoolYearDto;
    description!: string | undefined;

    constructor(data?: IGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.schoolYear = _data["schoolYear"] ? SchoolYearDto.fromJS(_data["schoolYear"]) : <any>undefined;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): GroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["schoolYear"] = this.schoolYear ? this.schoolYear.toJSON() : <any>undefined;
        data["description"] = this.description;
        return data;
    }

    clone(): GroupDto {
        const json = this.toJSON();
        let result = new GroupDto();
        result.init(json);
        return result;
    }
}

export interface IGroupDto {
    id: number;
    displayName: string | undefined;
    schoolYear: SchoolYearDto;
    description: string | undefined;
}

export class GroupDtoPagedResultDto implements IGroupDtoPagedResultDto {
    items!: GroupDto[] | undefined;
    totalCount!: number;

    constructor(data?: IGroupDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GroupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): GroupDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): GroupDtoPagedResultDto {
        const json = this.toJSON();
        let result = new GroupDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IGroupDtoPagedResultDto {
    items: GroupDto[] | undefined;
    totalCount: number;
}

export class GroupUsersDto implements IGroupUsersDto {
    group!: GroupDto;
    users!: BaseUserDto[] | undefined;

    constructor(data?: IGroupUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"] ? GroupDto.fromJS(_data["group"]) : <any>undefined;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(BaseUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }

    clone(): GroupUsersDto {
        const json = this.toJSON();
        let result = new GroupUsersDto();
        result.init(json);
        return result;
    }
}

export interface IGroupUsersDto {
    group: GroupDto;
    users: BaseUserDto[] | undefined;
}

export class HRRequestAndSupplyingObjectDto implements IHRRequestAndSupplyingObjectDto {
    id!: number;
    hrRequestSupplyingObject!: HRRequestSupplyingObject;
    hrRequest!: HRRequestDto;

    constructor(data?: IHRRequestAndSupplyingObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hrRequestSupplyingObject = _data["hrRequestSupplyingObject"] ? HRRequestSupplyingObject.fromJS(_data["hrRequestSupplyingObject"]) : <any>undefined;
            this.hrRequest = _data["hrRequest"] ? HRRequestDto.fromJS(_data["hrRequest"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HRRequestAndSupplyingObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestAndSupplyingObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hrRequestSupplyingObject"] = this.hrRequestSupplyingObject ? this.hrRequestSupplyingObject.toJSON() : <any>undefined;
        data["hrRequest"] = this.hrRequest ? this.hrRequest.toJSON() : <any>undefined;
        return data;
    }

    clone(): HRRequestAndSupplyingObjectDto {
        const json = this.toJSON();
        let result = new HRRequestAndSupplyingObjectDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestAndSupplyingObjectDto {
    id: number;
    hrRequestSupplyingObject: HRRequestSupplyingObject;
    hrRequest: HRRequestDto;
}

export class HRRequestApproverDto implements IHRRequestApproverDto {
    id!: number;
    user!: BaseUserDto;
    organizationUnit!: OrganizationUnitDto;
    level!: number;
    isApproved!: boolean | undefined;
    evaluationDate!: moment.Moment | undefined;
    annotation!: string | undefined;
    hrRequestCategoryApprovationFlow!: HRRequestCategoryApprovalFlowDto;

    constructor(data?: IHRRequestApproverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? BaseUserDto.fromJS(_data["user"]) : <any>undefined;
            this.organizationUnit = _data["organizationUnit"] ? OrganizationUnitDto.fromJS(_data["organizationUnit"]) : <any>undefined;
            this.level = _data["level"];
            this.isApproved = _data["isApproved"];
            this.evaluationDate = _data["evaluationDate"] ? moment(_data["evaluationDate"].toString()) : <any>undefined;
            this.annotation = _data["annotation"];
            this.hrRequestCategoryApprovationFlow = _data["hrRequestCategoryApprovationFlow"] ? HRRequestCategoryApprovalFlowDto.fromJS(_data["hrRequestCategoryApprovationFlow"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HRRequestApproverDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestApproverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["organizationUnit"] = this.organizationUnit ? this.organizationUnit.toJSON() : <any>undefined;
        data["level"] = this.level;
        data["isApproved"] = this.isApproved;
        data["evaluationDate"] = this.evaluationDate ? this.evaluationDate.toISOString() : <any>undefined;
        data["annotation"] = this.annotation;
        data["hrRequestCategoryApprovationFlow"] = this.hrRequestCategoryApprovationFlow ? this.hrRequestCategoryApprovationFlow.toJSON() : <any>undefined;
        return data;
    }

    clone(): HRRequestApproverDto {
        const json = this.toJSON();
        let result = new HRRequestApproverDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestApproverDto {
    id: number;
    user: BaseUserDto;
    organizationUnit: OrganizationUnitDto;
    level: number;
    isApproved: boolean | undefined;
    evaluationDate: moment.Moment | undefined;
    annotation: string | undefined;
    hrRequestCategoryApprovationFlow: HRRequestCategoryApprovalFlowDto;
}

export class HRRequestCategoryApprovalFlowDto implements IHRRequestCategoryApprovalFlowDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IHRRequestCategoryApprovalFlowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): HRRequestCategoryApprovalFlowDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestCategoryApprovalFlowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): HRRequestCategoryApprovalFlowDto {
        const json = this.toJSON();
        let result = new HRRequestCategoryApprovalFlowDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestCategoryApprovalFlowDto {
    id: number;
    description: string | undefined;
}

export class HRRequestDto implements IHRRequestDto {
    id!: number;
    user!: UserDto;
    creatorUser!: UserDto;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    totalDays!: number | undefined;
    totalHours!: number | undefined;
    hrRequestType!: HRRequestTypeDto;
    hrRequestState!: HRRequestStateDto;
    entityFiles!: HRRequestFileDto[] | undefined;
    illnessCertNumber!: string | undefined;
    userAnnotation!: string | undefined;
    acceptanceDate!: moment.Moment | undefined;
    rejectionDate!: moment.Moment | undefined;
    approverAnnotation!: string | undefined;
    readonly displayName!: string | undefined;
    projectReference!: string | undefined;
    activity!: string | undefined;
    place!: string | undefined;
    projectCode!: string | undefined;
    purchaseReason!: string | undefined;
    purchaseType!: PurchaseTypeDto;
    supplier!: string | undefined;
    deliveryPlace!: string | undefined;
    deliveryTime!: string | undefined;
    paymentType!: PaymentTypeDto;
    totalAmountRequired!: number;
    totalOrderPurchase!: number;
    residualPurchase!: number;
    currencyType!: CurrencyTypeDto;
    hrRequestAndSupplyingObjectDto!: HRRequestAndSupplyingObjectDto;
    cancellationTime!: moment.Moment | undefined;
    isCancelled!: boolean;

    constructor(data?: IHRRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.creatorUser = _data["creatorUser"] ? UserDto.fromJS(_data["creatorUser"]) : <any>undefined;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.totalDays = _data["totalDays"];
            this.totalHours = _data["totalHours"];
            this.hrRequestType = _data["hrRequestType"] ? HRRequestTypeDto.fromJS(_data["hrRequestType"]) : <any>undefined;
            this.hrRequestState = _data["hrRequestState"] ? HRRequestStateDto.fromJS(_data["hrRequestState"]) : <any>undefined;
            if (Array.isArray(_data["entityFiles"])) {
                this.entityFiles = [] as any;
                for (let item of _data["entityFiles"])
                    this.entityFiles!.push(HRRequestFileDto.fromJS(item));
            }
            this.illnessCertNumber = _data["illnessCertNumber"];
            this.userAnnotation = _data["userAnnotation"];
            this.acceptanceDate = _data["acceptanceDate"] ? moment(_data["acceptanceDate"].toString()) : <any>undefined;
            this.rejectionDate = _data["rejectionDate"] ? moment(_data["rejectionDate"].toString()) : <any>undefined;
            this.approverAnnotation = _data["approverAnnotation"];
            (<any>this).displayName = _data["displayName"];
            this.projectReference = _data["projectReference"];
            this.activity = _data["activity"];
            this.place = _data["place"];
            this.projectCode = _data["projectCode"];
            this.purchaseReason = _data["purchaseReason"];
            this.purchaseType = _data["purchaseType"] ? PurchaseTypeDto.fromJS(_data["purchaseType"]) : <any>undefined;
            this.supplier = _data["supplier"];
            this.deliveryPlace = _data["deliveryPlace"];
            this.deliveryTime = _data["deliveryTime"];
            this.paymentType = _data["paymentType"] ? PaymentTypeDto.fromJS(_data["paymentType"]) : <any>undefined;
            this.totalAmountRequired = _data["totalAmountRequired"];
            this.totalOrderPurchase = _data["totalOrderPurchase"];
            this.residualPurchase = _data["residualPurchase"];
            this.currencyType = _data["currencyType"] ? CurrencyTypeDto.fromJS(_data["currencyType"]) : <any>undefined;
            this.hrRequestAndSupplyingObjectDto = _data["hrRequestAndSupplyingObjectDto"] ? HRRequestAndSupplyingObjectDto.fromJS(_data["hrRequestAndSupplyingObjectDto"]) : <any>undefined;
            this.cancellationTime = _data["cancellationTime"] ? moment(_data["cancellationTime"].toString()) : <any>undefined;
            this.isCancelled = _data["isCancelled"];
        }
    }

    static fromJS(data: any): HRRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["hrRequestType"] = this.hrRequestType ? this.hrRequestType.toJSON() : <any>undefined;
        data["hrRequestState"] = this.hrRequestState ? this.hrRequestState.toJSON() : <any>undefined;
        if (Array.isArray(this.entityFiles)) {
            data["entityFiles"] = [];
            for (let item of this.entityFiles)
                data["entityFiles"].push(item.toJSON());
        }
        data["illnessCertNumber"] = this.illnessCertNumber;
        data["userAnnotation"] = this.userAnnotation;
        data["acceptanceDate"] = this.acceptanceDate ? this.acceptanceDate.toISOString() : <any>undefined;
        data["rejectionDate"] = this.rejectionDate ? this.rejectionDate.toISOString() : <any>undefined;
        data["approverAnnotation"] = this.approverAnnotation;
        data["displayName"] = this.displayName;
        data["projectReference"] = this.projectReference;
        data["activity"] = this.activity;
        data["place"] = this.place;
        data["projectCode"] = this.projectCode;
        data["purchaseReason"] = this.purchaseReason;
        data["purchaseType"] = this.purchaseType ? this.purchaseType.toJSON() : <any>undefined;
        data["supplier"] = this.supplier;
        data["deliveryPlace"] = this.deliveryPlace;
        data["deliveryTime"] = this.deliveryTime;
        data["paymentType"] = this.paymentType ? this.paymentType.toJSON() : <any>undefined;
        data["totalAmountRequired"] = this.totalAmountRequired;
        data["totalOrderPurchase"] = this.totalOrderPurchase;
        data["residualPurchase"] = this.residualPurchase;
        data["currencyType"] = this.currencyType ? this.currencyType.toJSON() : <any>undefined;
        data["hrRequestAndSupplyingObjectDto"] = this.hrRequestAndSupplyingObjectDto ? this.hrRequestAndSupplyingObjectDto.toJSON() : <any>undefined;
        data["cancellationTime"] = this.cancellationTime ? this.cancellationTime.toISOString() : <any>undefined;
        data["isCancelled"] = this.isCancelled;
        return data;
    }

    clone(): HRRequestDto {
        const json = this.toJSON();
        let result = new HRRequestDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestDto {
    id: number;
    user: UserDto;
    creatorUser: UserDto;
    startDate: moment.Moment;
    endDate: moment.Moment;
    totalDays: number | undefined;
    totalHours: number | undefined;
    hrRequestType: HRRequestTypeDto;
    hrRequestState: HRRequestStateDto;
    entityFiles: HRRequestFileDto[] | undefined;
    illnessCertNumber: string | undefined;
    userAnnotation: string | undefined;
    acceptanceDate: moment.Moment | undefined;
    rejectionDate: moment.Moment | undefined;
    approverAnnotation: string | undefined;
    displayName: string | undefined;
    projectReference: string | undefined;
    activity: string | undefined;
    place: string | undefined;
    projectCode: string | undefined;
    purchaseReason: string | undefined;
    purchaseType: PurchaseTypeDto;
    supplier: string | undefined;
    deliveryPlace: string | undefined;
    deliveryTime: string | undefined;
    paymentType: PaymentTypeDto;
    totalAmountRequired: number;
    totalOrderPurchase: number;
    residualPurchase: number;
    currencyType: CurrencyTypeDto;
    hrRequestAndSupplyingObjectDto: HRRequestAndSupplyingObjectDto;
    cancellationTime: moment.Moment | undefined;
    isCancelled: boolean;
}

export class HRRequestDtoPagedResultDto implements IHRRequestDtoPagedResultDto {
    items!: HRRequestDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHRRequestDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HRRequestDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HRRequestDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HRRequestDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HRRequestDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestDtoPagedResultDto {
    items: HRRequestDto[] | undefined;
    totalCount: number;
}

export class HRRequestFileDto implements IHRRequestFileDto {
    id!: number;
    file!: FileDto;

    constructor(data?: IHRRequestFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HRRequestFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }

    clone(): HRRequestFileDto {
        const json = this.toJSON();
        let result = new HRRequestFileDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestFileDto {
    id: number;
    file: FileDto;
}

export class HRRequestOrganizationUnitsApproverDto implements IHRRequestOrganizationUnitsApproverDto {
    id!: number;
    user!: BaseUserDto;
    hrRequestTypeOrganizationUnit!: HRRequestTypeOrganizationUnitsDto;
    level!: number;

    constructor(data?: IHRRequestOrganizationUnitsApproverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? BaseUserDto.fromJS(_data["user"]) : <any>undefined;
            this.hrRequestTypeOrganizationUnit = _data["hrRequestTypeOrganizationUnit"] ? HRRequestTypeOrganizationUnitsDto.fromJS(_data["hrRequestTypeOrganizationUnit"]) : <any>undefined;
            this.level = _data["level"];
        }
    }

    static fromJS(data: any): HRRequestOrganizationUnitsApproverDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestOrganizationUnitsApproverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["hrRequestTypeOrganizationUnit"] = this.hrRequestTypeOrganizationUnit ? this.hrRequestTypeOrganizationUnit.toJSON() : <any>undefined;
        data["level"] = this.level;
        return data;
    }

    clone(): HRRequestOrganizationUnitsApproverDto {
        const json = this.toJSON();
        let result = new HRRequestOrganizationUnitsApproverDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestOrganizationUnitsApproverDto {
    id: number;
    user: BaseUserDto;
    hrRequestTypeOrganizationUnit: HRRequestTypeOrganizationUnitsDto;
    level: number;
}

export class HRRequestOrganizationUnitsApproverDtoPagedResultDto implements IHRRequestOrganizationUnitsApproverDtoPagedResultDto {
    items!: HRRequestOrganizationUnitsApproverDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHRRequestOrganizationUnitsApproverDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HRRequestOrganizationUnitsApproverDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HRRequestOrganizationUnitsApproverDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestOrganizationUnitsApproverDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HRRequestOrganizationUnitsApproverDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HRRequestOrganizationUnitsApproverDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestOrganizationUnitsApproverDtoPagedResultDto {
    items: HRRequestOrganizationUnitsApproverDto[] | undefined;
    totalCount: number;
}

export class HRRequestStateDto implements IHRRequestStateDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IHRRequestStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): HRRequestStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): HRRequestStateDto {
        const json = this.toJSON();
        let result = new HRRequestStateDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestStateDto {
    id: number;
    description: string | undefined;
}

export class HRRequestSupplyingObject implements IHRRequestSupplyingObject {
    id!: number;
    name!: string | undefined;
    quantity!: number;
    unitPrice!: number;
    totalPrice!: number;

    constructor(data?: IHRRequestSupplyingObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): HRRequestSupplyingObject {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestSupplyingObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }

    clone(): HRRequestSupplyingObject {
        const json = this.toJSON();
        let result = new HRRequestSupplyingObject();
        result.init(json);
        return result;
    }
}

export interface IHRRequestSupplyingObject {
    id: number;
    name: string | undefined;
    quantity: number;
    unitPrice: number;
    totalPrice: number;
}

export class HRRequestSupplyingObjectDto implements IHRRequestSupplyingObjectDto {
    id!: number;
    name!: string | undefined;
    quantity!: number;
    unitPrice!: number;
    totalPrice!: number;

    constructor(data?: IHRRequestSupplyingObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.unitPrice = _data["unitPrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): HRRequestSupplyingObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestSupplyingObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["unitPrice"] = this.unitPrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }

    clone(): HRRequestSupplyingObjectDto {
        const json = this.toJSON();
        let result = new HRRequestSupplyingObjectDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestSupplyingObjectDto {
    id: number;
    name: string | undefined;
    quantity: number;
    unitPrice: number;
    totalPrice: number;
}

export class HRRequestSupplyingObjectDtoPagedResultDto implements IHRRequestSupplyingObjectDtoPagedResultDto {
    items!: HRRequestSupplyingObjectDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHRRequestSupplyingObjectDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HRRequestSupplyingObjectDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HRRequestSupplyingObjectDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestSupplyingObjectDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HRRequestSupplyingObjectDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HRRequestSupplyingObjectDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestSupplyingObjectDtoPagedResultDto {
    items: HRRequestSupplyingObjectDto[] | undefined;
    totalCount: number;
}

export class HRRequestTypeDto implements IHRRequestTypeDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: IHRRequestTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): HRRequestTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): HRRequestTypeDto {
        const json = this.toJSON();
        let result = new HRRequestTypeDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestTypeDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
}

export class HRRequestTypeOrganizationUnitsDto implements IHRRequestTypeOrganizationUnitsDto {
    id!: number;
    hrRequestType!: HRRequestTypeDto;
    organizationUnit!: OrganizationUnitDto;

    constructor(data?: IHRRequestTypeOrganizationUnitsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hrRequestType = _data["hrRequestType"] ? HRRequestTypeDto.fromJS(_data["hrRequestType"]) : <any>undefined;
            this.organizationUnit = _data["organizationUnit"] ? OrganizationUnitDto.fromJS(_data["organizationUnit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HRRequestTypeOrganizationUnitsDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestTypeOrganizationUnitsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hrRequestType"] = this.hrRequestType ? this.hrRequestType.toJSON() : <any>undefined;
        data["organizationUnit"] = this.organizationUnit ? this.organizationUnit.toJSON() : <any>undefined;
        return data;
    }

    clone(): HRRequestTypeOrganizationUnitsDto {
        const json = this.toJSON();
        let result = new HRRequestTypeOrganizationUnitsDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestTypeOrganizationUnitsDto {
    id: number;
    hrRequestType: HRRequestTypeDto;
    organizationUnit: OrganizationUnitDto;
}

export class HRRequestTypeOrganizationUnitsDtoPagedResultDto implements IHRRequestTypeOrganizationUnitsDtoPagedResultDto {
    items!: HRRequestTypeOrganizationUnitsDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHRRequestTypeOrganizationUnitsDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HRRequestTypeOrganizationUnitsDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HRRequestTypeOrganizationUnitsDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HRRequestTypeOrganizationUnitsDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HRRequestTypeOrganizationUnitsDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HRRequestTypeOrganizationUnitsDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHRRequestTypeOrganizationUnitsDtoPagedResultDto {
    items: HRRequestTypeOrganizationUnitsDto[] | undefined;
    totalCount: number;
}

export class IdentityError implements IIdentityError {
    code!: string | undefined;
    description!: string | undefined;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }

    clone(): IdentityError {
        const json = this.toJSON();
        let result = new IdentityError();
        result.init(json);
        return result;
    }
}

export interface IIdentityError {
    code: string | undefined;
    description: string | undefined;
}

export class IdentityResult implements IIdentityResult {
    readonly succeeded!: boolean;
    readonly errors!: IdentityError[] | undefined;

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(IdentityError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }

    clone(): IdentityResult {
        const json = this.toJSON();
        let result = new IdentityResult();
        result.init(json);
        return result;
    }
}

export interface IIdentityResult {
    succeeded: boolean;
    errors: IdentityError[] | undefined;
}

export class InfoPointDto implements IInfoPointDto {
    id!: number;
    title!: string | undefined;
    number!: number;

    constructor(data?: IInfoPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): InfoPointDto {
        data = typeof data === 'object' ? data : {};
        let result = new InfoPointDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["number"] = this.number;
        return data;
    }

    clone(): InfoPointDto {
        const json = this.toJSON();
        let result = new InfoPointDto();
        result.init(json);
        return result;
    }
}

export interface IInfoPointDto {
    id: number;
    title: string | undefined;
    number: number;
}

export class InformationAwarenessCourseDto implements IInformationAwarenessCourseDto {
    id!: number;
    title!: string | undefined;
    number!: number;

    constructor(data?: IInformationAwarenessCourseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): InformationAwarenessCourseDto {
        data = typeof data === 'object' ? data : {};
        let result = new InformationAwarenessCourseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["number"] = this.number;
        return data;
    }

    clone(): InformationAwarenessCourseDto {
        const json = this.toJSON();
        let result = new InformationAwarenessCourseDto();
        result.init(json);
        return result;
    }
}

export interface IInformationAwarenessCourseDto {
    id: number;
    title: string | undefined;
    number: number;
}

export class Int32EntityDto implements IInt32EntityDto {
    id!: number;

    constructor(data?: IInt32EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int32EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int32EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int32EntityDto {
        const json = this.toJSON();
        let result = new Int32EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt32EntityDto {
    id: number;
}

export class Int64EntityDto implements IInt64EntityDto {
    id!: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): Int64EntityDto {
        const json = this.toJSON();
        let result = new Int64EntityDto();
        result.init(json);
        return result;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
}

export class MediaEventDto implements IMediaEventDto {
    id!: number;
    description!: string | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    service!: ServiceDto;
    group!: GroupDto;
    media!: MediaEventFileDto[] | undefined;
    activityCategory!: ActivityCategoryDto;
    user!: UserDto[] | undefined;
    usersHours!: string | undefined;
    attendances!: AttendanceDto[] | undefined;

    constructor(data?: IMediaEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
            this.group = _data["group"] ? GroupDto.fromJS(_data["group"]) : <any>undefined;
            if (Array.isArray(_data["media"])) {
                this.media = [] as any;
                for (let item of _data["media"])
                    this.media!.push(MediaEventFileDto.fromJS(item));
            }
            this.activityCategory = _data["activityCategory"] ? ActivityCategoryDto.fromJS(_data["activityCategory"]) : <any>undefined;
            if (Array.isArray(_data["user"])) {
                this.user = [] as any;
                for (let item of _data["user"])
                    this.user!.push(UserDto.fromJS(item));
            }
            this.usersHours = _data["usersHours"];
            if (Array.isArray(_data["attendances"])) {
                this.attendances = [] as any;
                for (let item of _data["attendances"])
                    this.attendances!.push(AttendanceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MediaEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        if (Array.isArray(this.media)) {
            data["media"] = [];
            for (let item of this.media)
                data["media"].push(item.toJSON());
        }
        data["activityCategory"] = this.activityCategory ? this.activityCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.user)) {
            data["user"] = [];
            for (let item of this.user)
                data["user"].push(item.toJSON());
        }
        data["usersHours"] = this.usersHours;
        if (Array.isArray(this.attendances)) {
            data["attendances"] = [];
            for (let item of this.attendances)
                data["attendances"].push(item.toJSON());
        }
        return data;
    }

    clone(): MediaEventDto {
        const json = this.toJSON();
        let result = new MediaEventDto();
        result.init(json);
        return result;
    }
}

export interface IMediaEventDto {
    id: number;
    description: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    service: ServiceDto;
    group: GroupDto;
    media: MediaEventFileDto[] | undefined;
    activityCategory: ActivityCategoryDto;
    user: UserDto[] | undefined;
    usersHours: string | undefined;
    attendances: AttendanceDto[] | undefined;
}

export class MediaEventDtoPagedResultDto implements IMediaEventDtoPagedResultDto {
    items!: MediaEventDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMediaEventDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MediaEventDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MediaEventDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaEventDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MediaEventDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MediaEventDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMediaEventDtoPagedResultDto {
    items: MediaEventDto[] | undefined;
    totalCount: number;
}

export class MediaEventFileDto implements IMediaEventFileDto {
    id!: number;
    file!: FileDto;
    creationTime!: moment.Moment;

    constructor(data?: IMediaEventFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MediaEventFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaEventFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): MediaEventFileDto {
        const json = this.toJSON();
        let result = new MediaEventFileDto();
        result.init(json);
        return result;
    }
}

export interface IMediaEventFileDto {
    id: number;
    file: FileDto;
    creationTime: moment.Moment;
}

export class MediaEventFileDtoPagedResultDto implements IMediaEventFileDtoPagedResultDto {
    items!: MediaEventFileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMediaEventFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MediaEventFileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MediaEventFileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaEventFileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MediaEventFileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MediaEventFileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMediaEventFileDtoPagedResultDto {
    items: MediaEventFileDto[] | undefined;
    totalCount: number;
}

export class MessageDto implements IMessageDto {
    id!: number;
    text!: string | undefined;
    topicId!: number;
    creatorUser!: BaseUserDto;
    creationTime!: moment.Moment;
    entityFiles!: MessageFileDto[] | undefined;

    constructor(data?: IMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.text = _data["text"];
            this.topicId = _data["topicId"];
            this.creatorUser = _data["creatorUser"] ? BaseUserDto.fromJS(_data["creatorUser"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["entityFiles"])) {
                this.entityFiles = [] as any;
                for (let item of _data["entityFiles"])
                    this.entityFiles!.push(MessageFileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["text"] = this.text;
        data["topicId"] = this.topicId;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.entityFiles)) {
            data["entityFiles"] = [];
            for (let item of this.entityFiles)
                data["entityFiles"].push(item.toJSON());
        }
        return data;
    }

    clone(): MessageDto {
        const json = this.toJSON();
        let result = new MessageDto();
        result.init(json);
        return result;
    }
}

export interface IMessageDto {
    id: number;
    text: string | undefined;
    topicId: number;
    creatorUser: BaseUserDto;
    creationTime: moment.Moment;
    entityFiles: MessageFileDto[] | undefined;
}

export class MessageFileDto implements IMessageFileDto {
    file!: FileDto;

    constructor(data?: IMessageFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MessageFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }

    clone(): MessageFileDto {
        const json = this.toJSON();
        let result = new MessageFileDto();
        result.init(json);
        return result;
    }
}

export interface IMessageFileDto {
    file: FileDto;
}

export class MultipleServiceOperatorScheduledDto implements IMultipleServiceOperatorScheduledDto {
    predictedStartDate!: moment.Moment;
    predictedEndDate!: moment.Moment;
    workShiftFrequencyType!: WorkShiftFrequencyTypeDto;
    hoursAtPeriod!: number | undefined;
    workedMinutes!: number;
    predictedMinutes!: number | undefined;
    feePerHour!: number | undefined;

    constructor(data?: IMultipleServiceOperatorScheduledDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predictedStartDate = _data["predictedStartDate"] ? moment(_data["predictedStartDate"].toString()) : <any>undefined;
            this.predictedEndDate = _data["predictedEndDate"] ? moment(_data["predictedEndDate"].toString()) : <any>undefined;
            this.workShiftFrequencyType = _data["workShiftFrequencyType"] ? WorkShiftFrequencyTypeDto.fromJS(_data["workShiftFrequencyType"]) : <any>undefined;
            this.hoursAtPeriod = _data["hoursAtPeriod"];
            this.workedMinutes = _data["workedMinutes"];
            this.predictedMinutes = _data["predictedMinutes"];
            this.feePerHour = _data["feePerHour"];
        }
    }

    static fromJS(data: any): MultipleServiceOperatorScheduledDto {
        data = typeof data === 'object' ? data : {};
        let result = new MultipleServiceOperatorScheduledDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predictedStartDate"] = this.predictedStartDate ? this.predictedStartDate.toISOString() : <any>undefined;
        data["predictedEndDate"] = this.predictedEndDate ? this.predictedEndDate.toISOString() : <any>undefined;
        data["workShiftFrequencyType"] = this.workShiftFrequencyType ? this.workShiftFrequencyType.toJSON() : <any>undefined;
        data["hoursAtPeriod"] = this.hoursAtPeriod;
        data["workedMinutes"] = this.workedMinutes;
        data["predictedMinutes"] = this.predictedMinutes;
        data["feePerHour"] = this.feePerHour;
        return data;
    }

    clone(): MultipleServiceOperatorScheduledDto {
        const json = this.toJSON();
        let result = new MultipleServiceOperatorScheduledDto();
        result.init(json);
        return result;
    }
}

export interface IMultipleServiceOperatorScheduledDto {
    predictedStartDate: moment.Moment;
    predictedEndDate: moment.Moment;
    workShiftFrequencyType: WorkShiftFrequencyTypeDto;
    hoursAtPeriod: number | undefined;
    workedMinutes: number;
    predictedMinutes: number | undefined;
    feePerHour: number | undefined;
}

export class MunicipalityBaseDto implements IMunicipalityBaseDto {
    id!: number;
    name!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: IMunicipalityBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): MunicipalityBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new MunicipalityBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): MunicipalityBaseDto {
        const json = this.toJSON();
        let result = new MunicipalityBaseDto();
        result.init(json);
        return result;
    }
}

export interface IMunicipalityBaseDto {
    id: number;
    name: string | undefined;
    staticCode: string | undefined;
}

export class MunicipalityBaseDtoPagedResultDto implements IMunicipalityBaseDtoPagedResultDto {
    items!: MunicipalityBaseDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMunicipalityBaseDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MunicipalityBaseDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MunicipalityBaseDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MunicipalityBaseDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MunicipalityBaseDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MunicipalityBaseDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMunicipalityBaseDtoPagedResultDto {
    items: MunicipalityBaseDto[] | undefined;
    totalCount: number;
}

export class MunicipalityDto implements IMunicipalityDto {
    id!: number;
    name!: string | undefined;
    isChiefTown!: boolean;
    province!: ProvinceDto;
    staticCode!: string | undefined;

    constructor(data?: IMunicipalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isChiefTown = _data["isChiefTown"];
            this.province = _data["province"] ? ProvinceDto.fromJS(_data["province"]) : <any>undefined;
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): MunicipalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new MunicipalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isChiefTown"] = this.isChiefTown;
        data["province"] = this.province ? this.province.toJSON() : <any>undefined;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): MunicipalityDto {
        const json = this.toJSON();
        let result = new MunicipalityDto();
        result.init(json);
        return result;
    }
}

export interface IMunicipalityDto {
    id: number;
    name: string | undefined;
    isChiefTown: boolean;
    province: ProvinceDto;
    staticCode: string | undefined;
}

export class NonAttendanceMotivationDto implements INonAttendanceMotivationDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: INonAttendanceMotivationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): NonAttendanceMotivationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonAttendanceMotivationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): NonAttendanceMotivationDto {
        const json = this.toJSON();
        let result = new NonAttendanceMotivationDto();
        result.init(json);
        return result;
    }
}

export interface INonAttendanceMotivationDto {
    id: number;
    description: string | undefined;
}

export class NonAttendanceMotivationDtoPagedResultDto implements INonAttendanceMotivationDtoPagedResultDto {
    items!: NonAttendanceMotivationDto[] | undefined;
    totalCount!: number;

    constructor(data?: INonAttendanceMotivationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NonAttendanceMotivationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NonAttendanceMotivationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NonAttendanceMotivationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NonAttendanceMotivationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NonAttendanceMotivationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INonAttendanceMotivationDtoPagedResultDto {
    items: NonAttendanceMotivationDto[] | undefined;
    totalCount: number;
}

export class NotificationDto implements INotificationDto {
    id!: string;
    isRead!: boolean;
    notificationType!: string | undefined;
    notificationName!: string | undefined;
    notificationDescription!: string | undefined;
    entityName!: string | undefined;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    isEntityDeleted!: boolean;
    severity!: string | undefined;
    creationTime!: moment.Moment;

    constructor(data?: INotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isRead = _data["isRead"];
            this.notificationType = _data["notificationType"];
            this.notificationName = _data["notificationName"];
            this.notificationDescription = _data["notificationDescription"];
            this.entityName = _data["entityName"];
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.isEntityDeleted = _data["isEntityDeleted"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isRead"] = this.isRead;
        data["notificationType"] = this.notificationType;
        data["notificationName"] = this.notificationName;
        data["notificationDescription"] = this.notificationDescription;
        data["entityName"] = this.entityName;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["isEntityDeleted"] = this.isEntityDeleted;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): NotificationDto {
        const json = this.toJSON();
        let result = new NotificationDto();
        result.init(json);
        return result;
    }
}

export interface INotificationDto {
    id: string;
    isRead: boolean;
    notificationType: string | undefined;
    notificationName: string | undefined;
    notificationDescription: string | undefined;
    entityName: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    isEntityDeleted: boolean;
    severity: string | undefined;
    creationTime: moment.Moment;
}

export class NotificationDtoPagedResultDto implements INotificationDtoPagedResultDto {
    items!: NotificationDto[] | undefined;
    totalCount!: number;

    constructor(data?: INotificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NotificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): NotificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): NotificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new NotificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface INotificationDtoPagedResultDto {
    items: NotificationDto[] | undefined;
    totalCount: number;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    id!: number;
    displayName!: string | undefined;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): OrganizationUnitDto {
        const json = this.toJSON();
        let result = new OrganizationUnitDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitDto {
    id: number;
    displayName: string | undefined;
}

export class OrganizationUnitDtoPagedResultDto implements IOrganizationUnitDtoPagedResultDto {
    items!: OrganizationUnitDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOrganizationUnitDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OrganizationUnitDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OrganizationUnitDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrganizationUnitDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitDtoPagedResultDto {
    items: OrganizationUnitDto[] | undefined;
    totalCount: number;
}

export class OrganizationUnitUsersDto implements IOrganizationUnitUsersDto {
    organizationUnit!: OrganizationUnitDto;
    users!: BaseUserDto[] | undefined;

    constructor(data?: IOrganizationUnitUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnit = _data["organizationUnit"] ? OrganizationUnitDto.fromJS(_data["organizationUnit"]) : <any>undefined;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(BaseUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationUnitUsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnit"] = this.organizationUnit ? this.organizationUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        return data;
    }

    clone(): OrganizationUnitUsersDto {
        const json = this.toJSON();
        let result = new OrganizationUnitUsersDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationUnitUsersDto {
    organizationUnit: OrganizationUnitDto;
    users: BaseUserDto[] | undefined;
}

export class OtherSendingsDto implements IOtherSendingsDto {
    id!: number;
    title!: string | undefined;
    number!: number;

    constructor(data?: IOtherSendingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): OtherSendingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherSendingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["number"] = this.number;
        return data;
    }

    clone(): OtherSendingsDto {
        const json = this.toJSON();
        let result = new OtherSendingsDto();
        result.init(json);
        return result;
    }
}

export interface IOtherSendingsDto {
    id: number;
    title: string | undefined;
    number: number;
}

export class PagedAndSortedFileResultRequestDto implements IPagedAndSortedFileResultRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    keyword!: string | undefined;
    contractId!: number | undefined;
    contractName!: string | undefined;
    operatorName!: string | undefined;
    serviceId!: number | undefined;
    serviceName!: string | undefined;
    hrRequestId!: number | undefined;
    fileTypeId!: number | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    expirationDate!: moment.Moment | undefined;
    userId!: number | undefined;
    userParentId!: number | undefined;

    constructor(data?: IPagedAndSortedFileResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.keyword = _data["keyword"];
            this.contractId = _data["contractId"];
            this.contractName = _data["contractName"];
            this.operatorName = _data["operatorName"];
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.hrRequestId = _data["hrRequestId"];
            this.fileTypeId = _data["fileTypeId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.userParentId = _data["userParentId"];
        }
    }

    static fromJS(data: any): PagedAndSortedFileResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedAndSortedFileResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["keyword"] = this.keyword;
        data["contractId"] = this.contractId;
        data["contractName"] = this.contractName;
        data["operatorName"] = this.operatorName;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["hrRequestId"] = this.hrRequestId;
        data["fileTypeId"] = this.fileTypeId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["userParentId"] = this.userParentId;
        return data;
    }

    clone(): PagedAndSortedFileResultRequestDto {
        const json = this.toJSON();
        let result = new PagedAndSortedFileResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPagedAndSortedFileResultRequestDto {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    keyword: string | undefined;
    contractId: number | undefined;
    contractName: string | undefined;
    operatorName: string | undefined;
    serviceId: number | undefined;
    serviceName: string | undefined;
    hrRequestId: number | undefined;
    fileTypeId: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    expirationDate: moment.Moment | undefined;
    userId: number | undefined;
    userParentId: number | undefined;
}

export class PagedNotificationResultRequestDto implements IPagedNotificationResultRequestDto {
    maxResultCount!: number;
    skipCount!: number;
    keyword!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    isRead!: boolean | undefined;
    entityTypes!: string[] | undefined;

    constructor(data?: IPagedNotificationResultRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.keyword = _data["keyword"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.isRead = _data["isRead"];
            if (Array.isArray(_data["entityTypes"])) {
                this.entityTypes = [] as any;
                for (let item of _data["entityTypes"])
                    this.entityTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): PagedNotificationResultRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedNotificationResultRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["keyword"] = this.keyword;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["isRead"] = this.isRead;
        if (Array.isArray(this.entityTypes)) {
            data["entityTypes"] = [];
            for (let item of this.entityTypes)
                data["entityTypes"].push(item);
        }
        return data;
    }

    clone(): PagedNotificationResultRequestDto {
        const json = this.toJSON();
        let result = new PagedNotificationResultRequestDto();
        result.init(json);
        return result;
    }
}

export interface IPagedNotificationResultRequestDto {
    maxResultCount: number;
    skipCount: number;
    keyword: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    isRead: boolean | undefined;
    entityTypes: string[] | undefined;
}

export class ParentalDegreeDictionaryDto implements IParentalDegreeDictionaryDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    isVisibleToDescendant!: boolean;

    constructor(data?: IParentalDegreeDictionaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.isVisibleToDescendant = _data["isVisibleToDescendant"];
        }
    }

    static fromJS(data: any): ParentalDegreeDictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParentalDegreeDictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["isVisibleToDescendant"] = this.isVisibleToDescendant;
        return data;
    }

    clone(): ParentalDegreeDictionaryDto {
        const json = this.toJSON();
        let result = new ParentalDegreeDictionaryDto();
        result.init(json);
        return result;
    }
}

export interface IParentalDegreeDictionaryDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    isVisibleToDescendant: boolean;
}

export class ParentalDegreeDictionaryDtoPagedResultDto implements IParentalDegreeDictionaryDtoPagedResultDto {
    items!: ParentalDegreeDictionaryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IParentalDegreeDictionaryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParentalDegreeDictionaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ParentalDegreeDictionaryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParentalDegreeDictionaryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ParentalDegreeDictionaryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ParentalDegreeDictionaryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IParentalDegreeDictionaryDtoPagedResultDto {
    items: ParentalDegreeDictionaryDto[] | undefined;
    totalCount: number;
}

export class PaycheckPaymentTypeDto implements IPaycheckPaymentTypeDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: IPaycheckPaymentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): PaycheckPaymentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaycheckPaymentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): PaycheckPaymentTypeDto {
        const json = this.toJSON();
        let result = new PaycheckPaymentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IPaycheckPaymentTypeDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
}

export class PaymentTypeDto implements IPaymentTypeDto {
    id!: number;
    description!: string | undefined;
    displayName!: string | undefined;

    constructor(data?: IPaymentTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): PaymentTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): PaymentTypeDto {
        const json = this.toJSON();
        let result = new PaymentTypeDto();
        result.init(json);
        return result;
    }
}

export interface IPaymentTypeDto {
    id: number;
    description: string | undefined;
    displayName: string | undefined;
}

export class PermissionDto implements IPermissionDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items!: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class PlanningDto implements IPlanningDto {
    id!: number;
    service!: ServiceDto;
    group!: GroupDto;
    educator!: UserDto;
    timeIntervals!: TimeIntervalDto[] | undefined;
    date!: moment.Moment;
    annotation!: string | undefined;
    childrenCount!: number;

    constructor(data?: IPlanningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
            this.group = _data["group"] ? GroupDto.fromJS(_data["group"]) : <any>undefined;
            this.educator = _data["educator"] ? UserDto.fromJS(_data["educator"]) : <any>undefined;
            if (Array.isArray(_data["timeIntervals"])) {
                this.timeIntervals = [] as any;
                for (let item of _data["timeIntervals"])
                    this.timeIntervals!.push(TimeIntervalDto.fromJS(item));
            }
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.annotation = _data["annotation"];
            this.childrenCount = _data["childrenCount"];
        }
    }

    static fromJS(data: any): PlanningDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["educator"] = this.educator ? this.educator.toJSON() : <any>undefined;
        if (Array.isArray(this.timeIntervals)) {
            data["timeIntervals"] = [];
            for (let item of this.timeIntervals)
                data["timeIntervals"].push(item.toJSON());
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["annotation"] = this.annotation;
        data["childrenCount"] = this.childrenCount;
        return data;
    }

    clone(): PlanningDto {
        const json = this.toJSON();
        let result = new PlanningDto();
        result.init(json);
        return result;
    }
}

export interface IPlanningDto {
    id: number;
    service: ServiceDto;
    group: GroupDto;
    educator: UserDto;
    timeIntervals: TimeIntervalDto[] | undefined;
    date: moment.Moment;
    annotation: string | undefined;
    childrenCount: number;
}

export class PlanningDtoPagedResultDto implements IPlanningDtoPagedResultDto {
    items!: PlanningDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPlanningDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PlanningDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PlanningDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlanningDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PlanningDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PlanningDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPlanningDtoPagedResultDto {
    items: PlanningDto[] | undefined;
    totalCount: number;
}

export class ProfessionalRegisterDto implements IProfessionalRegisterDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IProfessionalRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ProfessionalRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): ProfessionalRegisterDto {
        const json = this.toJSON();
        let result = new ProfessionalRegisterDto();
        result.init(json);
        return result;
    }
}

export interface IProfessionalRegisterDto {
    id: number;
    description: string | undefined;
}

export class ProfessionalRegisterDtoPagedResultDto implements IProfessionalRegisterDtoPagedResultDto {
    items!: ProfessionalRegisterDto[] | undefined;
    totalCount!: number;

    constructor(data?: IProfessionalRegisterDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProfessionalRegisterDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProfessionalRegisterDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalRegisterDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProfessionalRegisterDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProfessionalRegisterDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProfessionalRegisterDtoPagedResultDto {
    items: ProfessionalRegisterDto[] | undefined;
    totalCount: number;
}

export class ProvinceDto implements IProvinceDto {
    id!: number;
    name!: string | undefined;
    abbreviation!: string | undefined;
    region!: RegionDto;

    constructor(data?: IProvinceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.abbreviation = _data["abbreviation"];
            this.region = _data["region"] ? RegionDto.fromJS(_data["region"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProvinceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["abbreviation"] = this.abbreviation;
        data["region"] = this.region ? this.region.toJSON() : <any>undefined;
        return data;
    }

    clone(): ProvinceDto {
        const json = this.toJSON();
        let result = new ProvinceDto();
        result.init(json);
        return result;
    }
}

export interface IProvinceDto {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;
    region: RegionDto;
}

export class PsychoeducationalLabDto implements IPsychoeducationalLabDto {
    id!: number;
    title!: string | undefined;
    number!: number;

    constructor(data?: IPsychoeducationalLabDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): PsychoeducationalLabDto {
        data = typeof data === 'object' ? data : {};
        let result = new PsychoeducationalLabDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["number"] = this.number;
        return data;
    }

    clone(): PsychoeducationalLabDto {
        const json = this.toJSON();
        let result = new PsychoeducationalLabDto();
        result.init(json);
        return result;
    }
}

export interface IPsychoeducationalLabDto {
    id: number;
    title: string | undefined;
    number: number;
}

export class PublicationDto implements IPublicationDto {
    id!: number;
    title!: string | undefined;

    constructor(data?: IPublicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): PublicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }

    clone(): PublicationDto {
        const json = this.toJSON();
        let result = new PublicationDto();
        result.init(json);
        return result;
    }
}

export interface IPublicationDto {
    id: number;
    title: string | undefined;
}

export class PurchaseTypeDto implements IPurchaseTypeDto {
    id!: number;
    description!: string | undefined;
    displayName!: string | undefined;

    constructor(data?: IPurchaseTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): PurchaseTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["displayName"] = this.displayName;
        return data;
    }

    clone(): PurchaseTypeDto {
        const json = this.toJSON();
        let result = new PurchaseTypeDto();
        result.init(json);
        return result;
    }
}

export interface IPurchaseTypeDto {
    id: number;
    description: string | undefined;
    displayName: string | undefined;
}

export class QualificationDto implements IQualificationDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): QualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): QualificationDto {
        const json = this.toJSON();
        let result = new QualificationDto();
        result.init(json);
        return result;
    }
}

export interface IQualificationDto {
    id: number;
    description: string | undefined;
}

export class QualificationDtoPagedResultDto implements IQualificationDtoPagedResultDto {
    items!: QualificationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IQualificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QualificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): QualificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): QualificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new QualificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IQualificationDtoPagedResultDto {
    items: QualificationDto[] | undefined;
    totalCount: number;
}

export class ReceiptDto implements IReceiptDto {
    id!: number;
    title!: string | undefined;
    commitment!: CommitmentDto;
    outputs!: ReceiptOutputDto[] | undefined;
    receiptFiles!: ReceiptFileDto[] | undefined;
    amount!: number;
    billingDate!: moment.Moment;
    feePerHour!: number | undefined;
    workedHours!: number | undefined;
    duePaycheck!: DuePaycheckDto;

    constructor(data?: IReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.commitment = _data["commitment"] ? CommitmentDto.fromJS(_data["commitment"]) : <any>undefined;
            if (Array.isArray(_data["outputs"])) {
                this.outputs = [] as any;
                for (let item of _data["outputs"])
                    this.outputs!.push(ReceiptOutputDto.fromJS(item));
            }
            if (Array.isArray(_data["receiptFiles"])) {
                this.receiptFiles = [] as any;
                for (let item of _data["receiptFiles"])
                    this.receiptFiles!.push(ReceiptFileDto.fromJS(item));
            }
            this.amount = _data["amount"];
            this.billingDate = _data["billingDate"] ? moment(_data["billingDate"].toString()) : <any>undefined;
            this.feePerHour = _data["feePerHour"];
            this.workedHours = _data["workedHours"];
            this.duePaycheck = _data["duePaycheck"] ? DuePaycheckDto.fromJS(_data["duePaycheck"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["commitment"] = this.commitment ? this.commitment.toJSON() : <any>undefined;
        if (Array.isArray(this.outputs)) {
            data["outputs"] = [];
            for (let item of this.outputs)
                data["outputs"].push(item.toJSON());
        }
        if (Array.isArray(this.receiptFiles)) {
            data["receiptFiles"] = [];
            for (let item of this.receiptFiles)
                data["receiptFiles"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["billingDate"] = this.billingDate ? this.billingDate.toISOString() : <any>undefined;
        data["feePerHour"] = this.feePerHour;
        data["workedHours"] = this.workedHours;
        data["duePaycheck"] = this.duePaycheck ? this.duePaycheck.toJSON() : <any>undefined;
        return data;
    }

    clone(): ReceiptDto {
        const json = this.toJSON();
        let result = new ReceiptDto();
        result.init(json);
        return result;
    }
}

export interface IReceiptDto {
    id: number;
    title: string | undefined;
    commitment: CommitmentDto;
    outputs: ReceiptOutputDto[] | undefined;
    receiptFiles: ReceiptFileDto[] | undefined;
    amount: number;
    billingDate: moment.Moment;
    feePerHour: number | undefined;
    workedHours: number | undefined;
    duePaycheck: DuePaycheckDto;
}

export class ReceiptDtoPagedResultDto implements IReceiptDtoPagedResultDto {
    items!: ReceiptDto[] | undefined;
    totalCount!: number;

    constructor(data?: IReceiptDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReceiptDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReceiptDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReceiptDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReceiptDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReceiptDtoPagedResultDto {
    items: ReceiptDto[] | undefined;
    totalCount: number;
}

export class ReceiptFileDto implements IReceiptFileDto {
    id!: number;
    file!: FileDto;
    creationTime!: moment.Moment;

    constructor(data?: IReceiptFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReceiptFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ReceiptFileDto {
        const json = this.toJSON();
        let result = new ReceiptFileDto();
        result.init(json);
        return result;
    }
}

export interface IReceiptFileDto {
    id: number;
    file: FileDto;
    creationTime: moment.Moment;
}

export class ReceiptFilesDto implements IReceiptFilesDto {
    id!: number;
    receipt!: ReceiptDto;
    file!: FileDto;
    creationTime!: moment.Moment;

    constructor(data?: IReceiptFilesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.receipt = _data["receipt"] ? ReceiptDto.fromJS(_data["receipt"]) : <any>undefined;
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReceiptFilesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptFilesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["receipt"] = this.receipt ? this.receipt.toJSON() : <any>undefined;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ReceiptFilesDto {
        const json = this.toJSON();
        let result = new ReceiptFilesDto();
        result.init(json);
        return result;
    }
}

export interface IReceiptFilesDto {
    id: number;
    receipt: ReceiptDto;
    file: FileDto;
    creationTime: moment.Moment;
}

export class ReceiptFilesDtoPagedResultDto implements IReceiptFilesDtoPagedResultDto {
    items!: ReceiptFilesDto[] | undefined;
    totalCount!: number;

    constructor(data?: IReceiptFilesDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReceiptFilesDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReceiptFilesDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptFilesDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReceiptFilesDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReceiptFilesDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReceiptFilesDtoPagedResultDto {
    items: ReceiptFilesDto[] | undefined;
    totalCount: number;
}

export class ReceiptOutputDto implements IReceiptOutputDto {
    id!: number;
    commitmentOutput!: CommitmentOutputDto;
    amount!: number;

    constructor(data?: IReceiptOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.commitmentOutput = _data["commitmentOutput"] ? CommitmentOutputDto.fromJS(_data["commitmentOutput"]) : <any>undefined;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): ReceiptOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["commitmentOutput"] = this.commitmentOutput ? this.commitmentOutput.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }

    clone(): ReceiptOutputDto {
        const json = this.toJSON();
        let result = new ReceiptOutputDto();
        result.init(json);
        return result;
    }
}

export interface IReceiptOutputDto {
    id: number;
    commitmentOutput: CommitmentOutputDto;
    amount: number;
}

export class RegionDto implements IRegionDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): RegionDto {
        const json = this.toJSON();
        let result = new RegionDto();
        result.init(json);
        return result;
    }
}

export interface IRegionDto {
    id: number;
    name: string | undefined;
}

export class RegistrationParametersDto implements IRegistrationParametersDto {
    id!: number;
    user!: BaseUserDto;
    timeSlot!: string | undefined;
    diaperOption!: DiaperOptions;
    imageUseAuthorization!: boolean | undefined;
    imageUseAuthorizationOnSocial!: boolean | undefined;

    constructor(data?: IRegistrationParametersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? BaseUserDto.fromJS(_data["user"]) : <any>undefined;
            this.timeSlot = _data["timeSlot"];
            this.diaperOption = _data["diaperOption"];
            this.imageUseAuthorization = _data["imageUseAuthorization"];
            this.imageUseAuthorizationOnSocial = _data["imageUseAuthorizationOnSocial"];
        }
    }

    static fromJS(data: any): RegistrationParametersDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationParametersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["timeSlot"] = this.timeSlot;
        data["diaperOption"] = this.diaperOption;
        data["imageUseAuthorization"] = this.imageUseAuthorization;
        data["imageUseAuthorizationOnSocial"] = this.imageUseAuthorizationOnSocial;
        return data;
    }

    clone(): RegistrationParametersDto {
        const json = this.toJSON();
        let result = new RegistrationParametersDto();
        result.init(json);
        return result;
    }
}

export interface IRegistrationParametersDto {
    id: number;
    user: BaseUserDto;
    timeSlot: string | undefined;
    diaperOption: DiaperOptions;
    imageUseAuthorization: boolean | undefined;
    imageUseAuthorizationOnSocial: boolean | undefined;
}

export class RemainingAmountInput implements IRemainingAmountInput {
    activity!: Int64EntityDto;

    constructor(data?: IRemainingAmountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activity = _data["activity"] ? Int64EntityDto.fromJS(_data["activity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RemainingAmountInput {
        data = typeof data === 'object' ? data : {};
        let result = new RemainingAmountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activity"] = this.activity ? this.activity.toJSON() : <any>undefined;
        return data;
    }

    clone(): RemainingAmountInput {
        const json = this.toJSON();
        let result = new RemainingAmountInput();
        result.init(json);
        return result;
    }
}

export interface IRemainingAmountInput {
    activity: Int64EntityDto;
}

export class ReminderDictionaryDto implements IReminderDictionaryDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: IReminderDictionaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): ReminderDictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderDictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): ReminderDictionaryDto {
        const json = this.toJSON();
        let result = new ReminderDictionaryDto();
        result.init(json);
        return result;
    }
}

export interface IReminderDictionaryDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
}

export class ReminderDictionaryDtoPagedResultDto implements IReminderDictionaryDtoPagedResultDto {
    items!: ReminderDictionaryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IReminderDictionaryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReminderDictionaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReminderDictionaryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderDictionaryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReminderDictionaryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReminderDictionaryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReminderDictionaryDtoPagedResultDto {
    items: ReminderDictionaryDto[] | undefined;
    totalCount: number;
}

export class ResetPasswordResultDto implements IResetPasswordResultDto {
    result!: IdentityResult;
    userId!: number;
    isUserActive!: boolean;

    constructor(data?: IResetPasswordResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : <any>undefined;
            this.userId = _data["userId"];
            this.isUserActive = _data["isUserActive"];
        }
    }

    static fromJS(data: any): ResetPasswordResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["isUserActive"] = this.isUserActive;
        return data;
    }

    clone(): ResetPasswordResultDto {
        const json = this.toJSON();
        let result = new ResetPasswordResultDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordResultDto {
    result: IdentityResult;
    userId: number;
    isUserActive: boolean;
}

export class RoleDto implements IRoleDto {
    id!: number;
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class RoleDtoListResultDto implements IRoleDtoListResultDto {
    items!: RoleDto[] | undefined;

    constructor(data?: IRoleDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoListResultDto {
    items: RoleDto[] | undefined;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items!: RoleDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number;
    name!: string;
    displayName!: string;
    description!: string | undefined;
    isStatic!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class ScheduledEventDo implements IScheduledEventDo {
    id!: string;
    eventName!: string | undefined;
    eventDescription!: string | undefined;
    creatorUserId!: number | undefined;
    users!: ScheduledEventUserDto[] | undefined;
    severity!: string | undefined;
    color!: string | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    reminderDate!: moment.Moment;
    service!: ServiceDto;

    constructor(data?: IScheduledEventDo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventName = _data["eventName"];
            this.eventDescription = _data["eventDescription"];
            this.creatorUserId = _data["creatorUserId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(ScheduledEventUserDto.fromJS(item));
            }
            this.severity = _data["severity"];
            this.color = _data["color"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.reminderDate = _data["reminderDate"] ? moment(_data["reminderDate"].toString()) : <any>undefined;
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduledEventDo {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledEventDo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventName"] = this.eventName;
        data["eventDescription"] = this.eventDescription;
        data["creatorUserId"] = this.creatorUserId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["severity"] = this.severity;
        data["color"] = this.color;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["reminderDate"] = this.reminderDate ? this.reminderDate.toISOString() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        return data;
    }

    clone(): ScheduledEventDo {
        const json = this.toJSON();
        let result = new ScheduledEventDo();
        result.init(json);
        return result;
    }
}

export interface IScheduledEventDo {
    id: string;
    eventName: string | undefined;
    eventDescription: string | undefined;
    creatorUserId: number | undefined;
    users: ScheduledEventUserDto[] | undefined;
    severity: string | undefined;
    color: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    reminderDate: moment.Moment;
    service: ServiceDto;
}

export class ScheduledEventDoPagedResultDto implements IScheduledEventDoPagedResultDto {
    items!: ScheduledEventDo[] | undefined;
    totalCount!: number;

    constructor(data?: IScheduledEventDoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScheduledEventDo.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ScheduledEventDoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledEventDoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ScheduledEventDoPagedResultDto {
        const json = this.toJSON();
        let result = new ScheduledEventDoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IScheduledEventDoPagedResultDto {
    items: ScheduledEventDo[] | undefined;
    totalCount: number;
}

export class ScheduledEventUserDto implements IScheduledEventUserDto {
    id!: number;
    user!: BaseUserDto;

    constructor(data?: IScheduledEventUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? BaseUserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduledEventUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledEventUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): ScheduledEventUserDto {
        const json = this.toJSON();
        let result = new ScheduledEventUserDto();
        result.init(json);
        return result;
    }
}

export interface IScheduledEventUserDto {
    id: number;
    user: BaseUserDto;
}

export class ScheduledNotificationDto implements IScheduledNotificationDto {
    id!: string;
    entityId!: string | undefined;
    entityType!: string | undefined;
    notificationName!: string | undefined;
    description!: string | undefined;
    creatorUserId!: number | undefined;
    users!: ScheduledNotificationUserDto[] | undefined;
    excludedUserIds!: string | undefined;
    severity!: string | undefined;
    dueDate!: moment.Moment;
    reminderDate!: moment.Moment;

    constructor(data?: IScheduledNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.entityType = _data["entityType"];
            this.notificationName = _data["notificationName"];
            this.description = _data["description"];
            this.creatorUserId = _data["creatorUserId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(ScheduledNotificationUserDto.fromJS(item));
            }
            this.excludedUserIds = _data["excludedUserIds"];
            this.severity = _data["severity"];
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.reminderDate = _data["reminderDate"] ? moment(_data["reminderDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduledNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["entityType"] = this.entityType;
        data["notificationName"] = this.notificationName;
        data["description"] = this.description;
        data["creatorUserId"] = this.creatorUserId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["excludedUserIds"] = this.excludedUserIds;
        data["severity"] = this.severity;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["reminderDate"] = this.reminderDate ? this.reminderDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): ScheduledNotificationDto {
        const json = this.toJSON();
        let result = new ScheduledNotificationDto();
        result.init(json);
        return result;
    }
}

export interface IScheduledNotificationDto {
    id: string;
    entityId: string | undefined;
    entityType: string | undefined;
    notificationName: string | undefined;
    description: string | undefined;
    creatorUserId: number | undefined;
    users: ScheduledNotificationUserDto[] | undefined;
    excludedUserIds: string | undefined;
    severity: string | undefined;
    dueDate: moment.Moment;
    reminderDate: moment.Moment;
}

export class ScheduledNotificationDtoPagedResultDto implements IScheduledNotificationDtoPagedResultDto {
    items!: ScheduledNotificationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IScheduledNotificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScheduledNotificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ScheduledNotificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledNotificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ScheduledNotificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ScheduledNotificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IScheduledNotificationDtoPagedResultDto {
    items: ScheduledNotificationDto[] | undefined;
    totalCount: number;
}

export class ScheduledNotificationUserDto implements IScheduledNotificationUserDto {
    id!: number;
    user!: BaseUserDto;

    constructor(data?: IScheduledNotificationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? BaseUserDto.fromJS(_data["user"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduledNotificationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduledNotificationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }

    clone(): ScheduledNotificationUserDto {
        const json = this.toJSON();
        let result = new ScheduledNotificationUserDto();
        result.init(json);
        return result;
    }
}

export interface IScheduledNotificationUserDto {
    id: number;
    user: BaseUserDto;
}

export class SchoolYearDto implements ISchoolYearDto {
    id!: number;
    year!: string | undefined;

    constructor(data?: ISchoolYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): SchoolYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        return data;
    }

    clone(): SchoolYearDto {
        const json = this.toJSON();
        let result = new SchoolYearDto();
        result.init(json);
        return result;
    }
}

export interface ISchoolYearDto {
    id: number;
    year: string | undefined;
}

export class SchoolYearDtoPagedResultDto implements ISchoolYearDtoPagedResultDto {
    items!: SchoolYearDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISchoolYearDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SchoolYearDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SchoolYearDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolYearDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SchoolYearDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SchoolYearDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISchoolYearDtoPagedResultDto {
    items: SchoolYearDto[] | undefined;
    totalCount: number;
}

export class ServiceAreaDto implements IServiceAreaDto {
    id!: number;
    service!: ServiceDto;
    area!: AreaDto;

    constructor(data?: IServiceAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
            this.area = _data["area"] ? AreaDto.fromJS(_data["area"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["area"] = this.area ? this.area.toJSON() : <any>undefined;
        return data;
    }

    clone(): ServiceAreaDto {
        const json = this.toJSON();
        let result = new ServiceAreaDto();
        result.init(json);
        return result;
    }
}

export interface IServiceAreaDto {
    id: number;
    service: ServiceDto;
    area: AreaDto;
}

export class ServiceAreaDtoPagedResultDto implements IServiceAreaDtoPagedResultDto {
    items!: ServiceAreaDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceAreaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceAreaDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceAreaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAreaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceAreaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceAreaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceAreaDtoPagedResultDto {
    items: ServiceAreaDto[] | undefined;
    totalCount: number;
}

export class ServiceBeneficiaryDto implements IServiceBeneficiaryDto {
    id!: number;
    beneficiary!: UserDto;
    service!: ServiceDto;

    constructor(data?: IServiceBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.beneficiary = _data["beneficiary"] ? UserDto.fromJS(_data["beneficiary"]) : <any>undefined;
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceBeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceBeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["beneficiary"] = this.beneficiary ? this.beneficiary.toJSON() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        return data;
    }

    clone(): ServiceBeneficiaryDto {
        const json = this.toJSON();
        let result = new ServiceBeneficiaryDto();
        result.init(json);
        return result;
    }
}

export interface IServiceBeneficiaryDto {
    id: number;
    beneficiary: UserDto;
    service: ServiceDto;
}

export class ServiceBeneficiaryDtoPagedResultDto implements IServiceBeneficiaryDtoPagedResultDto {
    items!: ServiceBeneficiaryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceBeneficiaryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceBeneficiaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceBeneficiaryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceBeneficiaryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceBeneficiaryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceBeneficiaryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceBeneficiaryDtoPagedResultDto {
    items: ServiceBeneficiaryDto[] | undefined;
    totalCount: number;
}

export class ServiceCustomerDto implements IServiceCustomerDto {
    id!: number;
    service!: ServiceDto;
    customer!: CustomerDto;

    constructor(data?: IServiceCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        return data;
    }

    clone(): ServiceCustomerDto {
        const json = this.toJSON();
        let result = new ServiceCustomerDto();
        result.init(json);
        return result;
    }
}

export interface IServiceCustomerDto {
    id: number;
    service: ServiceDto;
    customer: CustomerDto;
}

export class ServiceCustomerDtoPagedResultDto implements IServiceCustomerDtoPagedResultDto {
    items!: ServiceCustomerDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceCustomerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceCustomerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceCustomerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCustomerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceCustomerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceCustomerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceCustomerDtoPagedResultDto {
    items: ServiceCustomerDto[] | undefined;
    totalCount: number;
}

export class ServiceDto implements IServiceDto {
    id!: number;
    readonly entityType!: string | undefined;
    contract!: ContractDto;
    dvrFile!: FileDto;
    description!: string;
    userAmount!: number;
    dpi!: string | undefined;
    totalHour!: number | undefined;
    fundAmount!: number | undefined;
    referenceTerritories!: string | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    referenceUser!: string | undefined;
    isClosed!: boolean;
    requiredProfiles!: string | undefined;
    annotation!: string | undefined;
    schoolYear!: SchoolYearDto;

    constructor(data?: IServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).entityType = _data["entityType"];
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            this.dvrFile = _data["dvrFile"] ? FileDto.fromJS(_data["dvrFile"]) : <any>undefined;
            this.description = _data["description"];
            this.userAmount = _data["userAmount"];
            this.dpi = _data["dpi"];
            this.totalHour = _data["totalHour"];
            this.fundAmount = _data["fundAmount"];
            this.referenceTerritories = _data["referenceTerritories"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.referenceUser = _data["referenceUser"];
            this.isClosed = _data["isClosed"];
            this.requiredProfiles = _data["requiredProfiles"];
            this.annotation = _data["annotation"];
            this.schoolYear = _data["schoolYear"] ? SchoolYearDto.fromJS(_data["schoolYear"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["dvrFile"] = this.dvrFile ? this.dvrFile.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["userAmount"] = this.userAmount;
        data["dpi"] = this.dpi;
        data["totalHour"] = this.totalHour;
        data["fundAmount"] = this.fundAmount;
        data["referenceTerritories"] = this.referenceTerritories;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["referenceUser"] = this.referenceUser;
        data["isClosed"] = this.isClosed;
        data["requiredProfiles"] = this.requiredProfiles;
        data["annotation"] = this.annotation;
        data["schoolYear"] = this.schoolYear ? this.schoolYear.toJSON() : <any>undefined;
        return data;
    }

    clone(): ServiceDto {
        const json = this.toJSON();
        let result = new ServiceDto();
        result.init(json);
        return result;
    }
}

export interface IServiceDto {
    id: number;
    entityType: string | undefined;
    contract: ContractDto;
    dvrFile: FileDto;
    description: string;
    userAmount: number;
    dpi: string | undefined;
    totalHour: number | undefined;
    fundAmount: number | undefined;
    referenceTerritories: string | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    referenceUser: string | undefined;
    isClosed: boolean;
    requiredProfiles: string | undefined;
    annotation: string | undefined;
    schoolYear: SchoolYearDto;
}

export class ServiceDtoPagedResultDto implements IServiceDtoPagedResultDto {
    items!: ServiceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceDtoPagedResultDto {
    items: ServiceDto[] | undefined;
    totalCount: number;
}

export class ServiceFileDto implements IServiceFileDto {
    id!: number;
    service!: ServiceDto;
    creationTime!: moment.Moment;

    constructor(data?: IServiceFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): ServiceFileDto {
        const json = this.toJSON();
        let result = new ServiceFileDto();
        result.init(json);
        return result;
    }
}

export interface IServiceFileDto {
    id: number;
    service: ServiceDto;
    creationTime: moment.Moment;
}

export class ServiceGroupDto implements IServiceGroupDto {
    id!: number;
    group!: GroupDto;
    service!: ServiceDto;

    constructor(data?: IServiceGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.group = _data["group"] ? GroupDto.fromJS(_data["group"]) : <any>undefined;
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        return data;
    }

    clone(): ServiceGroupDto {
        const json = this.toJSON();
        let result = new ServiceGroupDto();
        result.init(json);
        return result;
    }
}

export interface IServiceGroupDto {
    id: number;
    group: GroupDto;
    service: ServiceDto;
}

export class ServiceGroupDtoPagedResultDto implements IServiceGroupDtoPagedResultDto {
    items!: ServiceGroupDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceGroupDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceGroupDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceGroupDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceGroupDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceGroupDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceGroupDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceGroupDtoPagedResultDto {
    items: ServiceGroupDto[] | undefined;
    totalCount: number;
}

export class ServiceOperatorBeneficiaryDto implements IServiceOperatorBeneficiaryDto {
    id!: number;
    serviceOperatorScheduled!: ServiceOperatorScheduledDto;
    serviceBeneficiary!: ServiceBeneficiaryDto;

    constructor(data?: IServiceOperatorBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceOperatorScheduled = _data["serviceOperatorScheduled"] ? ServiceOperatorScheduledDto.fromJS(_data["serviceOperatorScheduled"]) : <any>undefined;
            this.serviceBeneficiary = _data["serviceBeneficiary"] ? ServiceBeneficiaryDto.fromJS(_data["serviceBeneficiary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceOperatorBeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOperatorBeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceOperatorScheduled"] = this.serviceOperatorScheduled ? this.serviceOperatorScheduled.toJSON() : <any>undefined;
        data["serviceBeneficiary"] = this.serviceBeneficiary ? this.serviceBeneficiary.toJSON() : <any>undefined;
        return data;
    }

    clone(): ServiceOperatorBeneficiaryDto {
        const json = this.toJSON();
        let result = new ServiceOperatorBeneficiaryDto();
        result.init(json);
        return result;
    }
}

export interface IServiceOperatorBeneficiaryDto {
    id: number;
    serviceOperatorScheduled: ServiceOperatorScheduledDto;
    serviceBeneficiary: ServiceBeneficiaryDto;
}

export class ServiceOperatorDto implements IServiceOperatorDto {
    id!: number;
    operator!: UserDto;
    service!: ServiceDto;
    hourPerUserPredicted!: number | undefined;
    hourPerUserAtClosure!: number | undefined;
    stampEntryId!: number | undefined;
    calculatedWorkedMinutes!: number | undefined;
    isCoordinator!: boolean;
    isNotActive!: boolean;

    constructor(data?: IServiceOperatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operator = _data["operator"] ? UserDto.fromJS(_data["operator"]) : <any>undefined;
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : <any>undefined;
            this.hourPerUserPredicted = _data["hourPerUserPredicted"];
            this.hourPerUserAtClosure = _data["hourPerUserAtClosure"];
            this.stampEntryId = _data["stampEntryId"];
            this.calculatedWorkedMinutes = _data["calculatedWorkedMinutes"];
            this.isCoordinator = _data["isCoordinator"];
            this.isNotActive = _data["isNotActive"];
        }
    }

    static fromJS(data: any): ServiceOperatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOperatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operator"] = this.operator ? this.operator.toJSON() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["hourPerUserPredicted"] = this.hourPerUserPredicted;
        data["hourPerUserAtClosure"] = this.hourPerUserAtClosure;
        data["stampEntryId"] = this.stampEntryId;
        data["calculatedWorkedMinutes"] = this.calculatedWorkedMinutes;
        data["isCoordinator"] = this.isCoordinator;
        data["isNotActive"] = this.isNotActive;
        return data;
    }

    clone(): ServiceOperatorDto {
        const json = this.toJSON();
        let result = new ServiceOperatorDto();
        result.init(json);
        return result;
    }
}

export interface IServiceOperatorDto {
    id: number;
    operator: UserDto;
    service: ServiceDto;
    hourPerUserPredicted: number | undefined;
    hourPerUserAtClosure: number | undefined;
    stampEntryId: number | undefined;
    calculatedWorkedMinutes: number | undefined;
    isCoordinator: boolean;
    isNotActive: boolean;
}

export class ServiceOperatorDtoPagedResultDto implements IServiceOperatorDtoPagedResultDto {
    items!: ServiceOperatorDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceOperatorDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceOperatorDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceOperatorDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOperatorDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceOperatorDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceOperatorDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceOperatorDtoPagedResultDto {
    items: ServiceOperatorDto[] | undefined;
    totalCount: number;
}

export class ServiceOperatorScheduledBeneficiaryDto implements IServiceOperatorScheduledBeneficiaryDto {
    id!: number;
    serviceOperatorScheduled!: ServiceOperatorScheduledDto;
    beneficiary!: BaseUserDto;

    constructor(data?: IServiceOperatorScheduledBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceOperatorScheduled = _data["serviceOperatorScheduled"] ? ServiceOperatorScheduledDto.fromJS(_data["serviceOperatorScheduled"]) : <any>undefined;
            this.beneficiary = _data["beneficiary"] ? BaseUserDto.fromJS(_data["beneficiary"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceOperatorScheduledBeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOperatorScheduledBeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceOperatorScheduled"] = this.serviceOperatorScheduled ? this.serviceOperatorScheduled.toJSON() : <any>undefined;
        data["beneficiary"] = this.beneficiary ? this.beneficiary.toJSON() : <any>undefined;
        return data;
    }

    clone(): ServiceOperatorScheduledBeneficiaryDto {
        const json = this.toJSON();
        let result = new ServiceOperatorScheduledBeneficiaryDto();
        result.init(json);
        return result;
    }
}

export interface IServiceOperatorScheduledBeneficiaryDto {
    id: number;
    serviceOperatorScheduled: ServiceOperatorScheduledDto;
    beneficiary: BaseUserDto;
}

export class ServiceOperatorScheduledDto implements IServiceOperatorScheduledDto {
    id!: number;
    serviceOperator!: ServiceOperatorDto;
    predictedStartDate!: moment.Moment;
    predictedEndDate!: moment.Moment;
    badgedStartDate!: moment.Moment | undefined;
    badgedEndDate!: moment.Moment | undefined;
    workShiftFrequencyType!: WorkShiftFrequencyTypeDto;
    hoursAtPeriod!: number | undefined;
    workedMinutes!: number;
    predictedMinutes!: number | undefined;
    isBadgedByOperator!: boolean;
    annotationForOperator!: string | undefined;
    feePerHour!: number | undefined;

    constructor(data?: IServiceOperatorScheduledDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceOperator = _data["serviceOperator"] ? ServiceOperatorDto.fromJS(_data["serviceOperator"]) : <any>undefined;
            this.predictedStartDate = _data["predictedStartDate"] ? moment(_data["predictedStartDate"].toString()) : <any>undefined;
            this.predictedEndDate = _data["predictedEndDate"] ? moment(_data["predictedEndDate"].toString()) : <any>undefined;
            this.badgedStartDate = _data["badgedStartDate"] ? moment(_data["badgedStartDate"].toString()) : <any>undefined;
            this.badgedEndDate = _data["badgedEndDate"] ? moment(_data["badgedEndDate"].toString()) : <any>undefined;
            this.workShiftFrequencyType = _data["workShiftFrequencyType"] ? WorkShiftFrequencyTypeDto.fromJS(_data["workShiftFrequencyType"]) : <any>undefined;
            this.hoursAtPeriod = _data["hoursAtPeriod"];
            this.workedMinutes = _data["workedMinutes"];
            this.predictedMinutes = _data["predictedMinutes"];
            this.isBadgedByOperator = _data["isBadgedByOperator"];
            this.annotationForOperator = _data["annotationForOperator"];
            this.feePerHour = _data["feePerHour"];
        }
    }

    static fromJS(data: any): ServiceOperatorScheduledDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOperatorScheduledDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceOperator"] = this.serviceOperator ? this.serviceOperator.toJSON() : <any>undefined;
        data["predictedStartDate"] = this.predictedStartDate ? this.predictedStartDate.toISOString() : <any>undefined;
        data["predictedEndDate"] = this.predictedEndDate ? this.predictedEndDate.toISOString() : <any>undefined;
        data["badgedStartDate"] = this.badgedStartDate ? this.badgedStartDate.toISOString() : <any>undefined;
        data["badgedEndDate"] = this.badgedEndDate ? this.badgedEndDate.toISOString() : <any>undefined;
        data["workShiftFrequencyType"] = this.workShiftFrequencyType ? this.workShiftFrequencyType.toJSON() : <any>undefined;
        data["hoursAtPeriod"] = this.hoursAtPeriod;
        data["workedMinutes"] = this.workedMinutes;
        data["predictedMinutes"] = this.predictedMinutes;
        data["isBadgedByOperator"] = this.isBadgedByOperator;
        data["annotationForOperator"] = this.annotationForOperator;
        data["feePerHour"] = this.feePerHour;
        return data;
    }

    clone(): ServiceOperatorScheduledDto {
        const json = this.toJSON();
        let result = new ServiceOperatorScheduledDto();
        result.init(json);
        return result;
    }
}

export interface IServiceOperatorScheduledDto {
    id: number;
    serviceOperator: ServiceOperatorDto;
    predictedStartDate: moment.Moment;
    predictedEndDate: moment.Moment;
    badgedStartDate: moment.Moment | undefined;
    badgedEndDate: moment.Moment | undefined;
    workShiftFrequencyType: WorkShiftFrequencyTypeDto;
    hoursAtPeriod: number | undefined;
    workedMinutes: number;
    predictedMinutes: number | undefined;
    isBadgedByOperator: boolean;
    annotationForOperator: string | undefined;
    feePerHour: number | undefined;
}

export class ServiceOperatorScheduledDtoPagedResultDto implements IServiceOperatorScheduledDtoPagedResultDto {
    items!: ServiceOperatorScheduledDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceOperatorScheduledDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceOperatorScheduledDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceOperatorScheduledDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOperatorScheduledDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceOperatorScheduledDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceOperatorScheduledDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceOperatorScheduledDtoPagedResultDto {
    items: ServiceOperatorScheduledDto[] | undefined;
    totalCount: number;
}

export class ServiceOperatorScheduledIntervalResultDto implements IServiceOperatorScheduledIntervalResultDto {
    predictedStartDate!: moment.Moment;
    predictedEndDate!: moment.Moment | undefined;
    isValid!: boolean;

    constructor(data?: IServiceOperatorScheduledIntervalResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.predictedStartDate = _data["predictedStartDate"] ? moment(_data["predictedStartDate"].toString()) : <any>undefined;
            this.predictedEndDate = _data["predictedEndDate"] ? moment(_data["predictedEndDate"].toString()) : <any>undefined;
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): ServiceOperatorScheduledIntervalResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOperatorScheduledIntervalResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["predictedStartDate"] = this.predictedStartDate ? this.predictedStartDate.toISOString() : <any>undefined;
        data["predictedEndDate"] = this.predictedEndDate ? this.predictedEndDate.toISOString() : <any>undefined;
        data["isValid"] = this.isValid;
        return data;
    }

    clone(): ServiceOperatorScheduledIntervalResultDto {
        const json = this.toJSON();
        let result = new ServiceOperatorScheduledIntervalResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceOperatorScheduledIntervalResultDto {
    predictedStartDate: moment.Moment;
    predictedEndDate: moment.Moment | undefined;
    isValid: boolean;
}

export class ServiceOperatorWorkedMinutesDto implements IServiceOperatorWorkedMinutesDto {
    calculatedWorkedMinutes!: number;
    calculatedPredictedMinutes!: number;

    constructor(data?: IServiceOperatorWorkedMinutesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calculatedWorkedMinutes = _data["calculatedWorkedMinutes"];
            this.calculatedPredictedMinutes = _data["calculatedPredictedMinutes"];
        }
    }

    static fromJS(data: any): ServiceOperatorWorkedMinutesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceOperatorWorkedMinutesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calculatedWorkedMinutes"] = this.calculatedWorkedMinutes;
        data["calculatedPredictedMinutes"] = this.calculatedPredictedMinutes;
        return data;
    }

    clone(): ServiceOperatorWorkedMinutesDto {
        const json = this.toJSON();
        let result = new ServiceOperatorWorkedMinutesDto();
        result.init(json);
        return result;
    }
}

export interface IServiceOperatorWorkedMinutesDto {
    calculatedWorkedMinutes: number;
    calculatedPredictedMinutes: number;
}

export class ServiceReportDto implements IServiceReportDto {
    id!: number;
    serviceId!: number;
    year!: number;
    quarter!: string | undefined;
    creationTime!: moment.Moment;
    equipesAmount!: number | undefined;
    supervisionsAmount!: number | undefined;
    meetingWithInstitutions!: number | undefined;
    formationCourses!: number | undefined;
    prePostDegreeInternships!: number | undefined;
    publications!: PublicationDto[] | undefined;
    conferences!: ConferenceDto[] | undefined;
    userReportPartials!: UserReportPartialDto[] | undefined;
    contactReportPartialsUDS!: ContactReportPartialUDSDto[] | undefined;
    contactReportPartialsWithClasses!: ContactReportPartialWithClassesDto[] | undefined;
    totalCaredUsers!: number;
    totalCaredItalianUsers!: number;
    totalCaredForeignUsers!: number;
    foreignNationalities!: string | undefined;
    totalContactsUDS!: number;
    informativeMaterialsDistribuited!: number | undefined;
    informationContact!: number | undefined;
    psychoeducationalCounselingCourses!: number | undefined;
    counselingPreventionRDD!: number | undefined;
    activityOfSocialSecretary!: number | undefined;
    psychotherapyCourses!: number | undefined;
    psychotherapyGroups!: number | undefined;
    psycologicalCounselingSending!: number | undefined;
    medicalAdviceCounseling!: number | undefined;
    medications!: number | undefined;
    legalCounseling!: number | undefined;
    regularizationCourses!: number | undefined;
    regularUsers!: number | undefined;
    italianSchoolPlacemetsForForeigners!: number | undefined;
    schoolPlacementsMiddleSchoolDiploma!: number | undefined;
    usersWithMiddleSchoolDiploma!: number | undefined;
    highSchoolPlacements!: number | undefined;
    usersWithHighSchoolDiploma!: number | undefined;
    professionalTrainingCoursePlacements!: number | undefined;
    usersCourseFinished!: number | undefined;
    studySupportCourses!: number | undefined;
    workOrientationCourses!: number | undefined;
    workInternshipsActivated!: number | undefined;
    workPlacements!: number | undefined;
    housingAutonomyCourses!: number | undefined;
    usersWithHousingAutonomy!: number | undefined;
    internalRapidHIVTestsAmount!: number | undefined;
    internalRapidHCVTestsAmount!: number | undefined;
    psychoeducationalLabs!: PsychoeducationalLabDto[] | undefined;
    informationAwarenessCourses!: InformationAwarenessCourseDto[] | undefined;
    testedSubstancesAmount!: number | undefined;
    psychotherapyCoursesOutService!: number | undefined;
    psychotherapyGroupsSendings!: number | undefined;
    medicalCounselingSendings!: number | undefined;
    legalCounselingSendings!: number | undefined;
    studySuportCoursesSendings!: number | undefined;
    workOrientationCoursesSendings!: number | undefined;
    externalRapidHIVAndHCVTestsAmount!: number | undefined;
    otherSendings!: OtherSendingsDto[] | undefined;
    totalHygienAndSanitaryKits!: number | undefined;
    washingMachinesDone!: number | undefined;
    showersCarried!: number | undefined;
    totalInjectiveKits!: number | undefined;
    totalPulmonaryKits!: number | undefined;
    narcan!: number | undefined;
    condomsDistribuited!: number | undefined;
    informativeMaterial!: number | undefined;
    refreshmentMaterial!: number | undefined;
    meals!: number | undefined;
    gadgets!: GadgetDto[] | undefined;
    socialPosts!: number | undefined;
    socialPostsVisualizations!: number | undefined;
    legalArea!: string | undefined;
    sanitaryArea!: string | undefined;
    welfarePartnerArea!: string | undefined;
    volunteeringParishesArea!: string | undefined;
    publicServices!: string | undefined;
    other!: string | undefined;

    constructor(data?: IServiceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.year = _data["year"];
            this.quarter = _data["quarter"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.equipesAmount = _data["equipesAmount"];
            this.supervisionsAmount = _data["supervisionsAmount"];
            this.meetingWithInstitutions = _data["meetingWithInstitutions"];
            this.formationCourses = _data["formationCourses"];
            this.prePostDegreeInternships = _data["prePostDegreeInternships"];
            if (Array.isArray(_data["publications"])) {
                this.publications = [] as any;
                for (let item of _data["publications"])
                    this.publications!.push(PublicationDto.fromJS(item));
            }
            if (Array.isArray(_data["conferences"])) {
                this.conferences = [] as any;
                for (let item of _data["conferences"])
                    this.conferences!.push(ConferenceDto.fromJS(item));
            }
            if (Array.isArray(_data["userReportPartials"])) {
                this.userReportPartials = [] as any;
                for (let item of _data["userReportPartials"])
                    this.userReportPartials!.push(UserReportPartialDto.fromJS(item));
            }
            if (Array.isArray(_data["contactReportPartialsUDS"])) {
                this.contactReportPartialsUDS = [] as any;
                for (let item of _data["contactReportPartialsUDS"])
                    this.contactReportPartialsUDS!.push(ContactReportPartialUDSDto.fromJS(item));
            }
            if (Array.isArray(_data["contactReportPartialsWithClasses"])) {
                this.contactReportPartialsWithClasses = [] as any;
                for (let item of _data["contactReportPartialsWithClasses"])
                    this.contactReportPartialsWithClasses!.push(ContactReportPartialWithClassesDto.fromJS(item));
            }
            this.totalCaredUsers = _data["totalCaredUsers"];
            this.totalCaredItalianUsers = _data["totalCaredItalianUsers"];
            this.totalCaredForeignUsers = _data["totalCaredForeignUsers"];
            this.foreignNationalities = _data["foreignNationalities"];
            this.totalContactsUDS = _data["totalContactsUDS"];
            this.informativeMaterialsDistribuited = _data["informativeMaterialsDistribuited"];
            this.informationContact = _data["informationContact"];
            this.psychoeducationalCounselingCourses = _data["psychoeducationalCounselingCourses"];
            this.counselingPreventionRDD = _data["counselingPreventionRDD"];
            this.activityOfSocialSecretary = _data["activityOfSocialSecretary"];
            this.psychotherapyCourses = _data["psychotherapyCourses"];
            this.psychotherapyGroups = _data["psychotherapyGroups"];
            this.psycologicalCounselingSending = _data["psycologicalCounselingSending"];
            this.medicalAdviceCounseling = _data["medicalAdviceCounseling"];
            this.medications = _data["medications"];
            this.legalCounseling = _data["legalCounseling"];
            this.regularizationCourses = _data["regularizationCourses"];
            this.regularUsers = _data["regularUsers"];
            this.italianSchoolPlacemetsForForeigners = _data["italianSchoolPlacemetsForForeigners"];
            this.schoolPlacementsMiddleSchoolDiploma = _data["schoolPlacementsMiddleSchoolDiploma"];
            this.usersWithMiddleSchoolDiploma = _data["usersWithMiddleSchoolDiploma"];
            this.highSchoolPlacements = _data["highSchoolPlacements"];
            this.usersWithHighSchoolDiploma = _data["usersWithHighSchoolDiploma"];
            this.professionalTrainingCoursePlacements = _data["professionalTrainingCoursePlacements"];
            this.usersCourseFinished = _data["usersCourseFinished"];
            this.studySupportCourses = _data["studySupportCourses"];
            this.workOrientationCourses = _data["workOrientationCourses"];
            this.workInternshipsActivated = _data["workInternshipsActivated"];
            this.workPlacements = _data["workPlacements"];
            this.housingAutonomyCourses = _data["housingAutonomyCourses"];
            this.usersWithHousingAutonomy = _data["usersWithHousingAutonomy"];
            this.internalRapidHIVTestsAmount = _data["internalRapidHIVTestsAmount"];
            this.internalRapidHCVTestsAmount = _data["internalRapidHCVTestsAmount"];
            if (Array.isArray(_data["psychoeducationalLabs"])) {
                this.psychoeducationalLabs = [] as any;
                for (let item of _data["psychoeducationalLabs"])
                    this.psychoeducationalLabs!.push(PsychoeducationalLabDto.fromJS(item));
            }
            if (Array.isArray(_data["informationAwarenessCourses"])) {
                this.informationAwarenessCourses = [] as any;
                for (let item of _data["informationAwarenessCourses"])
                    this.informationAwarenessCourses!.push(InformationAwarenessCourseDto.fromJS(item));
            }
            this.testedSubstancesAmount = _data["testedSubstancesAmount"];
            this.psychotherapyCoursesOutService = _data["psychotherapyCoursesOutService"];
            this.psychotherapyGroupsSendings = _data["psychotherapyGroupsSendings"];
            this.medicalCounselingSendings = _data["medicalCounselingSendings"];
            this.legalCounselingSendings = _data["legalCounselingSendings"];
            this.studySuportCoursesSendings = _data["studySuportCoursesSendings"];
            this.workOrientationCoursesSendings = _data["workOrientationCoursesSendings"];
            this.externalRapidHIVAndHCVTestsAmount = _data["externalRapidHIVAndHCVTestsAmount"];
            if (Array.isArray(_data["otherSendings"])) {
                this.otherSendings = [] as any;
                for (let item of _data["otherSendings"])
                    this.otherSendings!.push(OtherSendingsDto.fromJS(item));
            }
            this.totalHygienAndSanitaryKits = _data["totalHygienAndSanitaryKits"];
            this.washingMachinesDone = _data["washingMachinesDone"];
            this.showersCarried = _data["showersCarried"];
            this.totalInjectiveKits = _data["totalInjectiveKits"];
            this.totalPulmonaryKits = _data["totalPulmonaryKits"];
            this.narcan = _data["narcan"];
            this.condomsDistribuited = _data["condomsDistribuited"];
            this.informativeMaterial = _data["informativeMaterial"];
            this.refreshmentMaterial = _data["refreshmentMaterial"];
            this.meals = _data["meals"];
            if (Array.isArray(_data["gadgets"])) {
                this.gadgets = [] as any;
                for (let item of _data["gadgets"])
                    this.gadgets!.push(GadgetDto.fromJS(item));
            }
            this.socialPosts = _data["socialPosts"];
            this.socialPostsVisualizations = _data["socialPostsVisualizations"];
            this.legalArea = _data["legalArea"];
            this.sanitaryArea = _data["sanitaryArea"];
            this.welfarePartnerArea = _data["welfarePartnerArea"];
            this.volunteeringParishesArea = _data["volunteeringParishesArea"];
            this.publicServices = _data["publicServices"];
            this.other = _data["other"];
        }
    }

    static fromJS(data: any): ServiceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["year"] = this.year;
        data["quarter"] = this.quarter;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["equipesAmount"] = this.equipesAmount;
        data["supervisionsAmount"] = this.supervisionsAmount;
        data["meetingWithInstitutions"] = this.meetingWithInstitutions;
        data["formationCourses"] = this.formationCourses;
        data["prePostDegreeInternships"] = this.prePostDegreeInternships;
        if (Array.isArray(this.publications)) {
            data["publications"] = [];
            for (let item of this.publications)
                data["publications"].push(item.toJSON());
        }
        if (Array.isArray(this.conferences)) {
            data["conferences"] = [];
            for (let item of this.conferences)
                data["conferences"].push(item.toJSON());
        }
        if (Array.isArray(this.userReportPartials)) {
            data["userReportPartials"] = [];
            for (let item of this.userReportPartials)
                data["userReportPartials"].push(item.toJSON());
        }
        if (Array.isArray(this.contactReportPartialsUDS)) {
            data["contactReportPartialsUDS"] = [];
            for (let item of this.contactReportPartialsUDS)
                data["contactReportPartialsUDS"].push(item.toJSON());
        }
        if (Array.isArray(this.contactReportPartialsWithClasses)) {
            data["contactReportPartialsWithClasses"] = [];
            for (let item of this.contactReportPartialsWithClasses)
                data["contactReportPartialsWithClasses"].push(item.toJSON());
        }
        data["totalCaredUsers"] = this.totalCaredUsers;
        data["totalCaredItalianUsers"] = this.totalCaredItalianUsers;
        data["totalCaredForeignUsers"] = this.totalCaredForeignUsers;
        data["foreignNationalities"] = this.foreignNationalities;
        data["totalContactsUDS"] = this.totalContactsUDS;
        data["informativeMaterialsDistribuited"] = this.informativeMaterialsDistribuited;
        data["informationContact"] = this.informationContact;
        data["psychoeducationalCounselingCourses"] = this.psychoeducationalCounselingCourses;
        data["counselingPreventionRDD"] = this.counselingPreventionRDD;
        data["activityOfSocialSecretary"] = this.activityOfSocialSecretary;
        data["psychotherapyCourses"] = this.psychotherapyCourses;
        data["psychotherapyGroups"] = this.psychotherapyGroups;
        data["psycologicalCounselingSending"] = this.psycologicalCounselingSending;
        data["medicalAdviceCounseling"] = this.medicalAdviceCounseling;
        data["medications"] = this.medications;
        data["legalCounseling"] = this.legalCounseling;
        data["regularizationCourses"] = this.regularizationCourses;
        data["regularUsers"] = this.regularUsers;
        data["italianSchoolPlacemetsForForeigners"] = this.italianSchoolPlacemetsForForeigners;
        data["schoolPlacementsMiddleSchoolDiploma"] = this.schoolPlacementsMiddleSchoolDiploma;
        data["usersWithMiddleSchoolDiploma"] = this.usersWithMiddleSchoolDiploma;
        data["highSchoolPlacements"] = this.highSchoolPlacements;
        data["usersWithHighSchoolDiploma"] = this.usersWithHighSchoolDiploma;
        data["professionalTrainingCoursePlacements"] = this.professionalTrainingCoursePlacements;
        data["usersCourseFinished"] = this.usersCourseFinished;
        data["studySupportCourses"] = this.studySupportCourses;
        data["workOrientationCourses"] = this.workOrientationCourses;
        data["workInternshipsActivated"] = this.workInternshipsActivated;
        data["workPlacements"] = this.workPlacements;
        data["housingAutonomyCourses"] = this.housingAutonomyCourses;
        data["usersWithHousingAutonomy"] = this.usersWithHousingAutonomy;
        data["internalRapidHIVTestsAmount"] = this.internalRapidHIVTestsAmount;
        data["internalRapidHCVTestsAmount"] = this.internalRapidHCVTestsAmount;
        if (Array.isArray(this.psychoeducationalLabs)) {
            data["psychoeducationalLabs"] = [];
            for (let item of this.psychoeducationalLabs)
                data["psychoeducationalLabs"].push(item.toJSON());
        }
        if (Array.isArray(this.informationAwarenessCourses)) {
            data["informationAwarenessCourses"] = [];
            for (let item of this.informationAwarenessCourses)
                data["informationAwarenessCourses"].push(item.toJSON());
        }
        data["testedSubstancesAmount"] = this.testedSubstancesAmount;
        data["psychotherapyCoursesOutService"] = this.psychotherapyCoursesOutService;
        data["psychotherapyGroupsSendings"] = this.psychotherapyGroupsSendings;
        data["medicalCounselingSendings"] = this.medicalCounselingSendings;
        data["legalCounselingSendings"] = this.legalCounselingSendings;
        data["studySuportCoursesSendings"] = this.studySuportCoursesSendings;
        data["workOrientationCoursesSendings"] = this.workOrientationCoursesSendings;
        data["externalRapidHIVAndHCVTestsAmount"] = this.externalRapidHIVAndHCVTestsAmount;
        if (Array.isArray(this.otherSendings)) {
            data["otherSendings"] = [];
            for (let item of this.otherSendings)
                data["otherSendings"].push(item.toJSON());
        }
        data["totalHygienAndSanitaryKits"] = this.totalHygienAndSanitaryKits;
        data["washingMachinesDone"] = this.washingMachinesDone;
        data["showersCarried"] = this.showersCarried;
        data["totalInjectiveKits"] = this.totalInjectiveKits;
        data["totalPulmonaryKits"] = this.totalPulmonaryKits;
        data["narcan"] = this.narcan;
        data["condomsDistribuited"] = this.condomsDistribuited;
        data["informativeMaterial"] = this.informativeMaterial;
        data["refreshmentMaterial"] = this.refreshmentMaterial;
        data["meals"] = this.meals;
        if (Array.isArray(this.gadgets)) {
            data["gadgets"] = [];
            for (let item of this.gadgets)
                data["gadgets"].push(item.toJSON());
        }
        data["socialPosts"] = this.socialPosts;
        data["socialPostsVisualizations"] = this.socialPostsVisualizations;
        data["legalArea"] = this.legalArea;
        data["sanitaryArea"] = this.sanitaryArea;
        data["welfarePartnerArea"] = this.welfarePartnerArea;
        data["volunteeringParishesArea"] = this.volunteeringParishesArea;
        data["publicServices"] = this.publicServices;
        data["other"] = this.other;
        return data;
    }

    clone(): ServiceReportDto {
        const json = this.toJSON();
        let result = new ServiceReportDto();
        result.init(json);
        return result;
    }
}

export interface IServiceReportDto {
    id: number;
    serviceId: number;
    year: number;
    quarter: string | undefined;
    creationTime: moment.Moment;
    equipesAmount: number | undefined;
    supervisionsAmount: number | undefined;
    meetingWithInstitutions: number | undefined;
    formationCourses: number | undefined;
    prePostDegreeInternships: number | undefined;
    publications: PublicationDto[] | undefined;
    conferences: ConferenceDto[] | undefined;
    userReportPartials: UserReportPartialDto[] | undefined;
    contactReportPartialsUDS: ContactReportPartialUDSDto[] | undefined;
    contactReportPartialsWithClasses: ContactReportPartialWithClassesDto[] | undefined;
    totalCaredUsers: number;
    totalCaredItalianUsers: number;
    totalCaredForeignUsers: number;
    foreignNationalities: string | undefined;
    totalContactsUDS: number;
    informativeMaterialsDistribuited: number | undefined;
    informationContact: number | undefined;
    psychoeducationalCounselingCourses: number | undefined;
    counselingPreventionRDD: number | undefined;
    activityOfSocialSecretary: number | undefined;
    psychotherapyCourses: number | undefined;
    psychotherapyGroups: number | undefined;
    psycologicalCounselingSending: number | undefined;
    medicalAdviceCounseling: number | undefined;
    medications: number | undefined;
    legalCounseling: number | undefined;
    regularizationCourses: number | undefined;
    regularUsers: number | undefined;
    italianSchoolPlacemetsForForeigners: number | undefined;
    schoolPlacementsMiddleSchoolDiploma: number | undefined;
    usersWithMiddleSchoolDiploma: number | undefined;
    highSchoolPlacements: number | undefined;
    usersWithHighSchoolDiploma: number | undefined;
    professionalTrainingCoursePlacements: number | undefined;
    usersCourseFinished: number | undefined;
    studySupportCourses: number | undefined;
    workOrientationCourses: number | undefined;
    workInternshipsActivated: number | undefined;
    workPlacements: number | undefined;
    housingAutonomyCourses: number | undefined;
    usersWithHousingAutonomy: number | undefined;
    internalRapidHIVTestsAmount: number | undefined;
    internalRapidHCVTestsAmount: number | undefined;
    psychoeducationalLabs: PsychoeducationalLabDto[] | undefined;
    informationAwarenessCourses: InformationAwarenessCourseDto[] | undefined;
    testedSubstancesAmount: number | undefined;
    psychotherapyCoursesOutService: number | undefined;
    psychotherapyGroupsSendings: number | undefined;
    medicalCounselingSendings: number | undefined;
    legalCounselingSendings: number | undefined;
    studySuportCoursesSendings: number | undefined;
    workOrientationCoursesSendings: number | undefined;
    externalRapidHIVAndHCVTestsAmount: number | undefined;
    otherSendings: OtherSendingsDto[] | undefined;
    totalHygienAndSanitaryKits: number | undefined;
    washingMachinesDone: number | undefined;
    showersCarried: number | undefined;
    totalInjectiveKits: number | undefined;
    totalPulmonaryKits: number | undefined;
    narcan: number | undefined;
    condomsDistribuited: number | undefined;
    informativeMaterial: number | undefined;
    refreshmentMaterial: number | undefined;
    meals: number | undefined;
    gadgets: GadgetDto[] | undefined;
    socialPosts: number | undefined;
    socialPostsVisualizations: number | undefined;
    legalArea: string | undefined;
    sanitaryArea: string | undefined;
    welfarePartnerArea: string | undefined;
    volunteeringParishesArea: string | undefined;
    publicServices: string | undefined;
    other: string | undefined;
}

export class ServiceReportDtoPagedResultDto implements IServiceReportDtoPagedResultDto {
    items!: ServiceReportDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceReportDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceReportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceReportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceReportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceReportDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceReportDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceReportDtoPagedResultDto {
    items: ServiceReportDto[] | undefined;
    totalCount: number;
}

export class SuggestionDto implements ISuggestionDto {
    id!: number;
    name!: string | undefined;
    type!: string | undefined;
    creationTime!: moment.Moment;

    constructor(data?: ISuggestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SuggestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): SuggestionDto {
        const json = this.toJSON();
        let result = new SuggestionDto();
        result.init(json);
        return result;
    }
}

export interface ISuggestionDto {
    id: number;
    name: string | undefined;
    type: string | undefined;
    creationTime: moment.Moment;
}

export class SuggestionEntitiesDto implements ISuggestionEntitiesDto {
    readonly list!: SuggestionDto[] | undefined;

    constructor(data?: ISuggestionEntitiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["list"])) {
                (<any>this).list = [] as any;
                for (let item of _data["list"])
                    (<any>this).list!.push(SuggestionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SuggestionEntitiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SuggestionEntitiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        return data;
    }

    clone(): SuggestionEntitiesDto {
        const json = this.toJSON();
        let result = new SuggestionEntitiesDto();
        result.init(json);
        return result;
    }
}

export interface ISuggestionEntitiesDto {
    list: SuggestionDto[] | undefined;
}

export class SummaryDto implements ISummaryDto {
    outputsPercentage!: number;
    amountPercentage!: number;
    durationPercentage!: number;

    constructor(data?: ISummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outputsPercentage = _data["outputsPercentage"];
            this.amountPercentage = _data["amountPercentage"];
            this.durationPercentage = _data["durationPercentage"];
        }
    }

    static fromJS(data: any): SummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outputsPercentage"] = this.outputsPercentage;
        data["amountPercentage"] = this.amountPercentage;
        data["durationPercentage"] = this.durationPercentage;
        return data;
    }

    clone(): SummaryDto {
        const json = this.toJSON();
        let result = new SummaryDto();
        result.init(json);
        return result;
    }
}

export interface ISummaryDto {
    outputsPercentage: number;
    amountPercentage: number;
    durationPercentage: number;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id!: number;
    tenancyName!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items!: TenantDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TerritorialAnimationEventDto implements ITerritorialAnimationEventDto {
    id!: number;
    title!: string | undefined;
    number!: number;

    constructor(data?: ITerritorialAnimationEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): TerritorialAnimationEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new TerritorialAnimationEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["number"] = this.number;
        return data;
    }

    clone(): TerritorialAnimationEventDto {
        const json = this.toJSON();
        let result = new TerritorialAnimationEventDto();
        result.init(json);
        return result;
    }
}

export interface ITerritorialAnimationEventDto {
    id: number;
    title: string | undefined;
    number: number;
}

export class TimeIntervalDto implements ITimeIntervalDto {
    id!: number;
    startDate!: moment.Moment;
    endDate!: moment.Moment | undefined;

    constructor(data?: ITimeIntervalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeIntervalDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeIntervalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): TimeIntervalDto {
        const json = this.toJSON();
        let result = new TimeIntervalDto();
        result.init(json);
        return result;
    }
}

export interface ITimeIntervalDto {
    id: number;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
}

export class TimeIntervalDtoPagedResultDto implements ITimeIntervalDtoPagedResultDto {
    items!: TimeIntervalDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITimeIntervalDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TimeIntervalDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TimeIntervalDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeIntervalDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TimeIntervalDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TimeIntervalDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITimeIntervalDtoPagedResultDto {
    items: TimeIntervalDto[] | undefined;
    totalCount: number;
}

export class TopicDto implements ITopicDto {
    id!: number;
    subject!: string | undefined;
    creatorUser!: BaseUserDto;
    userRecipientIds!: number[] | undefined;

    constructor(data?: ITopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.creatorUser = _data["creatorUser"] ? BaseUserDto.fromJS(_data["creatorUser"]) : <any>undefined;
            if (Array.isArray(_data["userRecipientIds"])) {
                this.userRecipientIds = [] as any;
                for (let item of _data["userRecipientIds"])
                    this.userRecipientIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        if (Array.isArray(this.userRecipientIds)) {
            data["userRecipientIds"] = [];
            for (let item of this.userRecipientIds)
                data["userRecipientIds"].push(item);
        }
        return data;
    }

    clone(): TopicDto {
        const json = this.toJSON();
        let result = new TopicDto();
        result.init(json);
        return result;
    }
}

export interface ITopicDto {
    id: number;
    subject: string | undefined;
    creatorUser: BaseUserDto;
    userRecipientIds: number[] | undefined;
}

export class TopicDtoPagedResultDto implements ITopicDtoPagedResultDto {
    items!: TopicDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITopicDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TopicDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TopicDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TopicDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TopicDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TopicDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITopicDtoPagedResultDto {
    items: TopicDto[] | undefined;
    totalCount: number;
}

export class UpdateActivityCategoryDto implements IUpdateActivityCategoryDto {
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    color!: string | undefined;
    activityMacroCategory!: Int64EntityDto;

    constructor(data?: IUpdateActivityCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.activityMacroCategory = _data["activityMacroCategory"] ? Int64EntityDto.fromJS(_data["activityMacroCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateActivityCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["color"] = this.color;
        data["activityMacroCategory"] = this.activityMacroCategory ? this.activityMacroCategory.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateActivityCategoryDto {
        const json = this.toJSON();
        let result = new UpdateActivityCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateActivityCategoryDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    color: string | undefined;
    activityMacroCategory: Int64EntityDto;
}

export class UpdateActivityDto implements IUpdateActivityDto {
    id!: number;
    title!: string | undefined;
    description!: string | undefined;
    totalCost!: number;
    headquarter!: string | undefined;
    localizations!: string | undefined;
    partners!: ActivityCustomerDto[] | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    outputs!: ActivityOutputDto[] | undefined;

    constructor(data?: IUpdateActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.totalCost = _data["totalCost"];
            this.headquarter = _data["headquarter"];
            this.localizations = _data["localizations"];
            if (Array.isArray(_data["partners"])) {
                this.partners = [] as any;
                for (let item of _data["partners"])
                    this.partners!.push(ActivityCustomerDto.fromJS(item));
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["outputs"])) {
                this.outputs = [] as any;
                for (let item of _data["outputs"])
                    this.outputs!.push(ActivityOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["totalCost"] = this.totalCost;
        data["headquarter"] = this.headquarter;
        data["localizations"] = this.localizations;
        if (Array.isArray(this.partners)) {
            data["partners"] = [];
            for (let item of this.partners)
                data["partners"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.outputs)) {
            data["outputs"] = [];
            for (let item of this.outputs)
                data["outputs"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateActivityDto {
        const json = this.toJSON();
        let result = new UpdateActivityDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateActivityDto {
    id: number;
    title: string | undefined;
    description: string | undefined;
    totalCost: number;
    headquarter: string | undefined;
    localizations: string | undefined;
    partners: ActivityCustomerDto[] | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    outputs: ActivityOutputDto[] | undefined;
}

export class UpdateActivityMacroCategoryDto implements IUpdateActivityMacroCategoryDto {
    id!: number;
    title!: string | undefined;

    constructor(data?: IUpdateActivityMacroCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): UpdateActivityMacroCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityMacroCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }

    clone(): UpdateActivityMacroCategoryDto {
        const json = this.toJSON();
        let result = new UpdateActivityMacroCategoryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateActivityMacroCategoryDto {
    id: number;
    title: string | undefined;
}

export class UpdateAddressDto implements IUpdateAddressDto {
    name!: string | undefined;
    description!: string | undefined;
    postalCode!: string | undefined;
    municipality!: MunicipalityDto;

    constructor(data?: IUpdateAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.postalCode = _data["postalCode"];
            this.municipality = _data["municipality"] ? MunicipalityDto.fromJS(_data["municipality"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["postalCode"] = this.postalCode;
        data["municipality"] = this.municipality ? this.municipality.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateAddressDto {
        const json = this.toJSON();
        let result = new UpdateAddressDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAddressDto {
    name: string | undefined;
    description: string | undefined;
    postalCode: string | undefined;
    municipality: MunicipalityDto;
}

export class UpdateAttendanceDto implements IUpdateAttendanceDto {
    id!: number;
    date!: moment.Moment;
    entryDate!: moment.Moment;
    exitDate!: moment.Moment | undefined;
    isMissing!: boolean;
    isJustified!: boolean;
    motivation!: Int64EntityDto;

    constructor(data?: IUpdateAttendanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.entryDate = _data["entryDate"] ? moment(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? moment(_data["exitDate"].toString()) : <any>undefined;
            this.isMissing = _data["isMissing"];
            this.isJustified = _data["isJustified"];
            this.motivation = _data["motivation"] ? Int64EntityDto.fromJS(_data["motivation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateAttendanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAttendanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toISOString() : <any>undefined;
        data["isMissing"] = this.isMissing;
        data["isJustified"] = this.isJustified;
        data["motivation"] = this.motivation ? this.motivation.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateAttendanceDto {
        const json = this.toJSON();
        let result = new UpdateAttendanceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAttendanceDto {
    id: number;
    date: moment.Moment;
    entryDate: moment.Moment;
    exitDate: moment.Moment | undefined;
    isMissing: boolean;
    isJustified: boolean;
    motivation: Int64EntityDto;
}

export class UpdateClockingDto implements IUpdateClockingDto {
    id!: number;
    date!: moment.Moment | undefined;
    timeIntervals!: CreateTimeIntervalDto[] | undefined;

    constructor(data?: IUpdateClockingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["timeIntervals"])) {
                this.timeIntervals = [] as any;
                for (let item of _data["timeIntervals"])
                    this.timeIntervals!.push(CreateTimeIntervalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateClockingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateClockingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.timeIntervals)) {
            data["timeIntervals"] = [];
            for (let item of this.timeIntervals)
                data["timeIntervals"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateClockingDto {
        const json = this.toJSON();
        let result = new UpdateClockingDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateClockingDto {
    id: number;
    date: moment.Moment | undefined;
    timeIntervals: CreateTimeIntervalDto[] | undefined;
}

export class UpdateCommitmentDto implements IUpdateCommitmentDto {
    id!: number;
    subject!: Int64EntityDto;
    category!: Int64EntityDto;
    costItem!: string;
    description!: string | undefined;
    menHours!: number | undefined;
    unitNumber!: number;
    unitCost!: number;
    coFinancingPercentage!: number;
    coFinancing!: number;
    unitOfMeasure!: string | undefined;
    requiredAmount!: number;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    outputs!: CommitmentOutputDto[] | undefined;
    staff!: Int64EntityDto;
    idCode!: string | undefined;
    registerType!: string | undefined;

    constructor(data?: IUpdateCommitmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subject = new Int64EntityDto();
            this.category = new Int64EntityDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"] ? Int64EntityDto.fromJS(_data["subject"]) : new Int64EntityDto();
            this.category = _data["category"] ? Int64EntityDto.fromJS(_data["category"]) : new Int64EntityDto();
            this.costItem = _data["costItem"];
            this.description = _data["description"];
            this.menHours = _data["menHours"];
            this.unitNumber = _data["unitNumber"];
            this.unitCost = _data["unitCost"];
            this.coFinancingPercentage = _data["coFinancingPercentage"];
            this.coFinancing = _data["coFinancing"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.requiredAmount = _data["requiredAmount"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["outputs"])) {
                this.outputs = [] as any;
                for (let item of _data["outputs"])
                    this.outputs!.push(CommitmentOutputDto.fromJS(item));
            }
            this.staff = _data["staff"] ? Int64EntityDto.fromJS(_data["staff"]) : <any>undefined;
            this.idCode = _data["idCode"];
            this.registerType = _data["registerType"];
        }
    }

    static fromJS(data: any): UpdateCommitmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCommitmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject ? this.subject.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        data["costItem"] = this.costItem;
        data["description"] = this.description;
        data["menHours"] = this.menHours;
        data["unitNumber"] = this.unitNumber;
        data["unitCost"] = this.unitCost;
        data["coFinancingPercentage"] = this.coFinancingPercentage;
        data["coFinancing"] = this.coFinancing;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["requiredAmount"] = this.requiredAmount;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.outputs)) {
            data["outputs"] = [];
            for (let item of this.outputs)
                data["outputs"].push(item.toJSON());
        }
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        data["idCode"] = this.idCode;
        data["registerType"] = this.registerType;
        return data;
    }

    clone(): UpdateCommitmentDto {
        const json = this.toJSON();
        let result = new UpdateCommitmentDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCommitmentDto {
    id: number;
    subject: Int64EntityDto;
    category: Int64EntityDto;
    costItem: string;
    description: string | undefined;
    menHours: number | undefined;
    unitNumber: number;
    unitCost: number;
    coFinancingPercentage: number;
    coFinancing: number;
    unitOfMeasure: string | undefined;
    requiredAmount: number;
    startDate: moment.Moment;
    endDate: moment.Moment;
    outputs: CommitmentOutputDto[] | undefined;
    staff: Int64EntityDto;
    idCode: string | undefined;
    registerType: string | undefined;
}

export class UpdateDuePaycheckDto implements IUpdateDuePaycheckDto {
    id!: number;
    paidDate!: moment.Moment | undefined;

    constructor(data?: IUpdateDuePaycheckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.paidDate = _data["paidDate"] ? moment(_data["paidDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateDuePaycheckDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDuePaycheckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["paidDate"] = this.paidDate ? this.paidDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UpdateDuePaycheckDto {
        const json = this.toJSON();
        let result = new UpdateDuePaycheckDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDuePaycheckDto {
    id: number;
    paidDate: moment.Moment | undefined;
}

export class UpdateFileDto implements IUpdateFileDto {
    id!: number;
    name!: string | undefined;
    expirationDate!: moment.Moment | undefined;
    fileType!: FileTypeDto;

    constructor(data?: IUpdateFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
            this.fileType = _data["fileType"] ? FileTypeDto.fromJS(_data["fileType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["fileType"] = this.fileType ? this.fileType.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateFileDto {
        const json = this.toJSON();
        let result = new UpdateFileDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFileDto {
    id: number;
    name: string | undefined;
    expirationDate: moment.Moment | undefined;
    fileType: FileTypeDto;
}

export class UpdateHRRequestDto implements IUpdateHRRequestDto {
    id!: number;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    totalDays!: number | undefined;
    totalHours!: number | undefined;
    illnessCertNumber!: string | undefined;
    userAnnotation!: string | undefined;
    projectReference!: string | undefined;
    deliveryPlace!: string | undefined;
    deliveryTime!: string | undefined;
    projectCode!: string | undefined;
    purchaseReason!: string | undefined;
    purchaseTypeId!: number;
    supplier!: string | undefined;
    paymentTypeId!: number;
    currencyTypeId!: number;

    constructor(data?: IUpdateHRRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.totalDays = _data["totalDays"];
            this.totalHours = _data["totalHours"];
            this.illnessCertNumber = _data["illnessCertNumber"];
            this.userAnnotation = _data["userAnnotation"];
            this.projectReference = _data["projectReference"];
            this.deliveryPlace = _data["deliveryPlace"];
            this.deliveryTime = _data["deliveryTime"];
            this.projectCode = _data["projectCode"];
            this.purchaseReason = _data["purchaseReason"];
            this.purchaseTypeId = _data["purchaseTypeId"];
            this.supplier = _data["supplier"];
            this.paymentTypeId = _data["paymentTypeId"];
            this.currencyTypeId = _data["currencyTypeId"];
        }
    }

    static fromJS(data: any): UpdateHRRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHRRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["totalDays"] = this.totalDays;
        data["totalHours"] = this.totalHours;
        data["illnessCertNumber"] = this.illnessCertNumber;
        data["userAnnotation"] = this.userAnnotation;
        data["projectReference"] = this.projectReference;
        data["deliveryPlace"] = this.deliveryPlace;
        data["deliveryTime"] = this.deliveryTime;
        data["projectCode"] = this.projectCode;
        data["purchaseReason"] = this.purchaseReason;
        data["purchaseTypeId"] = this.purchaseTypeId;
        data["supplier"] = this.supplier;
        data["paymentTypeId"] = this.paymentTypeId;
        data["currencyTypeId"] = this.currencyTypeId;
        return data;
    }

    clone(): UpdateHRRequestDto {
        const json = this.toJSON();
        let result = new UpdateHRRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHRRequestDto {
    id: number;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    totalDays: number | undefined;
    totalHours: number | undefined;
    illnessCertNumber: string | undefined;
    userAnnotation: string | undefined;
    projectReference: string | undefined;
    deliveryPlace: string | undefined;
    deliveryTime: string | undefined;
    projectCode: string | undefined;
    purchaseReason: string | undefined;
    purchaseTypeId: number;
    supplier: string | undefined;
    paymentTypeId: number;
    currencyTypeId: number;
}

export class UpdateMediaEventDto implements IUpdateMediaEventDto {
    id!: number;
    description!: string | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    service!: Int64EntityDto;
    group!: Int64EntityDto;
    mediaIds!: number[] | undefined;
    activityCategory!: Int64EntityDto;
    userIds!: number[] | undefined;
    usersHours!: string | undefined;

    constructor(data?: IUpdateMediaEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.service = _data["service"] ? Int64EntityDto.fromJS(_data["service"]) : <any>undefined;
            this.group = _data["group"] ? Int64EntityDto.fromJS(_data["group"]) : <any>undefined;
            if (Array.isArray(_data["mediaIds"])) {
                this.mediaIds = [] as any;
                for (let item of _data["mediaIds"])
                    this.mediaIds!.push(item);
            }
            this.activityCategory = _data["activityCategory"] ? Int64EntityDto.fromJS(_data["activityCategory"]) : <any>undefined;
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.usersHours = _data["usersHours"];
        }
    }

    static fromJS(data: any): UpdateMediaEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMediaEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        if (Array.isArray(this.mediaIds)) {
            data["mediaIds"] = [];
            for (let item of this.mediaIds)
                data["mediaIds"].push(item);
        }
        data["activityCategory"] = this.activityCategory ? this.activityCategory.toJSON() : <any>undefined;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["usersHours"] = this.usersHours;
        return data;
    }

    clone(): UpdateMediaEventDto {
        const json = this.toJSON();
        let result = new UpdateMediaEventDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMediaEventDto {
    id: number;
    description: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    service: Int64EntityDto;
    group: Int64EntityDto;
    mediaIds: number[] | undefined;
    activityCategory: Int64EntityDto;
    userIds: number[] | undefined;
    usersHours: string | undefined;
}

export class UpdatePlanningDto implements IUpdatePlanningDto {
    id!: number;
    timeIntervals!: CreateTimeIntervalDto[] | undefined;
    date!: moment.Moment;
    annotation!: string | undefined;
    childrenCount!: number;

    constructor(data?: IUpdatePlanningDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["timeIntervals"])) {
                this.timeIntervals = [] as any;
                for (let item of _data["timeIntervals"])
                    this.timeIntervals!.push(CreateTimeIntervalDto.fromJS(item));
            }
            this.date = _data["date"] ? moment(_data["date"].toString()) : <any>undefined;
            this.annotation = _data["annotation"];
            this.childrenCount = _data["childrenCount"];
        }
    }

    static fromJS(data: any): UpdatePlanningDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlanningDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.timeIntervals)) {
            data["timeIntervals"] = [];
            for (let item of this.timeIntervals)
                data["timeIntervals"].push(item.toJSON());
        }
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["annotation"] = this.annotation;
        data["childrenCount"] = this.childrenCount;
        return data;
    }

    clone(): UpdatePlanningDto {
        const json = this.toJSON();
        let result = new UpdatePlanningDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePlanningDto {
    id: number;
    timeIntervals: CreateTimeIntervalDto[] | undefined;
    date: moment.Moment;
    annotation: string | undefined;
    childrenCount: number;
}

export class UpdateReceiptDto implements IUpdateReceiptDto {
    id!: number;
    title!: string | undefined;
    outputs!: CreateUpdateReceiptOutputDto[] | undefined;
    amount!: number;
    billingDate!: moment.Moment;
    fileIds!: number[] | undefined;
    feePerHour!: number | undefined;
    workedHours!: number | undefined;
    duePaycheck!: Int64EntityDto;

    constructor(data?: IUpdateReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            if (Array.isArray(_data["outputs"])) {
                this.outputs = [] as any;
                for (let item of _data["outputs"])
                    this.outputs!.push(CreateUpdateReceiptOutputDto.fromJS(item));
            }
            this.amount = _data["amount"];
            this.billingDate = _data["billingDate"] ? moment(_data["billingDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
            this.feePerHour = _data["feePerHour"];
            this.workedHours = _data["workedHours"];
            this.duePaycheck = _data["duePaycheck"] ? Int64EntityDto.fromJS(_data["duePaycheck"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        if (Array.isArray(this.outputs)) {
            data["outputs"] = [];
            for (let item of this.outputs)
                data["outputs"].push(item.toJSON());
        }
        data["amount"] = this.amount;
        data["billingDate"] = this.billingDate ? this.billingDate.toISOString() : <any>undefined;
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        data["feePerHour"] = this.feePerHour;
        data["workedHours"] = this.workedHours;
        data["duePaycheck"] = this.duePaycheck ? this.duePaycheck.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateReceiptDto {
        const json = this.toJSON();
        let result = new UpdateReceiptDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateReceiptDto {
    id: number;
    title: string | undefined;
    outputs: CreateUpdateReceiptOutputDto[] | undefined;
    amount: number;
    billingDate: moment.Moment;
    fileIds: number[] | undefined;
    feePerHour: number | undefined;
    workedHours: number | undefined;
    duePaycheck: Int64EntityDto;
}

export class UpdateRegistrationParametersDto implements IUpdateRegistrationParametersDto {
    id!: number;
    user!: Int64EntityDto;
    timeSlot!: string | undefined;
    diaperOption!: DiaperOptions;
    imageUseAuthorization!: boolean | undefined;
    imageUseAuthorizationOnSocial!: boolean | undefined;

    constructor(data?: IUpdateRegistrationParametersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? Int64EntityDto.fromJS(_data["user"]) : <any>undefined;
            this.timeSlot = _data["timeSlot"];
            this.diaperOption = _data["diaperOption"];
            this.imageUseAuthorization = _data["imageUseAuthorization"];
            this.imageUseAuthorizationOnSocial = _data["imageUseAuthorizationOnSocial"];
        }
    }

    static fromJS(data: any): UpdateRegistrationParametersDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRegistrationParametersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["timeSlot"] = this.timeSlot;
        data["diaperOption"] = this.diaperOption;
        data["imageUseAuthorization"] = this.imageUseAuthorization;
        data["imageUseAuthorizationOnSocial"] = this.imageUseAuthorizationOnSocial;
        return data;
    }

    clone(): UpdateRegistrationParametersDto {
        const json = this.toJSON();
        let result = new UpdateRegistrationParametersDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRegistrationParametersDto {
    id: number;
    user: Int64EntityDto;
    timeSlot: string | undefined;
    diaperOption: DiaperOptions;
    imageUseAuthorization: boolean | undefined;
    imageUseAuthorizationOnSocial: boolean | undefined;
}

export class UpdateScheduledEventDto implements IUpdateScheduledEventDto {
    id!: string;
    eventName!: string | undefined;
    description!: string | undefined;
    groupIds!: number[] | undefined;
    roleIds!: number[] | undefined;
    color!: string | undefined;
    severity!: string | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment;
    reminder!: Int64EntityDto;
    service!: Int64EntityDto;

    constructor(data?: IUpdateScheduledEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventName = _data["eventName"];
            this.description = _data["description"];
            if (Array.isArray(_data["groupIds"])) {
                this.groupIds = [] as any;
                for (let item of _data["groupIds"])
                    this.groupIds!.push(item);
            }
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.color = _data["color"];
            this.severity = _data["severity"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.reminder = _data["reminder"] ? Int64EntityDto.fromJS(_data["reminder"]) : <any>undefined;
            this.service = _data["service"] ? Int64EntityDto.fromJS(_data["service"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateScheduledEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduledEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventName"] = this.eventName;
        data["description"] = this.description;
        if (Array.isArray(this.groupIds)) {
            data["groupIds"] = [];
            for (let item of this.groupIds)
                data["groupIds"].push(item);
        }
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["color"] = this.color;
        data["severity"] = this.severity;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["reminder"] = this.reminder ? this.reminder.toJSON() : <any>undefined;
        data["service"] = this.service ? this.service.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateScheduledEventDto {
        const json = this.toJSON();
        let result = new UpdateScheduledEventDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateScheduledEventDto {
    id: string;
    eventName: string | undefined;
    description: string | undefined;
    groupIds: number[] | undefined;
    roleIds: number[] | undefined;
    color: string | undefined;
    severity: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    reminder: Int64EntityDto;
    service: Int64EntityDto;
}

export class UpdateScheduledNotificationDto implements IUpdateScheduledNotificationDto {
    id!: string;
    notificationName!: string | undefined;
    description!: string | undefined;
    severity!: string | undefined;
    dueDate!: moment.Moment;
    reminder!: Int64EntityDto;

    constructor(data?: IUpdateScheduledNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notificationName = _data["notificationName"];
            this.description = _data["description"];
            this.severity = _data["severity"];
            this.dueDate = _data["dueDate"] ? moment(_data["dueDate"].toString()) : <any>undefined;
            this.reminder = _data["reminder"] ? Int64EntityDto.fromJS(_data["reminder"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateScheduledNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduledNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notificationName"] = this.notificationName;
        data["description"] = this.description;
        data["severity"] = this.severity;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["reminder"] = this.reminder ? this.reminder.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateScheduledNotificationDto {
        const json = this.toJSON();
        let result = new UpdateScheduledNotificationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateScheduledNotificationDto {
    id: string;
    notificationName: string | undefined;
    description: string | undefined;
    severity: string | undefined;
    dueDate: moment.Moment;
    reminder: Int64EntityDto;
}

export class UpdateServiceBeneficiaryDto implements IUpdateServiceBeneficiaryDto {
    id!: number;

    constructor(data?: IUpdateServiceBeneficiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateServiceBeneficiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceBeneficiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateServiceBeneficiaryDto {
        const json = this.toJSON();
        let result = new UpdateServiceBeneficiaryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceBeneficiaryDto {
    id: number;
}

export class UpdateServiceDto implements IUpdateServiceDto {
    id!: number;
    dvrFile!: FileDto;
    description!: string;
    userAmount!: number;
    dpi!: string | undefined;
    totalHour!: number | undefined;
    fundAmount!: number | undefined;
    referenceTerritories!: string | undefined;
    areasOfService!: AreaDto[];
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    referenceUser!: string | undefined;
    isClosed!: boolean;
    requiredProfiles!: string | undefined;
    customers!: CustomerDto[] | undefined;
    contractId!: number | undefined;
    annotation!: string | undefined;
    schoolYear!: Int64EntityDto;

    constructor(data?: IUpdateServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.areasOfService = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dvrFile = _data["dvrFile"] ? FileDto.fromJS(_data["dvrFile"]) : <any>undefined;
            this.description = _data["description"];
            this.userAmount = _data["userAmount"];
            this.dpi = _data["dpi"];
            this.totalHour = _data["totalHour"];
            this.fundAmount = _data["fundAmount"];
            this.referenceTerritories = _data["referenceTerritories"];
            if (Array.isArray(_data["areasOfService"])) {
                this.areasOfService = [] as any;
                for (let item of _data["areasOfService"])
                    this.areasOfService!.push(AreaDto.fromJS(item));
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.referenceUser = _data["referenceUser"];
            this.isClosed = _data["isClosed"];
            this.requiredProfiles = _data["requiredProfiles"];
            if (Array.isArray(_data["customers"])) {
                this.customers = [] as any;
                for (let item of _data["customers"])
                    this.customers!.push(CustomerDto.fromJS(item));
            }
            this.contractId = _data["contractId"];
            this.annotation = _data["annotation"];
            this.schoolYear = _data["schoolYear"] ? Int64EntityDto.fromJS(_data["schoolYear"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dvrFile"] = this.dvrFile ? this.dvrFile.toJSON() : <any>undefined;
        data["description"] = this.description;
        data["userAmount"] = this.userAmount;
        data["dpi"] = this.dpi;
        data["totalHour"] = this.totalHour;
        data["fundAmount"] = this.fundAmount;
        data["referenceTerritories"] = this.referenceTerritories;
        if (Array.isArray(this.areasOfService)) {
            data["areasOfService"] = [];
            for (let item of this.areasOfService)
                data["areasOfService"].push(item.toJSON());
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["referenceUser"] = this.referenceUser;
        data["isClosed"] = this.isClosed;
        data["requiredProfiles"] = this.requiredProfiles;
        if (Array.isArray(this.customers)) {
            data["customers"] = [];
            for (let item of this.customers)
                data["customers"].push(item.toJSON());
        }
        data["contractId"] = this.contractId;
        data["annotation"] = this.annotation;
        data["schoolYear"] = this.schoolYear ? this.schoolYear.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateServiceDto {
        const json = this.toJSON();
        let result = new UpdateServiceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceDto {
    id: number;
    dvrFile: FileDto;
    description: string;
    userAmount: number;
    dpi: string | undefined;
    totalHour: number | undefined;
    fundAmount: number | undefined;
    referenceTerritories: string | undefined;
    areasOfService: AreaDto[];
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    referenceUser: string | undefined;
    isClosed: boolean;
    requiredProfiles: string | undefined;
    customers: CustomerDto[] | undefined;
    contractId: number | undefined;
    annotation: string | undefined;
    schoolYear: Int64EntityDto;
}

export class UpdateServiceOperatorDto implements IUpdateServiceOperatorDto {
    id!: number;
    hourPerUserPredicted!: number | undefined;
    hourPerUserAtClosure!: number | undefined;
    isCoordinator!: boolean;

    constructor(data?: IUpdateServiceOperatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hourPerUserPredicted = _data["hourPerUserPredicted"];
            this.hourPerUserAtClosure = _data["hourPerUserAtClosure"];
            this.isCoordinator = _data["isCoordinator"];
        }
    }

    static fromJS(data: any): UpdateServiceOperatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceOperatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hourPerUserPredicted"] = this.hourPerUserPredicted;
        data["hourPerUserAtClosure"] = this.hourPerUserAtClosure;
        data["isCoordinator"] = this.isCoordinator;
        return data;
    }

    clone(): UpdateServiceOperatorDto {
        const json = this.toJSON();
        let result = new UpdateServiceOperatorDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceOperatorDto {
    id: number;
    hourPerUserPredicted: number | undefined;
    hourPerUserAtClosure: number | undefined;
    isCoordinator: boolean;
}

export class UpdateServiceOperatorScheduledDto implements IUpdateServiceOperatorScheduledDto {
    id!: number;
    predictedStartDate!: moment.Moment;
    predictedEndDate!: moment.Moment | undefined;
    badgedStartDate!: moment.Moment | undefined;
    badgedEndDate!: moment.Moment | undefined;
    workShiftFrequencyType!: WorkShiftFrequencyTypeDto;
    hoursAtPeriod!: number | undefined;
    workedMinutes!: number;
    predictedMinutes!: number | undefined;
    annotationForOperator!: string | undefined;
    feePerHour!: number | undefined;

    constructor(data?: IUpdateServiceOperatorScheduledDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.predictedStartDate = _data["predictedStartDate"] ? moment(_data["predictedStartDate"].toString()) : <any>undefined;
            this.predictedEndDate = _data["predictedEndDate"] ? moment(_data["predictedEndDate"].toString()) : <any>undefined;
            this.badgedStartDate = _data["badgedStartDate"] ? moment(_data["badgedStartDate"].toString()) : <any>undefined;
            this.badgedEndDate = _data["badgedEndDate"] ? moment(_data["badgedEndDate"].toString()) : <any>undefined;
            this.workShiftFrequencyType = _data["workShiftFrequencyType"] ? WorkShiftFrequencyTypeDto.fromJS(_data["workShiftFrequencyType"]) : <any>undefined;
            this.hoursAtPeriod = _data["hoursAtPeriod"];
            this.workedMinutes = _data["workedMinutes"];
            this.predictedMinutes = _data["predictedMinutes"];
            this.annotationForOperator = _data["annotationForOperator"];
            this.feePerHour = _data["feePerHour"];
        }
    }

    static fromJS(data: any): UpdateServiceOperatorScheduledDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceOperatorScheduledDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["predictedStartDate"] = this.predictedStartDate ? this.predictedStartDate.toISOString() : <any>undefined;
        data["predictedEndDate"] = this.predictedEndDate ? this.predictedEndDate.toISOString() : <any>undefined;
        data["badgedStartDate"] = this.badgedStartDate ? this.badgedStartDate.toISOString() : <any>undefined;
        data["badgedEndDate"] = this.badgedEndDate ? this.badgedEndDate.toISOString() : <any>undefined;
        data["workShiftFrequencyType"] = this.workShiftFrequencyType ? this.workShiftFrequencyType.toJSON() : <any>undefined;
        data["hoursAtPeriod"] = this.hoursAtPeriod;
        data["workedMinutes"] = this.workedMinutes;
        data["predictedMinutes"] = this.predictedMinutes;
        data["annotationForOperator"] = this.annotationForOperator;
        data["feePerHour"] = this.feePerHour;
        return data;
    }

    clone(): UpdateServiceOperatorScheduledDto {
        const json = this.toJSON();
        let result = new UpdateServiceOperatorScheduledDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceOperatorScheduledDto {
    id: number;
    predictedStartDate: moment.Moment;
    predictedEndDate: moment.Moment | undefined;
    badgedStartDate: moment.Moment | undefined;
    badgedEndDate: moment.Moment | undefined;
    workShiftFrequencyType: WorkShiftFrequencyTypeDto;
    hoursAtPeriod: number | undefined;
    workedMinutes: number;
    predictedMinutes: number | undefined;
    annotationForOperator: string | undefined;
    feePerHour: number | undefined;
}

export class UpdateServiceReportDto implements IUpdateServiceReportDto {
    id!: number;
    serviceId!: number;
    equipesAmount!: number | undefined;
    supervisionsAmount!: number | undefined;
    meetingWithInstitutions!: number | undefined;
    formationCourses!: number | undefined;
    prePostDegreeInternships!: number | undefined;
    publications!: PublicationDto[] | undefined;
    conferences!: ConferenceDto[] | undefined;
    foreignNationalities!: string | undefined;
    informativeMaterialsDistribuited!: number | undefined;
    caredUsersInformations!: UserReportPartialDto;
    usersContactsInformationsUDS!: ContactReportPartialUDSDto;
    usersContactsInformationWithClasses!: ContactReportPartialWithClassesDto;
    informationContact!: number | undefined;
    psychoeducationalCounselingCourses!: number | undefined;
    counselingPreventionRDD!: number | undefined;
    activityOfSocialSecretary!: number | undefined;
    psychotherapyCourses!: number | undefined;
    psychotherapyGroups!: number | undefined;
    psycologicalCounselingSending!: number | undefined;
    medicalAdviceCounseling!: number | undefined;
    medications!: number | undefined;
    legalCounseling!: number | undefined;
    regularizationCourses!: number | undefined;
    regularUsers!: number | undefined;
    italianSchoolPlacemetsForForeigners!: number | undefined;
    schoolPlacementsMiddleSchoolDiploma!: number | undefined;
    usersWithMiddleSchoolDiploma!: number | undefined;
    highSchoolPlacements!: number | undefined;
    usersWithHighSchoolDiploma!: number | undefined;
    professionalTrainingCoursePlacements!: number | undefined;
    usersCourseFinished!: number | undefined;
    studySupportCourses!: number | undefined;
    workOrientationCourses!: number | undefined;
    workInternshipsActivated!: number | undefined;
    workPlacements!: number | undefined;
    housingAutonomyCourses!: number | undefined;
    usersWithHousingAutonomy!: number | undefined;
    internalRapidHIVTestsAmount!: number | undefined;
    internalRapidHCVTestsAmount!: number | undefined;
    psychoeducationalLabs!: PsychoeducationalLabDto[] | undefined;
    informationAwarenessCourses!: InformationAwarenessCourseDto[] | undefined;
    testedSubstancesAmount!: number | undefined;
    psychotherapyCoursesOutService!: number | undefined;
    psychotherapyGroupsSendings!: number | undefined;
    medicalCounselingSendings!: number | undefined;
    legalCounselingSendings!: number | undefined;
    studySuportCoursesSendings!: number | undefined;
    workOrientationCoursesSendings!: number | undefined;
    externalRapidHIVAndHCVTestsAmount!: number | undefined;
    otherSendings!: OtherSendingsDto[] | undefined;
    totalHygienAndSanitaryKits!: number | undefined;
    washingMachinesDone!: number | undefined;
    showersCarried!: number | undefined;
    totalInjectiveKits!: number | undefined;
    totalPulmonaryKits!: number | undefined;
    narcan!: number | undefined;
    condomsDistribuited!: number | undefined;
    informativeMaterial!: number | undefined;
    refreshmentMaterial!: number | undefined;
    meals!: number | undefined;
    gadgets!: GadgetDto[] | undefined;
    socialPosts!: number | undefined;
    socialPostsVisualizations!: number | undefined;
    legalArea!: string | undefined;
    sanitaryArea!: string | undefined;
    welfarePartnerArea!: string | undefined;
    volunteeringParishesArea!: string | undefined;
    publicServices!: string | undefined;
    other!: string | undefined;

    constructor(data?: IUpdateServiceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.equipesAmount = _data["equipesAmount"];
            this.supervisionsAmount = _data["supervisionsAmount"];
            this.meetingWithInstitutions = _data["meetingWithInstitutions"];
            this.formationCourses = _data["formationCourses"];
            this.prePostDegreeInternships = _data["prePostDegreeInternships"];
            if (Array.isArray(_data["publications"])) {
                this.publications = [] as any;
                for (let item of _data["publications"])
                    this.publications!.push(PublicationDto.fromJS(item));
            }
            if (Array.isArray(_data["conferences"])) {
                this.conferences = [] as any;
                for (let item of _data["conferences"])
                    this.conferences!.push(ConferenceDto.fromJS(item));
            }
            this.foreignNationalities = _data["foreignNationalities"];
            this.informativeMaterialsDistribuited = _data["informativeMaterialsDistribuited"];
            this.caredUsersInformations = _data["caredUsersInformations"] ? UserReportPartialDto.fromJS(_data["caredUsersInformations"]) : <any>undefined;
            this.usersContactsInformationsUDS = _data["usersContactsInformationsUDS"] ? ContactReportPartialUDSDto.fromJS(_data["usersContactsInformationsUDS"]) : <any>undefined;
            this.usersContactsInformationWithClasses = _data["usersContactsInformationWithClasses"] ? ContactReportPartialWithClassesDto.fromJS(_data["usersContactsInformationWithClasses"]) : <any>undefined;
            this.informationContact = _data["informationContact"];
            this.psychoeducationalCounselingCourses = _data["psychoeducationalCounselingCourses"];
            this.counselingPreventionRDD = _data["counselingPreventionRDD"];
            this.activityOfSocialSecretary = _data["activityOfSocialSecretary"];
            this.psychotherapyCourses = _data["psychotherapyCourses"];
            this.psychotherapyGroups = _data["psychotherapyGroups"];
            this.psycologicalCounselingSending = _data["psycologicalCounselingSending"];
            this.medicalAdviceCounseling = _data["medicalAdviceCounseling"];
            this.medications = _data["medications"];
            this.legalCounseling = _data["legalCounseling"];
            this.regularizationCourses = _data["regularizationCourses"];
            this.regularUsers = _data["regularUsers"];
            this.italianSchoolPlacemetsForForeigners = _data["italianSchoolPlacemetsForForeigners"];
            this.schoolPlacementsMiddleSchoolDiploma = _data["schoolPlacementsMiddleSchoolDiploma"];
            this.usersWithMiddleSchoolDiploma = _data["usersWithMiddleSchoolDiploma"];
            this.highSchoolPlacements = _data["highSchoolPlacements"];
            this.usersWithHighSchoolDiploma = _data["usersWithHighSchoolDiploma"];
            this.professionalTrainingCoursePlacements = _data["professionalTrainingCoursePlacements"];
            this.usersCourseFinished = _data["usersCourseFinished"];
            this.studySupportCourses = _data["studySupportCourses"];
            this.workOrientationCourses = _data["workOrientationCourses"];
            this.workInternshipsActivated = _data["workInternshipsActivated"];
            this.workPlacements = _data["workPlacements"];
            this.housingAutonomyCourses = _data["housingAutonomyCourses"];
            this.usersWithHousingAutonomy = _data["usersWithHousingAutonomy"];
            this.internalRapidHIVTestsAmount = _data["internalRapidHIVTestsAmount"];
            this.internalRapidHCVTestsAmount = _data["internalRapidHCVTestsAmount"];
            if (Array.isArray(_data["psychoeducationalLabs"])) {
                this.psychoeducationalLabs = [] as any;
                for (let item of _data["psychoeducationalLabs"])
                    this.psychoeducationalLabs!.push(PsychoeducationalLabDto.fromJS(item));
            }
            if (Array.isArray(_data["informationAwarenessCourses"])) {
                this.informationAwarenessCourses = [] as any;
                for (let item of _data["informationAwarenessCourses"])
                    this.informationAwarenessCourses!.push(InformationAwarenessCourseDto.fromJS(item));
            }
            this.testedSubstancesAmount = _data["testedSubstancesAmount"];
            this.psychotherapyCoursesOutService = _data["psychotherapyCoursesOutService"];
            this.psychotherapyGroupsSendings = _data["psychotherapyGroupsSendings"];
            this.medicalCounselingSendings = _data["medicalCounselingSendings"];
            this.legalCounselingSendings = _data["legalCounselingSendings"];
            this.studySuportCoursesSendings = _data["studySuportCoursesSendings"];
            this.workOrientationCoursesSendings = _data["workOrientationCoursesSendings"];
            this.externalRapidHIVAndHCVTestsAmount = _data["externalRapidHIVAndHCVTestsAmount"];
            if (Array.isArray(_data["otherSendings"])) {
                this.otherSendings = [] as any;
                for (let item of _data["otherSendings"])
                    this.otherSendings!.push(OtherSendingsDto.fromJS(item));
            }
            this.totalHygienAndSanitaryKits = _data["totalHygienAndSanitaryKits"];
            this.washingMachinesDone = _data["washingMachinesDone"];
            this.showersCarried = _data["showersCarried"];
            this.totalInjectiveKits = _data["totalInjectiveKits"];
            this.totalPulmonaryKits = _data["totalPulmonaryKits"];
            this.narcan = _data["narcan"];
            this.condomsDistribuited = _data["condomsDistribuited"];
            this.informativeMaterial = _data["informativeMaterial"];
            this.refreshmentMaterial = _data["refreshmentMaterial"];
            this.meals = _data["meals"];
            if (Array.isArray(_data["gadgets"])) {
                this.gadgets = [] as any;
                for (let item of _data["gadgets"])
                    this.gadgets!.push(GadgetDto.fromJS(item));
            }
            this.socialPosts = _data["socialPosts"];
            this.socialPostsVisualizations = _data["socialPostsVisualizations"];
            this.legalArea = _data["legalArea"];
            this.sanitaryArea = _data["sanitaryArea"];
            this.welfarePartnerArea = _data["welfarePartnerArea"];
            this.volunteeringParishesArea = _data["volunteeringParishesArea"];
            this.publicServices = _data["publicServices"];
            this.other = _data["other"];
        }
    }

    static fromJS(data: any): UpdateServiceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["equipesAmount"] = this.equipesAmount;
        data["supervisionsAmount"] = this.supervisionsAmount;
        data["meetingWithInstitutions"] = this.meetingWithInstitutions;
        data["formationCourses"] = this.formationCourses;
        data["prePostDegreeInternships"] = this.prePostDegreeInternships;
        if (Array.isArray(this.publications)) {
            data["publications"] = [];
            for (let item of this.publications)
                data["publications"].push(item.toJSON());
        }
        if (Array.isArray(this.conferences)) {
            data["conferences"] = [];
            for (let item of this.conferences)
                data["conferences"].push(item.toJSON());
        }
        data["foreignNationalities"] = this.foreignNationalities;
        data["informativeMaterialsDistribuited"] = this.informativeMaterialsDistribuited;
        data["caredUsersInformations"] = this.caredUsersInformations ? this.caredUsersInformations.toJSON() : <any>undefined;
        data["usersContactsInformationsUDS"] = this.usersContactsInformationsUDS ? this.usersContactsInformationsUDS.toJSON() : <any>undefined;
        data["usersContactsInformationWithClasses"] = this.usersContactsInformationWithClasses ? this.usersContactsInformationWithClasses.toJSON() : <any>undefined;
        data["informationContact"] = this.informationContact;
        data["psychoeducationalCounselingCourses"] = this.psychoeducationalCounselingCourses;
        data["counselingPreventionRDD"] = this.counselingPreventionRDD;
        data["activityOfSocialSecretary"] = this.activityOfSocialSecretary;
        data["psychotherapyCourses"] = this.psychotherapyCourses;
        data["psychotherapyGroups"] = this.psychotherapyGroups;
        data["psycologicalCounselingSending"] = this.psycologicalCounselingSending;
        data["medicalAdviceCounseling"] = this.medicalAdviceCounseling;
        data["medications"] = this.medications;
        data["legalCounseling"] = this.legalCounseling;
        data["regularizationCourses"] = this.regularizationCourses;
        data["regularUsers"] = this.regularUsers;
        data["italianSchoolPlacemetsForForeigners"] = this.italianSchoolPlacemetsForForeigners;
        data["schoolPlacementsMiddleSchoolDiploma"] = this.schoolPlacementsMiddleSchoolDiploma;
        data["usersWithMiddleSchoolDiploma"] = this.usersWithMiddleSchoolDiploma;
        data["highSchoolPlacements"] = this.highSchoolPlacements;
        data["usersWithHighSchoolDiploma"] = this.usersWithHighSchoolDiploma;
        data["professionalTrainingCoursePlacements"] = this.professionalTrainingCoursePlacements;
        data["usersCourseFinished"] = this.usersCourseFinished;
        data["studySupportCourses"] = this.studySupportCourses;
        data["workOrientationCourses"] = this.workOrientationCourses;
        data["workInternshipsActivated"] = this.workInternshipsActivated;
        data["workPlacements"] = this.workPlacements;
        data["housingAutonomyCourses"] = this.housingAutonomyCourses;
        data["usersWithHousingAutonomy"] = this.usersWithHousingAutonomy;
        data["internalRapidHIVTestsAmount"] = this.internalRapidHIVTestsAmount;
        data["internalRapidHCVTestsAmount"] = this.internalRapidHCVTestsAmount;
        if (Array.isArray(this.psychoeducationalLabs)) {
            data["psychoeducationalLabs"] = [];
            for (let item of this.psychoeducationalLabs)
                data["psychoeducationalLabs"].push(item.toJSON());
        }
        if (Array.isArray(this.informationAwarenessCourses)) {
            data["informationAwarenessCourses"] = [];
            for (let item of this.informationAwarenessCourses)
                data["informationAwarenessCourses"].push(item.toJSON());
        }
        data["testedSubstancesAmount"] = this.testedSubstancesAmount;
        data["psychotherapyCoursesOutService"] = this.psychotherapyCoursesOutService;
        data["psychotherapyGroupsSendings"] = this.psychotherapyGroupsSendings;
        data["medicalCounselingSendings"] = this.medicalCounselingSendings;
        data["legalCounselingSendings"] = this.legalCounselingSendings;
        data["studySuportCoursesSendings"] = this.studySuportCoursesSendings;
        data["workOrientationCoursesSendings"] = this.workOrientationCoursesSendings;
        data["externalRapidHIVAndHCVTestsAmount"] = this.externalRapidHIVAndHCVTestsAmount;
        if (Array.isArray(this.otherSendings)) {
            data["otherSendings"] = [];
            for (let item of this.otherSendings)
                data["otherSendings"].push(item.toJSON());
        }
        data["totalHygienAndSanitaryKits"] = this.totalHygienAndSanitaryKits;
        data["washingMachinesDone"] = this.washingMachinesDone;
        data["showersCarried"] = this.showersCarried;
        data["totalInjectiveKits"] = this.totalInjectiveKits;
        data["totalPulmonaryKits"] = this.totalPulmonaryKits;
        data["narcan"] = this.narcan;
        data["condomsDistribuited"] = this.condomsDistribuited;
        data["informativeMaterial"] = this.informativeMaterial;
        data["refreshmentMaterial"] = this.refreshmentMaterial;
        data["meals"] = this.meals;
        if (Array.isArray(this.gadgets)) {
            data["gadgets"] = [];
            for (let item of this.gadgets)
                data["gadgets"].push(item.toJSON());
        }
        data["socialPosts"] = this.socialPosts;
        data["socialPostsVisualizations"] = this.socialPostsVisualizations;
        data["legalArea"] = this.legalArea;
        data["sanitaryArea"] = this.sanitaryArea;
        data["welfarePartnerArea"] = this.welfarePartnerArea;
        data["volunteeringParishesArea"] = this.volunteeringParishesArea;
        data["publicServices"] = this.publicServices;
        data["other"] = this.other;
        return data;
    }

    clone(): UpdateServiceReportDto {
        const json = this.toJSON();
        let result = new UpdateServiceReportDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceReportDto {
    id: number;
    serviceId: number;
    equipesAmount: number | undefined;
    supervisionsAmount: number | undefined;
    meetingWithInstitutions: number | undefined;
    formationCourses: number | undefined;
    prePostDegreeInternships: number | undefined;
    publications: PublicationDto[] | undefined;
    conferences: ConferenceDto[] | undefined;
    foreignNationalities: string | undefined;
    informativeMaterialsDistribuited: number | undefined;
    caredUsersInformations: UserReportPartialDto;
    usersContactsInformationsUDS: ContactReportPartialUDSDto;
    usersContactsInformationWithClasses: ContactReportPartialWithClassesDto;
    informationContact: number | undefined;
    psychoeducationalCounselingCourses: number | undefined;
    counselingPreventionRDD: number | undefined;
    activityOfSocialSecretary: number | undefined;
    psychotherapyCourses: number | undefined;
    psychotherapyGroups: number | undefined;
    psycologicalCounselingSending: number | undefined;
    medicalAdviceCounseling: number | undefined;
    medications: number | undefined;
    legalCounseling: number | undefined;
    regularizationCourses: number | undefined;
    regularUsers: number | undefined;
    italianSchoolPlacemetsForForeigners: number | undefined;
    schoolPlacementsMiddleSchoolDiploma: number | undefined;
    usersWithMiddleSchoolDiploma: number | undefined;
    highSchoolPlacements: number | undefined;
    usersWithHighSchoolDiploma: number | undefined;
    professionalTrainingCoursePlacements: number | undefined;
    usersCourseFinished: number | undefined;
    studySupportCourses: number | undefined;
    workOrientationCourses: number | undefined;
    workInternshipsActivated: number | undefined;
    workPlacements: number | undefined;
    housingAutonomyCourses: number | undefined;
    usersWithHousingAutonomy: number | undefined;
    internalRapidHIVTestsAmount: number | undefined;
    internalRapidHCVTestsAmount: number | undefined;
    psychoeducationalLabs: PsychoeducationalLabDto[] | undefined;
    informationAwarenessCourses: InformationAwarenessCourseDto[] | undefined;
    testedSubstancesAmount: number | undefined;
    psychotherapyCoursesOutService: number | undefined;
    psychotherapyGroupsSendings: number | undefined;
    medicalCounselingSendings: number | undefined;
    legalCounselingSendings: number | undefined;
    studySuportCoursesSendings: number | undefined;
    workOrientationCoursesSendings: number | undefined;
    externalRapidHIVAndHCVTestsAmount: number | undefined;
    otherSendings: OtherSendingsDto[] | undefined;
    totalHygienAndSanitaryKits: number | undefined;
    washingMachinesDone: number | undefined;
    showersCarried: number | undefined;
    totalInjectiveKits: number | undefined;
    totalPulmonaryKits: number | undefined;
    narcan: number | undefined;
    condomsDistribuited: number | undefined;
    informativeMaterial: number | undefined;
    refreshmentMaterial: number | undefined;
    meals: number | undefined;
    gadgets: GadgetDto[] | undefined;
    socialPosts: number | undefined;
    socialPostsVisualizations: number | undefined;
    legalArea: string | undefined;
    sanitaryArea: string | undefined;
    welfarePartnerArea: string | undefined;
    volunteeringParishesArea: string | undefined;
    publicServices: string | undefined;
    other: string | undefined;
}

export class UpdateTimeIntervalDto implements IUpdateTimeIntervalDto {
    id!: number;
    startDate!: moment.Moment;
    dateTime!: moment.Moment | undefined;

    constructor(data?: IUpdateTimeIntervalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateTimeIntervalDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTimeIntervalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UpdateTimeIntervalDto {
        const json = this.toJSON();
        let result = new UpdateTimeIntervalDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTimeIntervalDto {
    id: number;
    startDate: moment.Moment;
    dateTime: moment.Moment | undefined;
}

export class UpdateTopicDto implements IUpdateTopicDto {
    id!: number;
    subject!: string | undefined;
    userRecipientIds!: number[] | undefined;

    constructor(data?: IUpdateTopicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            if (Array.isArray(_data["userRecipientIds"])) {
                this.userRecipientIds = [] as any;
                for (let item of _data["userRecipientIds"])
                    this.userRecipientIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateTopicDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTopicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        if (Array.isArray(this.userRecipientIds)) {
            data["userRecipientIds"] = [];
            for (let item of this.userRecipientIds)
                data["userRecipientIds"].push(item);
        }
        return data;
    }

    clone(): UpdateTopicDto {
        const json = this.toJSON();
        let result = new UpdateTopicDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTopicDto {
    id: number;
    subject: string | undefined;
    userRecipientIds: number[] | undefined;
}

export class UpdateUserDto implements IUpdateUserDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    birthDate!: moment.Moment | undefined;
    phoneNumber!: string | undefined;
    vatCode!: string | undefined;
    fiscalCode!: string | undefined;
    gender!: Int32EntityDto;
    emailAddress!: string | undefined;
    roleNames!: string[] | undefined;
    isActive!: boolean;
    annotation!: string | undefined;
    address!: UpdateAddressDto;
    workerUserAdditional!: UpdateWorkerUserAdditionalDto;
    feePerHour!: number | undefined;
    color!: string | undefined;
    municipality!: Int64EntityDto;
    foreignPlaceOfBirth!: string | undefined;

    constructor(data?: IUpdateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.vatCode = _data["vatCode"];
            this.fiscalCode = _data["fiscalCode"];
            this.gender = _data["gender"] ? Int32EntityDto.fromJS(_data["gender"]) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.isActive = _data["isActive"];
            this.annotation = _data["annotation"];
            this.address = _data["address"] ? UpdateAddressDto.fromJS(_data["address"]) : <any>undefined;
            this.workerUserAdditional = _data["workerUserAdditional"] ? UpdateWorkerUserAdditionalDto.fromJS(_data["workerUserAdditional"]) : <any>undefined;
            this.feePerHour = _data["feePerHour"];
            this.color = _data["color"];
            this.municipality = _data["municipality"] ? Int64EntityDto.fromJS(_data["municipality"]) : <any>undefined;
            this.foreignPlaceOfBirth = _data["foreignPlaceOfBirth"];
        }
    }

    static fromJS(data: any): UpdateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["vatCode"] = this.vatCode;
        data["fiscalCode"] = this.fiscalCode;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["isActive"] = this.isActive;
        data["annotation"] = this.annotation;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["workerUserAdditional"] = this.workerUserAdditional ? this.workerUserAdditional.toJSON() : <any>undefined;
        data["feePerHour"] = this.feePerHour;
        data["color"] = this.color;
        data["municipality"] = this.municipality ? this.municipality.toJSON() : <any>undefined;
        data["foreignPlaceOfBirth"] = this.foreignPlaceOfBirth;
        return data;
    }

    clone(): UpdateUserDto {
        const json = this.toJSON();
        let result = new UpdateUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    birthDate: moment.Moment | undefined;
    phoneNumber: string | undefined;
    vatCode: string | undefined;
    fiscalCode: string | undefined;
    gender: Int32EntityDto;
    emailAddress: string | undefined;
    roleNames: string[] | undefined;
    isActive: boolean;
    annotation: string | undefined;
    address: UpdateAddressDto;
    workerUserAdditional: UpdateWorkerUserAdditionalDto;
    feePerHour: number | undefined;
    color: string | undefined;
    municipality: Int64EntityDto;
    foreignPlaceOfBirth: string | undefined;
}

export class UpdateUserMediaEventDto implements IUpdateUserMediaEventDto {
    id!: number;
    user!: Int64EntityDto;
    entryDate!: moment.Moment;
    exitDate!: moment.Moment;

    constructor(data?: IUpdateUserMediaEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? Int64EntityDto.fromJS(_data["user"]) : <any>undefined;
            this.entryDate = _data["entryDate"] ? moment(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? moment(_data["exitDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateUserMediaEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserMediaEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UpdateUserMediaEventDto {
        const json = this.toJSON();
        let result = new UpdateUserMediaEventDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserMediaEventDto {
    id: number;
    user: Int64EntityDto;
    entryDate: moment.Moment;
    exitDate: moment.Moment;
}

export class UpdateUserParentDto implements IUpdateUserParentDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    birthDate!: moment.Moment;
    emailAddress!: string | undefined;
    address!: AddressCreateDto;
    fiscalCode!: string | undefined;
    gender!: Int32EntityDto;
    phoneNumber!: string | undefined;
    parentalDegree!: Int64EntityDto;
    user!: Int64EntityDto;
    delegate!: boolean;
    invoicing!: boolean;

    constructor(data?: IUpdateUserParentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.address = _data["address"] ? AddressCreateDto.fromJS(_data["address"]) : <any>undefined;
            this.fiscalCode = _data["fiscalCode"];
            this.gender = _data["gender"] ? Int32EntityDto.fromJS(_data["gender"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.parentalDegree = _data["parentalDegree"] ? Int64EntityDto.fromJS(_data["parentalDegree"]) : <any>undefined;
            this.user = _data["user"] ? Int64EntityDto.fromJS(_data["user"]) : <any>undefined;
            this.delegate = _data["delegate"];
            this.invoicing = _data["invoicing"];
        }
    }

    static fromJS(data: any): UpdateUserParentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserParentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["fiscalCode"] = this.fiscalCode;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["parentalDegree"] = this.parentalDegree ? this.parentalDegree.toJSON() : <any>undefined;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["delegate"] = this.delegate;
        data["invoicing"] = this.invoicing;
        return data;
    }

    clone(): UpdateUserParentDto {
        const json = this.toJSON();
        let result = new UpdateUserParentDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserParentDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    birthDate: moment.Moment;
    emailAddress: string | undefined;
    address: AddressCreateDto;
    fiscalCode: string | undefined;
    gender: Int32EntityDto;
    phoneNumber: string | undefined;
    parentalDegree: Int64EntityDto;
    user: Int64EntityDto;
    delegate: boolean;
    invoicing: boolean;
}

export class UpdateWorkerUserAdditionalDto implements IUpdateWorkerUserAdditionalDto {
    isAssociate!: boolean | undefined;
    isVoluntaryAssociate!: boolean | undefined;
    isWorker!: boolean | undefined;
    workContractTypeId!: number | undefined;
    workContractLevelId!: number | undefined;
    educationalDegreeLevelId!: number | undefined;

    constructor(data?: IUpdateWorkerUserAdditionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isAssociate = _data["isAssociate"];
            this.isVoluntaryAssociate = _data["isVoluntaryAssociate"];
            this.isWorker = _data["isWorker"];
            this.workContractTypeId = _data["workContractTypeId"];
            this.workContractLevelId = _data["workContractLevelId"];
            this.educationalDegreeLevelId = _data["educationalDegreeLevelId"];
        }
    }

    static fromJS(data: any): UpdateWorkerUserAdditionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWorkerUserAdditionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isAssociate"] = this.isAssociate;
        data["isVoluntaryAssociate"] = this.isVoluntaryAssociate;
        data["isWorker"] = this.isWorker;
        data["workContractTypeId"] = this.workContractTypeId;
        data["workContractLevelId"] = this.workContractLevelId;
        data["educationalDegreeLevelId"] = this.educationalDegreeLevelId;
        return data;
    }

    clone(): UpdateWorkerUserAdditionalDto {
        const json = this.toJSON();
        let result = new UpdateWorkerUserAdditionalDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateWorkerUserAdditionalDto {
    isAssociate: boolean | undefined;
    isVoluntaryAssociate: boolean | undefined;
    isWorker: boolean | undefined;
    workContractTypeId: number | undefined;
    workContractLevelId: number | undefined;
    educationalDegreeLevelId: number | undefined;
}

export class UploadFileRequestDto implements IUploadFileRequestDto {
    mask!: string | undefined;
    signedUrl!: string | undefined;

    constructor(data?: IUploadFileRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mask = _data["mask"];
            this.signedUrl = _data["signedUrl"];
        }
    }

    static fromJS(data: any): UploadFileRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UploadFileRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mask"] = this.mask;
        data["signedUrl"] = this.signedUrl;
        return data;
    }

    clone(): UploadFileRequestDto {
        const json = this.toJSON();
        let result = new UploadFileRequestDto();
        result.init(json);
        return result;
    }
}

export interface IUploadFileRequestDto {
    mask: string | undefined;
    signedUrl: string | undefined;
}

export class UserCertificationDto implements IUserCertificationDto {
    id!: number;
    certification!: CertificationDto;
    userId!: number;
    certificationDate!: moment.Moment | undefined;
    expirationDate!: moment.Moment | undefined;

    constructor(data?: IUserCertificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.certification = _data["certification"] ? CertificationDto.fromJS(_data["certification"]) : <any>undefined;
            this.userId = _data["userId"];
            this.certificationDate = _data["certificationDate"] ? moment(_data["certificationDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserCertificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCertificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["certification"] = this.certification ? this.certification.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["certificationDate"] = this.certificationDate ? this.certificationDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserCertificationDto {
        const json = this.toJSON();
        let result = new UserCertificationDto();
        result.init(json);
        return result;
    }
}

export interface IUserCertificationDto {
    id: number;
    certification: CertificationDto;
    userId: number;
    certificationDate: moment.Moment | undefined;
    expirationDate: moment.Moment | undefined;
}

export class UserCertificationDtoPagedResultDto implements IUserCertificationDtoPagedResultDto {
    items!: UserCertificationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserCertificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserCertificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserCertificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCertificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserCertificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserCertificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserCertificationDtoPagedResultDto {
    items: UserCertificationDto[] | undefined;
    totalCount: number;
}

export class UserDto implements IUserDto {
    id!: number;
    readonly entityType!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    gender!: GenderDto;
    birthDate!: moment.Moment | undefined;
    phoneNumber!: string | undefined;
    vatCode!: string | undefined;
    fiscalCode!: string | undefined;
    address!: AddressDto;
    annotation!: string | undefined;
    municipality!: MunicipalityDto;
    foreignPlaceOfBirth!: string | undefined;
    workerUserAdditional!: WorkerUserAdditionalDto;
    feePerHour!: number | undefined;
    emailAddress!: string | undefined;
    roleNames!: string[] | undefined;
    roleDisplayNames!: string[] | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    lastLoginTime!: moment.Moment | undefined;
    isEmailConfirmed!: boolean;
    fullName!: string | undefined;
    accessFailedCount!: number;
    lockoutEndDateUtc!: moment.Moment | undefined;
    grantedPermissions!: string[] | undefined;
    userParents!: UserParentDto[] | undefined;
    color!: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            (<any>this).entityType = _data["entityType"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.gender = _data["gender"] ? GenderDto.fromJS(_data["gender"]) : <any>undefined;
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.vatCode = _data["vatCode"];
            this.fiscalCode = _data["fiscalCode"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.annotation = _data["annotation"];
            this.municipality = _data["municipality"] ? MunicipalityDto.fromJS(_data["municipality"]) : <any>undefined;
            this.foreignPlaceOfBirth = _data["foreignPlaceOfBirth"];
            this.workerUserAdditional = _data["workerUserAdditional"] ? WorkerUserAdditionalDto.fromJS(_data["workerUserAdditional"]) : <any>undefined;
            this.feePerHour = _data["feePerHour"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            if (Array.isArray(_data["roleDisplayNames"])) {
                this.roleDisplayNames = [] as any;
                for (let item of _data["roleDisplayNames"])
                    this.roleDisplayNames!.push(item);
            }
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : <any>undefined;
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.fullName = _data["fullName"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : <any>undefined;
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
            if (Array.isArray(_data["userParents"])) {
                this.userParents = [] as any;
                for (let item of _data["userParents"])
                    this.userParents!.push(UserParentDto.fromJS(item));
            }
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["vatCode"] = this.vatCode;
        data["fiscalCode"] = this.fiscalCode;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["annotation"] = this.annotation;
        data["municipality"] = this.municipality ? this.municipality.toJSON() : <any>undefined;
        data["foreignPlaceOfBirth"] = this.foreignPlaceOfBirth;
        data["workerUserAdditional"] = this.workerUserAdditional ? this.workerUserAdditional.toJSON() : <any>undefined;
        data["feePerHour"] = this.feePerHour;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.roleDisplayNames)) {
            data["roleDisplayNames"] = [];
            for (let item of this.roleDisplayNames)
                data["roleDisplayNames"].push(item);
        }
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["fullName"] = this.fullName;
        data["accessFailedCount"] = this.accessFailedCount;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        if (Array.isArray(this.userParents)) {
            data["userParents"] = [];
            for (let item of this.userParents)
                data["userParents"].push(item.toJSON());
        }
        data["color"] = this.color;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    entityType: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    gender: GenderDto;
    birthDate: moment.Moment | undefined;
    phoneNumber: string | undefined;
    vatCode: string | undefined;
    fiscalCode: string | undefined;
    address: AddressDto;
    annotation: string | undefined;
    municipality: MunicipalityDto;
    foreignPlaceOfBirth: string | undefined;
    workerUserAdditional: WorkerUserAdditionalDto;
    feePerHour: number | undefined;
    emailAddress: string | undefined;
    roleNames: string[] | undefined;
    roleDisplayNames: string[] | undefined;
    isActive: boolean;
    isDeleted: boolean;
    lastLoginTime: moment.Moment | undefined;
    isEmailConfirmed: boolean;
    fullName: string | undefined;
    accessFailedCount: number;
    lockoutEndDateUtc: moment.Moment | undefined;
    grantedPermissions: string[] | undefined;
    userParents: UserParentDto[] | undefined;
    color: string | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items!: UserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserEducationalDegreeDto implements IUserEducationalDegreeDto {
    id!: number;
    educationalDegree!: EducationalDegreeDto;
    userId!: number;

    constructor(data?: IUserEducationalDegreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.educationalDegree = _data["educationalDegree"] ? EducationalDegreeDto.fromJS(_data["educationalDegree"]) : <any>undefined;
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserEducationalDegreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEducationalDegreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["educationalDegree"] = this.educationalDegree ? this.educationalDegree.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        return data;
    }

    clone(): UserEducationalDegreeDto {
        const json = this.toJSON();
        let result = new UserEducationalDegreeDto();
        result.init(json);
        return result;
    }
}

export interface IUserEducationalDegreeDto {
    id: number;
    educationalDegree: EducationalDegreeDto;
    userId: number;
}

export class UserEducationalDegreeDtoPagedResultDto implements IUserEducationalDegreeDtoPagedResultDto {
    items!: UserEducationalDegreeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserEducationalDegreeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserEducationalDegreeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserEducationalDegreeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEducationalDegreeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserEducationalDegreeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserEducationalDegreeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserEducationalDegreeDtoPagedResultDto {
    items: UserEducationalDegreeDto[] | undefined;
    totalCount: number;
}

export class UserFileDto implements IUserFileDto {
    id!: number;
    user!: BaseUserDto;
    creationTime!: moment.Moment;

    constructor(data?: IUserFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? BaseUserDto.fromJS(_data["user"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserFileDto {
        const json = this.toJSON();
        let result = new UserFileDto();
        result.init(json);
        return result;
    }
}

export interface IUserFileDto {
    id: number;
    user: BaseUserDto;
    creationTime: moment.Moment;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id!: number;
    fullName!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    roleNames!: string[] | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    fullName: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    roleNames: string[] | undefined;
}

export class UserMediaEventDto implements IUserMediaEventDto {
    id!: number;
    user!: UserDto;
    entryDate!: moment.Moment;
    exitDate!: moment.Moment;

    constructor(data?: IUserMediaEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.entryDate = _data["entryDate"] ? moment(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? moment(_data["exitDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserMediaEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserMediaEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserMediaEventDto {
        const json = this.toJSON();
        let result = new UserMediaEventDto();
        result.init(json);
        return result;
    }
}

export interface IUserMediaEventDto {
    id: number;
    user: UserDto;
    entryDate: moment.Moment;
    exitDate: moment.Moment;
}

export class UserMediaEventDtoPagedResultDto implements IUserMediaEventDtoPagedResultDto {
    items!: UserMediaEventDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserMediaEventDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserMediaEventDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserMediaEventDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserMediaEventDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserMediaEventDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserMediaEventDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserMediaEventDtoPagedResultDto {
    items: UserMediaEventDto[] | undefined;
    totalCount: number;
}

export class UserOrganizationUnitDto implements IUserOrganizationUnitDto {
    id!: number;
    user!: UserDto;
    organizationUnitId!: number;

    constructor(data?: IUserOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : <any>undefined;
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UserOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }

    clone(): UserOrganizationUnitDto {
        const json = this.toJSON();
        let result = new UserOrganizationUnitDto();
        result.init(json);
        return result;
    }
}

export interface IUserOrganizationUnitDto {
    id: number;
    user: UserDto;
    organizationUnitId: number;
}

export class UserOrganizationUnitDtoPagedResultDto implements IUserOrganizationUnitDtoPagedResultDto {
    items!: UserOrganizationUnitDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserOrganizationUnitDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserOrganizationUnitDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserOrganizationUnitDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserOrganizationUnitDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserOrganizationUnitDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserOrganizationUnitDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserOrganizationUnitDtoPagedResultDto {
    items: UserOrganizationUnitDto[] | undefined;
    totalCount: number;
}

export class UserParentDto implements IUserParentDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    birthDate!: moment.Moment;
    emailAddress!: string | undefined;
    address!: AddressDto;
    fiscalCode!: string | undefined;
    gender!: GenderDto;
    phoneNumber!: string | undefined;
    parentalDegree!: ParentalDegreeDictionaryDto;
    delegate!: boolean;
    invoicing!: boolean;

    constructor(data?: IUserParentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : <any>undefined;
            this.emailAddress = _data["emailAddress"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : <any>undefined;
            this.fiscalCode = _data["fiscalCode"];
            this.gender = _data["gender"] ? GenderDto.fromJS(_data["gender"]) : <any>undefined;
            this.phoneNumber = _data["phoneNumber"];
            this.parentalDegree = _data["parentalDegree"] ? ParentalDegreeDictionaryDto.fromJS(_data["parentalDegree"]) : <any>undefined;
            this.delegate = _data["delegate"];
            this.invoicing = _data["invoicing"];
        }
    }

    static fromJS(data: any): UserParentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserParentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
        data["emailAddress"] = this.emailAddress;
        data["address"] = this.address ? this.address.toJSON() : <any>undefined;
        data["fiscalCode"] = this.fiscalCode;
        data["gender"] = this.gender ? this.gender.toJSON() : <any>undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["parentalDegree"] = this.parentalDegree ? this.parentalDegree.toJSON() : <any>undefined;
        data["delegate"] = this.delegate;
        data["invoicing"] = this.invoicing;
        return data;
    }

    clone(): UserParentDto {
        const json = this.toJSON();
        let result = new UserParentDto();
        result.init(json);
        return result;
    }
}

export interface IUserParentDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    birthDate: moment.Moment;
    emailAddress: string | undefined;
    address: AddressDto;
    fiscalCode: string | undefined;
    gender: GenderDto;
    phoneNumber: string | undefined;
    parentalDegree: ParentalDegreeDictionaryDto;
    delegate: boolean;
    invoicing: boolean;
}

export class UserParentDtoPagedResultDto implements IUserParentDtoPagedResultDto {
    items!: UserParentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserParentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserParentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserParentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserParentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserParentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserParentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserParentDtoPagedResultDto {
    items: UserParentDto[] | undefined;
    totalCount: number;
}

export class UserParentFileDto implements IUserParentFileDto {
    id!: number;
    userParent!: UserParentDto;
    file!: FileDto;

    constructor(data?: IUserParentFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userParent = _data["userParent"] ? UserParentDto.fromJS(_data["userParent"]) : <any>undefined;
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserParentFileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserParentFileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userParent"] = this.userParent ? this.userParent.toJSON() : <any>undefined;
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        return data;
    }

    clone(): UserParentFileDto {
        const json = this.toJSON();
        let result = new UserParentFileDto();
        result.init(json);
        return result;
    }
}

export interface IUserParentFileDto {
    id: number;
    userParent: UserParentDto;
    file: FileDto;
}

export class UserParentFileDtoPagedResultDto implements IUserParentFileDtoPagedResultDto {
    items!: UserParentFileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserParentFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserParentFileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserParentFileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserParentFileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserParentFileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserParentFileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserParentFileDtoPagedResultDto {
    items: UserParentFileDto[] | undefined;
    totalCount: number;
}

export class UserProfessionalRegisterDto implements IUserProfessionalRegisterDto {
    id!: number;
    professionalRegister!: ProfessionalRegisterDto;
    userId!: number;
    startDate!: moment.Moment;
    expirationDate!: moment.Moment | undefined;

    constructor(data?: IUserProfessionalRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.professionalRegister = _data["professionalRegister"] ? ProfessionalRegisterDto.fromJS(_data["professionalRegister"]) : <any>undefined;
            this.userId = _data["userId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserProfessionalRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfessionalRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["professionalRegister"] = this.professionalRegister ? this.professionalRegister.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserProfessionalRegisterDto {
        const json = this.toJSON();
        let result = new UserProfessionalRegisterDto();
        result.init(json);
        return result;
    }
}

export interface IUserProfessionalRegisterDto {
    id: number;
    professionalRegister: ProfessionalRegisterDto;
    userId: number;
    startDate: moment.Moment;
    expirationDate: moment.Moment | undefined;
}

export class UserProfessionalRegisterDtoPagedResultDto implements IUserProfessionalRegisterDtoPagedResultDto {
    items!: UserProfessionalRegisterDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserProfessionalRegisterDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserProfessionalRegisterDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserProfessionalRegisterDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfessionalRegisterDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserProfessionalRegisterDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserProfessionalRegisterDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserProfessionalRegisterDtoPagedResultDto {
    items: UserProfessionalRegisterDto[] | undefined;
    totalCount: number;
}

export class UserQualificationDto implements IUserQualificationDto {
    id!: number;
    userId!: number;
    qualification!: QualificationDto;
    qualificationDate!: moment.Moment | undefined;

    constructor(data?: IUserQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.qualification = _data["qualification"] ? QualificationDto.fromJS(_data["qualification"]) : <any>undefined;
            this.qualificationDate = _data["qualificationDate"] ? moment(_data["qualificationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserQualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : <any>undefined;
        data["qualificationDate"] = this.qualificationDate ? this.qualificationDate.toISOString() : <any>undefined;
        return data;
    }

    clone(): UserQualificationDto {
        const json = this.toJSON();
        let result = new UserQualificationDto();
        result.init(json);
        return result;
    }
}

export interface IUserQualificationDto {
    id: number;
    userId: number;
    qualification: QualificationDto;
    qualificationDate: moment.Moment | undefined;
}

export class UserQualificationDtoPagedResultDto implements IUserQualificationDtoPagedResultDto {
    items!: UserQualificationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserQualificationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserQualificationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserQualificationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserQualificationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserQualificationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserQualificationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserQualificationDtoPagedResultDto {
    items: UserQualificationDto[] | undefined;
    totalCount: number;
}

export class UserReportPartialDto implements IUserReportPartialDto {
    id!: number;
    creationTime!: moment.Moment;
    caredItalianMaleUsers!: number | undefined;
    caredItalianFemaleUsers!: number | undefined;
    caredItalianNonBinaryUsers!: number | undefined;
    caredForeignMaleUsers!: number | undefined;
    caredForeignFemaleUsers!: number | undefined;
    caredForeignNonBinaryUsers!: number | undefined;
    caredHomelessUsers!: number | undefined;
    caredUsersUnder14!: number | undefined;
    caredUsers1418!: number | undefined;
    caredUsers1925!: number | undefined;
    caredUsers2640!: number | undefined;
    caredUsers4150!: number | undefined;
    caredUsers5165!: number | undefined;
    caredUsersOver65!: number | undefined;

    constructor(data?: IUserReportPartialDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : <any>undefined;
            this.caredItalianMaleUsers = _data["caredItalianMaleUsers"];
            this.caredItalianFemaleUsers = _data["caredItalianFemaleUsers"];
            this.caredItalianNonBinaryUsers = _data["caredItalianNonBinaryUsers"];
            this.caredForeignMaleUsers = _data["caredForeignMaleUsers"];
            this.caredForeignFemaleUsers = _data["caredForeignFemaleUsers"];
            this.caredForeignNonBinaryUsers = _data["caredForeignNonBinaryUsers"];
            this.caredHomelessUsers = _data["caredHomelessUsers"];
            this.caredUsersUnder14 = _data["caredUsersUnder14"];
            this.caredUsers1418 = _data["caredUsers1418"];
            this.caredUsers1925 = _data["caredUsers1925"];
            this.caredUsers2640 = _data["caredUsers2640"];
            this.caredUsers4150 = _data["caredUsers4150"];
            this.caredUsers5165 = _data["caredUsers5165"];
            this.caredUsersOver65 = _data["caredUsersOver65"];
        }
    }

    static fromJS(data: any): UserReportPartialDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportPartialDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["caredItalianMaleUsers"] = this.caredItalianMaleUsers;
        data["caredItalianFemaleUsers"] = this.caredItalianFemaleUsers;
        data["caredItalianNonBinaryUsers"] = this.caredItalianNonBinaryUsers;
        data["caredForeignMaleUsers"] = this.caredForeignMaleUsers;
        data["caredForeignFemaleUsers"] = this.caredForeignFemaleUsers;
        data["caredForeignNonBinaryUsers"] = this.caredForeignNonBinaryUsers;
        data["caredHomelessUsers"] = this.caredHomelessUsers;
        data["caredUsersUnder14"] = this.caredUsersUnder14;
        data["caredUsers1418"] = this.caredUsers1418;
        data["caredUsers1925"] = this.caredUsers1925;
        data["caredUsers2640"] = this.caredUsers2640;
        data["caredUsers4150"] = this.caredUsers4150;
        data["caredUsers5165"] = this.caredUsers5165;
        data["caredUsersOver65"] = this.caredUsersOver65;
        return data;
    }

    clone(): UserReportPartialDto {
        const json = this.toJSON();
        let result = new UserReportPartialDto();
        result.init(json);
        return result;
    }
}

export interface IUserReportPartialDto {
    id: number;
    creationTime: moment.Moment;
    caredItalianMaleUsers: number | undefined;
    caredItalianFemaleUsers: number | undefined;
    caredItalianNonBinaryUsers: number | undefined;
    caredForeignMaleUsers: number | undefined;
    caredForeignFemaleUsers: number | undefined;
    caredForeignNonBinaryUsers: number | undefined;
    caredHomelessUsers: number | undefined;
    caredUsersUnder14: number | undefined;
    caredUsers1418: number | undefined;
    caredUsers1925: number | undefined;
    caredUsers2640: number | undefined;
    caredUsers4150: number | undefined;
    caredUsers5165: number | undefined;
    caredUsersOver65: number | undefined;
}

export class UserReportPartialDtoPagedResultDto implements IUserReportPartialDtoPagedResultDto {
    items!: UserReportPartialDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserReportPartialDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserReportPartialDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserReportPartialDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserReportPartialDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserReportPartialDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserReportPartialDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserReportPartialDtoPagedResultDto {
    items: UserReportPartialDto[] | undefined;
    totalCount: number;
}

export class WorkContractLevelDictionaryDto implements IWorkContractLevelDictionaryDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: IWorkContractLevelDictionaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): WorkContractLevelDictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkContractLevelDictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): WorkContractLevelDictionaryDto {
        const json = this.toJSON();
        let result = new WorkContractLevelDictionaryDto();
        result.init(json);
        return result;
    }
}

export interface IWorkContractLevelDictionaryDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
}

export class WorkContractLevelDictionaryDtoPagedResultDto implements IWorkContractLevelDictionaryDtoPagedResultDto {
    items!: WorkContractLevelDictionaryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IWorkContractLevelDictionaryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WorkContractLevelDictionaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WorkContractLevelDictionaryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkContractLevelDictionaryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WorkContractLevelDictionaryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WorkContractLevelDictionaryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWorkContractLevelDictionaryDtoPagedResultDto {
    items: WorkContractLevelDictionaryDto[] | undefined;
    totalCount: number;
}

export class WorkContractTypeDto implements IWorkContractTypeDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: IWorkContractTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): WorkContractTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkContractTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): WorkContractTypeDto {
        const json = this.toJSON();
        let result = new WorkContractTypeDto();
        result.init(json);
        return result;
    }
}

export interface IWorkContractTypeDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
}

export class WorkerUserAdditionalDto implements IWorkerUserAdditionalDto {
    id!: number;
    isAssociate!: boolean | undefined;
    isVoluntaryAssociate!: boolean | undefined;
    isWorker!: boolean | undefined;
    workContractType!: WorkContractTypeDto;
    workContractLevel!: WorkContractLevelDictionaryDto;
    educationalDegreeLevel!: EducationalDegreeLevelDto;

    constructor(data?: IWorkerUserAdditionalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isAssociate = _data["isAssociate"];
            this.isVoluntaryAssociate = _data["isVoluntaryAssociate"];
            this.isWorker = _data["isWorker"];
            this.workContractType = _data["workContractType"] ? WorkContractTypeDto.fromJS(_data["workContractType"]) : <any>undefined;
            this.workContractLevel = _data["workContractLevel"] ? WorkContractLevelDictionaryDto.fromJS(_data["workContractLevel"]) : <any>undefined;
            this.educationalDegreeLevel = _data["educationalDegreeLevel"] ? EducationalDegreeLevelDto.fromJS(_data["educationalDegreeLevel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkerUserAdditionalDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkerUserAdditionalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isAssociate"] = this.isAssociate;
        data["isVoluntaryAssociate"] = this.isVoluntaryAssociate;
        data["isWorker"] = this.isWorker;
        data["workContractType"] = this.workContractType ? this.workContractType.toJSON() : <any>undefined;
        data["workContractLevel"] = this.workContractLevel ? this.workContractLevel.toJSON() : <any>undefined;
        data["educationalDegreeLevel"] = this.educationalDegreeLevel ? this.educationalDegreeLevel.toJSON() : <any>undefined;
        return data;
    }

    clone(): WorkerUserAdditionalDto {
        const json = this.toJSON();
        let result = new WorkerUserAdditionalDto();
        result.init(json);
        return result;
    }
}

export interface IWorkerUserAdditionalDto {
    id: number;
    isAssociate: boolean | undefined;
    isVoluntaryAssociate: boolean | undefined;
    isWorker: boolean | undefined;
    workContractType: WorkContractTypeDto;
    workContractLevel: WorkContractLevelDictionaryDto;
    educationalDegreeLevel: EducationalDegreeLevelDto;
}

export class WorkShiftFrequencyTypeDto implements IWorkShiftFrequencyTypeDto {
    id!: number;
    description!: string | undefined;

    constructor(data?: IWorkShiftFrequencyTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): WorkShiftFrequencyTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorkShiftFrequencyTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }

    clone(): WorkShiftFrequencyTypeDto {
        const json = this.toJSON();
        let result = new WorkShiftFrequencyTypeDto();
        result.init(json);
        return result;
    }
}

export interface IWorkShiftFrequencyTypeDto {
    id: number;
    description: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}